(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("451Sc", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2f891507bcc3501a$export$6503ec6e8aabbaf; }, function (v) { return $2f891507bcc3501a$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $2f891507bcc3501a$export$f7ad0328861e2f03; }, function (v) { return $2f891507bcc3501a$export$f7ad0328861e2f03 = v; });
var $2f891507bcc3501a$export$6503ec6e8aabbaf;
var $2f891507bcc3501a$export$f7ad0328861e2f03;
"use strict";
var $2f891507bcc3501a$var$mapping = new Map();
function $2f891507bcc3501a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2f891507bcc3501a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2f891507bcc3501a$var$resolve(id) {
    var resolved = $2f891507bcc3501a$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2f891507bcc3501a$export$6503ec6e8aabbaf = $2f891507bcc3501a$var$register;
$2f891507bcc3501a$export$f7ad0328861e2f03 = $2f891507bcc3501a$var$resolve;

});

parcelRegister("i1aqH", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $d1e0691a4ecd19e1$export$bdfd709ae4826697; }, function (v) { return $d1e0691a4ecd19e1$export$bdfd709ae4826697 = v; });
var $d1e0691a4ecd19e1$export$bdfd709ae4826697;
var $d1e0691a4ecd19e1$export$c9e73fbda7da57b6;
var $d1e0691a4ecd19e1$export$5a759dc7a1cfb72a;
"use strict";
var $d1e0691a4ecd19e1$var$bundleURL = {};
function $d1e0691a4ecd19e1$var$getBundleURLCached(id) {
    var value = $d1e0691a4ecd19e1$var$bundleURL[id];
    if (!value) {
        value = $d1e0691a4ecd19e1$var$getBundleURL();
        $d1e0691a4ecd19e1$var$bundleURL[id] = value;
    }
    return value;
}
function $d1e0691a4ecd19e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $d1e0691a4ecd19e1$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $d1e0691a4ecd19e1$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $d1e0691a4ecd19e1$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$d1e0691a4ecd19e1$export$bdfd709ae4826697 = $d1e0691a4ecd19e1$var$getBundleURLCached;
$d1e0691a4ecd19e1$export$c9e73fbda7da57b6 = $d1e0691a4ecd19e1$var$getBaseURL;
$d1e0691a4ecd19e1$export$5a759dc7a1cfb72a = $d1e0691a4ecd19e1$var$getOrigin;

});

parcelRegister("cc6u1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5HeJu"));

});
parcelRegister("5HeJu", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $425c6581edea75b8$export$ffb0004e005737fa; }, function (v) { return $425c6581edea75b8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $425c6581edea75b8$export$34b9dba7ce09269b; }, function (v) { return $425c6581edea75b8$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $425c6581edea75b8$export$25062201e9e25d76; }, function (v) { return $425c6581edea75b8$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $425c6581edea75b8$export$ffb0004e005737fa;
var $425c6581edea75b8$export$34b9dba7ce09269b;
var $425c6581edea75b8$export$25062201e9e25d76;
"use strict";
var $425c6581edea75b8$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $425c6581edea75b8$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $425c6581edea75b8$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $425c6581edea75b8$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$425c6581edea75b8$export$ffb0004e005737fa = $425c6581edea75b8$var$REACT_FRAGMENT_TYPE;
$425c6581edea75b8$export$34b9dba7ce09269b = $425c6581edea75b8$var$jsxProd;
$425c6581edea75b8$export$25062201e9e25d76 = $425c6581edea75b8$var$jsxProd;

});


parcelRegister("5p0Oe", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $3eefea38dbe2eeaf$export$dca3b0875bd9a954; }, function (v) { return $3eefea38dbe2eeaf$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $3eefea38dbe2eeaf$export$16fa2f45be04daa8; }, function (v) { return $3eefea38dbe2eeaf$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3eefea38dbe2eeaf$export$ffb0004e005737fa; }, function (v) { return $3eefea38dbe2eeaf$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $3eefea38dbe2eeaf$export$e2c29f18771995cb; }, function (v) { return $3eefea38dbe2eeaf$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $3eefea38dbe2eeaf$export$221d75b3f55bb0bd; }, function (v) { return $3eefea38dbe2eeaf$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3eefea38dbe2eeaf$export$5f8d39834fd61797; }, function (v) { return $3eefea38dbe2eeaf$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3eefea38dbe2eeaf$export$74bf444e3cd11ea5; }, function (v) { return $3eefea38dbe2eeaf$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $3eefea38dbe2eeaf$export$1ced07cd6b1985ce; }, function (v) { return $3eefea38dbe2eeaf$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $3eefea38dbe2eeaf$export$3ba232387fd5d6dd; }, function (v) { return $3eefea38dbe2eeaf$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $3eefea38dbe2eeaf$export$69a3209f1a06c04d; }, function (v) { return $3eefea38dbe2eeaf$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $3eefea38dbe2eeaf$export$e530037191fcd5d7; }, function (v) { return $3eefea38dbe2eeaf$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $3eefea38dbe2eeaf$export$fd42f52fd3ae1109; }, function (v) { return $3eefea38dbe2eeaf$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $3eefea38dbe2eeaf$export$c8a8987d4410bf2d; }, function (v) { return $3eefea38dbe2eeaf$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $3eefea38dbe2eeaf$export$7d1e3a5e95ceca43; }, function (v) { return $3eefea38dbe2eeaf$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $3eefea38dbe2eeaf$export$257a8862b851cb5b; }, function (v) { return $3eefea38dbe2eeaf$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $3eefea38dbe2eeaf$export$a8257692ac88316c; }, function (v) { return $3eefea38dbe2eeaf$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $3eefea38dbe2eeaf$export$488013bae63b21da; }, function (v) { return $3eefea38dbe2eeaf$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $3eefea38dbe2eeaf$export$7c73462e0d25e514; }, function (v) { return $3eefea38dbe2eeaf$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $3eefea38dbe2eeaf$export$7568632d0d33d16d; }, function (v) { return $3eefea38dbe2eeaf$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $3eefea38dbe2eeaf$export$f93f40ac0ca7e3a8; }, function (v) { return $3eefea38dbe2eeaf$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $3eefea38dbe2eeaf$export$1f96ae73734a86cc; }, function (v) { return $3eefea38dbe2eeaf$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $3eefea38dbe2eeaf$export$9a47ced3238df325; }, function (v) { return $3eefea38dbe2eeaf$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $3eefea38dbe2eeaf$export$35808ee640e87ca7; }, function (v) { return $3eefea38dbe2eeaf$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $3eefea38dbe2eeaf$export$fae74005e78b1a27; }, function (v) { return $3eefea38dbe2eeaf$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $3eefea38dbe2eeaf$export$dc8fbce3eb94dc1e; }, function (v) { return $3eefea38dbe2eeaf$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $3eefea38dbe2eeaf$export$6a7bc4e911dc01cf; }, function (v) { return $3eefea38dbe2eeaf$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $3eefea38dbe2eeaf$export$6d9c69b0de29b591; }, function (v) { return $3eefea38dbe2eeaf$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $3eefea38dbe2eeaf$export$f680877a34711e37; }, function (v) { return $3eefea38dbe2eeaf$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $3eefea38dbe2eeaf$export$d5a552a76deda3c2; }, function (v) { return $3eefea38dbe2eeaf$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $3eefea38dbe2eeaf$export$aaabe4eda9ed9969; }, function (v) { return $3eefea38dbe2eeaf$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $3eefea38dbe2eeaf$export$e5c5a5f917a5871c; }, function (v) { return $3eefea38dbe2eeaf$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $3eefea38dbe2eeaf$export$1538c33de8887b59; }, function (v) { return $3eefea38dbe2eeaf$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $3eefea38dbe2eeaf$export$fca7f784ae7a249a; }, function (v) { return $3eefea38dbe2eeaf$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $3eefea38dbe2eeaf$export$13e3392192263954; }, function (v) { return $3eefea38dbe2eeaf$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $3eefea38dbe2eeaf$export$b8f5890fc79d6aca; }, function (v) { return $3eefea38dbe2eeaf$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $3eefea38dbe2eeaf$export$60241385465d0a34; }, function (v) { return $3eefea38dbe2eeaf$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $3eefea38dbe2eeaf$export$306c0aa65ff9ec16; }, function (v) { return $3eefea38dbe2eeaf$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $3eefea38dbe2eeaf$export$7b286972b8d8ccbf; }, function (v) { return $3eefea38dbe2eeaf$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $3eefea38dbe2eeaf$export$83d89fbfd8236492; }, function (v) { return $3eefea38dbe2eeaf$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $3eefea38dbe2eeaf$export$dca3b0875bd9a954;
var $3eefea38dbe2eeaf$export$16fa2f45be04daa8;
var $3eefea38dbe2eeaf$export$ffb0004e005737fa;
var $3eefea38dbe2eeaf$export$e2c29f18771995cb;
var $3eefea38dbe2eeaf$export$221d75b3f55bb0bd;
var $3eefea38dbe2eeaf$export$5f8d39834fd61797;
var $3eefea38dbe2eeaf$export$74bf444e3cd11ea5;
var $3eefea38dbe2eeaf$export$1ced07cd6b1985ce;
var $3eefea38dbe2eeaf$export$3ba232387fd5d6dd;
var $3eefea38dbe2eeaf$export$69a3209f1a06c04d;
var $3eefea38dbe2eeaf$export$e530037191fcd5d7;
var $3eefea38dbe2eeaf$export$fd42f52fd3ae1109;
var $3eefea38dbe2eeaf$export$c8a8987d4410bf2d;
var $3eefea38dbe2eeaf$export$7d1e3a5e95ceca43;
var $3eefea38dbe2eeaf$export$257a8862b851cb5b;
var $3eefea38dbe2eeaf$export$a8257692ac88316c;
var $3eefea38dbe2eeaf$export$488013bae63b21da;
var $3eefea38dbe2eeaf$export$7c73462e0d25e514;
var $3eefea38dbe2eeaf$export$7568632d0d33d16d;
var $3eefea38dbe2eeaf$export$f93f40ac0ca7e3a8;
var $3eefea38dbe2eeaf$export$1f96ae73734a86cc;
var $3eefea38dbe2eeaf$export$9a47ced3238df325;
var $3eefea38dbe2eeaf$export$35808ee640e87ca7;
var $3eefea38dbe2eeaf$export$fae74005e78b1a27;
var $3eefea38dbe2eeaf$export$dc8fbce3eb94dc1e;
var $3eefea38dbe2eeaf$export$6a7bc4e911dc01cf;
var $3eefea38dbe2eeaf$export$6d9c69b0de29b591;
var $3eefea38dbe2eeaf$export$f680877a34711e37;
var $3eefea38dbe2eeaf$export$d5a552a76deda3c2;
var $3eefea38dbe2eeaf$export$aaabe4eda9ed9969;
var $3eefea38dbe2eeaf$export$e5c5a5f917a5871c;
var $3eefea38dbe2eeaf$export$1538c33de8887b59;
var $3eefea38dbe2eeaf$export$fca7f784ae7a249a;
var $3eefea38dbe2eeaf$export$13e3392192263954;
var $3eefea38dbe2eeaf$export$b8f5890fc79d6aca;
var $3eefea38dbe2eeaf$export$60241385465d0a34;
var $3eefea38dbe2eeaf$export$306c0aa65ff9ec16;
var $3eefea38dbe2eeaf$export$7b286972b8d8ccbf;
var $3eefea38dbe2eeaf$export$83d89fbfd8236492;

var $ibRPI = parcelRequire("ibRPI");
"use strict";
var $3eefea38dbe2eeaf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $3eefea38dbe2eeaf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $3eefea38dbe2eeaf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $3eefea38dbe2eeaf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $3eefea38dbe2eeaf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $3eefea38dbe2eeaf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $3eefea38dbe2eeaf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $3eefea38dbe2eeaf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $3eefea38dbe2eeaf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $3eefea38dbe2eeaf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $3eefea38dbe2eeaf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $3eefea38dbe2eeaf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $3eefea38dbe2eeaf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $YtE9h._)(maybeIterable))) return null;
    maybeIterable = $3eefea38dbe2eeaf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$3eefea38dbe2eeaf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $3eefea38dbe2eeaf$var$ReactNoopUpdateQueue = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $3eefea38dbe2eeaf$var$assign = Object.assign, $3eefea38dbe2eeaf$var$emptyObject = {};
function $3eefea38dbe2eeaf$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $3eefea38dbe2eeaf$var$emptyObject;
    this.updater = updater || $3eefea38dbe2eeaf$var$ReactNoopUpdateQueue;
}
$3eefea38dbe2eeaf$var$Component.prototype.isReactComponent = {};
$3eefea38dbe2eeaf$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== (typeof partialState === "undefined" ? "undefined" : (0, $YtE9h._)(partialState)) && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$3eefea38dbe2eeaf$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $3eefea38dbe2eeaf$var$ComponentDummy() {}
$3eefea38dbe2eeaf$var$ComponentDummy.prototype = $3eefea38dbe2eeaf$var$Component.prototype;
function $3eefea38dbe2eeaf$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $3eefea38dbe2eeaf$var$emptyObject;
    this.updater = updater || $3eefea38dbe2eeaf$var$ReactNoopUpdateQueue;
}
var $3eefea38dbe2eeaf$var$pureComponentPrototype = $3eefea38dbe2eeaf$var$PureComponent.prototype = new $3eefea38dbe2eeaf$var$ComponentDummy();
$3eefea38dbe2eeaf$var$pureComponentPrototype.constructor = $3eefea38dbe2eeaf$var$PureComponent;
$3eefea38dbe2eeaf$var$assign($3eefea38dbe2eeaf$var$pureComponentPrototype, $3eefea38dbe2eeaf$var$Component.prototype);
$3eefea38dbe2eeaf$var$pureComponentPrototype.isPureReactComponent = !0;
var $3eefea38dbe2eeaf$var$isArrayImpl = Array.isArray, $3eefea38dbe2eeaf$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $3eefea38dbe2eeaf$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $3eefea38dbe2eeaf$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $3eefea38dbe2eeaf$var$cloneAndReplaceKey(oldElement, newKey) {
    return $3eefea38dbe2eeaf$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $3eefea38dbe2eeaf$var$isValidElement(object) {
    return "object" === (typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) && null !== object && object.$$typeof === $3eefea38dbe2eeaf$var$REACT_ELEMENT_TYPE;
}
function $3eefea38dbe2eeaf$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $3eefea38dbe2eeaf$var$userProvidedKeyEscapeRegex = /\/+/g;
function $3eefea38dbe2eeaf$var$getElementKey(element, index) {
    return "object" === (typeof element === "undefined" ? "undefined" : (0, $YtE9h._)(element)) && null !== element && null != element.key ? $3eefea38dbe2eeaf$var$escape("" + element.key) : index.toString(36);
}
function $3eefea38dbe2eeaf$var$noop$1() {}
function $3eefea38dbe2eeaf$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($3eefea38dbe2eeaf$var$noop$1, $3eefea38dbe2eeaf$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $3eefea38dbe2eeaf$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children === "undefined" ? "undefined" : (0, $YtE9h._)(children);
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $3eefea38dbe2eeaf$var$REACT_ELEMENT_TYPE:
                case $3eefea38dbe2eeaf$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $3eefea38dbe2eeaf$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $3eefea38dbe2eeaf$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $3eefea38dbe2eeaf$var$getElementKey(children, 0) : nameSoFar, $3eefea38dbe2eeaf$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($3eefea38dbe2eeaf$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $3eefea38dbe2eeaf$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($3eefea38dbe2eeaf$var$isValidElement(callback) && (callback = $3eefea38dbe2eeaf$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($3eefea38dbe2eeaf$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($3eefea38dbe2eeaf$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $3eefea38dbe2eeaf$var$getElementKey(nameSoFar, i), invokeCallback += $3eefea38dbe2eeaf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $3eefea38dbe2eeaf$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $3eefea38dbe2eeaf$var$getElementKey(nameSoFar, i++), invokeCallback += $3eefea38dbe2eeaf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $3eefea38dbe2eeaf$var$mapIntoArray($3eefea38dbe2eeaf$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $3eefea38dbe2eeaf$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $3eefea38dbe2eeaf$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $3eefea38dbe2eeaf$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $3eefea38dbe2eeaf$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $YtE9h._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $YtE9h._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === (typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI)) && "function" === typeof $ibRPI.emit) {
        $ibRPI.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $3eefea38dbe2eeaf$var$noop() {}
$3eefea38dbe2eeaf$export$dca3b0875bd9a954 = {
    map: $3eefea38dbe2eeaf$var$mapChildren,
    forEach: function forEach(children, forEachFunc, forEachContext) {
        $3eefea38dbe2eeaf$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function count(children) {
        var n = 0;
        $3eefea38dbe2eeaf$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function toArray(children) {
        return $3eefea38dbe2eeaf$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function only(children) {
        if (!$3eefea38dbe2eeaf$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$3eefea38dbe2eeaf$export$16fa2f45be04daa8 = $3eefea38dbe2eeaf$var$Component;
$3eefea38dbe2eeaf$export$ffb0004e005737fa = $3eefea38dbe2eeaf$var$REACT_FRAGMENT_TYPE;
$3eefea38dbe2eeaf$export$e2c29f18771995cb = $3eefea38dbe2eeaf$var$REACT_PROFILER_TYPE;
$3eefea38dbe2eeaf$export$221d75b3f55bb0bd = $3eefea38dbe2eeaf$var$PureComponent;
$3eefea38dbe2eeaf$export$5f8d39834fd61797 = $3eefea38dbe2eeaf$var$REACT_STRICT_MODE_TYPE;
$3eefea38dbe2eeaf$export$74bf444e3cd11ea5 = $3eefea38dbe2eeaf$var$REACT_SUSPENSE_TYPE;
$3eefea38dbe2eeaf$export$1ced07cd6b1985ce = $3eefea38dbe2eeaf$var$ReactSharedInternals;
$3eefea38dbe2eeaf$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$3eefea38dbe2eeaf$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$3eefea38dbe2eeaf$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $3eefea38dbe2eeaf$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$3eefea38dbe2eeaf$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $3eefea38dbe2eeaf$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$3eefea38dbe2eeaf$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$3eefea38dbe2eeaf$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$3eefea38dbe2eeaf$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $3eefea38dbe2eeaf$var$ReactElement(type, key, void 0, void 0, null, props);
};
$3eefea38dbe2eeaf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3eefea38dbe2eeaf$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$3eefea38dbe2eeaf$export$a8257692ac88316c = $3eefea38dbe2eeaf$var$isValidElement;
$3eefea38dbe2eeaf$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $3eefea38dbe2eeaf$var$lazyInitializer
    };
};
$3eefea38dbe2eeaf$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$3eefea38dbe2eeaf$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $3eefea38dbe2eeaf$var$ReactSharedInternals.T, currentTransition = {};
    $3eefea38dbe2eeaf$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $3eefea38dbe2eeaf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $YtE9h._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($3eefea38dbe2eeaf$var$noop, $3eefea38dbe2eeaf$var$reportGlobalError);
    } catch (error) {
        $3eefea38dbe2eeaf$var$reportGlobalError(error);
    } finally{
        $3eefea38dbe2eeaf$var$ReactSharedInternals.T = prevTransition;
    }
};
$3eefea38dbe2eeaf$export$f93f40ac0ca7e3a8 = function() {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useCacheRefresh();
};
$3eefea38dbe2eeaf$export$1f96ae73734a86cc = function(usable) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.use(usable);
};
$3eefea38dbe2eeaf$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$3eefea38dbe2eeaf$export$35808ee640e87ca7 = function(callback, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$3eefea38dbe2eeaf$export$fae74005e78b1a27 = function(Context) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useContext(Context);
};
$3eefea38dbe2eeaf$export$dc8fbce3eb94dc1e = function() {};
$3eefea38dbe2eeaf$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$3eefea38dbe2eeaf$export$6d9c69b0de29b591 = function(create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useEffect(create, deps);
};
$3eefea38dbe2eeaf$export$f680877a34711e37 = function() {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useId();
};
$3eefea38dbe2eeaf$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$3eefea38dbe2eeaf$export$aaabe4eda9ed9969 = function(create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$3eefea38dbe2eeaf$export$e5c5a5f917a5871c = function(create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$3eefea38dbe2eeaf$export$1538c33de8887b59 = function(create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useMemo(create, deps);
};
$3eefea38dbe2eeaf$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$3eefea38dbe2eeaf$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$3eefea38dbe2eeaf$export$b8f5890fc79d6aca = function(initialValue) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useRef(initialValue);
};
$3eefea38dbe2eeaf$export$60241385465d0a34 = function(initialState) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useState(initialState);
};
$3eefea38dbe2eeaf$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$3eefea38dbe2eeaf$export$7b286972b8d8ccbf = function() {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useTransition();
};
$3eefea38dbe2eeaf$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("YtE9h", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b5c99e6a0876eaa$export$71511d61b312f219; });
function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("ibRPI", function(module, exports) {
// shim for using process in browser
var $d3e3033a14238d9e$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3e3033a14238d9e$var$cachedSetTimeout;
var $d3e3033a14238d9e$var$cachedClearTimeout;
function $d3e3033a14238d9e$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3e3033a14238d9e$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3e3033a14238d9e$var$cachedSetTimeout = setTimeout;
        else $d3e3033a14238d9e$var$cachedSetTimeout = $d3e3033a14238d9e$var$defaultSetTimout;
    } catch (e) {
        $d3e3033a14238d9e$var$cachedSetTimeout = $d3e3033a14238d9e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3e3033a14238d9e$var$cachedClearTimeout = clearTimeout;
        else $d3e3033a14238d9e$var$cachedClearTimeout = $d3e3033a14238d9e$var$defaultClearTimeout;
    } catch (e) {
        $d3e3033a14238d9e$var$cachedClearTimeout = $d3e3033a14238d9e$var$defaultClearTimeout;
    }
})();
function $d3e3033a14238d9e$var$runTimeout(fun) {
    if ($d3e3033a14238d9e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3e3033a14238d9e$var$cachedSetTimeout === $d3e3033a14238d9e$var$defaultSetTimout || !$d3e3033a14238d9e$var$cachedSetTimeout) && setTimeout) {
        $d3e3033a14238d9e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3e3033a14238d9e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3e3033a14238d9e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3e3033a14238d9e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3e3033a14238d9e$var$runClearTimeout(marker) {
    if ($d3e3033a14238d9e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3e3033a14238d9e$var$cachedClearTimeout === $d3e3033a14238d9e$var$defaultClearTimeout || !$d3e3033a14238d9e$var$cachedClearTimeout) && clearTimeout) {
        $d3e3033a14238d9e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3e3033a14238d9e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3e3033a14238d9e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3e3033a14238d9e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3e3033a14238d9e$var$queue = [];
var $d3e3033a14238d9e$var$draining = false;
var $d3e3033a14238d9e$var$currentQueue;
var $d3e3033a14238d9e$var$queueIndex = -1;
function $d3e3033a14238d9e$var$cleanUpNextTick() {
    if (!$d3e3033a14238d9e$var$draining || !$d3e3033a14238d9e$var$currentQueue) return;
    $d3e3033a14238d9e$var$draining = false;
    if ($d3e3033a14238d9e$var$currentQueue.length) $d3e3033a14238d9e$var$queue = $d3e3033a14238d9e$var$currentQueue.concat($d3e3033a14238d9e$var$queue);
    else $d3e3033a14238d9e$var$queueIndex = -1;
    if ($d3e3033a14238d9e$var$queue.length) $d3e3033a14238d9e$var$drainQueue();
}
function $d3e3033a14238d9e$var$drainQueue() {
    if ($d3e3033a14238d9e$var$draining) return;
    var timeout = $d3e3033a14238d9e$var$runTimeout($d3e3033a14238d9e$var$cleanUpNextTick);
    $d3e3033a14238d9e$var$draining = true;
    var len = $d3e3033a14238d9e$var$queue.length;
    while(len){
        $d3e3033a14238d9e$var$currentQueue = $d3e3033a14238d9e$var$queue;
        $d3e3033a14238d9e$var$queue = [];
        while(++$d3e3033a14238d9e$var$queueIndex < len)if ($d3e3033a14238d9e$var$currentQueue) $d3e3033a14238d9e$var$currentQueue[$d3e3033a14238d9e$var$queueIndex].run();
        $d3e3033a14238d9e$var$queueIndex = -1;
        len = $d3e3033a14238d9e$var$queue.length;
    }
    $d3e3033a14238d9e$var$currentQueue = null;
    $d3e3033a14238d9e$var$draining = false;
    $d3e3033a14238d9e$var$runClearTimeout(timeout);
}
$d3e3033a14238d9e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3e3033a14238d9e$var$queue.push(new $d3e3033a14238d9e$var$Item(fun, args));
    if ($d3e3033a14238d9e$var$queue.length === 1 && !$d3e3033a14238d9e$var$draining) $d3e3033a14238d9e$var$runTimeout($d3e3033a14238d9e$var$drainQueue);
};
// v8 likes predictible objects
function $d3e3033a14238d9e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3e3033a14238d9e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3e3033a14238d9e$var$process.title = 'browser';
$d3e3033a14238d9e$var$process.browser = true;
$d3e3033a14238d9e$var$process.env = {};
$d3e3033a14238d9e$var$process.argv = [];
$d3e3033a14238d9e$var$process.version = ''; // empty string to avoid regexp issues
$d3e3033a14238d9e$var$process.versions = {};
function $d3e3033a14238d9e$var$noop() {}
$d3e3033a14238d9e$var$process.on = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.addListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.once = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.off = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.removeListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.removeAllListeners = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.emit = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.prependListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.prependOnceListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.listeners = function(name) {
    return [];
};
$d3e3033a14238d9e$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3e3033a14238d9e$var$process.cwd = function() {
    return '/';
};
$d3e3033a14238d9e$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3e3033a14238d9e$var$process.umask = function() {
    return 0;
};

});


parcelRegister("gd2PY", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $bcd00faefdd4b5d7$export$882461b6382ed46c; }, function (v) { return $bcd00faefdd4b5d7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bcd00faefdd4b5d7$export$757ceba2d55c277e; }, function (v) { return $bcd00faefdd4b5d7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $bcd00faefdd4b5d7$export$83d89fbfd8236492; }, function (v) { return $bcd00faefdd4b5d7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $YtE9h = parcelRequire("YtE9h");
var $bcd00faefdd4b5d7$export$882461b6382ed46c;
var $bcd00faefdd4b5d7$export$757ceba2d55c277e;
var $bcd00faefdd4b5d7$export$83d89fbfd8236492;

var $ibRPI = parcelRequire("ibRPI");
"use strict";

var $go0bk = parcelRequire("go0bk");

var $fIwXP = parcelRequire("fIwXP");

var $9F3H4 = parcelRequire("9F3H4");
function $bcd00faefdd4b5d7$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $bcd00faefdd4b5d7$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $bcd00faefdd4b5d7$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bcd00faefdd4b5d7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bcd00faefdd4b5d7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bcd00faefdd4b5d7$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $bcd00faefdd4b5d7$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bcd00faefdd4b5d7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bcd00faefdd4b5d7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bcd00faefdd4b5d7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $bcd00faefdd4b5d7$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $bcd00faefdd4b5d7$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $bcd00faefdd4b5d7$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $bcd00faefdd4b5d7$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $bcd00faefdd4b5d7$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $YtE9h._)(maybeIterable))) return null;
    maybeIterable = $bcd00faefdd4b5d7$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$bcd00faefdd4b5d7$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $bcd00faefdd4b5d7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $bcd00faefdd4b5d7$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $bcd00faefdd4b5d7$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $bcd00faefdd4b5d7$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $bcd00faefdd4b5d7$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $bcd00faefdd4b5d7$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $bcd00faefdd4b5d7$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type))) switch(type.$$typeof){
        case $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $bcd00faefdd4b5d7$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $bcd00faefdd4b5d7$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $bcd00faefdd4b5d7$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $bcd00faefdd4b5d7$var$getComponentNameFromType(type.type) || "Memo";
        case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $bcd00faefdd4b5d7$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $bcd00faefdd4b5d7$var$ReactSharedInternals = $fIwXP.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $bcd00faefdd4b5d7$var$assign = Object.assign, $bcd00faefdd4b5d7$var$prefix, $bcd00faefdd4b5d7$var$suffix;
function $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $bcd00faefdd4b5d7$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $bcd00faefdd4b5d7$var$prefix = match && match[1] || "";
        $bcd00faefdd4b5d7$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $bcd00faefdd4b5d7$var$prefix + name + $bcd00faefdd4b5d7$var$suffix;
}
var $bcd00faefdd4b5d7$var$reentry = !1;
function $bcd00faefdd4b5d7$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $bcd00faefdd4b5d7$var$reentry) return "";
    $bcd00faefdd4b5d7$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function DetermineComponentFrameRoot() {
                try {
                    if (construct) {
                        var Fake = function Fake() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function set() {
                                throw Error();
                            }
                        });
                        if ("object" === (typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $bcd00faefdd4b5d7$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $bcd00faefdd4b5d7$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $bcd00faefdd4b5d7$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $bcd00faefdd4b5d7$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $bcd00faefdd4b5d7$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $bcd00faefdd4b5d7$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $bcd00faefdd4b5d7$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $bcd00faefdd4b5d7$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $bcd00faefdd4b5d7$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$assertIsMounted(fiber) {
    if ($bcd00faefdd4b5d7$var$getNearestMountedFiber(fiber) !== fiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
}
function $bcd00faefdd4b5d7$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $bcd00faefdd4b5d7$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $bcd00faefdd4b5d7$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $bcd00faefdd4b5d7$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $bcd00faefdd4b5d7$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $bcd00faefdd4b5d7$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $bcd00faefdd4b5d7$var$isArrayImpl = Array.isArray, $bcd00faefdd4b5d7$var$ReactDOMSharedInternals = $9F3H4.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $bcd00faefdd4b5d7$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $bcd00faefdd4b5d7$var$valueStack = [], $bcd00faefdd4b5d7$var$index = -1;
function $bcd00faefdd4b5d7$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $bcd00faefdd4b5d7$var$pop(cursor) {
    0 > $bcd00faefdd4b5d7$var$index || (cursor.current = $bcd00faefdd4b5d7$var$valueStack[$bcd00faefdd4b5d7$var$index], $bcd00faefdd4b5d7$var$valueStack[$bcd00faefdd4b5d7$var$index] = null, $bcd00faefdd4b5d7$var$index--);
}
function $bcd00faefdd4b5d7$var$push(cursor, value) {
    $bcd00faefdd4b5d7$var$index++;
    $bcd00faefdd4b5d7$var$valueStack[$bcd00faefdd4b5d7$var$index] = cursor.current;
    cursor.current = value;
}
var $bcd00faefdd4b5d7$var$contextStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$contextFiberStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$rootInstanceStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$hostTransitionProviderCursor = $bcd00faefdd4b5d7$var$createCursor(null);
function $bcd00faefdd4b5d7$var$pushHostContainer(fiber, nextRootInstance) {
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$rootInstanceStackCursor, nextRootInstance);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextFiberStackCursor, fiber);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $bcd00faefdd4b5d7$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $bcd00faefdd4b5d7$var$getOwnHostContext(fiber), nextRootInstance = $bcd00faefdd4b5d7$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextStackCursor);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextStackCursor, nextRootInstance);
}
function $bcd00faefdd4b5d7$var$popHostContainer() {
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextStackCursor);
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextFiberStackCursor);
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$rootInstanceStackCursor);
}
function $bcd00faefdd4b5d7$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$hostTransitionProviderCursor, fiber);
    var context = $bcd00faefdd4b5d7$var$contextStackCursor.current;
    var JSCompiler_inline_result = $bcd00faefdd4b5d7$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextFiberStackCursor, fiber), $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextStackCursor, JSCompiler_inline_result));
}
function $bcd00faefdd4b5d7$var$popHostContext(fiber) {
    $bcd00faefdd4b5d7$var$contextFiberStackCursor.current === fiber && ($bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextStackCursor), $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextFiberStackCursor));
    $bcd00faefdd4b5d7$var$hostTransitionProviderCursor.current === fiber && ($bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$hostTransitionProviderCursor), $bcd00faefdd4b5d7$var$HostTransitionContext._currentValue = $bcd00faefdd4b5d7$var$sharedNotPendingObject);
}
var $bcd00faefdd4b5d7$var$hasOwnProperty = Object.prototype.hasOwnProperty, $bcd00faefdd4b5d7$var$scheduleCallback$3 = $go0bk.unstable_scheduleCallback, $bcd00faefdd4b5d7$var$cancelCallback$1 = $go0bk.unstable_cancelCallback, $bcd00faefdd4b5d7$var$shouldYield = $go0bk.unstable_shouldYield, $bcd00faefdd4b5d7$var$requestPaint = $go0bk.unstable_requestPaint, $bcd00faefdd4b5d7$var$now = $go0bk.unstable_now, $bcd00faefdd4b5d7$var$getCurrentPriorityLevel = $go0bk.unstable_getCurrentPriorityLevel, $bcd00faefdd4b5d7$var$ImmediatePriority = $go0bk.unstable_ImmediatePriority, $bcd00faefdd4b5d7$var$UserBlockingPriority = $go0bk.unstable_UserBlockingPriority, $bcd00faefdd4b5d7$var$NormalPriority$1 = $go0bk.unstable_NormalPriority, $bcd00faefdd4b5d7$var$LowPriority = $go0bk.unstable_LowPriority, $bcd00faefdd4b5d7$var$IdlePriority = $go0bk.unstable_IdlePriority, $bcd00faefdd4b5d7$var$log$1 = $go0bk.log, $bcd00faefdd4b5d7$var$unstable_setDisableYieldValue = $go0bk.unstable_setDisableYieldValue, $bcd00faefdd4b5d7$var$rendererID = null, $bcd00faefdd4b5d7$var$injectedHook = null;
function $bcd00faefdd4b5d7$var$onCommitRoot(root) {
    if ($bcd00faefdd4b5d7$var$injectedHook && "function" === typeof $bcd00faefdd4b5d7$var$injectedHook.onCommitFiberRoot) try {
        $bcd00faefdd4b5d7$var$injectedHook.onCommitFiberRoot($bcd00faefdd4b5d7$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $bcd00faefdd4b5d7$var$log$1 && $bcd00faefdd4b5d7$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($bcd00faefdd4b5d7$var$injectedHook && "function" === typeof $bcd00faefdd4b5d7$var$injectedHook.setStrictMode) try {
        $bcd00faefdd4b5d7$var$injectedHook.setStrictMode($bcd00faefdd4b5d7$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $bcd00faefdd4b5d7$var$clz32 = Math.clz32 ? Math.clz32 : $bcd00faefdd4b5d7$var$clz32Fallback, $bcd00faefdd4b5d7$var$log = Math.log, $bcd00faefdd4b5d7$var$LN2 = Math.LN2;
function $bcd00faefdd4b5d7$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($bcd00faefdd4b5d7$var$log(x) / $bcd00faefdd4b5d7$var$LN2 | 0) | 0;
}
var $bcd00faefdd4b5d7$var$nextTransitionLane = 128, $bcd00faefdd4b5d7$var$nextRetryLane = 4194304;
function $bcd00faefdd4b5d7$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $bcd00faefdd4b5d7$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $bcd00faefdd4b5d7$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bcd00faefdd4b5d7$var$claimNextTransitionLane() {
    var lane = $bcd00faefdd4b5d7$var$nextTransitionLane;
    $bcd00faefdd4b5d7$var$nextTransitionLane <<= 1;
    0 === ($bcd00faefdd4b5d7$var$nextTransitionLane & 4194176) && ($bcd00faefdd4b5d7$var$nextTransitionLane = 128);
    return lane;
}
function $bcd00faefdd4b5d7$var$claimNextRetryLane() {
    var lane = $bcd00faefdd4b5d7$var$nextRetryLane;
    $bcd00faefdd4b5d7$var$nextRetryLane <<= 1;
    0 === ($bcd00faefdd4b5d7$var$nextRetryLane & 62914560) && ($bcd00faefdd4b5d7$var$nextRetryLane = 4194304);
    return lane;
}
function $bcd00faefdd4b5d7$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $bcd00faefdd4b5d7$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $bcd00faefdd4b5d7$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $bcd00faefdd4b5d7$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $bcd00faefdd4b5d7$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $bcd00faefdd4b5d7$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $bcd00faefdd4b5d7$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $bcd00faefdd4b5d7$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $bcd00faefdd4b5d7$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $bcd00faefdd4b5d7$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $bcd00faefdd4b5d7$var$resolveUpdatePriority() {
    var updatePriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $bcd00faefdd4b5d7$var$getEventPriority(updatePriority.type);
}
function $bcd00faefdd4b5d7$var$runWithPriority(priority, fn) {
    var previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    try {
        return $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $bcd00faefdd4b5d7$var$randomKey = Math.random().toString(36).slice(2), $bcd00faefdd4b5d7$var$internalInstanceKey = "__reactFiber$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalPropsKey = "__reactProps$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalContainerInstanceKey = "__reactContainer$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalEventHandlersKey = "__reactEvents$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalEventHandlerListenersKey = "__reactListeners$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalEventHandlesSetKey = "__reactHandles$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalRootNodeResourcesKey = "__reactResources$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalHoistableMarker = "__reactMarker$" + $bcd00faefdd4b5d7$var$randomKey;
function $bcd00faefdd4b5d7$var$detachDeletedInstance(node) {
    delete node[$bcd00faefdd4b5d7$var$internalInstanceKey];
    delete node[$bcd00faefdd4b5d7$var$internalPropsKey];
    delete node[$bcd00faefdd4b5d7$var$internalEventHandlersKey];
    delete node[$bcd00faefdd4b5d7$var$internalEventHandlerListenersKey];
    delete node[$bcd00faefdd4b5d7$var$internalEventHandlesSetKey];
}
function $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$bcd00faefdd4b5d7$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$bcd00faefdd4b5d7$var$internalContainerInstanceKey] || parentNode[$bcd00faefdd4b5d7$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $bcd00faefdd4b5d7$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$bcd00faefdd4b5d7$var$internalInstanceKey]) return parentNode;
                targetNode = $bcd00faefdd4b5d7$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$getInstanceFromNode(node) {
    if (node = node[$bcd00faefdd4b5d7$var$internalInstanceKey] || node[$bcd00faefdd4b5d7$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(33));
}
function $bcd00faefdd4b5d7$var$getResourcesFromRoot(root) {
    var resources = root[$bcd00faefdd4b5d7$var$internalRootNodeResourcesKey];
    resources || (resources = root[$bcd00faefdd4b5d7$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $bcd00faefdd4b5d7$var$markNodeAsHoistable(node) {
    node[$bcd00faefdd4b5d7$var$internalHoistableMarker] = !0;
}
var $bcd00faefdd4b5d7$var$allNativeEvents = new Set(), $bcd00faefdd4b5d7$var$registrationNameDependencies = {};
function $bcd00faefdd4b5d7$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $bcd00faefdd4b5d7$var$registerDirectEvent(registrationName, dependencies);
    $bcd00faefdd4b5d7$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $bcd00faefdd4b5d7$var$registerDirectEvent(registrationName, dependencies) {
    $bcd00faefdd4b5d7$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$bcd00faefdd4b5d7$var$allNativeEvents.add(dependencies[registrationName]);
}
var $bcd00faefdd4b5d7$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bcd00faefdd4b5d7$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $bcd00faefdd4b5d7$var$illegalAttributeNameCache = {}, $bcd00faefdd4b5d7$var$validatedAttributeNameCache = {};
function $bcd00faefdd4b5d7$var$isAttributeNameSafe(attributeName) {
    if ($bcd00faefdd4b5d7$var$hasOwnProperty.call($bcd00faefdd4b5d7$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($bcd00faefdd4b5d7$var$hasOwnProperty.call($bcd00faefdd4b5d7$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($bcd00faefdd4b5d7$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $bcd00faefdd4b5d7$var$validatedAttributeNameCache[attributeName] = !0;
    $bcd00faefdd4b5d7$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $bcd00faefdd4b5d7$var$setValueForAttribute(node, name, value) {
    if ($bcd00faefdd4b5d7$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $bcd00faefdd4b5d7$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $bcd00faefdd4b5d7$var$getToStringValue(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $bcd00faefdd4b5d7$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $bcd00faefdd4b5d7$var$trackValueOnNode(node) {
    var valueField = $bcd00faefdd4b5d7$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function get1() {
                return get.call(this);
            },
            set: function set1(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function getValue() {
                return currentValue;
            },
            setValue: function setValue(value) {
                currentValue = "" + value;
            },
            stopTracking: function stopTracking() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $bcd00faefdd4b5d7$var$track(node) {
    node._valueTracker || (node._valueTracker = $bcd00faefdd4b5d7$var$trackValueOnNode(node));
}
function $bcd00faefdd4b5d7$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $bcd00faefdd4b5d7$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $bcd00faefdd4b5d7$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $bcd00faefdd4b5d7$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $bcd00faefdd4b5d7$var$getToStringValue(value);
        } else element.value !== "" + $bcd00faefdd4b5d7$var$getToStringValue(value) && (element.value = "" + $bcd00faefdd4b5d7$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $bcd00faefdd4b5d7$var$setDefaultValue(element, type, $bcd00faefdd4b5d7$var$getToStringValue(value)) : null != defaultValue ? $bcd00faefdd4b5d7$var$setDefaultValue(element, type, $bcd00faefdd4b5d7$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $YtE9h._)(checked)));
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) && "boolean" !== typeof name ? element.name = "" + $bcd00faefdd4b5d7$var$getToStringValue(name) : element.removeAttribute("name");
}
function $bcd00faefdd4b5d7$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $bcd00faefdd4b5d7$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $bcd00faefdd4b5d7$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $YtE9h._)(checked)) && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) && "boolean" !== typeof name && (element.name = name);
}
function $bcd00faefdd4b5d7$var$setDefaultValue(node, type, value) {
    "number" === type && $bcd00faefdd4b5d7$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $bcd00faefdd4b5d7$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $bcd00faefdd4b5d7$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $bcd00faefdd4b5d7$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $bcd00faefdd4b5d7$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $bcd00faefdd4b5d7$var$getToStringValue(defaultValue) : "";
}
function $bcd00faefdd4b5d7$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(92));
            if ($bcd00faefdd4b5d7$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $bcd00faefdd4b5d7$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $bcd00faefdd4b5d7$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $bcd00faefdd4b5d7$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $bcd00faefdd4b5d7$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $bcd00faefdd4b5d7$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $bcd00faefdd4b5d7$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== (typeof styles === "undefined" ? "undefined" : (0, $YtE9h._)(styles))) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $bcd00faefdd4b5d7$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $bcd00faefdd4b5d7$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $bcd00faefdd4b5d7$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bcd00faefdd4b5d7$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $bcd00faefdd4b5d7$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $bcd00faefdd4b5d7$var$sanitizeURL(url) {
    return $bcd00faefdd4b5d7$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $bcd00faefdd4b5d7$var$currentReplayingEvent = null;
function $bcd00faefdd4b5d7$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $bcd00faefdd4b5d7$var$restoreTarget = null, $bcd00faefdd4b5d7$var$restoreQueue = null;
function $bcd00faefdd4b5d7$var$restoreStateOfTarget(target) {
    var internalInstance = $bcd00faefdd4b5d7$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$bcd00faefdd4b5d7$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $bcd00faefdd4b5d7$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$bcd00faefdd4b5d7$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(90));
                            $bcd00faefdd4b5d7$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $bcd00faefdd4b5d7$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $bcd00faefdd4b5d7$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $bcd00faefdd4b5d7$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $bcd00faefdd4b5d7$var$isInsideEventHandler = !1;
function $bcd00faefdd4b5d7$var$batchedUpdates$1(fn, a, b) {
    if ($bcd00faefdd4b5d7$var$isInsideEventHandler) return fn(a, b);
    $bcd00faefdd4b5d7$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($bcd00faefdd4b5d7$var$isInsideEventHandler = !1, null !== $bcd00faefdd4b5d7$var$restoreTarget || null !== $bcd00faefdd4b5d7$var$restoreQueue) {
            if ($bcd00faefdd4b5d7$var$flushSyncWork$1(), $bcd00faefdd4b5d7$var$restoreTarget && (a = $bcd00faefdd4b5d7$var$restoreTarget, fn = $bcd00faefdd4b5d7$var$restoreQueue, $bcd00faefdd4b5d7$var$restoreQueue = $bcd00faefdd4b5d7$var$restoreTarget = null, $bcd00faefdd4b5d7$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$bcd00faefdd4b5d7$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $bcd00faefdd4b5d7$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$bcd00faefdd4b5d7$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(231, registrationName, typeof stateNode === "undefined" ? "undefined" : (0, $YtE9h._)(stateNode)));
    return stateNode;
}
var $bcd00faefdd4b5d7$var$passiveBrowserEventsSupported = !1;
if ($bcd00faefdd4b5d7$var$canUseDOM) try {
    var $bcd00faefdd4b5d7$var$options = {};
    Object.defineProperty($bcd00faefdd4b5d7$var$options, "passive", {
        get: function get() {
            $bcd00faefdd4b5d7$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $bcd00faefdd4b5d7$var$options, $bcd00faefdd4b5d7$var$options);
    window.removeEventListener("test", $bcd00faefdd4b5d7$var$options, $bcd00faefdd4b5d7$var$options);
} catch (e) {
    $bcd00faefdd4b5d7$var$passiveBrowserEventsSupported = !1;
}
var $bcd00faefdd4b5d7$var$root = null, $bcd00faefdd4b5d7$var$startText = null, $bcd00faefdd4b5d7$var$fallbackText = null;
function $bcd00faefdd4b5d7$var$getData() {
    if ($bcd00faefdd4b5d7$var$fallbackText) return $bcd00faefdd4b5d7$var$fallbackText;
    var start, startValue = $bcd00faefdd4b5d7$var$startText, startLength = startValue.length, end, endValue = "value" in $bcd00faefdd4b5d7$var$root ? $bcd00faefdd4b5d7$var$root.value : $bcd00faefdd4b5d7$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $bcd00faefdd4b5d7$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $bcd00faefdd4b5d7$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $bcd00faefdd4b5d7$var$functionThatReturnsTrue() {
    return !0;
}
function $bcd00faefdd4b5d7$var$functionThatReturnsFalse() {
    return !1;
}
function $bcd00faefdd4b5d7$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $bcd00faefdd4b5d7$var$functionThatReturnsTrue : $bcd00faefdd4b5d7$var$functionThatReturnsFalse;
        this.isPropagationStopped = $bcd00faefdd4b5d7$var$functionThatReturnsFalse;
        return this;
    }
    $bcd00faefdd4b5d7$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== (0, $YtE9h._)(event.returnValue) && (event.returnValue = !1), this.isDefaultPrevented = $bcd00faefdd4b5d7$var$functionThatReturnsTrue);
        },
        stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== (0, $YtE9h._)(event.cancelBubble) && (event.cancelBubble = !0), this.isPropagationStopped = $bcd00faefdd4b5d7$var$functionThatReturnsTrue);
        },
        persist: function persist() {},
        isPersistent: $bcd00faefdd4b5d7$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $bcd00faefdd4b5d7$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bcd00faefdd4b5d7$var$SyntheticEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$EventInterface), $bcd00faefdd4b5d7$var$UIEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    view: 0,
    detail: 0
}), $bcd00faefdd4b5d7$var$SyntheticUIEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$UIEventInterface), $bcd00faefdd4b5d7$var$lastMovementX, $bcd00faefdd4b5d7$var$lastMovementY, $bcd00faefdd4b5d7$var$lastMouseEvent, $bcd00faefdd4b5d7$var$MouseEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bcd00faefdd4b5d7$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function movementX(event) {
        if ("movementX" in event) return event.movementX;
        event !== $bcd00faefdd4b5d7$var$lastMouseEvent && ($bcd00faefdd4b5d7$var$lastMouseEvent && "mousemove" === event.type ? ($bcd00faefdd4b5d7$var$lastMovementX = event.screenX - $bcd00faefdd4b5d7$var$lastMouseEvent.screenX, $bcd00faefdd4b5d7$var$lastMovementY = event.screenY - $bcd00faefdd4b5d7$var$lastMouseEvent.screenY) : $bcd00faefdd4b5d7$var$lastMovementY = $bcd00faefdd4b5d7$var$lastMovementX = 0, $bcd00faefdd4b5d7$var$lastMouseEvent = event);
        return $bcd00faefdd4b5d7$var$lastMovementX;
    },
    movementY: function movementY(event) {
        return "movementY" in event ? event.movementY : $bcd00faefdd4b5d7$var$lastMovementY;
    }
}), $bcd00faefdd4b5d7$var$SyntheticMouseEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$MouseEventInterface), $bcd00faefdd4b5d7$var$DragEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$MouseEventInterface, {
    dataTransfer: 0
}), $bcd00faefdd4b5d7$var$SyntheticDragEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$DragEventInterface), $bcd00faefdd4b5d7$var$FocusEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$UIEventInterface, {
    relatedTarget: 0
}), $bcd00faefdd4b5d7$var$SyntheticFocusEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$FocusEventInterface), $bcd00faefdd4b5d7$var$AnimationEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bcd00faefdd4b5d7$var$SyntheticAnimationEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$AnimationEventInterface), $bcd00faefdd4b5d7$var$ClipboardEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    clipboardData: function clipboardData(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $bcd00faefdd4b5d7$var$SyntheticClipboardEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$ClipboardEventInterface), $bcd00faefdd4b5d7$var$CompositionEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    data: 0
}), $bcd00faefdd4b5d7$var$SyntheticCompositionEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$CompositionEventInterface), $bcd00faefdd4b5d7$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bcd00faefdd4b5d7$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bcd00faefdd4b5d7$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bcd00faefdd4b5d7$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $bcd00faefdd4b5d7$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $bcd00faefdd4b5d7$var$getEventModifierState() {
    return $bcd00faefdd4b5d7$var$modifierStateGetter;
}
var $bcd00faefdd4b5d7$var$KeyboardEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$UIEventInterface, {
    key: function key(nativeEvent) {
        if (nativeEvent.key) {
            var key = $bcd00faefdd4b5d7$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $bcd00faefdd4b5d7$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $bcd00faefdd4b5d7$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bcd00faefdd4b5d7$var$getEventModifierState,
    charCode: function charCode(event) {
        return "keypress" === event.type ? $bcd00faefdd4b5d7$var$getEventCharCode(event) : 0;
    },
    keyCode: function keyCode(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function which(event) {
        return "keypress" === event.type ? $bcd00faefdd4b5d7$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $bcd00faefdd4b5d7$var$SyntheticKeyboardEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$KeyboardEventInterface), $bcd00faefdd4b5d7$var$PointerEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bcd00faefdd4b5d7$var$SyntheticPointerEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$PointerEventInterface), $bcd00faefdd4b5d7$var$TouchEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bcd00faefdd4b5d7$var$getEventModifierState
}), $bcd00faefdd4b5d7$var$SyntheticTouchEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$TouchEventInterface), $bcd00faefdd4b5d7$var$TransitionEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bcd00faefdd4b5d7$var$SyntheticTransitionEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$TransitionEventInterface), $bcd00faefdd4b5d7$var$WheelEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$MouseEventInterface, {
    deltaX: function deltaX(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function deltaY(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bcd00faefdd4b5d7$var$SyntheticWheelEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$WheelEventInterface), $bcd00faefdd4b5d7$var$ToggleEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $bcd00faefdd4b5d7$var$SyntheticToggleEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$ToggleEventInterface), $bcd00faefdd4b5d7$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $bcd00faefdd4b5d7$var$canUseCompositionEvent = $bcd00faefdd4b5d7$var$canUseDOM && "CompositionEvent" in window, $bcd00faefdd4b5d7$var$documentMode = null;
$bcd00faefdd4b5d7$var$canUseDOM && "documentMode" in document && ($bcd00faefdd4b5d7$var$documentMode = document.documentMode);
var $bcd00faefdd4b5d7$var$canUseTextInputEvent = $bcd00faefdd4b5d7$var$canUseDOM && "TextEvent" in window && !$bcd00faefdd4b5d7$var$documentMode, $bcd00faefdd4b5d7$var$useFallbackCompositionData = $bcd00faefdd4b5d7$var$canUseDOM && (!$bcd00faefdd4b5d7$var$canUseCompositionEvent || $bcd00faefdd4b5d7$var$documentMode && 8 < $bcd00faefdd4b5d7$var$documentMode && 11 >= $bcd00faefdd4b5d7$var$documentMode), $bcd00faefdd4b5d7$var$SPACEBAR_CHAR = String.fromCharCode(32), $bcd00faefdd4b5d7$var$hasSpaceKeypress = !1;
function $bcd00faefdd4b5d7$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $bcd00faefdd4b5d7$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bcd00faefdd4b5d7$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === (typeof nativeEvent === "undefined" ? "undefined" : (0, $YtE9h._)(nativeEvent)) && "data" in nativeEvent ? nativeEvent.data : null;
}
var $bcd00faefdd4b5d7$var$isComposing = !1;
function $bcd00faefdd4b5d7$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $bcd00faefdd4b5d7$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $bcd00faefdd4b5d7$var$hasSpaceKeypress = !0;
            return $bcd00faefdd4b5d7$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $bcd00faefdd4b5d7$var$SPACEBAR_CHAR && $bcd00faefdd4b5d7$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $bcd00faefdd4b5d7$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($bcd00faefdd4b5d7$var$isComposing) return "compositionend" === domEventName || !$bcd00faefdd4b5d7$var$canUseCompositionEvent && $bcd00faefdd4b5d7$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $bcd00faefdd4b5d7$var$getData(), $bcd00faefdd4b5d7$var$fallbackText = $bcd00faefdd4b5d7$var$startText = $bcd00faefdd4b5d7$var$root = null, $bcd00faefdd4b5d7$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $bcd00faefdd4b5d7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $bcd00faefdd4b5d7$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bcd00faefdd4b5d7$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$bcd00faefdd4b5d7$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $bcd00faefdd4b5d7$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $bcd00faefdd4b5d7$var$restoreTarget ? $bcd00faefdd4b5d7$var$restoreQueue ? $bcd00faefdd4b5d7$var$restoreQueue.push(target) : $bcd00faefdd4b5d7$var$restoreQueue = [
        target
    ] : $bcd00faefdd4b5d7$var$restoreTarget = target;
    inst = $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $bcd00faefdd4b5d7$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $bcd00faefdd4b5d7$var$activeElement$1 = null, $bcd00faefdd4b5d7$var$activeElementInst$1 = null;
function $bcd00faefdd4b5d7$var$runEventInBatch(dispatchQueue) {
    $bcd00faefdd4b5d7$var$processDispatchQueue(dispatchQueue, 0);
}
function $bcd00faefdd4b5d7$var$getInstIfValueChanged(targetInst) {
    var targetNode = $bcd00faefdd4b5d7$var$getNodeFromInstance(targetInst);
    if ($bcd00faefdd4b5d7$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $bcd00faefdd4b5d7$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $bcd00faefdd4b5d7$var$isInputEventSupported = !1;
if ($bcd00faefdd4b5d7$var$canUseDOM) {
    var $bcd00faefdd4b5d7$var$JSCompiler_inline_result$jscomp$283;
    if ($bcd00faefdd4b5d7$var$canUseDOM) {
        var $bcd00faefdd4b5d7$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$bcd00faefdd4b5d7$var$isSupported$jscomp$inline_418) {
            var $bcd00faefdd4b5d7$var$element$jscomp$inline_419 = document.createElement("div");
            $bcd00faefdd4b5d7$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $bcd00faefdd4b5d7$var$isSupported$jscomp$inline_418 = "function" === typeof $bcd00faefdd4b5d7$var$element$jscomp$inline_419.oninput;
        }
        $bcd00faefdd4b5d7$var$JSCompiler_inline_result$jscomp$283 = $bcd00faefdd4b5d7$var$isSupported$jscomp$inline_418;
    } else $bcd00faefdd4b5d7$var$JSCompiler_inline_result$jscomp$283 = !1;
    $bcd00faefdd4b5d7$var$isInputEventSupported = $bcd00faefdd4b5d7$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $bcd00faefdd4b5d7$var$stopWatchingForValueChange() {
    $bcd00faefdd4b5d7$var$activeElement$1 && ($bcd00faefdd4b5d7$var$activeElement$1.detachEvent("onpropertychange", $bcd00faefdd4b5d7$var$handlePropertyChange), $bcd00faefdd4b5d7$var$activeElementInst$1 = $bcd00faefdd4b5d7$var$activeElement$1 = null);
}
function $bcd00faefdd4b5d7$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $bcd00faefdd4b5d7$var$getInstIfValueChanged($bcd00faefdd4b5d7$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $bcd00faefdd4b5d7$var$createAndAccumulateChangeEvent(dispatchQueue, $bcd00faefdd4b5d7$var$activeElementInst$1, nativeEvent, $bcd00faefdd4b5d7$var$getEventTarget(nativeEvent));
        $bcd00faefdd4b5d7$var$batchedUpdates$1($bcd00faefdd4b5d7$var$runEventInBatch, dispatchQueue);
    }
}
function $bcd00faefdd4b5d7$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($bcd00faefdd4b5d7$var$stopWatchingForValueChange(), $bcd00faefdd4b5d7$var$activeElement$1 = target, $bcd00faefdd4b5d7$var$activeElementInst$1 = targetInst, $bcd00faefdd4b5d7$var$activeElement$1.attachEvent("onpropertychange", $bcd00faefdd4b5d7$var$handlePropertyChange)) : "focusout" === domEventName && $bcd00faefdd4b5d7$var$stopWatchingForValueChange();
}
function $bcd00faefdd4b5d7$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $bcd00faefdd4b5d7$var$getInstIfValueChanged($bcd00faefdd4b5d7$var$activeElementInst$1);
}
function $bcd00faefdd4b5d7$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $bcd00faefdd4b5d7$var$getInstIfValueChanged(targetInst);
}
function $bcd00faefdd4b5d7$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $bcd00faefdd4b5d7$var$getInstIfValueChanged(targetInst);
}
function $bcd00faefdd4b5d7$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $bcd00faefdd4b5d7$var$objectIs = "function" === typeof Object.is ? Object.is : $bcd00faefdd4b5d7$var$is;
function $bcd00faefdd4b5d7$var$shallowEqual(objA, objB) {
    if ($bcd00faefdd4b5d7$var$objectIs(objA, objB)) return !0;
    if ("object" !== (typeof objA === "undefined" ? "undefined" : (0, $YtE9h._)(objA)) || null === objA || "object" !== (typeof objB === "undefined" ? "undefined" : (0, $YtE9h._)(objB)) || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$bcd00faefdd4b5d7$var$hasOwnProperty.call(objB, currentKey) || !$bcd00faefdd4b5d7$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $bcd00faefdd4b5d7$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $bcd00faefdd4b5d7$var$getNodeForCharacterOffset(root, offset) {
    var node = $bcd00faefdd4b5d7$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $bcd00faefdd4b5d7$var$getLeafNode(node);
    }
}
function $bcd00faefdd4b5d7$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $bcd00faefdd4b5d7$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $bcd00faefdd4b5d7$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $bcd00faefdd4b5d7$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $bcd00faefdd4b5d7$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $bcd00faefdd4b5d7$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $bcd00faefdd4b5d7$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $bcd00faefdd4b5d7$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $bcd00faefdd4b5d7$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $bcd00faefdd4b5d7$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $bcd00faefdd4b5d7$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $bcd00faefdd4b5d7$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $bcd00faefdd4b5d7$var$skipSelectionChangeEvent = $bcd00faefdd4b5d7$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $bcd00faefdd4b5d7$var$activeElement = null, $bcd00faefdd4b5d7$var$activeElementInst = null, $bcd00faefdd4b5d7$var$lastSelection = null, $bcd00faefdd4b5d7$var$mouseDown = !1;
function $bcd00faefdd4b5d7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $bcd00faefdd4b5d7$var$mouseDown || null == $bcd00faefdd4b5d7$var$activeElement || $bcd00faefdd4b5d7$var$activeElement !== $bcd00faefdd4b5d7$var$getActiveElement(doc) || (doc = $bcd00faefdd4b5d7$var$activeElement, "selectionStart" in doc && $bcd00faefdd4b5d7$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $bcd00faefdd4b5d7$var$lastSelection && $bcd00faefdd4b5d7$var$shallowEqual($bcd00faefdd4b5d7$var$lastSelection, doc) || ($bcd00faefdd4b5d7$var$lastSelection = doc, doc = $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners($bcd00faefdd4b5d7$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $bcd00faefdd4b5d7$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $bcd00faefdd4b5d7$var$activeElement)));
}
function $bcd00faefdd4b5d7$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $bcd00faefdd4b5d7$var$vendorPrefixes = {
    animationend: $bcd00faefdd4b5d7$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $bcd00faefdd4b5d7$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $bcd00faefdd4b5d7$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $bcd00faefdd4b5d7$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $bcd00faefdd4b5d7$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $bcd00faefdd4b5d7$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $bcd00faefdd4b5d7$var$makePrefixMap("Transition", "TransitionEnd")
}, $bcd00faefdd4b5d7$var$prefixedEventNames = {}, $bcd00faefdd4b5d7$var$style = {};
$bcd00faefdd4b5d7$var$canUseDOM && ($bcd00faefdd4b5d7$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $bcd00faefdd4b5d7$var$vendorPrefixes.animationend.animation, delete $bcd00faefdd4b5d7$var$vendorPrefixes.animationiteration.animation, delete $bcd00faefdd4b5d7$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $bcd00faefdd4b5d7$var$vendorPrefixes.transitionend.transition);
function $bcd00faefdd4b5d7$var$getVendorPrefixedEventName(eventName) {
    if ($bcd00faefdd4b5d7$var$prefixedEventNames[eventName]) return $bcd00faefdd4b5d7$var$prefixedEventNames[eventName];
    if (!$bcd00faefdd4b5d7$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $bcd00faefdd4b5d7$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $bcd00faefdd4b5d7$var$style) return $bcd00faefdd4b5d7$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $bcd00faefdd4b5d7$var$ANIMATION_END = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("animationend"), $bcd00faefdd4b5d7$var$ANIMATION_ITERATION = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("animationiteration"), $bcd00faefdd4b5d7$var$ANIMATION_START = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("animationstart"), $bcd00faefdd4b5d7$var$TRANSITION_RUN = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("transitionrun"), $bcd00faefdd4b5d7$var$TRANSITION_START = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("transitionstart"), $bcd00faefdd4b5d7$var$TRANSITION_CANCEL = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("transitioncancel"), $bcd00faefdd4b5d7$var$TRANSITION_END = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("transitionend"), $bcd00faefdd4b5d7$var$topLevelEventsToReactNames = new Map(), $bcd00faefdd4b5d7$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $bcd00faefdd4b5d7$var$registerSimpleEvent(domEventName, reactName) {
    $bcd00faefdd4b5d7$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $bcd00faefdd4b5d7$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $bcd00faefdd4b5d7$var$concurrentQueues = [], $bcd00faefdd4b5d7$var$concurrentQueuesIndex = 0, $bcd00faefdd4b5d7$var$concurrentlyUpdatedLanes = 0;
function $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $bcd00faefdd4b5d7$var$concurrentQueuesIndex, i = $bcd00faefdd4b5d7$var$concurrentlyUpdatedLanes = $bcd00faefdd4b5d7$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $bcd00faefdd4b5d7$var$concurrentQueues[i];
        $bcd00faefdd4b5d7$var$concurrentQueues[i++] = null;
        var queue = $bcd00faefdd4b5d7$var$concurrentQueues[i];
        $bcd00faefdd4b5d7$var$concurrentQueues[i++] = null;
        var update = $bcd00faefdd4b5d7$var$concurrentQueues[i];
        $bcd00faefdd4b5d7$var$concurrentQueues[i++] = null;
        var lane = $bcd00faefdd4b5d7$var$concurrentQueues[i];
        $bcd00faefdd4b5d7$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $bcd00faefdd4b5d7$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $bcd00faefdd4b5d7$var$concurrentQueues[$bcd00faefdd4b5d7$var$concurrentQueuesIndex++] = fiber;
    $bcd00faefdd4b5d7$var$concurrentQueues[$bcd00faefdd4b5d7$var$concurrentQueuesIndex++] = queue;
    $bcd00faefdd4b5d7$var$concurrentQueues[$bcd00faefdd4b5d7$var$concurrentQueuesIndex++] = update;
    $bcd00faefdd4b5d7$var$concurrentQueues[$bcd00faefdd4b5d7$var$concurrentQueuesIndex++] = lane;
    $bcd00faefdd4b5d7$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $bcd00faefdd4b5d7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(fiber);
}
function $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, null, null, lane);
    return $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(fiber);
}
function $bcd00faefdd4b5d7$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $bcd00faefdd4b5d7$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $bcd00faefdd4b5d7$var$nestedUpdateCount) throw $bcd00faefdd4b5d7$var$nestedUpdateCount = 0, $bcd00faefdd4b5d7$var$rootWithNestedUpdates = null, Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $bcd00faefdd4b5d7$var$emptyContextObject = {}, $bcd00faefdd4b5d7$var$CapturedStacks = new WeakMap();
function $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(value, source) {
    if ("object" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) && null !== value) {
        var existing = $bcd00faefdd4b5d7$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $bcd00faefdd4b5d7$var$getStackByFiberInDevAndProd(source)
        };
        $bcd00faefdd4b5d7$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $bcd00faefdd4b5d7$var$getStackByFiberInDevAndProd(source)
    };
}
var $bcd00faefdd4b5d7$var$forkStack = [], $bcd00faefdd4b5d7$var$forkStackIndex = 0, $bcd00faefdd4b5d7$var$treeForkProvider = null, $bcd00faefdd4b5d7$var$treeForkCount = 0, $bcd00faefdd4b5d7$var$idStack = [], $bcd00faefdd4b5d7$var$idStackIndex = 0, $bcd00faefdd4b5d7$var$treeContextProvider = null, $bcd00faefdd4b5d7$var$treeContextId = 1, $bcd00faefdd4b5d7$var$treeContextOverflow = "";
function $bcd00faefdd4b5d7$var$pushTreeFork(workInProgress, totalChildren) {
    $bcd00faefdd4b5d7$var$forkStack[$bcd00faefdd4b5d7$var$forkStackIndex++] = $bcd00faefdd4b5d7$var$treeForkCount;
    $bcd00faefdd4b5d7$var$forkStack[$bcd00faefdd4b5d7$var$forkStackIndex++] = $bcd00faefdd4b5d7$var$treeForkProvider;
    $bcd00faefdd4b5d7$var$treeForkProvider = workInProgress;
    $bcd00faefdd4b5d7$var$treeForkCount = totalChildren;
}
function $bcd00faefdd4b5d7$var$pushTreeId(workInProgress, totalChildren, index) {
    $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextId;
    $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextOverflow;
    $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextProvider;
    $bcd00faefdd4b5d7$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $bcd00faefdd4b5d7$var$treeContextId;
    workInProgress = $bcd00faefdd4b5d7$var$treeContextOverflow;
    var baseLength = 32 - $bcd00faefdd4b5d7$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $bcd00faefdd4b5d7$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $bcd00faefdd4b5d7$var$treeContextId = 1 << 32 - $bcd00faefdd4b5d7$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $bcd00faefdd4b5d7$var$treeContextOverflow = length + workInProgress;
    } else $bcd00faefdd4b5d7$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $bcd00faefdd4b5d7$var$treeContextOverflow = workInProgress;
}
function $bcd00faefdd4b5d7$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($bcd00faefdd4b5d7$var$pushTreeFork(workInProgress, 1), $bcd00faefdd4b5d7$var$pushTreeId(workInProgress, 1, 0));
}
function $bcd00faefdd4b5d7$var$popTreeContext(workInProgress) {
    for(; workInProgress === $bcd00faefdd4b5d7$var$treeForkProvider;)$bcd00faefdd4b5d7$var$treeForkProvider = $bcd00faefdd4b5d7$var$forkStack[--$bcd00faefdd4b5d7$var$forkStackIndex], $bcd00faefdd4b5d7$var$forkStack[$bcd00faefdd4b5d7$var$forkStackIndex] = null, $bcd00faefdd4b5d7$var$treeForkCount = $bcd00faefdd4b5d7$var$forkStack[--$bcd00faefdd4b5d7$var$forkStackIndex], $bcd00faefdd4b5d7$var$forkStack[$bcd00faefdd4b5d7$var$forkStackIndex] = null;
    for(; workInProgress === $bcd00faefdd4b5d7$var$treeContextProvider;)$bcd00faefdd4b5d7$var$treeContextProvider = $bcd00faefdd4b5d7$var$idStack[--$bcd00faefdd4b5d7$var$idStackIndex], $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex] = null, $bcd00faefdd4b5d7$var$treeContextOverflow = $bcd00faefdd4b5d7$var$idStack[--$bcd00faefdd4b5d7$var$idStackIndex], $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex] = null, $bcd00faefdd4b5d7$var$treeContextId = $bcd00faefdd4b5d7$var$idStack[--$bcd00faefdd4b5d7$var$idStackIndex], $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex] = null;
}
var $bcd00faefdd4b5d7$var$hydrationParentFiber = null, $bcd00faefdd4b5d7$var$nextHydratableInstance = null, $bcd00faefdd4b5d7$var$isHydrating = !1, $bcd00faefdd4b5d7$var$hydrationErrors = null, $bcd00faefdd4b5d7$var$rootOrSingletonContext = !1, $bcd00faefdd4b5d7$var$HydrationMismatchException = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(519));
function $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(fiber) {
    var error = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(418, ""));
    $bcd00faefdd4b5d7$var$queueHydrationError($bcd00faefdd4b5d7$var$createCapturedValueAtFiber(error, fiber));
    throw $bcd00faefdd4b5d7$var$HydrationMismatchException;
}
function $bcd00faefdd4b5d7$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$bcd00faefdd4b5d7$var$internalInstanceKey] = fiber;
    instance[$bcd00faefdd4b5d7$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("cancel", instance);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $bcd00faefdd4b5d7$var$mediaEventTypes.length; type++)$bcd00faefdd4b5d7$var$listenToNonDelegatedEvent($bcd00faefdd4b5d7$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", instance);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", instance);
            $bcd00faefdd4b5d7$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $bcd00faefdd4b5d7$var$track(instance);
            break;
        case "select":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", instance), $bcd00faefdd4b5d7$var$initTextarea(instance, props.value, props.defaultValue, props.children), $bcd00faefdd4b5d7$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $bcd00faefdd4b5d7$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("beforetoggle", instance), $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $bcd00faefdd4b5d7$var$noop$1), instance = !0) : instance = !1;
    instance || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(fiber);
}
function $bcd00faefdd4b5d7$var$popToNextHostParent(fiber) {
    for($bcd00faefdd4b5d7$var$hydrationParentFiber = fiber.return; $bcd00faefdd4b5d7$var$hydrationParentFiber;)switch($bcd00faefdd4b5d7$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $bcd00faefdd4b5d7$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $bcd00faefdd4b5d7$var$rootOrSingletonContext = !1;
            return;
        default:
            $bcd00faefdd4b5d7$var$hydrationParentFiber = $bcd00faefdd4b5d7$var$hydrationParentFiber.return;
    }
}
function $bcd00faefdd4b5d7$var$popHydrationState(fiber) {
    if (fiber !== $bcd00faefdd4b5d7$var$hydrationParentFiber) return !1;
    if (!$bcd00faefdd4b5d7$var$isHydrating) return $bcd00faefdd4b5d7$var$popToNextHostParent(fiber), $bcd00faefdd4b5d7$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $bcd00faefdd4b5d7$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $bcd00faefdd4b5d7$var$nextHydratableInstance && $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(fiber);
    $bcd00faefdd4b5d7$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $bcd00faefdd4b5d7$var$nextHydratableInstance = null;
        }
    } else $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$hydrationParentFiber ? $bcd00faefdd4b5d7$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $bcd00faefdd4b5d7$var$resetHydrationState() {
    $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$hydrationParentFiber = null;
    $bcd00faefdd4b5d7$var$isHydrating = !1;
}
function $bcd00faefdd4b5d7$var$queueHydrationError(error) {
    null === $bcd00faefdd4b5d7$var$hydrationErrors ? $bcd00faefdd4b5d7$var$hydrationErrors = [
        error
    ] : $bcd00faefdd4b5d7$var$hydrationErrors.push(error);
}
var $bcd00faefdd4b5d7$var$SuspenseException = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(460)), $bcd00faefdd4b5d7$var$SuspenseyCommitException = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(474)), $bcd00faefdd4b5d7$var$noopSuspenseyCommitThenable = {
    then: function then() {}
};
function $bcd00faefdd4b5d7$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $bcd00faefdd4b5d7$var$noop$3() {}
function $bcd00faefdd4b5d7$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($bcd00faefdd4b5d7$var$noop$3, $bcd00faefdd4b5d7$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $bcd00faefdd4b5d7$var$SuspenseException) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($bcd00faefdd4b5d7$var$noop$3, $bcd00faefdd4b5d7$var$noop$3);
            else {
                thenableState = $bcd00faefdd4b5d7$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $bcd00faefdd4b5d7$var$SuspenseException) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $bcd00faefdd4b5d7$var$suspendedThenable = thenable;
            throw $bcd00faefdd4b5d7$var$SuspenseException;
    }
}
var $bcd00faefdd4b5d7$var$suspendedThenable = null;
function $bcd00faefdd4b5d7$var$getSuspendedThenable() {
    if (null === $bcd00faefdd4b5d7$var$suspendedThenable) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(459));
    var thenable = $bcd00faefdd4b5d7$var$suspendedThenable;
    $bcd00faefdd4b5d7$var$suspendedThenable = null;
    return thenable;
}
var $bcd00faefdd4b5d7$var$thenableState$1 = null, $bcd00faefdd4b5d7$var$thenableIndexCounter$1 = 0;
function $bcd00faefdd4b5d7$var$unwrapThenable(thenable) {
    var index = $bcd00faefdd4b5d7$var$thenableIndexCounter$1;
    $bcd00faefdd4b5d7$var$thenableIndexCounter$1 += 1;
    null === $bcd00faefdd4b5d7$var$thenableState$1 && ($bcd00faefdd4b5d7$var$thenableState$1 = []);
    return $bcd00faefdd4b5d7$var$trackUsedThenable($bcd00faefdd4b5d7$var$thenableState$1, thenable, index);
}
function $bcd00faefdd4b5d7$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $bcd00faefdd4b5d7$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $bcd00faefdd4b5d7$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $bcd00faefdd4b5d7$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $bcd00faefdd4b5d7$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === (typeof elementType === "undefined" ? "undefined" : (0, $YtE9h._)(elementType)) && null !== elementType && elementType.$$typeof === $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE && $bcd00faefdd4b5d7$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $bcd00faefdd4b5d7$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $bcd00faefdd4b5d7$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $bcd00faefdd4b5d7$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $bcd00faefdd4b5d7$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild))) return newChild = $bcd00faefdd4b5d7$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE:
                    return lanes = $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $bcd00faefdd4b5d7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
                    return newChild = $bcd00faefdd4b5d7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($bcd00faefdd4b5d7$var$isArrayImpl(newChild) || $bcd00faefdd4b5d7$var$getIteratorFn(newChild)) return newChild = $bcd00faefdd4b5d7$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $bcd00faefdd4b5d7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $bcd00faefdd4b5d7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild))) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($bcd00faefdd4b5d7$var$isArrayImpl(newChild) || $bcd00faefdd4b5d7$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $bcd00faefdd4b5d7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $bcd00faefdd4b5d7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild))) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($bcd00faefdd4b5d7$var$isArrayImpl(newChild) || $bcd00faefdd4b5d7$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $bcd00faefdd4b5d7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $bcd00faefdd4b5d7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild && newChild.type === $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) && null !== key && key.$$typeof === $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE && $bcd00faefdd4b5d7$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $bcd00faefdd4b5d7$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE ? (lanes = $bcd00faefdd4b5d7$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $bcd00faefdd4b5d7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $bcd00faefdd4b5d7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($bcd00faefdd4b5d7$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($bcd00faefdd4b5d7$var$getIteratorFn(newChild)) {
                key = $bcd00faefdd4b5d7$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $bcd00faefdd4b5d7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $bcd00faefdd4b5d7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $bcd00faefdd4b5d7$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $bcd00faefdd4b5d7$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $bcd00faefdd4b5d7$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $bcd00faefdd4b5d7$var$SuspenseException) throw x;
            var fiber = $bcd00faefdd4b5d7$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $bcd00faefdd4b5d7$var$reconcileChildFibers = $bcd00faefdd4b5d7$var$createChildReconciler(!0), $bcd00faefdd4b5d7$var$mountChildFibers = $bcd00faefdd4b5d7$var$createChildReconciler(!1), $bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor = $bcd00faefdd4b5d7$var$createCursor(0);
function $bcd00faefdd4b5d7$var$pushHiddenContext(fiber, context) {
    fiber = $bcd00faefdd4b5d7$var$entangledRenderLanes;
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor, fiber);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor, context);
    $bcd00faefdd4b5d7$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $bcd00faefdd4b5d7$var$reuseHiddenContextOnStack() {
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor, $bcd00faefdd4b5d7$var$entangledRenderLanes);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor, $bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor.current);
}
function $bcd00faefdd4b5d7$var$popHiddenContext() {
    $bcd00faefdd4b5d7$var$entangledRenderLanes = $bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor.current;
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor);
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor);
}
var $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$shellBoundary = null;
function $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current & 1);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseHandlerStackCursor, handler);
    null === $bcd00faefdd4b5d7$var$shellBoundary && (null === current || null !== $bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor.current ? $bcd00faefdd4b5d7$var$shellBoundary = handler : null !== current.memoizedState && ($bcd00faefdd4b5d7$var$shellBoundary = handler));
}
function $bcd00faefdd4b5d7$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current), $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseHandlerStackCursor, fiber), null === $bcd00faefdd4b5d7$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($bcd00faefdd4b5d7$var$shellBoundary = fiber);
        }
    } else $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(fiber);
}
function $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack() {
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseHandlerStackCursor, $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current);
}
function $bcd00faefdd4b5d7$var$popSuspenseHandler(fiber) {
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseHandlerStackCursor);
    $bcd00faefdd4b5d7$var$shellBoundary === fiber && ($bcd00faefdd4b5d7$var$shellBoundary = null);
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseStackCursor);
}
var $bcd00faefdd4b5d7$var$suspenseStackCursor = $bcd00faefdd4b5d7$var$createCursor(0);
function $bcd00faefdd4b5d7$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $bcd00faefdd4b5d7$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function AbortControllerLocal() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function addEventListener(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $bcd00faefdd4b5d7$var$scheduleCallback$2 = $go0bk.unstable_scheduleCallback, $bcd00faefdd4b5d7$var$NormalPriority = $go0bk.unstable_NormalPriority, $bcd00faefdd4b5d7$var$CacheContext = {
    $$typeof: $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $bcd00faefdd4b5d7$var$createCache() {
    return {
        controller: new $bcd00faefdd4b5d7$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $bcd00faefdd4b5d7$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $bcd00faefdd4b5d7$var$scheduleCallback$2($bcd00faefdd4b5d7$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $bcd00faefdd4b5d7$var$currentEntangledListeners = null, $bcd00faefdd4b5d7$var$currentEntangledPendingCount = 0, $bcd00faefdd4b5d7$var$currentEntangledLane = 0, $bcd00faefdd4b5d7$var$currentEntangledActionThenable = null;
function $bcd00faefdd4b5d7$var$entangleAsyncAction(transition, thenable) {
    if (null === $bcd00faefdd4b5d7$var$currentEntangledListeners) {
        var entangledListeners = $bcd00faefdd4b5d7$var$currentEntangledListeners = [];
        $bcd00faefdd4b5d7$var$currentEntangledPendingCount = 0;
        $bcd00faefdd4b5d7$var$currentEntangledLane = $bcd00faefdd4b5d7$var$requestTransitionLane();
        $bcd00faefdd4b5d7$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function then(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $bcd00faefdd4b5d7$var$currentEntangledPendingCount++;
    thenable.then($bcd00faefdd4b5d7$var$pingEngtangledActionScope, $bcd00faefdd4b5d7$var$pingEngtangledActionScope);
    return thenable;
}
function $bcd00faefdd4b5d7$var$pingEngtangledActionScope() {
    if (0 === --$bcd00faefdd4b5d7$var$currentEntangledPendingCount && null !== $bcd00faefdd4b5d7$var$currentEntangledListeners) {
        null !== $bcd00faefdd4b5d7$var$currentEntangledActionThenable && ($bcd00faefdd4b5d7$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $bcd00faefdd4b5d7$var$currentEntangledListeners;
        $bcd00faefdd4b5d7$var$currentEntangledListeners = null;
        $bcd00faefdd4b5d7$var$currentEntangledLane = 0;
        $bcd00faefdd4b5d7$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $bcd00faefdd4b5d7$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function then(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $bcd00faefdd4b5d7$var$prevOnStartTransitionFinish = $bcd00faefdd4b5d7$var$ReactSharedInternals.S;
$bcd00faefdd4b5d7$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $YtE9h._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && $bcd00faefdd4b5d7$var$entangleAsyncAction(transition, returnValue);
    null !== $bcd00faefdd4b5d7$var$prevOnStartTransitionFinish && $bcd00faefdd4b5d7$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $bcd00faefdd4b5d7$var$resumedCache = $bcd00faefdd4b5d7$var$createCursor(null);
function $bcd00faefdd4b5d7$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $bcd00faefdd4b5d7$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $bcd00faefdd4b5d7$var$workInProgressRoot.pooledCache;
}
function $bcd00faefdd4b5d7$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$resumedCache, $bcd00faefdd4b5d7$var$resumedCache.current) : $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$resumedCache, prevCachePool.pool);
}
function $bcd00faefdd4b5d7$var$getSuspendedCache() {
    var cacheFromPool = $bcd00faefdd4b5d7$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $bcd00faefdd4b5d7$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $bcd00faefdd4b5d7$var$renderLanes = 0, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = null, $bcd00faefdd4b5d7$var$currentHook = null, $bcd00faefdd4b5d7$var$workInProgressHook = null, $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate = !1, $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $bcd00faefdd4b5d7$var$localIdCounter = 0, $bcd00faefdd4b5d7$var$thenableIndexCounter = 0, $bcd00faefdd4b5d7$var$thenableState = null, $bcd00faefdd4b5d7$var$globalClientIdCounter = 0;
function $bcd00faefdd4b5d7$var$throwInvalidHookError() {
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(321));
}
function $bcd00faefdd4b5d7$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$bcd00faefdd4b5d7$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $bcd00faefdd4b5d7$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $bcd00faefdd4b5d7$var$renderLanes = nextRenderLanes;
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $bcd00faefdd4b5d7$var$HooksDispatcherOnMount : $bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate;
    $bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $bcd00faefdd4b5d7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $bcd00faefdd4b5d7$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $bcd00faefdd4b5d7$var$finishRenderingHooks(current) {
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = $bcd00faefdd4b5d7$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $bcd00faefdd4b5d7$var$currentHook && null !== $bcd00faefdd4b5d7$var$currentHook.next;
    $bcd00faefdd4b5d7$var$renderLanes = 0;
    $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$currentHook = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = null;
    $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate = !1;
    $bcd00faefdd4b5d7$var$thenableIndexCounter = 0;
    $bcd00faefdd4b5d7$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(300));
    null === current || $bcd00faefdd4b5d7$var$didReceiveUpdate || (current = current.dependencies, null !== current && $bcd00faefdd4b5d7$var$checkIfContextChanged(current) && ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0));
}
function $bcd00faefdd4b5d7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass && ($bcd00faefdd4b5d7$var$thenableState = null);
        $bcd00faefdd4b5d7$var$thenableIndexCounter = 0;
        $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $bcd00faefdd4b5d7$var$ReactSharedInternals.H = $bcd00faefdd4b5d7$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $bcd00faefdd4b5d7$var$TransitionAwareHostComponent() {
    var dispatcher = $bcd00faefdd4b5d7$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $bcd00faefdd4b5d7$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $bcd00faefdd4b5d7$var$currentHook ? $bcd00faefdd4b5d7$var$currentHook.memoizedState : null) !== dispatcher && ($bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $bcd00faefdd4b5d7$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $bcd00faefdd4b5d7$var$localIdCounter;
    $bcd00faefdd4b5d7$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $bcd00faefdd4b5d7$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $bcd00faefdd4b5d7$var$resetHooksOnUnwind(workInProgress) {
    if ($bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate = !1;
    }
    $bcd00faefdd4b5d7$var$renderLanes = 0;
    $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$currentHook = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = null;
    $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $bcd00faefdd4b5d7$var$thenableIndexCounter = $bcd00faefdd4b5d7$var$localIdCounter = 0;
    $bcd00faefdd4b5d7$var$thenableState = null;
}
function $bcd00faefdd4b5d7$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bcd00faefdd4b5d7$var$workInProgressHook ? $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.memoizedState = $bcd00faefdd4b5d7$var$workInProgressHook = hook : $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$workInProgressHook.next = hook;
    return $bcd00faefdd4b5d7$var$workInProgressHook;
}
function $bcd00faefdd4b5d7$var$updateWorkInProgressHook() {
    if (null === $bcd00faefdd4b5d7$var$currentHook) {
        var nextCurrentHook = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $bcd00faefdd4b5d7$var$currentHook.next;
    var nextWorkInProgressHook = null === $bcd00faefdd4b5d7$var$workInProgressHook ? $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.memoizedState : $bcd00faefdd4b5d7$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $bcd00faefdd4b5d7$var$workInProgressHook = nextWorkInProgressHook, $bcd00faefdd4b5d7$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.alternate) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(467));
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(310));
        }
        $bcd00faefdd4b5d7$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $bcd00faefdd4b5d7$var$currentHook.memoizedState,
            baseState: $bcd00faefdd4b5d7$var$currentHook.baseState,
            baseQueue: $bcd00faefdd4b5d7$var$currentHook.baseQueue,
            queue: $bcd00faefdd4b5d7$var$currentHook.queue,
            next: null
        };
        null === $bcd00faefdd4b5d7$var$workInProgressHook ? $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.memoizedState = $bcd00faefdd4b5d7$var$workInProgressHook = nextCurrentHook : $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$workInProgressHook.next = nextCurrentHook;
    }
    return $bcd00faefdd4b5d7$var$workInProgressHook;
}
var $bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue;
$bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue = function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $bcd00faefdd4b5d7$var$useThenable(thenable) {
    var index = $bcd00faefdd4b5d7$var$thenableIndexCounter;
    $bcd00faefdd4b5d7$var$thenableIndexCounter += 1;
    null === $bcd00faefdd4b5d7$var$thenableState && ($bcd00faefdd4b5d7$var$thenableState = []);
    thenable = $bcd00faefdd4b5d7$var$trackUsedThenable($bcd00faefdd4b5d7$var$thenableState, thenable, index);
    index = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1;
    null === (null === $bcd00faefdd4b5d7$var$workInProgressHook ? index.memoizedState : $bcd00faefdd4b5d7$var$workInProgressHook.next) && (index = index.alternate, $bcd00faefdd4b5d7$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $bcd00faefdd4b5d7$var$HooksDispatcherOnMount : $bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $bcd00faefdd4b5d7$var$use(usable) {
    if (null !== usable && "object" === (typeof usable === "undefined" ? "undefined" : (0, $YtE9h._)(usable))) {
        if ("function" === typeof usable.then) return $bcd00faefdd4b5d7$var$useThenable(usable);
        if (usable.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return $bcd00faefdd4b5d7$var$readContext(usable);
    }
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(438, String(usable)));
}
function $bcd00faefdd4b5d7$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue(), $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $bcd00faefdd4b5d7$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $bcd00faefdd4b5d7$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $bcd00faefdd4b5d7$var$updateReducer(reducer) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    return $bcd00faefdd4b5d7$var$updateReducerImpl(hook, $bcd00faefdd4b5d7$var$currentHook, reducer);
}
function $bcd00faefdd4b5d7$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($bcd00faefdd4b5d7$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $bcd00faefdd4b5d7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($bcd00faefdd4b5d7$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $bcd00faefdd4b5d7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.lanes |= revertLane, $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.lanes |= updateLane, $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$bcd00faefdd4b5d7$var$objectIs(pendingQueue, hook.memoizedState) && ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $bcd00faefdd4b5d7$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $bcd00faefdd4b5d7$var$rerenderReducer(reducer) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $bcd00faefdd4b5d7$var$objectIs(newState, hook.memoizedState) || ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $bcd00faefdd4b5d7$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $bcd00faefdd4b5d7$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$bcd00faefdd4b5d7$var$objectIs(($bcd00faefdd4b5d7$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $bcd00faefdd4b5d7$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $bcd00faefdd4b5d7$var$updateEffect($bcd00faefdd4b5d7$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $bcd00faefdd4b5d7$var$workInProgressHook && $bcd00faefdd4b5d7$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $bcd00faefdd4b5d7$var$pushEffect(9, $bcd00faefdd4b5d7$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $bcd00faefdd4b5d7$var$workInProgressRoot) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($bcd00faefdd4b5d7$var$renderLanes & 60) || $bcd00faefdd4b5d7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $bcd00faefdd4b5d7$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue(), $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $bcd00faefdd4b5d7$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $bcd00faefdd4b5d7$var$checkIfSnapshotChanged(inst) && $bcd00faefdd4b5d7$var$forceStoreRerender(fiber);
}
function $bcd00faefdd4b5d7$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $bcd00faefdd4b5d7$var$checkIfSnapshotChanged(inst) && $bcd00faefdd4b5d7$var$forceStoreRerender(fiber);
    });
}
function $bcd00faefdd4b5d7$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$bcd00faefdd4b5d7$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $bcd00faefdd4b5d7$var$forceStoreRerender(fiber) {
    var root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $bcd00faefdd4b5d7$var$mountStateImpl(initialState) {
    var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bcd00faefdd4b5d7$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $bcd00faefdd4b5d7$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $bcd00faefdd4b5d7$var$updateReducerImpl(hook, $bcd00faefdd4b5d7$var$currentHook, "function" === typeof reducer ? reducer : $bcd00faefdd4b5d7$var$basicStateReducer);
}
function $bcd00faefdd4b5d7$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function then(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $bcd00faefdd4b5d7$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $bcd00faefdd4b5d7$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $bcd00faefdd4b5d7$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, currentTransition = {};
        $bcd00faefdd4b5d7$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $bcd00faefdd4b5d7$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $bcd00faefdd4b5d7$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $bcd00faefdd4b5d7$var$onActionError(actionQueue, node, error);
        } finally{
            $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $bcd00faefdd4b5d7$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $bcd00faefdd4b5d7$var$onActionError(actionQueue, node, error$60);
    }
}
function $bcd00faefdd4b5d7$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $YtE9h._)(returnValue)) && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $bcd00faefdd4b5d7$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $bcd00faefdd4b5d7$var$onActionError(actionQueue, node, error);
    }) : $bcd00faefdd4b5d7$var$onActionSuccess(actionQueue, node, returnValue);
}
function $bcd00faefdd4b5d7$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $bcd00faefdd4b5d7$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $bcd00faefdd4b5d7$var$runActionStateAction(actionQueue, nextState)));
}
function $bcd00faefdd4b5d7$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $bcd00faefdd4b5d7$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $bcd00faefdd4b5d7$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $bcd00faefdd4b5d7$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $bcd00faefdd4b5d7$var$mountActionState(action, initialStateProp) {
    if ($bcd00faefdd4b5d7$var$isHydrating) {
        var ssrFormState = $bcd00faefdd4b5d7$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1;
                if ($bcd00faefdd4b5d7$var$isHydrating) {
                    if ($bcd00faefdd4b5d7$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $bcd00faefdd4b5d7$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $bcd00faefdd4b5d7$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $bcd00faefdd4b5d7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bcd00faefdd4b5d7$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $bcd00faefdd4b5d7$var$dispatchSetState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $bcd00faefdd4b5d7$var$mountStateImpl(!1);
    inRootOrSingleton = $bcd00faefdd4b5d7$var$dispatchOptimisticSetState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $bcd00faefdd4b5d7$var$dispatchActionState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $bcd00faefdd4b5d7$var$updateActionState(action) {
    var stateHook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    return $bcd00faefdd4b5d7$var$updateActionStateImpl(stateHook, $bcd00faefdd4b5d7$var$currentHook, action);
}
function $bcd00faefdd4b5d7$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $bcd00faefdd4b5d7$var$updateReducerImpl(stateHook, currentStateHook, $bcd00faefdd4b5d7$var$actionStateReducer)[0];
    stateHook = $bcd00faefdd4b5d7$var$updateReducer($bcd00faefdd4b5d7$var$basicStateReducer)[0];
    currentStateHook = "object" === (typeof currentStateHook === "undefined" ? "undefined" : (0, $YtE9h._)(currentStateHook)) && null !== currentStateHook && "function" === typeof currentStateHook.then ? $bcd00faefdd4b5d7$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.flags |= 2048, $bcd00faefdd4b5d7$var$pushEffect(9, $bcd00faefdd4b5d7$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $bcd00faefdd4b5d7$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $bcd00faefdd4b5d7$var$rerenderActionState(action) {
    var stateHook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook(), currentStateHook = $bcd00faefdd4b5d7$var$currentHook;
    if (null !== currentStateHook) return $bcd00faefdd4b5d7$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $bcd00faefdd4b5d7$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue(), $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $bcd00faefdd4b5d7$var$updateRef() {
    return $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
}
function $bcd00faefdd4b5d7$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $bcd00faefdd4b5d7$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $bcd00faefdd4b5d7$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $bcd00faefdd4b5d7$var$currentHook && null !== deps && $bcd00faefdd4b5d7$var$areHookInputsEqual(deps, $bcd00faefdd4b5d7$var$currentHook.memoizedState.deps) ? hook.memoizedState = $bcd00faefdd4b5d7$var$pushEffect(hookFlags, create, inst, deps) : ($bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $bcd00faefdd4b5d7$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $bcd00faefdd4b5d7$var$mountEffect(create, deps) {
    $bcd00faefdd4b5d7$var$mountEffectImpl(8390656, 8, create, deps);
}
function $bcd00faefdd4b5d7$var$updateEffect(create, deps) {
    $bcd00faefdd4b5d7$var$updateEffectImpl(2048, 8, create, deps);
}
function $bcd00faefdd4b5d7$var$updateInsertionEffect(create, deps) {
    return $bcd00faefdd4b5d7$var$updateEffectImpl(4, 2, create, deps);
}
function $bcd00faefdd4b5d7$var$updateLayoutEffect(create, deps) {
    return $bcd00faefdd4b5d7$var$updateEffectImpl(4, 4, create, deps);
}
function $bcd00faefdd4b5d7$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $bcd00faefdd4b5d7$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $bcd00faefdd4b5d7$var$updateEffectImpl(4, 4, $bcd00faefdd4b5d7$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $bcd00faefdd4b5d7$var$mountDebugValue() {}
function $bcd00faefdd4b5d7$var$updateCallback(callback, deps) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $bcd00faefdd4b5d7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $bcd00faefdd4b5d7$var$updateMemo(nextCreate, deps) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $bcd00faefdd4b5d7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $bcd00faefdd4b5d7$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($bcd00faefdd4b5d7$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $bcd00faefdd4b5d7$var$requestDeferredLane();
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.lanes |= hook;
    $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $bcd00faefdd4b5d7$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($bcd00faefdd4b5d7$var$objectIs(value, prevValue)) return value;
    if (null !== $bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor.current) return hook = $bcd00faefdd4b5d7$var$mountDeferredValueImpl(hook, value, initialValue), $bcd00faefdd4b5d7$var$objectIs(hook, prevValue) || ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0), hook;
    if (0 === ($bcd00faefdd4b5d7$var$renderLanes & 42)) return $bcd00faefdd4b5d7$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $bcd00faefdd4b5d7$var$requestDeferredLane();
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.lanes |= hook;
    $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $bcd00faefdd4b5d7$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, currentTransition = {};
    $bcd00faefdd4b5d7$var$ReactSharedInternals.T = currentTransition;
    $bcd00faefdd4b5d7$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $bcd00faefdd4b5d7$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $YtE9h._)(returnValue)) && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $bcd00faefdd4b5d7$var$chainThenableValue(returnValue, finishedState);
            $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $bcd00faefdd4b5d7$var$requestUpdateLane(fiber));
        } else $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, finishedState, $bcd00faefdd4b5d7$var$requestUpdateLane(fiber));
    } catch (error) {
        $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, {
            then: function then() {},
            status: "rejected",
            reason: error
        }, $bcd00faefdd4b5d7$var$requestUpdateLane());
    } finally{
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $bcd00faefdd4b5d7$var$noop$2() {}
function $bcd00faefdd4b5d7$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(476));
    var queue = $bcd00faefdd4b5d7$var$ensureFormComponentIsStateful(formFiber).queue;
    $bcd00faefdd4b5d7$var$startTransition(formFiber, queue, pendingState, $bcd00faefdd4b5d7$var$sharedNotPendingObject, null === action ? $bcd00faefdd4b5d7$var$noop$2 : function() {
        $bcd00faefdd4b5d7$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $bcd00faefdd4b5d7$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $bcd00faefdd4b5d7$var$sharedNotPendingObject,
        baseState: $bcd00faefdd4b5d7$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $bcd00faefdd4b5d7$var$basicStateReducer,
            lastRenderedState: $bcd00faefdd4b5d7$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $bcd00faefdd4b5d7$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $bcd00faefdd4b5d7$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $bcd00faefdd4b5d7$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $bcd00faefdd4b5d7$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $bcd00faefdd4b5d7$var$requestUpdateLane());
}
function $bcd00faefdd4b5d7$var$useHostTransitionStatus() {
    return $bcd00faefdd4b5d7$var$readContext($bcd00faefdd4b5d7$var$HostTransitionContext);
}
function $bcd00faefdd4b5d7$var$updateId() {
    return $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
}
function $bcd00faefdd4b5d7$var$updateRefresh() {
    return $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
}
function $bcd00faefdd4b5d7$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $bcd00faefdd4b5d7$var$requestUpdateLane();
                fiber = $bcd00faefdd4b5d7$var$createUpdate(lane);
                var root$63 = $bcd00faefdd4b5d7$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root$63, provider, lane), $bcd00faefdd4b5d7$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $bcd00faefdd4b5d7$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $bcd00faefdd4b5d7$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $bcd00faefdd4b5d7$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber) ? $bcd00faefdd4b5d7$var$enqueueRenderPhaseUpdate(queue, action) : (action = $bcd00faefdd4b5d7$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(action, fiber, lane), $bcd00faefdd4b5d7$var$entangleTransitionUpdate(action, queue, lane)));
}
function $bcd00faefdd4b5d7$var$dispatchSetState(fiber, queue, action) {
    var lane = $bcd00faefdd4b5d7$var$requestUpdateLane();
    $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber)) $bcd00faefdd4b5d7$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($bcd00faefdd4b5d7$var$objectIs(eagerState, currentState)) return $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, queue, update, 0), null === $bcd00faefdd4b5d7$var$workInProgressRoot && $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $bcd00faefdd4b5d7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(action, fiber, lane), $bcd00faefdd4b5d7$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $bcd00faefdd4b5d7$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $bcd00faefdd4b5d7$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1;
}
function $bcd00faefdd4b5d7$var$enqueueRenderPhaseUpdate(queue, update) {
    $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass = $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $bcd00faefdd4b5d7$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $bcd00faefdd4b5d7$var$markRootEntangled(root, lane);
    }
}
var $bcd00faefdd4b5d7$var$ContextOnlyDispatcher = {
    readContext: $bcd00faefdd4b5d7$var$readContext,
    use: $bcd00faefdd4b5d7$var$use,
    useCallback: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useContext: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useEffect: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useImperativeHandle: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useLayoutEffect: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useInsertionEffect: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useMemo: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useReducer: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useRef: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useState: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useDebugValue: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useDeferredValue: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useTransition: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useSyncExternalStore: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useId: $bcd00faefdd4b5d7$var$throwInvalidHookError
};
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useCacheRefresh = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useMemoCache = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useHostTransitionStatus = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useFormState = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useActionState = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useOptimistic = $bcd00faefdd4b5d7$var$throwInvalidHookError;
var $bcd00faefdd4b5d7$var$HooksDispatcherOnMount = {
    readContext: $bcd00faefdd4b5d7$var$readContext,
    use: $bcd00faefdd4b5d7$var$use,
    useCallback: function useCallback(callback, deps) {
        $bcd00faefdd4b5d7$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $bcd00faefdd4b5d7$var$readContext,
    useEffect: $bcd00faefdd4b5d7$var$mountEffect,
    useImperativeHandle: function useImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $bcd00faefdd4b5d7$var$mountEffectImpl(4194308, 4, $bcd00faefdd4b5d7$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function useLayoutEffect(create, deps) {
        return $bcd00faefdd4b5d7$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function useInsertionEffect(create, deps) {
        $bcd00faefdd4b5d7$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function useMemo(nextCreate, deps) {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function useReducer(reducer, initialArg, init) {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $bcd00faefdd4b5d7$var$dispatchReducerAction.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function useRef(initialValue) {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function useState(initialState) {
        initialState = $bcd00faefdd4b5d7$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $bcd00faefdd4b5d7$var$dispatchSetState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $bcd00faefdd4b5d7$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        return $bcd00faefdd4b5d7$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function useTransition() {
        var stateHook = $bcd00faefdd4b5d7$var$mountStateImpl(!1);
        stateHook = $bcd00faefdd4b5d7$var$startTransition.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $bcd00faefdd4b5d7$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        if ($bcd00faefdd4b5d7$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $bcd00faefdd4b5d7$var$workInProgressRoot) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(349));
            0 !== ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 60) || $bcd00faefdd4b5d7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $bcd00faefdd4b5d7$var$mountEffect($bcd00faefdd4b5d7$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $bcd00faefdd4b5d7$var$pushEffect(9, $bcd00faefdd4b5d7$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function useId() {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook(), identifierPrefix = $bcd00faefdd4b5d7$var$workInProgressRoot.identifierPrefix;
        if ($bcd00faefdd4b5d7$var$isHydrating) {
            var JSCompiler_inline_result = $bcd00faefdd4b5d7$var$treeContextOverflow;
            var idWithLeadingBit = $bcd00faefdd4b5d7$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $bcd00faefdd4b5d7$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $bcd00faefdd4b5d7$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $bcd00faefdd4b5d7$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function useCacheRefresh() {
        return $bcd00faefdd4b5d7$var$mountWorkInProgressHook().memoizedState = $bcd00faefdd4b5d7$var$refreshCache.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1);
    }
};
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useMemoCache = $bcd00faefdd4b5d7$var$useMemoCache;
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useHostTransitionStatus = $bcd00faefdd4b5d7$var$useHostTransitionStatus;
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useFormState = $bcd00faefdd4b5d7$var$mountActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useActionState = $bcd00faefdd4b5d7$var$mountActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $bcd00faefdd4b5d7$var$dispatchOptimisticSetState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate = {
    readContext: $bcd00faefdd4b5d7$var$readContext,
    use: $bcd00faefdd4b5d7$var$use,
    useCallback: $bcd00faefdd4b5d7$var$updateCallback,
    useContext: $bcd00faefdd4b5d7$var$readContext,
    useEffect: $bcd00faefdd4b5d7$var$updateEffect,
    useImperativeHandle: $bcd00faefdd4b5d7$var$updateImperativeHandle,
    useInsertionEffect: $bcd00faefdd4b5d7$var$updateInsertionEffect,
    useLayoutEffect: $bcd00faefdd4b5d7$var$updateLayoutEffect,
    useMemo: $bcd00faefdd4b5d7$var$updateMemo,
    useReducer: $bcd00faefdd4b5d7$var$updateReducer,
    useRef: $bcd00faefdd4b5d7$var$updateRef,
    useState: function useState() {
        return $bcd00faefdd4b5d7$var$updateReducer($bcd00faefdd4b5d7$var$basicStateReducer);
    },
    useDebugValue: $bcd00faefdd4b5d7$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
        return $bcd00faefdd4b5d7$var$updateDeferredValueImpl(hook, $bcd00faefdd4b5d7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $bcd00faefdd4b5d7$var$updateReducer($bcd00faefdd4b5d7$var$basicStateReducer)[0], start = $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $bcd00faefdd4b5d7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $bcd00faefdd4b5d7$var$updateSyncExternalStore,
    useId: $bcd00faefdd4b5d7$var$updateId
};
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useCacheRefresh = $bcd00faefdd4b5d7$var$updateRefresh;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useMemoCache = $bcd00faefdd4b5d7$var$useMemoCache;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $bcd00faefdd4b5d7$var$useHostTransitionStatus;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useFormState = $bcd00faefdd4b5d7$var$updateActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useActionState = $bcd00faefdd4b5d7$var$updateActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    return $bcd00faefdd4b5d7$var$updateOptimisticImpl(hook, $bcd00faefdd4b5d7$var$currentHook, passthrough, reducer);
};
var $bcd00faefdd4b5d7$var$HooksDispatcherOnRerender = {
    readContext: $bcd00faefdd4b5d7$var$readContext,
    use: $bcd00faefdd4b5d7$var$use,
    useCallback: $bcd00faefdd4b5d7$var$updateCallback,
    useContext: $bcd00faefdd4b5d7$var$readContext,
    useEffect: $bcd00faefdd4b5d7$var$updateEffect,
    useImperativeHandle: $bcd00faefdd4b5d7$var$updateImperativeHandle,
    useInsertionEffect: $bcd00faefdd4b5d7$var$updateInsertionEffect,
    useLayoutEffect: $bcd00faefdd4b5d7$var$updateLayoutEffect,
    useMemo: $bcd00faefdd4b5d7$var$updateMemo,
    useReducer: $bcd00faefdd4b5d7$var$rerenderReducer,
    useRef: $bcd00faefdd4b5d7$var$updateRef,
    useState: function useState() {
        return $bcd00faefdd4b5d7$var$rerenderReducer($bcd00faefdd4b5d7$var$basicStateReducer);
    },
    useDebugValue: $bcd00faefdd4b5d7$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
        return null === $bcd00faefdd4b5d7$var$currentHook ? $bcd00faefdd4b5d7$var$mountDeferredValueImpl(hook, value, initialValue) : $bcd00faefdd4b5d7$var$updateDeferredValueImpl(hook, $bcd00faefdd4b5d7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $bcd00faefdd4b5d7$var$rerenderReducer($bcd00faefdd4b5d7$var$basicStateReducer)[0], start = $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $bcd00faefdd4b5d7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $bcd00faefdd4b5d7$var$updateSyncExternalStore,
    useId: $bcd00faefdd4b5d7$var$updateId
};
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useCacheRefresh = $bcd00faefdd4b5d7$var$updateRefresh;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useMemoCache = $bcd00faefdd4b5d7$var$useMemoCache;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useHostTransitionStatus = $bcd00faefdd4b5d7$var$useHostTransitionStatus;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useFormState = $bcd00faefdd4b5d7$var$rerenderActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useActionState = $bcd00faefdd4b5d7$var$rerenderActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    if (null !== $bcd00faefdd4b5d7$var$currentHook) return $bcd00faefdd4b5d7$var$updateOptimisticImpl(hook, $bcd00faefdd4b5d7$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $bcd00faefdd4b5d7$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $bcd00faefdd4b5d7$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $bcd00faefdd4b5d7$var$classComponentUpdater = {
    isMounted: function isMounted(component) {
        return (component = component._reactInternals) ? $bcd00faefdd4b5d7$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function enqueueSetState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $bcd00faefdd4b5d7$var$requestUpdateLane(), update = $bcd00faefdd4b5d7$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $bcd00faefdd4b5d7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(payload, inst, lane), $bcd00faefdd4b5d7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $bcd00faefdd4b5d7$var$requestUpdateLane(), update = $bcd00faefdd4b5d7$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $bcd00faefdd4b5d7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(payload, inst, lane), $bcd00faefdd4b5d7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
        inst = inst._reactInternals;
        var lane = $bcd00faefdd4b5d7$var$requestUpdateLane(), update = $bcd00faefdd4b5d7$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $bcd00faefdd4b5d7$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(callback, inst, lane), $bcd00faefdd4b5d7$var$entangleTransitions(callback, inst, lane));
    }
};
function $bcd00faefdd4b5d7$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$bcd00faefdd4b5d7$var$shallowEqual(oldProps, newProps) || !$bcd00faefdd4b5d7$var$shallowEqual(oldState, newState) : !0;
}
function $bcd00faefdd4b5d7$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $bcd00faefdd4b5d7$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $bcd00faefdd4b5d7$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $bcd00faefdd4b5d7$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $bcd00faefdd4b5d7$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $YtE9h._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $YtE9h._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === (typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI)) && "function" === typeof $ibRPI.emit) {
        $ibRPI.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $bcd00faefdd4b5d7$var$defaultOnUncaughtError(error) {
    $bcd00faefdd4b5d7$var$reportGlobalError(error);
}
function $bcd00faefdd4b5d7$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $bcd00faefdd4b5d7$var$defaultOnRecoverableError(error) {
    $bcd00faefdd4b5d7$var$reportGlobalError(error);
}
function $bcd00faefdd4b5d7$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $bcd00faefdd4b5d7$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $bcd00faefdd4b5d7$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $bcd00faefdd4b5d7$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $bcd00faefdd4b5d7$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $bcd00faefdd4b5d7$var$createClassErrorUpdate(lane) {
    lane = $bcd00faefdd4b5d7$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $bcd00faefdd4b5d7$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $bcd00faefdd4b5d7$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $bcd00faefdd4b5d7$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed ? $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $bcd00faefdd4b5d7$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $bcd00faefdd4b5d7$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $bcd00faefdd4b5d7$var$shellBoundary ? $bcd00faefdd4b5d7$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $bcd00faefdd4b5d7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $bcd00faefdd4b5d7$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $bcd00faefdd4b5d7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $bcd00faefdd4b5d7$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $bcd00faefdd4b5d7$var$attachPingListener(root, value, rootRenderLanes);
        $bcd00faefdd4b5d7$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($bcd00faefdd4b5d7$var$isHydrating) return returnFiber = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $bcd00faefdd4b5d7$var$HydrationMismatchException && (root = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(422), {
        cause: value
    }), $bcd00faefdd4b5d7$var$queueHydrationError($bcd00faefdd4b5d7$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $bcd00faefdd4b5d7$var$HydrationMismatchException && (returnFiber = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(423), {
        cause: value
    }), $bcd00faefdd4b5d7$var$queueHydrationError($bcd00faefdd4b5d7$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $bcd00faefdd4b5d7$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $bcd00faefdd4b5d7$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors ? $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $bcd00faefdd4b5d7$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $bcd00faefdd4b5d7$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed || !$bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $bcd00faefdd4b5d7$var$createClassErrorUpdate(rootRenderLanes), $bcd00faefdd4b5d7$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $bcd00faefdd4b5d7$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $bcd00faefdd4b5d7$var$SelectiveHydrationException = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(461)), $bcd00faefdd4b5d7$var$didReceiveUpdate = !1;
function $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $bcd00faefdd4b5d7$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $bcd00faefdd4b5d7$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress);
    nextProps = $bcd00faefdd4b5d7$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $bcd00faefdd4b5d7$var$checkDidRenderIdHook();
    if (null !== current && !$bcd00faefdd4b5d7$var$didReceiveUpdate) return $bcd00faefdd4b5d7$var$bailoutHooks(current, workInProgress, renderLanes), $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $bcd00faefdd4b5d7$var$isHydrating && key && $bcd00faefdd4b5d7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$bcd00faefdd4b5d7$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $bcd00faefdd4b5d7$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$bcd00faefdd4b5d7$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $bcd00faefdd4b5d7$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $bcd00faefdd4b5d7$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $bcd00faefdd4b5d7$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($bcd00faefdd4b5d7$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($bcd00faefdd4b5d7$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $bcd00faefdd4b5d7$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $bcd00faefdd4b5d7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $bcd00faefdd4b5d7$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $bcd00faefdd4b5d7$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $bcd00faefdd4b5d7$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $bcd00faefdd4b5d7$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $bcd00faefdd4b5d7$var$pushHiddenContext(workInProgress, prevState) : $bcd00faefdd4b5d7$var$reuseHiddenContextOnStack(), $bcd00faefdd4b5d7$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $bcd00faefdd4b5d7$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($bcd00faefdd4b5d7$var$pushTransition(workInProgress, prevState.cachePool), $bcd00faefdd4b5d7$var$pushHiddenContext(workInProgress, prevState), $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $bcd00faefdd4b5d7$var$pushTransition(workInProgress, null), $bcd00faefdd4b5d7$var$reuseHiddenContextOnStack(), $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress));
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $bcd00faefdd4b5d7$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $bcd00faefdd4b5d7$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $bcd00faefdd4b5d7$var$pushTransition(workInProgress, null);
    $bcd00faefdd4b5d7$var$reuseHiddenContextOnStack();
    $bcd00faefdd4b5d7$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $bcd00faefdd4b5d7$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== (typeof ref === "undefined" ? "undefined" : (0, $YtE9h._)(ref))) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $bcd00faefdd4b5d7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress);
    Component = $bcd00faefdd4b5d7$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $bcd00faefdd4b5d7$var$checkDidRenderIdHook();
    if (null !== current && !$bcd00faefdd4b5d7$var$didReceiveUpdate) return $bcd00faefdd4b5d7$var$bailoutHooks(current, workInProgress, renderLanes), $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $bcd00faefdd4b5d7$var$isHydrating && nextProps && $bcd00faefdd4b5d7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $bcd00faefdd4b5d7$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $bcd00faefdd4b5d7$var$finishRenderingHooks(current);
    Component = $bcd00faefdd4b5d7$var$checkDidRenderIdHook();
    if (null !== current && !$bcd00faefdd4b5d7$var$didReceiveUpdate) return $bcd00faefdd4b5d7$var$bailoutHooks(current, workInProgress, renderLanes), $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $bcd00faefdd4b5d7$var$isHydrating && Component && $bcd00faefdd4b5d7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $bcd00faefdd4b5d7$var$emptyContextObject, contextType = Component.contextType;
        "object" === (typeof contextType === "undefined" ? "undefined" : (0, $YtE9h._)(contextType)) && null !== contextType && (context = $bcd00faefdd4b5d7$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $bcd00faefdd4b5d7$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $bcd00faefdd4b5d7$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === (typeof contextType === "undefined" ? "undefined" : (0, $YtE9h._)(contextType)) && null !== contextType ? $bcd00faefdd4b5d7$var$readContext(contextType) : $bcd00faefdd4b5d7$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($bcd00faefdd4b5d7$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $bcd00faefdd4b5d7$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $bcd00faefdd4b5d7$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $bcd00faefdd4b5d7$var$emptyContextObject;
        "object" === (typeof contextType$jscomp$0 === "undefined" ? "undefined" : (0, $YtE9h._)(contextType$jscomp$0)) && null !== contextType$jscomp$0 && (contextType = $bcd00faefdd4b5d7$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $bcd00faefdd4b5d7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $bcd00faefdd4b5d7$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $bcd00faefdd4b5d7$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($bcd00faefdd4b5d7$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $bcd00faefdd4b5d7$var$hasForceUpdate || $bcd00faefdd4b5d7$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $bcd00faefdd4b5d7$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $bcd00faefdd4b5d7$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $bcd00faefdd4b5d7$var$emptyContextObject;
        "object" === (typeof oldContext === "undefined" ? "undefined" : (0, $YtE9h._)(oldContext)) && null !== oldContext && (oldProps = $bcd00faefdd4b5d7$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $bcd00faefdd4b5d7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $bcd00faefdd4b5d7$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $bcd00faefdd4b5d7$var$hasForceUpdate || null !== current && null !== current.dependencies && $bcd00faefdd4b5d7$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($bcd00faefdd4b5d7$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $bcd00faefdd4b5d7$var$hasForceUpdate || $bcd00faefdd4b5d7$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $bcd00faefdd4b5d7$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $bcd00faefdd4b5d7$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $bcd00faefdd4b5d7$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $bcd00faefdd4b5d7$var$resetHydrationState();
    workInProgress.flags |= 256;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $bcd00faefdd4b5d7$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bcd00faefdd4b5d7$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $bcd00faefdd4b5d7$var$getSuspendedCache()
    };
}
function $bcd00faefdd4b5d7$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $bcd00faefdd4b5d7$var$workInProgressDeferredLane);
    return current;
}
function $bcd00faefdd4b5d7$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($bcd00faefdd4b5d7$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($bcd00faefdd4b5d7$var$isHydrating) {
            showFallback ? $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($bcd00faefdd4b5d7$var$isHydrating) {
                var nextInstance = $bcd00faefdd4b5d7$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $bcd00faefdd4b5d7$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $bcd00faefdd4b5d7$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $bcd00faefdd4b5d7$var$treeContextProvider ? {
                            id: $bcd00faefdd4b5d7$var$treeContextId,
                            overflow: $bcd00faefdd4b5d7$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $bcd00faefdd4b5d7$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $bcd00faefdd4b5d7$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $bcd00faefdd4b5d7$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $bcd00faefdd4b5d7$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $bcd00faefdd4b5d7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $bcd00faefdd4b5d7$var$SUSPENDED_MARKER, nextProps;
        $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $bcd00faefdd4b5d7$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $bcd00faefdd4b5d7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $bcd00faefdd4b5d7$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $bcd00faefdd4b5d7$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $bcd00faefdd4b5d7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $bcd00faefdd4b5d7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $bcd00faefdd4b5d7$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $bcd00faefdd4b5d7$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $bcd00faefdd4b5d7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($bcd00faefdd4b5d7$var$didReceiveUpdate || $bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $bcd00faefdd4b5d7$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $bcd00faefdd4b5d7$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(current, nextProps), $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $bcd00faefdd4b5d7$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $bcd00faefdd4b5d7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $bcd00faefdd4b5d7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $bcd00faefdd4b5d7$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(nextInstance.nextSibling), $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$isHydrating = !0, $bcd00faefdd4b5d7$var$hydrationErrors = null, $bcd00faefdd4b5d7$var$rootOrSingletonContext = !1, null !== current && ($bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextId, $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextOverflow, $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextProvider, $bcd00faefdd4b5d7$var$treeContextId = current.id, $bcd00faefdd4b5d7$var$treeContextOverflow = current.overflow, $bcd00faefdd4b5d7$var$treeContextProvider = workInProgress), workInProgress = $bcd00faefdd4b5d7$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $bcd00faefdd4b5d7$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $bcd00faefdd4b5d7$var$createWorkInProgress(digest, showFallback) : (showFallback = $bcd00faefdd4b5d7$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $bcd00faefdd4b5d7$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $bcd00faefdd4b5d7$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $bcd00faefdd4b5d7$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $bcd00faefdd4b5d7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $bcd00faefdd4b5d7$var$SUSPENDED_MARKER, nextProps;
    $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $bcd00faefdd4b5d7$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $bcd00faefdd4b5d7$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $bcd00faefdd4b5d7$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $bcd00faefdd4b5d7$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $bcd00faefdd4b5d7$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $bcd00faefdd4b5d7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $bcd00faefdd4b5d7$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $bcd00faefdd4b5d7$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $bcd00faefdd4b5d7$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $bcd00faefdd4b5d7$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $bcd00faefdd4b5d7$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $bcd00faefdd4b5d7$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $bcd00faefdd4b5d7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $bcd00faefdd4b5d7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $bcd00faefdd4b5d7$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $bcd00faefdd4b5d7$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $bcd00faefdd4b5d7$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $bcd00faefdd4b5d7$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $bcd00faefdd4b5d7$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $bcd00faefdd4b5d7$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $bcd00faefdd4b5d7$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $bcd00faefdd4b5d7$var$checkIfContextChanged(current) ? !0 : !1;
}
function $bcd00faefdd4b5d7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $bcd00faefdd4b5d7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, current.memoizedState.cache);
            $bcd00faefdd4b5d7$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $bcd00faefdd4b5d7$var$pushHostContext(workInProgress);
            break;
        case 4:
            $bcd00faefdd4b5d7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $bcd00faefdd4b5d7$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $bcd00faefdd4b5d7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $bcd00faefdd4b5d7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $bcd00faefdd4b5d7$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, current.memoizedState.cache);
    }
    return $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $bcd00faefdd4b5d7$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $bcd00faefdd4b5d7$var$didReceiveUpdate = !0;
        else {
            if (!$bcd00faefdd4b5d7$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $bcd00faefdd4b5d7$var$didReceiveUpdate = !1, $bcd00faefdd4b5d7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $bcd00faefdd4b5d7$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $bcd00faefdd4b5d7$var$didReceiveUpdate = !1, $bcd00faefdd4b5d7$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $bcd00faefdd4b5d7$var$pushTreeId(workInProgress, $bcd00faefdd4b5d7$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $bcd00faefdd4b5d7$var$shouldConstruct(lazyComponent) ? (current = $bcd00faefdd4b5d7$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $bcd00faefdd4b5d7$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $bcd00faefdd4b5d7$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $bcd00faefdd4b5d7$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $bcd00faefdd4b5d7$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $bcd00faefdd4b5d7$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $bcd00faefdd4b5d7$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $bcd00faefdd4b5d7$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $bcd00faefdd4b5d7$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $bcd00faefdd4b5d7$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $bcd00faefdd4b5d7$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $bcd00faefdd4b5d7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $bcd00faefdd4b5d7$var$cloneUpdateQueue(current, workInProgress);
                $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, nextProps);
                nextProps !== init.cache && $bcd00faefdd4b5d7$var$propagateContextChanges(workInProgress, [
                    $bcd00faefdd4b5d7$var$CacheContext
                ], renderLanes, !0);
                $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $bcd00faefdd4b5d7$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(424)), workInProgress);
                        $bcd00faefdd4b5d7$var$queueHydrationError(lazyComponent);
                        workInProgress = $bcd00faefdd4b5d7$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$isHydrating = !0, $bcd00faefdd4b5d7$var$hydrationErrors = null, $bcd00faefdd4b5d7$var$rootOrSingletonContext = !0, renderLanes = $bcd00faefdd4b5d7$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $bcd00faefdd4b5d7$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $bcd00faefdd4b5d7$var$markRef(current, workInProgress), null === current ? (renderLanes = $bcd00faefdd4b5d7$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $bcd00faefdd4b5d7$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer($bcd00faefdd4b5d7$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress, lazyComponent[$bcd00faefdd4b5d7$var$internalPropsKey] = current, $bcd00faefdd4b5d7$var$setInitialProperties(lazyComponent, renderLanes, current), $bcd00faefdd4b5d7$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $bcd00faefdd4b5d7$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $bcd00faefdd4b5d7$var$pushHostContext(workInProgress), null === current && $bcd00faefdd4b5d7$var$isHydrating && (lazyComponent = workInProgress.stateNode = $bcd00faefdd4b5d7$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $bcd00faefdd4b5d7$var$rootInstanceStackCursor.current), $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$rootOrSingletonContext = !0, $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $bcd00faefdd4b5d7$var$isHydrating ? $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $bcd00faefdd4b5d7$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $bcd00faefdd4b5d7$var$isHydrating) {
                if (init = lazyComponent = $bcd00faefdd4b5d7$var$nextHydratableInstance) lazyComponent = $bcd00faefdd4b5d7$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $bcd00faefdd4b5d7$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(lazyComponent.firstChild), $bcd00faefdd4b5d7$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(workInProgress);
            }
            $bcd00faefdd4b5d7$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $bcd00faefdd4b5d7$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $bcd00faefdd4b5d7$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $bcd00faefdd4b5d7$var$renderWithHooks(current, workInProgress, $bcd00faefdd4b5d7$var$TransitionAwareHostComponent, null, null, renderLanes), $bcd00faefdd4b5d7$var$HostTransitionContext._currentValue = init);
            $bcd00faefdd4b5d7$var$markRef(current, workInProgress);
            $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $bcd00faefdd4b5d7$var$isHydrating) {
                if (current = renderLanes = $bcd00faefdd4b5d7$var$nextHydratableInstance) renderLanes = $bcd00faefdd4b5d7$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $bcd00faefdd4b5d7$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $bcd00faefdd4b5d7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $bcd00faefdd4b5d7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $bcd00faefdd4b5d7$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $bcd00faefdd4b5d7$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress), init = $bcd00faefdd4b5d7$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $bcd00faefdd4b5d7$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $bcd00faefdd4b5d7$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $bcd00faefdd4b5d7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $bcd00faefdd4b5d7$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress), lazyComponent = $bcd00faefdd4b5d7$var$readContext($bcd00faefdd4b5d7$var$CacheContext), null === current ? (init = $bcd00faefdd4b5d7$var$peekCacheFromPool(), null === init && (init = $bcd00faefdd4b5d7$var$workInProgressRoot, nextProps = $bcd00faefdd4b5d7$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $bcd00faefdd4b5d7$var$initializeUpdateQueue(workInProgress), $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($bcd00faefdd4b5d7$var$cloneUpdateQueue(current, workInProgress), $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, null, null, renderLanes), $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $bcd00faefdd4b5d7$var$propagateContextChanges(workInProgress, [
                $bcd00faefdd4b5d7$var$CacheContext
            ], renderLanes, !0))), $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $bcd00faefdd4b5d7$var$valueCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null, $bcd00faefdd4b5d7$var$lastContextDependency = null;
function $bcd00faefdd4b5d7$var$pushProvider(providerFiber, context, nextValue) {
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $bcd00faefdd4b5d7$var$popProvider(context) {
    context._currentValue = $bcd00faefdd4b5d7$var$valueCursor.current;
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$valueCursor);
}
function $bcd00faefdd4b5d7$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $bcd00faefdd4b5d7$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $bcd00faefdd4b5d7$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $bcd00faefdd4b5d7$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $bcd00faefdd4b5d7$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $bcd00faefdd4b5d7$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($bcd00faefdd4b5d7$var$HostTransitionContext) : current = [
                $bcd00faefdd4b5d7$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $bcd00faefdd4b5d7$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $bcd00faefdd4b5d7$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$bcd00faefdd4b5d7$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress) {
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber = workInProgress;
    $bcd00faefdd4b5d7$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $bcd00faefdd4b5d7$var$readContext(context) {
    return $bcd00faefdd4b5d7$var$readContextForConsumer($bcd00faefdd4b5d7$var$currentlyRenderingFiber, context);
}
function $bcd00faefdd4b5d7$var$readContextDuringReconciliation(consumer, context) {
    null === $bcd00faefdd4b5d7$var$currentlyRenderingFiber && $bcd00faefdd4b5d7$var$prepareToReadContext(consumer);
    return $bcd00faefdd4b5d7$var$readContextForConsumer(consumer, context);
}
function $bcd00faefdd4b5d7$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $bcd00faefdd4b5d7$var$lastContextDependency) {
        if (null === consumer) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(308));
        $bcd00faefdd4b5d7$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$lastContextDependency.next = context;
    return value;
}
var $bcd00faefdd4b5d7$var$hasForceUpdate = !1;
function $bcd00faefdd4b5d7$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $bcd00faefdd4b5d7$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $bcd00faefdd4b5d7$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bcd00faefdd4b5d7$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(fiber);
        $bcd00faefdd4b5d7$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(fiber);
}
function $bcd00faefdd4b5d7$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $bcd00faefdd4b5d7$var$markRootEntangled(root, lane);
    }
}
function $bcd00faefdd4b5d7$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $bcd00faefdd4b5d7$var$didReadFromEntangledAsyncAction = !1;
function $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($bcd00faefdd4b5d7$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $bcd00faefdd4b5d7$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $bcd00faefdd4b5d7$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $bcd00faefdd4b5d7$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $bcd00faefdd4b5d7$var$currentEntangledLane && ($bcd00faefdd4b5d7$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $bcd00faefdd4b5d7$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $bcd00faefdd4b5d7$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $bcd00faefdd4b5d7$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $bcd00faefdd4b5d7$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$bcd00faefdd4b5d7$var$callCallback(callbacks[updateQueue], context);
}
function $bcd00faefdd4b5d7$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $bcd00faefdd4b5d7$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $bcd00faefdd4b5d7$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $bcd00faefdd4b5d7$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $bcd00faefdd4b5d7$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $bcd00faefdd4b5d7$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $bcd00faefdd4b5d7$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $bcd00faefdd4b5d7$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $bcd00faefdd4b5d7$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$bcd00faefdd4b5d7$var$internalPropsKey] = newProps;
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $bcd00faefdd4b5d7$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $bcd00faefdd4b5d7$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $bcd00faefdd4b5d7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $bcd00faefdd4b5d7$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($bcd00faefdd4b5d7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$bcd00faefdd4b5d7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = !1, $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = !1, $bcd00faefdd4b5d7$var$needsFormReset = !1, $bcd00faefdd4b5d7$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $bcd00faefdd4b5d7$var$nextEffect = null, $bcd00faefdd4b5d7$var$shouldFireAfterActiveInstanceBlur = !1;
function $bcd00faefdd4b5d7$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $bcd00faefdd4b5d7$var$eventsEnabled = $bcd00faefdd4b5d7$var$_enabled;
    root = $bcd00faefdd4b5d7$var$getActiveElementDeep(root);
    if ($bcd00faefdd4b5d7$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $bcd00faefdd4b5d7$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $bcd00faefdd4b5d7$var$_enabled = !1;
    for($bcd00faefdd4b5d7$var$nextEffect = firstChild; null !== $bcd00faefdd4b5d7$var$nextEffect;)if (firstChild = $bcd00faefdd4b5d7$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $bcd00faefdd4b5d7$var$nextEffect = root;
    else for(; null !== $bcd00faefdd4b5d7$var$nextEffect;){
        firstChild = $bcd00faefdd4b5d7$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $bcd00faefdd4b5d7$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $bcd00faefdd4b5d7$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $bcd00faefdd4b5d7$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $bcd00faefdd4b5d7$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $bcd00faefdd4b5d7$var$nextEffect = root;
            break;
        }
        $bcd00faefdd4b5d7$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $bcd00faefdd4b5d7$var$shouldFireAfterActiveInstanceBlur;
    $bcd00faefdd4b5d7$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $bcd00faefdd4b5d7$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $bcd00faefdd4b5d7$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $bcd00faefdd4b5d7$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $bcd00faefdd4b5d7$var$commitClassCallbacks(finishedWork);
            flags & 512 && $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $bcd00faefdd4b5d7$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $bcd00faefdd4b5d7$var$commitHostMount(finishedWork);
            flags & 512 && $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $bcd00faefdd4b5d7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden;
                $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = prevProps;
                ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return) : $bcd00faefdd4b5d7$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $bcd00faefdd4b5d7$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $bcd00faefdd4b5d7$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $bcd00faefdd4b5d7$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $bcd00faefdd4b5d7$var$hostParent = null, $bcd00faefdd4b5d7$var$hostParentIsContainer = !1;
function $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$bcd00faefdd4b5d7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $bcd00faefdd4b5d7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($bcd00faefdd4b5d7$var$injectedHook && "function" === typeof $bcd00faefdd4b5d7$var$injectedHook.onCommitFiberUnmount) try {
        $bcd00faefdd4b5d7$var$injectedHook.onCommitFiberUnmount($bcd00faefdd4b5d7$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $bcd00faefdd4b5d7$var$hostParent, prevHostParentIsContainer = $bcd00faefdd4b5d7$var$hostParentIsContainer;
            $bcd00faefdd4b5d7$var$hostParent = deletedFiber.stateNode;
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $bcd00faefdd4b5d7$var$detachDeletedInstance(deletedFiber);
            $bcd00faefdd4b5d7$var$hostParent = prevHostParent;
            $bcd00faefdd4b5d7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $bcd00faefdd4b5d7$var$hostParent;
            var prevHostParentIsContainer$119 = $bcd00faefdd4b5d7$var$hostParentIsContainer;
            $bcd00faefdd4b5d7$var$hostParent = null;
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $bcd00faefdd4b5d7$var$hostParent = prevHostParentIsContainer;
            $bcd00faefdd4b5d7$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $bcd00faefdd4b5d7$var$hostParent) {
                if ($bcd00faefdd4b5d7$var$hostParentIsContainer) try {
                    finishedRoot = $bcd00faefdd4b5d7$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $bcd00faefdd4b5d7$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $bcd00faefdd4b5d7$var$hostParent && ($bcd00faefdd4b5d7$var$hostParentIsContainer ? (nearestMountedAncestor = $bcd00faefdd4b5d7$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $bcd00faefdd4b5d7$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $bcd00faefdd4b5d7$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $bcd00faefdd4b5d7$var$retryIfBlockedOn(nearestMountedAncestor)) : $bcd00faefdd4b5d7$var$clearSuspenseBoundary($bcd00faefdd4b5d7$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $bcd00faefdd4b5d7$var$hostParent;
            prevHostParentIsContainer = $bcd00faefdd4b5d7$var$hostParentIsContainer;
            $bcd00faefdd4b5d7$var$hostParent = deletedFiber.stateNode.containerInfo;
            $bcd00faefdd4b5d7$var$hostParentIsContainer = !0;
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $bcd00faefdd4b5d7$var$hostParent = prevHostParent;
            $bcd00faefdd4b5d7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || ($bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $bcd00faefdd4b5d7$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = (prevHostParent = $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $bcd00faefdd4b5d7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $bcd00faefdd4b5d7$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $bcd00faefdd4b5d7$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $bcd00faefdd4b5d7$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $bcd00faefdd4b5d7$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $bcd00faefdd4b5d7$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $bcd00faefdd4b5d7$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $bcd00faefdd4b5d7$var$hostParent = parent.stateNode;
                    $bcd00faefdd4b5d7$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $bcd00faefdd4b5d7$var$hostParent = parent.stateNode.containerInfo;
                    $bcd00faefdd4b5d7$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $bcd00faefdd4b5d7$var$hostParent = parent.stateNode.containerInfo;
                    $bcd00faefdd4b5d7$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $bcd00faefdd4b5d7$var$hostParent) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(160));
        $bcd00faefdd4b5d7$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $bcd00faefdd4b5d7$var$hostParent = null;
        $bcd00faefdd4b5d7$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $bcd00faefdd4b5d7$var$currentHoistableRoot = null;
function $bcd00faefdd4b5d7$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($bcd00faefdd4b5d7$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $bcd00faefdd4b5d7$var$commitHookEffectListMount(3, finishedWork), $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || null === current || $bcd00faefdd4b5d7$var$safelyDetachRef(current, current.return));
            flags & 64 && $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $bcd00faefdd4b5d7$var$currentHoistableRoot;
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || null === current || $bcd00faefdd4b5d7$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$bcd00faefdd4b5d7$var$internalHoistableMarker] || currentResource[$bcd00faefdd4b5d7$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $bcd00faefdd4b5d7$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$bcd00faefdd4b5d7$var$internalInstanceKey] = finishedWork;
                                        $bcd00faefdd4b5d7$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $bcd00faefdd4b5d7$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $bcd00faefdd4b5d7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $bcd00faefdd4b5d7$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $bcd00faefdd4b5d7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$bcd00faefdd4b5d7$var$internalInstanceKey] = finishedWork;
                                $bcd00faefdd4b5d7$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $bcd00faefdd4b5d7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $bcd00faefdd4b5d7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $bcd00faefdd4b5d7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $bcd00faefdd4b5d7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $bcd00faefdd4b5d7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$bcd00faefdd4b5d7$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $bcd00faefdd4b5d7$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$bcd00faefdd4b5d7$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$bcd00faefdd4b5d7$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || null === current || $bcd00faefdd4b5d7$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $bcd00faefdd4b5d7$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $bcd00faefdd4b5d7$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($bcd00faefdd4b5d7$var$needsFormReset = !0);
            break;
        case 6:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $bcd00faefdd4b5d7$var$tagCaches = null;
            hoistableRoot = $bcd00faefdd4b5d7$var$currentHoistableRoot;
            $bcd00faefdd4b5d7$var$currentHoistableRoot = $bcd00faefdd4b5d7$var$getHoistableRoot(root.containerInfo);
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$currentHoistableRoot = hoistableRoot;
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $bcd00faefdd4b5d7$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $bcd00faefdd4b5d7$var$needsFormReset && ($bcd00faefdd4b5d7$var$needsFormReset = !1, $bcd00faefdd4b5d7$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $bcd00faefdd4b5d7$var$currentHoistableRoot;
            $bcd00faefdd4b5d7$var$currentHoistableRoot = $bcd00faefdd4b5d7$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            $bcd00faefdd4b5d7$var$currentHoistableRoot = flags;
            break;
        case 12:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($bcd00faefdd4b5d7$var$globalMostRecentFallbackTime = $bcd00faefdd4b5d7$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $bcd00faefdd4b5d7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || null === current || $bcd00faefdd4b5d7$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden;
            type = $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden;
            $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = nodeName || node;
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = type || nextNode;
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = type;
            $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = nodeName;
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden || $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $bcd00faefdd4b5d7$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $bcd00faefdd4b5d7$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $bcd00faefdd4b5d7$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $bcd00faefdd4b5d7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork), $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
    }
}
function $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($bcd00faefdd4b5d7$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $bcd00faefdd4b5d7$var$getHostSibling(finishedWork);
                        $bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($bcd00faefdd4b5d7$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $bcd00faefdd4b5d7$var$getHostSibling(finishedWork);
                        $bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $bcd00faefdd4b5d7$var$getHostSibling(finishedWork);
                        $bcd00faefdd4b5d7$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $bcd00faefdd4b5d7$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $bcd00faefdd4b5d7$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $bcd00faefdd4b5d7$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $bcd00faefdd4b5d7$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $bcd00faefdd4b5d7$var$safelyDetachRef(finishedWork, finishedWork.return);
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $bcd00faefdd4b5d7$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $bcd00faefdd4b5d7$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$bcd00faefdd4b5d7$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $bcd00faefdd4b5d7$var$commitClassCallbacks(finishedWork);
                $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $bcd00faefdd4b5d7$var$commitHostMount(finishedWork);
                $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $bcd00faefdd4b5d7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $bcd00faefdd4b5d7$var$releaseCache(previousCache));
}
function $bcd00faefdd4b5d7$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $bcd00faefdd4b5d7$var$releaseCache(current));
}
function $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $bcd00faefdd4b5d7$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $bcd00faefdd4b5d7$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $bcd00faefdd4b5d7$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $bcd00faefdd4b5d7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $bcd00faefdd4b5d7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $bcd00faefdd4b5d7$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $bcd00faefdd4b5d7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $bcd00faefdd4b5d7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $bcd00faefdd4b5d7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $bcd00faefdd4b5d7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $bcd00faefdd4b5d7$var$suspenseyCommitFlag = 8192;
function $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $bcd00faefdd4b5d7$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $bcd00faefdd4b5d7$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $bcd00faefdd4b5d7$var$suspenseyCommitFlag && null !== fiber.memoizedState && $bcd00faefdd4b5d7$var$suspendResource($bcd00faefdd4b5d7$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $bcd00faefdd4b5d7$var$currentHoistableRoot;
            $bcd00faefdd4b5d7$var$currentHoistableRoot = $bcd00faefdd4b5d7$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $bcd00faefdd4b5d7$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $bcd00faefdd4b5d7$var$suspenseyCommitFlag, $bcd00faefdd4b5d7$var$suspenseyCommitFlag = 16777216, $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber), $bcd00faefdd4b5d7$var$suspenseyCommitFlag = previousHoistableRoot) : $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $bcd00faefdd4b5d7$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $bcd00faefdd4b5d7$var$nextEffect = childToDelete;
            $bcd00faefdd4b5d7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $bcd00faefdd4b5d7$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $bcd00faefdd4b5d7$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $bcd00faefdd4b5d7$var$nextEffect = childToDelete;
            $bcd00faefdd4b5d7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $bcd00faefdd4b5d7$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $bcd00faefdd4b5d7$var$nextEffect;){
        var fiber = $bcd00faefdd4b5d7$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $bcd00faefdd4b5d7$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $bcd00faefdd4b5d7$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $bcd00faefdd4b5d7$var$nextEffect;){
            cache = $bcd00faefdd4b5d7$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $bcd00faefdd4b5d7$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $bcd00faefdd4b5d7$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $bcd00faefdd4b5d7$var$nextEffect = sibling;
                break a;
            }
            $bcd00faefdd4b5d7$var$nextEffect = returnFiber;
        }
    }
}
function $bcd00faefdd4b5d7$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bcd00faefdd4b5d7$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $bcd00faefdd4b5d7$var$FiberNode(tag, pendingProps, key, mode);
}
function $bcd00faefdd4b5d7$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $bcd00faefdd4b5d7$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $bcd00faefdd4b5d7$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $bcd00faefdd4b5d7$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $bcd00faefdd4b5d7$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $bcd00faefdd4b5d7$var$isHostHoistableType(type, pendingProps, $bcd00faefdd4b5d7$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE:
            return $bcd00faefdd4b5d7$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $bcd00faefdd4b5d7$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $bcd00faefdd4b5d7$var$REACT_PROFILER_TYPE:
            return type = $bcd00faefdd4b5d7$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $bcd00faefdd4b5d7$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $bcd00faefdd4b5d7$var$REACT_SUSPENSE_TYPE:
            return type = $bcd00faefdd4b5d7$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $bcd00faefdd4b5d7$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $bcd00faefdd4b5d7$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $bcd00faefdd4b5d7$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $bcd00faefdd4b5d7$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $bcd00faefdd4b5d7$var$REACT_OFFSCREEN_TYPE:
            return $bcd00faefdd4b5d7$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) && null !== type) switch(type.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_PROVIDER_TYPE:
                case $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $bcd00faefdd4b5d7$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $bcd00faefdd4b5d7$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $bcd00faefdd4b5d7$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(130, null === type ? "null" : typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type), ""));
            owner = null;
    }
    key = $bcd00faefdd4b5d7$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $bcd00faefdd4b5d7$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $bcd00faefdd4b5d7$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $bcd00faefdd4b5d7$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $bcd00faefdd4b5d7$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $bcd00faefdd4b5d7$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function detach() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function attach() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $bcd00faefdd4b5d7$var$createFiberFromText(content, mode, lanes) {
    content = $bcd00faefdd4b5d7$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $bcd00faefdd4b5d7$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $bcd00faefdd4b5d7$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $bcd00faefdd4b5d7$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $bcd00faefdd4b5d7$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$bcd00faefdd4b5d7$var$preloadResource(resource)) {
        resource = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 4194176) === $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes ? null !== $bcd00faefdd4b5d7$var$shellBoundary : ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 62914560) !== $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes && 0 === ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 536870912) || resource !== $bcd00faefdd4b5d7$var$shellBoundary)) throw $bcd00faefdd4b5d7$var$suspendedThenable = $bcd00faefdd4b5d7$var$noopSuspenseyCommitThenable, $bcd00faefdd4b5d7$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $bcd00faefdd4b5d7$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$bcd00faefdd4b5d7$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $bcd00faefdd4b5d7$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $bcd00faefdd4b5d7$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $bcd00faefdd4b5d7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 1:
            return $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext);
            $bcd00faefdd4b5d7$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $bcd00faefdd4b5d7$var$popHydrationState(workInProgress) ? $bcd00faefdd4b5d7$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $bcd00faefdd4b5d7$var$hydrationErrors && ($bcd00faefdd4b5d7$var$queueRecoverableErrors($bcd00faefdd4b5d7$var$hydrationErrors), $bcd00faefdd4b5d7$var$hydrationErrors = null));
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($bcd00faefdd4b5d7$var$markUpdate(workInProgress), null !== renderLanes ? ($bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), $bcd00faefdd4b5d7$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($bcd00faefdd4b5d7$var$markUpdate(workInProgress), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), $bcd00faefdd4b5d7$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $bcd00faefdd4b5d7$var$markUpdate(workInProgress), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $bcd00faefdd4b5d7$var$popHostContext(workInProgress);
            renderLanes = $bcd00faefdd4b5d7$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $bcd00faefdd4b5d7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(166));
                    $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $bcd00faefdd4b5d7$var$contextStackCursor.current;
                $bcd00faefdd4b5d7$var$popHydrationState(workInProgress) ? $bcd00faefdd4b5d7$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $bcd00faefdd4b5d7$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $bcd00faefdd4b5d7$var$markUpdate(workInProgress));
            }
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $bcd00faefdd4b5d7$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $bcd00faefdd4b5d7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(166));
                    $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $bcd00faefdd4b5d7$var$contextStackCursor.current;
                if ($bcd00faefdd4b5d7$var$popHydrationState(workInProgress)) $bcd00faefdd4b5d7$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer($bcd00faefdd4b5d7$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress;
                    current[$bcd00faefdd4b5d7$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($bcd00faefdd4b5d7$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $bcd00faefdd4b5d7$var$markUpdate(workInProgress);
                }
            }
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $bcd00faefdd4b5d7$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(166));
                current = $bcd00faefdd4b5d7$var$rootInstanceStackCursor.current;
                if ($bcd00faefdd4b5d7$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $bcd00faefdd4b5d7$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $bcd00faefdd4b5d7$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(workInProgress);
                } else current = $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $bcd00faefdd4b5d7$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(317));
                        type[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress;
                    } else $bcd00faefdd4b5d7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $bcd00faefdd4b5d7$var$hydrationErrors && ($bcd00faefdd4b5d7$var$queueRecoverableErrors($bcd00faefdd4b5d7$var$hydrationErrors), $bcd00faefdd4b5d7$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $bcd00faefdd4b5d7$var$popHostContainer(), null === current && $bcd00faefdd4b5d7$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 10:
            return $bcd00faefdd4b5d7$var$popProvider(workInProgress.type), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 19:
            $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $bcd00faefdd4b5d7$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $bcd00faefdd4b5d7$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$bcd00faefdd4b5d7$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $bcd00faefdd4b5d7$var$now() > $bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $bcd00faefdd4b5d7$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, current), $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$bcd00faefdd4b5d7$var$isHydrating) return $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
                    } else 2 * $bcd00faefdd4b5d7$var$now() - type.renderingStartTime > $bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $bcd00faefdd4b5d7$var$now(), workInProgress.sibling = null, current = $bcd00faefdd4b5d7$var$suspenseStackCursor.current, $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress), $bcd00faefdd4b5d7$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $bcd00faefdd4b5d7$var$unwindWork(current, workInProgress) {
    $bcd00faefdd4b5d7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext), $bcd00faefdd4b5d7$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $bcd00faefdd4b5d7$var$popHostContext(workInProgress), null;
        case 13:
            $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(340));
                $bcd00faefdd4b5d7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseStackCursor), null;
        case 4:
            return $bcd00faefdd4b5d7$var$popHostContainer(), null;
        case 10:
            return $bcd00faefdd4b5d7$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress), $bcd00faefdd4b5d7$var$popHiddenContext(), null !== current && $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $bcd00faefdd4b5d7$var$unwindInterruptedWork(current, interruptedWork) {
    $bcd00faefdd4b5d7$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext);
            $bcd00faefdd4b5d7$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $bcd00faefdd4b5d7$var$popHostContext(interruptedWork);
            break;
        case 4:
            $bcd00faefdd4b5d7$var$popHostContainer();
            break;
        case 13:
            $bcd00faefdd4b5d7$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseStackCursor);
            break;
        case 10:
            $bcd00faefdd4b5d7$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $bcd00faefdd4b5d7$var$popSuspenseHandler(interruptedWork);
            $bcd00faefdd4b5d7$var$popHiddenContext();
            null !== current && $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$resumedCache);
            break;
        case 24:
            $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext);
    }
}
var $bcd00faefdd4b5d7$var$DefaultAsyncDispatcher = {
    getCacheForType: function getCacheForType(resourceType) {
        var cache = $bcd00faefdd4b5d7$var$readContext($bcd00faefdd4b5d7$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $bcd00faefdd4b5d7$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $bcd00faefdd4b5d7$var$executionContext = 0, $bcd00faefdd4b5d7$var$workInProgressRoot = null, $bcd00faefdd4b5d7$var$workInProgress = null, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = 0, $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0, $bcd00faefdd4b5d7$var$workInProgressThrownValue = null, $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings = !1, $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering = !1, $bcd00faefdd4b5d7$var$workInProgressRootDidAttachPingListener = !1, $bcd00faefdd4b5d7$var$entangledRenderLanes = 0, $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 0, $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes = 0, $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes = 0, $bcd00faefdd4b5d7$var$workInProgressRootPingedLanes = 0, $bcd00faefdd4b5d7$var$workInProgressDeferredLane = 0, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes = 0, $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors = null, $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = null, $bcd00faefdd4b5d7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $bcd00faefdd4b5d7$var$globalMostRecentFallbackTime = 0, $bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime = Infinity, $bcd00faefdd4b5d7$var$workInProgressTransitions = null, $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed = null, $bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects = !1, $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects = null, $bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes = 0, $bcd00faefdd4b5d7$var$pendingPassiveEffectsRemainingLanes = 0, $bcd00faefdd4b5d7$var$pendingPassiveTransitions = null, $bcd00faefdd4b5d7$var$nestedUpdateCount = 0, $bcd00faefdd4b5d7$var$rootWithNestedUpdates = null;
function $bcd00faefdd4b5d7$var$requestUpdateLane() {
    if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 2) && 0 !== $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes) return $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & -$bcd00faefdd4b5d7$var$workInProgressRootRenderLanes;
    if (null !== $bcd00faefdd4b5d7$var$ReactSharedInternals.T) {
        var actionScopeLane = $bcd00faefdd4b5d7$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $bcd00faefdd4b5d7$var$requestTransitionLane();
    }
    return $bcd00faefdd4b5d7$var$resolveUpdatePriority();
}
function $bcd00faefdd4b5d7$var$requestDeferredLane() {
    0 === $bcd00faefdd4b5d7$var$workInProgressDeferredLane && ($bcd00faefdd4b5d7$var$workInProgressDeferredLane = 0 === ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 536870912) || $bcd00faefdd4b5d7$var$isHydrating ? $bcd00faefdd4b5d7$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $bcd00faefdd4b5d7$var$workInProgressDeferredLane;
}
function $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $bcd00faefdd4b5d7$var$workInProgressRoot && 2 === $bcd00faefdd4b5d7$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $bcd00faefdd4b5d7$var$prepareFreshStack(root, 0), $bcd00faefdd4b5d7$var$markRootSuspended(root, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !1);
    $bcd00faefdd4b5d7$var$markRootUpdated$1(root, lane);
    if (0 === ($bcd00faefdd4b5d7$var$executionContext & 2) || root !== $bcd00faefdd4b5d7$var$workInProgressRoot) root === $bcd00faefdd4b5d7$var$workInProgressRoot && (0 === ($bcd00faefdd4b5d7$var$executionContext & 2) && ($bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && $bcd00faefdd4b5d7$var$markRootSuspended(root, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !1)), $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root);
}
function $bcd00faefdd4b5d7$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 6)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $bcd00faefdd4b5d7$var$renderRootConcurrent(root$jscomp$0, lanes) : $bcd00faefdd4b5d7$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $bcd00faefdd4b5d7$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $bcd00faefdd4b5d7$var$markRootSuspended(root$jscomp$0, lanes, 0, !$bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$bcd00faefdd4b5d7$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $bcd00faefdd4b5d7$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($bcd00faefdd4b5d7$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $bcd00faefdd4b5d7$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($bcd00faefdd4b5d7$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors;
                            $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $bcd00faefdd4b5d7$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $bcd00faefdd4b5d7$var$prepareFreshStack(root$jscomp$0, 0);
                $bcd00faefdd4b5d7$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $bcd00faefdd4b5d7$var$markRootSuspended(shouldTimeSlice, lanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !$bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $bcd00faefdd4b5d7$var$globalMostRecentFallbackTime + 300 - $bcd00faefdd4b5d7$var$now(), 10 < renderWasConcurrent)) {
                    $bcd00faefdd4b5d7$var$markRootSuspended(shouldTimeSlice, lanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !$bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $bcd00faefdd4b5d7$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $bcd00faefdd4b5d7$var$scheduleTimeout($bcd00faefdd4b5d7$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors, $bcd00faefdd4b5d7$var$workInProgressTransitions, $bcd00faefdd4b5d7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes, $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $bcd00faefdd4b5d7$var$commitRootWhenReady(shouldTimeSlice, forceSync, $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors, $bcd00faefdd4b5d7$var$workInProgressTransitions, $bcd00faefdd4b5d7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes, $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root$jscomp$0);
}
function $bcd00faefdd4b5d7$var$queueRecoverableErrors(errors) {
    null === $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors ? $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = errors : $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors.push.apply($bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors, errors);
}
function $bcd00faefdd4b5d7$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($bcd00faefdd4b5d7$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $bcd00faefdd4b5d7$var$noop
        }, $bcd00faefdd4b5d7$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $bcd00faefdd4b5d7$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($bcd00faefdd4b5d7$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $bcd00faefdd4b5d7$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $bcd00faefdd4b5d7$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $bcd00faefdd4b5d7$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$bcd00faefdd4b5d7$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $bcd00faefdd4b5d7$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$bcd00faefdd4b5d7$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $bcd00faefdd4b5d7$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $bcd00faefdd4b5d7$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $bcd00faefdd4b5d7$var$flushSyncWork$1() {
    return 0 === ($bcd00faefdd4b5d7$var$executionContext & 6) ? ($bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $bcd00faefdd4b5d7$var$resetWorkInProgressStack() {
    if (null !== $bcd00faefdd4b5d7$var$workInProgress) {
        if (0 === $bcd00faefdd4b5d7$var$workInProgressSuspendedReason) var interruptedWork = $bcd00faefdd4b5d7$var$workInProgress.return;
        else interruptedWork = $bcd00faefdd4b5d7$var$workInProgress, $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null, $bcd00faefdd4b5d7$var$resetHooksOnUnwind(interruptedWork), $bcd00faefdd4b5d7$var$thenableState$1 = null, $bcd00faefdd4b5d7$var$thenableIndexCounter$1 = 0, interruptedWork = $bcd00faefdd4b5d7$var$workInProgress;
        for(; null !== interruptedWork;)$bcd00faefdd4b5d7$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $bcd00faefdd4b5d7$var$workInProgress = null;
    }
}
function $bcd00faefdd4b5d7$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $bcd00faefdd4b5d7$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $bcd00faefdd4b5d7$var$resetWorkInProgressStack();
    $bcd00faefdd4b5d7$var$workInProgressRoot = root;
    $bcd00faefdd4b5d7$var$workInProgress = timeoutHandle = $bcd00faefdd4b5d7$var$createWorkInProgress(root.current, null);
    $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = lanes;
    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
    $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering = $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root, lanes);
    $bcd00faefdd4b5d7$var$workInProgressRootDidAttachPingListener = !1;
    $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes = $bcd00faefdd4b5d7$var$workInProgressDeferredLane = $bcd00faefdd4b5d7$var$workInProgressRootPingedLanes = $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes = $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes = $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 0;
    $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors = null;
    $bcd00faefdd4b5d7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $bcd00faefdd4b5d7$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $bcd00faefdd4b5d7$var$entangledRenderLanes = lanes;
    $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $bcd00faefdd4b5d7$var$handleThrow(root, thrownValue) {
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = null;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = $bcd00faefdd4b5d7$var$ContextOnlyDispatcher;
    thrownValue === $bcd00faefdd4b5d7$var$SuspenseException ? (thrownValue = $bcd00faefdd4b5d7$var$getSuspendedThenable(), $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 3) : thrownValue === $bcd00faefdd4b5d7$var$SuspenseyCommitException ? (thrownValue = $bcd00faefdd4b5d7$var$getSuspendedThenable(), $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 4) : $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = thrownValue === $bcd00faefdd4b5d7$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === (typeof thrownValue === "undefined" ? "undefined" : (0, $YtE9h._)(thrownValue)) && "function" === typeof thrownValue.then ? 6 : 1;
    $bcd00faefdd4b5d7$var$workInProgressThrownValue = thrownValue;
    null === $bcd00faefdd4b5d7$var$workInProgress && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 1, $bcd00faefdd4b5d7$var$logUncaughtError(root, $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $bcd00faefdd4b5d7$var$pushDispatcher() {
    var prevDispatcher = $bcd00faefdd4b5d7$var$ReactSharedInternals.H;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = $bcd00faefdd4b5d7$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $bcd00faefdd4b5d7$var$ContextOnlyDispatcher : prevDispatcher;
}
function $bcd00faefdd4b5d7$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $bcd00faefdd4b5d7$var$ReactSharedInternals.A;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.A = $bcd00faefdd4b5d7$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $bcd00faefdd4b5d7$var$renderDidSuspendDelayIfPossible() {
    $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 4;
    $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings || ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 4194176) !== $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes && null !== $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current || ($bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering = !0);
    0 === ($bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $bcd00faefdd4b5d7$var$workInProgressRoot || $bcd00faefdd4b5d7$var$markRootSuspended($bcd00faefdd4b5d7$var$workInProgressRoot, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !1);
}
function $bcd00faefdd4b5d7$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $bcd00faefdd4b5d7$var$executionContext;
    $bcd00faefdd4b5d7$var$executionContext |= 2;
    var prevDispatcher = $bcd00faefdd4b5d7$var$pushDispatcher(), prevAsyncDispatcher = $bcd00faefdd4b5d7$var$pushAsyncDispatcher();
    if ($bcd00faefdd4b5d7$var$workInProgressRoot !== root || $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes !== lanes) $bcd00faefdd4b5d7$var$workInProgressTransitions = null, $bcd00faefdd4b5d7$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $bcd00faefdd4b5d7$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $bcd00faefdd4b5d7$var$workInProgressSuspendedReason && null !== $bcd00faefdd4b5d7$var$workInProgress) {
            var unitOfWork = $bcd00faefdd4b5d7$var$workInProgress, thrownValue = $bcd00faefdd4b5d7$var$workInProgressThrownValue;
            switch($bcd00faefdd4b5d7$var$workInProgressSuspendedReason){
                case 8:
                    $bcd00faefdd4b5d7$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $bcd00faefdd4b5d7$var$workInProgressSuspendedReason;
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                    $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $bcd00faefdd4b5d7$var$workInProgressSuspendedReason, $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0, $bcd00faefdd4b5d7$var$workInProgressThrownValue = null, $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $bcd00faefdd4b5d7$var$workLoopSync();
        exitStatus = $bcd00faefdd4b5d7$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $bcd00faefdd4b5d7$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null;
    $bcd00faefdd4b5d7$var$executionContext = prevExecutionContext;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = prevDispatcher;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $bcd00faefdd4b5d7$var$workInProgress && ($bcd00faefdd4b5d7$var$workInProgressRoot = null, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = 0, $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $bcd00faefdd4b5d7$var$workLoopSync() {
    for(; null !== $bcd00faefdd4b5d7$var$workInProgress;)$bcd00faefdd4b5d7$var$performUnitOfWork($bcd00faefdd4b5d7$var$workInProgress);
}
function $bcd00faefdd4b5d7$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $bcd00faefdd4b5d7$var$executionContext;
    $bcd00faefdd4b5d7$var$executionContext |= 2;
    var prevDispatcher = $bcd00faefdd4b5d7$var$pushDispatcher(), prevAsyncDispatcher = $bcd00faefdd4b5d7$var$pushAsyncDispatcher();
    $bcd00faefdd4b5d7$var$workInProgressRoot !== root || $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes !== lanes ? ($bcd00faefdd4b5d7$var$workInProgressTransitions = null, $bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime = $bcd00faefdd4b5d7$var$now() + 500, $bcd00faefdd4b5d7$var$prepareFreshStack(root, lanes)) : $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering = $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $bcd00faefdd4b5d7$var$workInProgressSuspendedReason && null !== $bcd00faefdd4b5d7$var$workInProgress) {
            lanes = $bcd00faefdd4b5d7$var$workInProgress;
            var thrownValue = $bcd00faefdd4b5d7$var$workInProgressThrownValue;
            b: switch($bcd00faefdd4b5d7$var$workInProgressSuspendedReason){
                case 1:
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                    $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($bcd00faefdd4b5d7$var$isThenableResolved(thrownValue)) {
                        $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                        $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                        $bcd00faefdd4b5d7$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function lanes() {
                        2 === $bcd00faefdd4b5d7$var$workInProgressSuspendedReason && $bcd00faefdd4b5d7$var$workInProgressRoot === root && ($bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 7);
                        $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $bcd00faefdd4b5d7$var$isThenableResolved(thrownValue) ? ($bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0, $bcd00faefdd4b5d7$var$workInProgressThrownValue = null, $bcd00faefdd4b5d7$var$replaySuspendedUnitOfWork(lanes)) : ($bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0, $bcd00faefdd4b5d7$var$workInProgressThrownValue = null, $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($bcd00faefdd4b5d7$var$workInProgress.tag){
                        case 26:
                            resource = $bcd00faefdd4b5d7$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $bcd00faefdd4b5d7$var$workInProgress;
                            if (resource ? $bcd00faefdd4b5d7$var$preloadResource(resource) : 1) {
                                $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                                $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $bcd00faefdd4b5d7$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($bcd00faefdd4b5d7$var$workInProgress = returnFiber, $bcd00faefdd4b5d7$var$completeUnitOfWork(returnFiber)) : $bcd00faefdd4b5d7$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                    $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                    $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $bcd00faefdd4b5d7$var$resetWorkInProgressStack();
                    $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(462));
            }
        }
        $bcd00faefdd4b5d7$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $bcd00faefdd4b5d7$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = prevDispatcher;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $bcd00faefdd4b5d7$var$executionContext = prevExecutionContext;
    if (null !== $bcd00faefdd4b5d7$var$workInProgress) return 0;
    $bcd00faefdd4b5d7$var$workInProgressRoot = null;
    $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = 0;
    $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates();
    return $bcd00faefdd4b5d7$var$workInProgressRootExitStatus;
}
function $bcd00faefdd4b5d7$var$workLoopConcurrent() {
    for(; null !== $bcd00faefdd4b5d7$var$workInProgress && !$bcd00faefdd4b5d7$var$shouldYield();)$bcd00faefdd4b5d7$var$performUnitOfWork($bcd00faefdd4b5d7$var$workInProgress);
}
function $bcd00faefdd4b5d7$var$performUnitOfWork(unitOfWork) {
    var next = $bcd00faefdd4b5d7$var$beginWork(unitOfWork.alternate, unitOfWork, $bcd00faefdd4b5d7$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $bcd00faefdd4b5d7$var$completeUnitOfWork(unitOfWork) : $bcd00faefdd4b5d7$var$workInProgress = next;
}
function $bcd00faefdd4b5d7$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $bcd00faefdd4b5d7$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $bcd00faefdd4b5d7$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $bcd00faefdd4b5d7$var$resetHooksOnUnwind(next);
        default:
            $bcd00faefdd4b5d7$var$unwindInterruptedWork(current, next), next = $bcd00faefdd4b5d7$var$workInProgress = $bcd00faefdd4b5d7$var$resetWorkInProgress(next, $bcd00faefdd4b5d7$var$entangledRenderLanes), next = $bcd00faefdd4b5d7$var$beginWork(current, next, $bcd00faefdd4b5d7$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $bcd00faefdd4b5d7$var$completeUnitOfWork(unitOfWork) : $bcd00faefdd4b5d7$var$workInProgress = next;
}
function $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null;
    $bcd00faefdd4b5d7$var$resetHooksOnUnwind(unitOfWork);
    $bcd00faefdd4b5d7$var$thenableState$1 = null;
    $bcd00faefdd4b5d7$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($bcd00faefdd4b5d7$var$throwException(root, returnFiber, unitOfWork, thrownValue, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes)) {
            $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 1;
            $bcd00faefdd4b5d7$var$logUncaughtError(root, $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(thrownValue, root.current));
            $bcd00faefdd4b5d7$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $bcd00faefdd4b5d7$var$workInProgress = returnFiber, error;
        $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 1;
        $bcd00faefdd4b5d7$var$logUncaughtError(root, $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(thrownValue, root.current));
        $bcd00faefdd4b5d7$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($bcd00faefdd4b5d7$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering || 0 !== ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $bcd00faefdd4b5d7$var$unwindUnitOfWork(unitOfWork, root);
    } else $bcd00faefdd4b5d7$var$completeUnitOfWork(unitOfWork);
}
function $bcd00faefdd4b5d7$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $bcd00faefdd4b5d7$var$unwindUnitOfWork(completedWork, $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $bcd00faefdd4b5d7$var$completeWork(completedWork.alternate, completedWork, $bcd00faefdd4b5d7$var$entangledRenderLanes);
        if (null !== next) {
            $bcd00faefdd4b5d7$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $bcd00faefdd4b5d7$var$workInProgress = completedWork;
            return;
        }
        $bcd00faefdd4b5d7$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 5);
}
function $bcd00faefdd4b5d7$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $bcd00faefdd4b5d7$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $bcd00faefdd4b5d7$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $bcd00faefdd4b5d7$var$workInProgress = unitOfWork;
            return;
        }
        $bcd00faefdd4b5d7$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 6;
    $bcd00faefdd4b5d7$var$workInProgress = null;
}
function $bcd00faefdd4b5d7$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, previousUpdateLanePriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    try {
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 2, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null, $bcd00faefdd4b5d7$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition, $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $bcd00faefdd4b5d7$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $bcd00faefdd4b5d7$var$flushPassiveEffects();
    while (null !== $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects);
    if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 6)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $bcd00faefdd4b5d7$var$concurrentlyUpdatedLanes;
    $bcd00faefdd4b5d7$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $bcd00faefdd4b5d7$var$workInProgressRoot && ($bcd00faefdd4b5d7$var$workInProgress = $bcd00faefdd4b5d7$var$workInProgressRoot = null, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects || ($bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects = !0, $bcd00faefdd4b5d7$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $bcd00faefdd4b5d7$var$pendingPassiveTransitions = transitions, $bcd00faefdd4b5d7$var$scheduleCallback$1($bcd00faefdd4b5d7$var$NormalPriority$1, function() {
        $bcd00faefdd4b5d7$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null, spawnedLane = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p, $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 2, updatedLanes = $bcd00faefdd4b5d7$var$executionContext, $bcd00faefdd4b5d7$var$executionContext |= 4, $bcd00faefdd4b5d7$var$commitBeforeMutationEffects(root, finishedWork), $bcd00faefdd4b5d7$var$commitMutationEffectsOnFiber(finishedWork, root), $bcd00faefdd4b5d7$var$restoreSelection($bcd00faefdd4b5d7$var$selectionInformation, root.containerInfo), $bcd00faefdd4b5d7$var$_enabled = !!$bcd00faefdd4b5d7$var$eventsEnabled, $bcd00faefdd4b5d7$var$selectionInformation = $bcd00faefdd4b5d7$var$eventsEnabled = null, root.current = finishedWork, $bcd00faefdd4b5d7$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $bcd00faefdd4b5d7$var$requestPaint(), $bcd00faefdd4b5d7$var$executionContext = updatedLanes, $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = spawnedLane, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects ? ($bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects = !1, $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects = root, $bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $bcd00faefdd4b5d7$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $bcd00faefdd4b5d7$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes & 3) && $bcd00faefdd4b5d7$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $bcd00faefdd4b5d7$var$rootWithNestedUpdates ? $bcd00faefdd4b5d7$var$nestedUpdateCount++ : ($bcd00faefdd4b5d7$var$nestedUpdateCount = 0, $bcd00faefdd4b5d7$var$rootWithNestedUpdates = root) : $bcd00faefdd4b5d7$var$nestedUpdateCount = 0;
    $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $bcd00faefdd4b5d7$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $bcd00faefdd4b5d7$var$releaseCache(remainingLanes)));
}
function $bcd00faefdd4b5d7$var$flushPassiveEffects() {
    if (null !== $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects) {
        var root$170 = $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects, remainingLanes = $bcd00faefdd4b5d7$var$pendingPassiveEffectsRemainingLanes;
        $bcd00faefdd4b5d7$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $bcd00faefdd4b5d7$var$lanesToEventPriority($bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes), prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
        try {
            $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null;
            if (null === $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $bcd00faefdd4b5d7$var$pendingPassiveTransitions;
                $bcd00faefdd4b5d7$var$pendingPassiveTransitions = null;
                var root = $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects, lanes = $bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes;
                $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects = null;
                $bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 6)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(331));
                var prevExecutionContext = $bcd00faefdd4b5d7$var$executionContext;
                $bcd00faefdd4b5d7$var$executionContext |= 4;
                $bcd00faefdd4b5d7$var$commitPassiveUnmountOnFiber(root.current);
                $bcd00faefdd4b5d7$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $bcd00faefdd4b5d7$var$executionContext = prevExecutionContext;
                $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($bcd00faefdd4b5d7$var$injectedHook && "function" === typeof $bcd00faefdd4b5d7$var$injectedHook.onPostCommitFiberRoot) try {
                    $bcd00faefdd4b5d7$var$injectedHook.onPostCommitFiberRoot($bcd00faefdd4b5d7$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition, $bcd00faefdd4b5d7$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $bcd00faefdd4b5d7$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $bcd00faefdd4b5d7$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($bcd00faefdd4b5d7$var$markRootUpdated$1(rootFiber, 2), $bcd00faefdd4b5d7$var$ensureRootIsScheduled(rootFiber));
}
function $bcd00faefdd4b5d7$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $bcd00faefdd4b5d7$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed || !$bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $bcd00faefdd4b5d7$var$createClassErrorUpdate(2);
                instance = $bcd00faefdd4b5d7$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($bcd00faefdd4b5d7$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $bcd00faefdd4b5d7$var$markRootUpdated$1(instance, 2), $bcd00faefdd4b5d7$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $bcd00faefdd4b5d7$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $bcd00faefdd4b5d7$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($bcd00faefdd4b5d7$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $bcd00faefdd4b5d7$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $bcd00faefdd4b5d7$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $bcd00faefdd4b5d7$var$workInProgressRoot === root && ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus || 3 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 62914560) === $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes && 300 > $bcd00faefdd4b5d7$var$now() - $bcd00faefdd4b5d7$var$globalMostRecentFallbackTime ? 0 === ($bcd00faefdd4b5d7$var$executionContext & 2) && $bcd00faefdd4b5d7$var$prepareFreshStack(root, 0) : $bcd00faefdd4b5d7$var$workInProgressRootPingedLanes |= pingedLanes, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes === $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes && ($bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes = 0));
    $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root);
}
function $bcd00faefdd4b5d7$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $bcd00faefdd4b5d7$var$claimNextRetryLane());
    boundaryFiber = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($bcd00faefdd4b5d7$var$markRootUpdated$1(boundaryFiber, retryLane), $bcd00faefdd4b5d7$var$ensureRootIsScheduled(boundaryFiber));
}
function $bcd00faefdd4b5d7$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $bcd00faefdd4b5d7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $bcd00faefdd4b5d7$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $bcd00faefdd4b5d7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $bcd00faefdd4b5d7$var$scheduleCallback$1(priorityLevel, callback) {
    return $bcd00faefdd4b5d7$var$scheduleCallback$3(priorityLevel, callback);
}
var $bcd00faefdd4b5d7$var$firstScheduledRoot = null, $bcd00faefdd4b5d7$var$lastScheduledRoot = null, $bcd00faefdd4b5d7$var$didScheduleMicrotask = !1, $bcd00faefdd4b5d7$var$mightHavePendingSyncWork = !1, $bcd00faefdd4b5d7$var$isFlushingWork = !1, $bcd00faefdd4b5d7$var$currentEventTransitionLane = 0;
function $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root) {
    root !== $bcd00faefdd4b5d7$var$lastScheduledRoot && null === root.next && (null === $bcd00faefdd4b5d7$var$lastScheduledRoot ? $bcd00faefdd4b5d7$var$firstScheduledRoot = $bcd00faefdd4b5d7$var$lastScheduledRoot = root : $bcd00faefdd4b5d7$var$lastScheduledRoot = $bcd00faefdd4b5d7$var$lastScheduledRoot.next = root);
    $bcd00faefdd4b5d7$var$mightHavePendingSyncWork = !0;
    $bcd00faefdd4b5d7$var$didScheduleMicrotask || ($bcd00faefdd4b5d7$var$didScheduleMicrotask = !0, $bcd00faefdd4b5d7$var$scheduleImmediateTask($bcd00faefdd4b5d7$var$processRootScheduleInMicrotask));
}
function $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$bcd00faefdd4b5d7$var$isFlushingWork && $bcd00faefdd4b5d7$var$mightHavePendingSyncWork) {
        $bcd00faefdd4b5d7$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $bcd00faefdd4b5d7$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $bcd00faefdd4b5d7$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $bcd00faefdd4b5d7$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $bcd00faefdd4b5d7$var$getNextLanes(root$172, root$172 === $bcd00faefdd4b5d7$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $bcd00faefdd4b5d7$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $bcd00faefdd4b5d7$var$isFlushingWork = !1;
    }
}
function $bcd00faefdd4b5d7$var$processRootScheduleInMicrotask() {
    $bcd00faefdd4b5d7$var$mightHavePendingSyncWork = $bcd00faefdd4b5d7$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $bcd00faefdd4b5d7$var$currentEventTransitionLane && ($bcd00faefdd4b5d7$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $bcd00faefdd4b5d7$var$currentEventTransitionLane), $bcd00faefdd4b5d7$var$currentEventTransitionLane = 0);
    for(var currentTime = $bcd00faefdd4b5d7$var$now(), prev = null, root = $bcd00faefdd4b5d7$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $bcd00faefdd4b5d7$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $bcd00faefdd4b5d7$var$firstScheduledRoot = next : prev.next = next, null === next && ($bcd00faefdd4b5d7$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $bcd00faefdd4b5d7$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $bcd00faefdd4b5d7$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $bcd00faefdd4b5d7$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $bcd00faefdd4b5d7$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $bcd00faefdd4b5d7$var$workInProgressRoot;
    suspendedLanes = $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes;
    suspendedLanes = $bcd00faefdd4b5d7$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $bcd00faefdd4b5d7$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $bcd00faefdd4b5d7$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $bcd00faefdd4b5d7$var$cancelCallback$1(pingedLanes);
        switch($bcd00faefdd4b5d7$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $bcd00faefdd4b5d7$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $bcd00faefdd4b5d7$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $bcd00faefdd4b5d7$var$IdlePriority;
                break;
            default:
                suspendedLanes = $bcd00faefdd4b5d7$var$NormalPriority$1;
        }
        pingedLanes = $bcd00faefdd4b5d7$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $bcd00faefdd4b5d7$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $bcd00faefdd4b5d7$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $bcd00faefdd4b5d7$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($bcd00faefdd4b5d7$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $bcd00faefdd4b5d7$var$getNextLanes(root, root === $bcd00faefdd4b5d7$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $bcd00faefdd4b5d7$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $bcd00faefdd4b5d7$var$scheduleTaskForRootDuringMicrotask(root, $bcd00faefdd4b5d7$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $bcd00faefdd4b5d7$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $bcd00faefdd4b5d7$var$performSyncWorkOnRoot(root, lanes) {
    if ($bcd00faefdd4b5d7$var$flushPassiveEffects()) return null;
    $bcd00faefdd4b5d7$var$performWorkOnRoot(root, lanes, !0);
}
function $bcd00faefdd4b5d7$var$scheduleImmediateTask(cb) {
    $bcd00faefdd4b5d7$var$scheduleMicrotask(function() {
        0 !== ($bcd00faefdd4b5d7$var$executionContext & 6) ? $bcd00faefdd4b5d7$var$scheduleCallback$3($bcd00faefdd4b5d7$var$ImmediatePriority, cb) : cb();
    });
}
function $bcd00faefdd4b5d7$var$requestTransitionLane() {
    0 === $bcd00faefdd4b5d7$var$currentEventTransitionLane && ($bcd00faefdd4b5d7$var$currentEventTransitionLane = $bcd00faefdd4b5d7$var$claimNextTransitionLane());
    return $bcd00faefdd4b5d7$var$currentEventTransitionLane;
}
function $bcd00faefdd4b5d7$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === (typeof actionProp === "undefined" ? "undefined" : (0, $YtE9h._)(actionProp)) || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $bcd00faefdd4b5d7$var$sanitizeURL("" + actionProp);
}
function $bcd00faefdd4b5d7$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $bcd00faefdd4b5d7$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $bcd00faefdd4b5d7$var$coerceFormActionProp((nativeEventTarget[$bcd00faefdd4b5d7$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$bcd00faefdd4b5d7$var$internalPropsKey] || null) ? $bcd00faefdd4b5d7$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $bcd00faefdd4b5d7$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function listener() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $bcd00faefdd4b5d7$var$currentEventTransitionLane) {
                                var formData = submitter ? $bcd00faefdd4b5d7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $bcd00faefdd4b5d7$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $bcd00faefdd4b5d7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $bcd00faefdd4b5d7$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $bcd00faefdd4b5d7$var$i$jscomp$inline_1439 = 0; $bcd00faefdd4b5d7$var$i$jscomp$inline_1439 < $bcd00faefdd4b5d7$var$simpleEventPluginEvents.length; $bcd00faefdd4b5d7$var$i$jscomp$inline_1439++){
    var $bcd00faefdd4b5d7$var$eventName$jscomp$inline_1440 = $bcd00faefdd4b5d7$var$simpleEventPluginEvents[$bcd00faefdd4b5d7$var$i$jscomp$inline_1439], $bcd00faefdd4b5d7$var$domEventName$jscomp$inline_1441 = $bcd00faefdd4b5d7$var$eventName$jscomp$inline_1440.toLowerCase(), $bcd00faefdd4b5d7$var$capitalizedEvent$jscomp$inline_1442 = $bcd00faefdd4b5d7$var$eventName$jscomp$inline_1440[0].toUpperCase() + $bcd00faefdd4b5d7$var$eventName$jscomp$inline_1440.slice(1);
    $bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$domEventName$jscomp$inline_1441, "on" + $bcd00faefdd4b5d7$var$capitalizedEvent$jscomp$inline_1442);
}
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$ANIMATION_END, "onAnimationEnd");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$ANIMATION_ITERATION, "onAnimationIteration");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$ANIMATION_START, "onAnimationStart");
$bcd00faefdd4b5d7$var$registerSimpleEvent("dblclick", "onDoubleClick");
$bcd00faefdd4b5d7$var$registerSimpleEvent("focusin", "onFocus");
$bcd00faefdd4b5d7$var$registerSimpleEvent("focusout", "onBlur");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$TRANSITION_RUN, "onTransitionRun");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$TRANSITION_START, "onTransitionStart");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$TRANSITION_CANCEL, "onTransitionCancel");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$TRANSITION_END, "onTransitionEnd");
$bcd00faefdd4b5d7$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bcd00faefdd4b5d7$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bcd00faefdd4b5d7$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bcd00faefdd4b5d7$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bcd00faefdd4b5d7$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bcd00faefdd4b5d7$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($bcd00faefdd4b5d7$var$mediaEventTypes));
function $bcd00faefdd4b5d7$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$bcd00faefdd4b5d7$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$bcd00faefdd4b5d7$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($bcd00faefdd4b5d7$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $bcd00faefdd4b5d7$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $bcd00faefdd4b5d7$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $bcd00faefdd4b5d7$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $bcd00faefdd4b5d7$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$bcd00faefdd4b5d7$var$listeningMarker]) {
        rootContainerElement[$bcd00faefdd4b5d7$var$listeningMarker] = !0;
        $bcd00faefdd4b5d7$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($bcd00faefdd4b5d7$var$nonDelegatedEvents.has(domEventName) || $bcd00faefdd4b5d7$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $bcd00faefdd4b5d7$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$bcd00faefdd4b5d7$var$listeningMarker] || (ownerDocument[$bcd00faefdd4b5d7$var$listeningMarker] = !0, $bcd00faefdd4b5d7$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $bcd00faefdd4b5d7$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($bcd00faefdd4b5d7$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $bcd00faefdd4b5d7$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $bcd00faefdd4b5d7$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $bcd00faefdd4b5d7$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$bcd00faefdd4b5d7$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $bcd00faefdd4b5d7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $bcd00faefdd4b5d7$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $bcd00faefdd4b5d7$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $bcd00faefdd4b5d7$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $bcd00faefdd4b5d7$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticTouchEvent;
                        break;
                    case $bcd00faefdd4b5d7$var$ANIMATION_END:
                    case $bcd00faefdd4b5d7$var$ANIMATION_ITERATION:
                    case $bcd00faefdd4b5d7$var$ANIMATION_START:
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticAnimationEvent;
                        break;
                    case $bcd00faefdd4b5d7$var$TRANSITION_END:
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $bcd00faefdd4b5d7$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($bcd00faefdd4b5d7$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $bcd00faefdd4b5d7$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($bcd00faefdd4b5d7$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$bcd00faefdd4b5d7$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $bcd00faefdd4b5d7$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $bcd00faefdd4b5d7$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $bcd00faefdd4b5d7$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $bcd00faefdd4b5d7$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $bcd00faefdd4b5d7$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $bcd00faefdd4b5d7$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $bcd00faefdd4b5d7$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $bcd00faefdd4b5d7$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $bcd00faefdd4b5d7$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $bcd00faefdd4b5d7$var$getParent(inCapturePhase);
                                reactEventName = $bcd00faefdd4b5d7$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $bcd00faefdd4b5d7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $bcd00faefdd4b5d7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $bcd00faefdd4b5d7$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForChangeEvent;
                else if ($bcd00faefdd4b5d7$var$isTextInputElement(reactName)) {
                    if ($bcd00faefdd4b5d7$var$isInputEventSupported) getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $bcd00faefdd4b5d7$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $bcd00faefdd4b5d7$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForChangeEvent) : getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $bcd00faefdd4b5d7$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $bcd00faefdd4b5d7$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $bcd00faefdd4b5d7$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($bcd00faefdd4b5d7$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $bcd00faefdd4b5d7$var$activeElement = handleEventFunc, $bcd00faefdd4b5d7$var$activeElementInst = targetInst, $bcd00faefdd4b5d7$var$lastSelection = null;
                    break;
                case "focusout":
                    $bcd00faefdd4b5d7$var$lastSelection = $bcd00faefdd4b5d7$var$activeElementInst = $bcd00faefdd4b5d7$var$activeElement = null;
                    break;
                case "mousedown":
                    $bcd00faefdd4b5d7$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bcd00faefdd4b5d7$var$mouseDown = !1;
                    $bcd00faefdd4b5d7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($bcd00faefdd4b5d7$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $bcd00faefdd4b5d7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($bcd00faefdd4b5d7$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $bcd00faefdd4b5d7$var$isComposing ? $bcd00faefdd4b5d7$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($bcd00faefdd4b5d7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($bcd00faefdd4b5d7$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $bcd00faefdd4b5d7$var$isComposing && (fallbackData = $bcd00faefdd4b5d7$var$getData()) : ($bcd00faefdd4b5d7$var$root = nativeEventTarget, $bcd00faefdd4b5d7$var$startText = "value" in $bcd00faefdd4b5d7$var$root ? $bcd00faefdd4b5d7$var$root.value : $bcd00faefdd4b5d7$var$root.textContent, $bcd00faefdd4b5d7$var$isComposing = !0)), handleEventFunc = $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $bcd00faefdd4b5d7$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $bcd00faefdd4b5d7$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $bcd00faefdd4b5d7$var$canUseTextInputEvent ? $bcd00faefdd4b5d7$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $bcd00faefdd4b5d7$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $bcd00faefdd4b5d7$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $bcd00faefdd4b5d7$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $bcd00faefdd4b5d7$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $bcd00faefdd4b5d7$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $bcd00faefdd4b5d7$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($bcd00faefdd4b5d7$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $bcd00faefdd4b5d7$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($bcd00faefdd4b5d7$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $bcd00faefdd4b5d7$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $bcd00faefdd4b5d7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $bcd00faefdd4b5d7$var$getListener(target, registrationName), null != stateNode && listeners.unshift($bcd00faefdd4b5d7$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $bcd00faefdd4b5d7$var$getListener(target, registrationName), null != stateNode && listeners.push($bcd00faefdd4b5d7$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $bcd00faefdd4b5d7$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $bcd00faefdd4b5d7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $bcd00faefdd4b5d7$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($bcd00faefdd4b5d7$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($bcd00faefdd4b5d7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $bcd00faefdd4b5d7$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $bcd00faefdd4b5d7$var$normalizeMarkupForTextOrAttribute(clientText);
    return $bcd00faefdd4b5d7$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $bcd00faefdd4b5d7$var$noop$1() {}
function $bcd00faefdd4b5d7$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $bcd00faefdd4b5d7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value))) && "body" !== tag && $bcd00faefdd4b5d7$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $bcd00faefdd4b5d7$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $bcd00faefdd4b5d7$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $bcd00faefdd4b5d7$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $bcd00faefdd4b5d7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $bcd00faefdd4b5d7$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $bcd00faefdd4b5d7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $bcd00faefdd4b5d7$var$setProp(domElement, tag, "name", props.name, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($bcd00faefdd4b5d7$var$setProp(domElement, tag, "encType", props.encType, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "method", props.method, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $bcd00faefdd4b5d7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $bcd00faefdd4b5d7$var$noop$1);
            break;
        case "onScroll":
            null != value && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || !("__html" in value)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value));
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value));
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value))) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $bcd00faefdd4b5d7$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("toggle", domElement);
            $bcd00faefdd4b5d7$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $bcd00faefdd4b5d7$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $bcd00faefdd4b5d7$var$aliases.get(key) || key, $bcd00faefdd4b5d7$var$setValueForAttribute(domElement, key, value);
    }
}
function $bcd00faefdd4b5d7$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $bcd00faefdd4b5d7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || !("__html" in value)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $bcd00faefdd4b5d7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value))) && $bcd00faefdd4b5d7$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $bcd00faefdd4b5d7$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$bcd00faefdd4b5d7$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$bcd00faefdd4b5d7$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $bcd00faefdd4b5d7$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $bcd00faefdd4b5d7$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", domElement);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                    default:
                        $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $bcd00faefdd4b5d7$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $bcd00faefdd4b5d7$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $bcd00faefdd4b5d7$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $bcd00faefdd4b5d7$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $bcd00faefdd4b5d7$var$track(domElement);
            return;
        case "select":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $bcd00faefdd4b5d7$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $bcd00faefdd4b5d7$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(91));
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $bcd00faefdd4b5d7$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $bcd00faefdd4b5d7$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== (typeof hasSrc === "undefined" ? "undefined" : (0, $YtE9h._)(hasSrc));
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("cancel", domElement);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $bcd00faefdd4b5d7$var$mediaEventTypes.length; hasSrc++)$bcd00faefdd4b5d7$var$listenToNonDelegatedEvent($bcd00faefdd4b5d7$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", domElement);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", domElement), $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($bcd00faefdd4b5d7$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $bcd00faefdd4b5d7$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $bcd00faefdd4b5d7$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $bcd00faefdd4b5d7$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $bcd00faefdd4b5d7$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $bcd00faefdd4b5d7$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $bcd00faefdd4b5d7$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $bcd00faefdd4b5d7$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $bcd00faefdd4b5d7$var$updateOptions(domElement, !!lastProps, tag, !0) : $bcd00faefdd4b5d7$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $bcd00faefdd4b5d7$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $bcd00faefdd4b5d7$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== (typeof propKey$203 === "undefined" ? "undefined" : (0, $YtE9h._)(propKey$203));
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($bcd00faefdd4b5d7$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $bcd00faefdd4b5d7$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $bcd00faefdd4b5d7$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $bcd00faefdd4b5d7$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $bcd00faefdd4b5d7$var$eventsEnabled = null, $bcd00faefdd4b5d7$var$selectionInformation = null;
function $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $bcd00faefdd4b5d7$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $bcd00faefdd4b5d7$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $bcd00faefdd4b5d7$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === (0, $YtE9h._)(props.children) || "object" === (0, $YtE9h._)(props.dangerouslySetInnerHTML) && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $bcd00faefdd4b5d7$var$currentPopstateTransitionEvent = null;
function $bcd00faefdd4b5d7$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $bcd00faefdd4b5d7$var$currentPopstateTransitionEvent) return !1;
        $bcd00faefdd4b5d7$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $bcd00faefdd4b5d7$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $bcd00faefdd4b5d7$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $bcd00faefdd4b5d7$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $bcd00faefdd4b5d7$var$localPromise = "function" === typeof Promise ? Promise : void 0, $bcd00faefdd4b5d7$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bcd00faefdd4b5d7$var$localPromise ? function scheduleMicrotask(callback) {
    return $bcd00faefdd4b5d7$var$localPromise.resolve(null).then(callback).catch($bcd00faefdd4b5d7$var$handleErrorInNextTick);
} : $bcd00faefdd4b5d7$var$scheduleTimeout;
function $bcd00faefdd4b5d7$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $bcd00faefdd4b5d7$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $bcd00faefdd4b5d7$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $bcd00faefdd4b5d7$var$retryIfBlockedOn(suspenseInstance);
}
function $bcd00faefdd4b5d7$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $bcd00faefdd4b5d7$var$clearContainerSparingly(node);
                $bcd00faefdd4b5d7$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $bcd00faefdd4b5d7$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$bcd00faefdd4b5d7$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $bcd00faefdd4b5d7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $bcd00faefdd4b5d7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $bcd00faefdd4b5d7$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $bcd00faefdd4b5d7$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(451));
    }
}
var $bcd00faefdd4b5d7$var$preloadPropsMap = new Map(), $bcd00faefdd4b5d7$var$preconnectsSet = new Set();
function $bcd00faefdd4b5d7$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $bcd00faefdd4b5d7$var$previousDispatcher = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.d;
$bcd00faefdd4b5d7$var$ReactDOMSharedInternals.d = {
    f: $bcd00faefdd4b5d7$var$flushSyncWork,
    r: $bcd00faefdd4b5d7$var$requestFormReset,
    D: $bcd00faefdd4b5d7$var$prefetchDNS,
    C: $bcd00faefdd4b5d7$var$preconnect,
    L: $bcd00faefdd4b5d7$var$preload,
    m: $bcd00faefdd4b5d7$var$preloadModule,
    X: $bcd00faefdd4b5d7$var$preinitScript,
    S: $bcd00faefdd4b5d7$var$preinitStyle,
    M: $bcd00faefdd4b5d7$var$preinitModuleScript
};
function $bcd00faefdd4b5d7$var$flushSyncWork() {
    var previousWasRendering = $bcd00faefdd4b5d7$var$previousDispatcher.f(), wasRendering = $bcd00faefdd4b5d7$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $bcd00faefdd4b5d7$var$requestFormReset(form) {
    var formInst = $bcd00faefdd4b5d7$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $bcd00faefdd4b5d7$var$requestFormReset$1(formInst) : $bcd00faefdd4b5d7$var$previousDispatcher.r(form);
}
var $bcd00faefdd4b5d7$var$globalDocument = "undefined" === typeof document ? null : document;
function $bcd00faefdd4b5d7$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $bcd00faefdd4b5d7$var$preconnectsSet.has(limitedEscapedHref) || ($bcd00faefdd4b5d7$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $bcd00faefdd4b5d7$var$setInitialProperties(href, "link", rel), $bcd00faefdd4b5d7$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $bcd00faefdd4b5d7$var$prefetchDNS(href) {
    $bcd00faefdd4b5d7$var$previousDispatcher.D(href);
    $bcd00faefdd4b5d7$var$preconnectAs("dns-prefetch", href, null);
}
function $bcd00faefdd4b5d7$var$preconnect(href, crossOrigin) {
    $bcd00faefdd4b5d7$var$previousDispatcher.C(href, crossOrigin);
    $bcd00faefdd4b5d7$var$preconnectAs("preconnect", href, crossOrigin);
}
function $bcd00faefdd4b5d7$var$preload(href, as, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $bcd00faefdd4b5d7$var$getStyleKey(href);
                break;
            case "script":
                key = $bcd00faefdd4b5d7$var$getScriptKey(href);
        }
        $bcd00faefdd4b5d7$var$preloadPropsMap.has(key) || (href = $bcd00faefdd4b5d7$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $bcd00faefdd4b5d7$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $bcd00faefdd4b5d7$var$setInitialProperties(as, "link", href), $bcd00faefdd4b5d7$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $bcd00faefdd4b5d7$var$preloadModule(href, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.m(href, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $bcd00faefdd4b5d7$var$getScriptKey(href);
        }
        if (!$bcd00faefdd4b5d7$var$preloadPropsMap.has(key) && (href = $bcd00faefdd4b5d7$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $bcd00faefdd4b5d7$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $bcd00faefdd4b5d7$var$setInitialProperties(as, "link", href);
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $bcd00faefdd4b5d7$var$preinitStyle(href, precedence, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $bcd00faefdd4b5d7$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $bcd00faefdd4b5d7$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $bcd00faefdd4b5d7$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $bcd00faefdd4b5d7$var$preloadPropsMap.get(key)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $bcd00faefdd4b5d7$var$markNodeAsHoistable(link);
                $bcd00faefdd4b5d7$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $bcd00faefdd4b5d7$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $bcd00faefdd4b5d7$var$preinitScript(src, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.X(src, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $bcd00faefdd4b5d7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $bcd00faefdd4b5d7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key)), resource || (src = $bcd00faefdd4b5d7$var$assign({
            src: src,
            async: !0
        }, options), (options = $bcd00faefdd4b5d7$var$preloadPropsMap.get(key)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $bcd00faefdd4b5d7$var$markNodeAsHoistable(resource), $bcd00faefdd4b5d7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $bcd00faefdd4b5d7$var$preinitModuleScript(src, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.M(src, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $bcd00faefdd4b5d7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $bcd00faefdd4b5d7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key)), resource || (src = $bcd00faefdd4b5d7$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $bcd00faefdd4b5d7$var$preloadPropsMap.get(key)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $bcd00faefdd4b5d7$var$markNodeAsHoistable(resource), $bcd00faefdd4b5d7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $bcd00faefdd4b5d7$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $bcd00faefdd4b5d7$var$rootInstanceStackCursor.current) ? $bcd00faefdd4b5d7$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $bcd00faefdd4b5d7$var$getStyleKey(pendingProps.href), pendingProps = $bcd00faefdd4b5d7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $bcd00faefdd4b5d7$var$getStyleKey(pendingProps.href);
                var styles$242 = $bcd00faefdd4b5d7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $bcd00faefdd4b5d7$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $bcd00faefdd4b5d7$var$preloadPropsMap.set(type, pendingProps), styles$242 || $bcd00faefdd4b5d7$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== (typeof currentProps === "undefined" ? "undefined" : (0, $YtE9h._)(currentProps)) ? (currentProps = $bcd00faefdd4b5d7$var$getScriptKey(pendingProps), pendingProps = $bcd00faefdd4b5d7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(444, type));
    }
}
function $bcd00faefdd4b5d7$var$getStyleKey(href) {
    return 'href="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $bcd00faefdd4b5d7$var$stylesheetPropsFromRawProps(rawProps) {
    return $bcd00faefdd4b5d7$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $bcd00faefdd4b5d7$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $bcd00faefdd4b5d7$var$setInitialProperties(key, "link", preloadProps), $bcd00faefdd4b5d7$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $bcd00faefdd4b5d7$var$getScriptKey(src) {
    return '[src="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $bcd00faefdd4b5d7$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance), instance;
            var styleProps = $bcd00faefdd4b5d7$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance);
            $bcd00faefdd4b5d7$var$setInitialProperties(instance, "style", styleProps);
            $bcd00faefdd4b5d7$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $bcd00faefdd4b5d7$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $bcd00faefdd4b5d7$var$stylesheetPropsFromRawProps(props);
            (styleProps = $bcd00faefdd4b5d7$var$preloadPropsMap.get(styleProps)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $bcd00faefdd4b5d7$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $bcd00faefdd4b5d7$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $bcd00faefdd4b5d7$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $bcd00faefdd4b5d7$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $bcd00faefdd4b5d7$var$preloadPropsMap.get(instance$248)) instance = $bcd00faefdd4b5d7$var$assign({}, props), $bcd00faefdd4b5d7$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(styleProps);
            $bcd00faefdd4b5d7$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $bcd00faefdd4b5d7$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $bcd00faefdd4b5d7$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $bcd00faefdd4b5d7$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $bcd00faefdd4b5d7$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $bcd00faefdd4b5d7$var$tagCaches = null;
function $bcd00faefdd4b5d7$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $bcd00faefdd4b5d7$var$tagCaches) {
        var cache = new Map();
        var caches = $bcd00faefdd4b5d7$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $bcd00faefdd4b5d7$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$bcd00faefdd4b5d7$var$internalHoistableMarker] || node[$bcd00faefdd4b5d7$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $bcd00faefdd4b5d7$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $bcd00faefdd4b5d7$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== (0, $YtE9h._)(props.async) && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $bcd00faefdd4b5d7$var$suspendedState = null;
function $bcd00faefdd4b5d7$var$noop() {}
function $bcd00faefdd4b5d7$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $bcd00faefdd4b5d7$var$suspendedState) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(475));
    var state = $bcd00faefdd4b5d7$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $bcd00faefdd4b5d7$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === (typeof hoistableRoot === "undefined" ? "undefined" : (0, $YtE9h._)(hoistableRoot)) && "function" === typeof hoistableRoot.then && (state.count++, state = $bcd00faefdd4b5d7$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $bcd00faefdd4b5d7$var$stylesheetPropsFromRawProps(props);
            (key = $bcd00faefdd4b5d7$var$preloadPropsMap.get(key)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $bcd00faefdd4b5d7$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $bcd00faefdd4b5d7$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $bcd00faefdd4b5d7$var$waitForCommitToBeReady() {
    if (null === $bcd00faefdd4b5d7$var$suspendedState) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(475));
    var state = $bcd00faefdd4b5d7$var$suspendedState;
    state.stylesheets && 0 === state.count && $bcd00faefdd4b5d7$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $bcd00faefdd4b5d7$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $bcd00faefdd4b5d7$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $bcd00faefdd4b5d7$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $bcd00faefdd4b5d7$var$precedencesByRoot = null;
function $bcd00faefdd4b5d7$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $bcd00faefdd4b5d7$var$precedencesByRoot = new Map(), resources.forEach($bcd00faefdd4b5d7$var$insertStylesheetIntoRoot, state), $bcd00faefdd4b5d7$var$precedencesByRoot = null, $bcd00faefdd4b5d7$var$onUnsuspend.call(state));
}
function $bcd00faefdd4b5d7$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $bcd00faefdd4b5d7$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $bcd00faefdd4b5d7$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $bcd00faefdd4b5d7$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $bcd00faefdd4b5d7$var$HostTransitionContext = {
    $$typeof: $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $bcd00faefdd4b5d7$var$sharedNotPendingObject,
    _currentValue2: $bcd00faefdd4b5d7$var$sharedNotPendingObject,
    _threadCount: 0
};
function $bcd00faefdd4b5d7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $bcd00faefdd4b5d7$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bcd00faefdd4b5d7$var$createLaneMap(0);
    this.hiddenUpdates = $bcd00faefdd4b5d7$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $bcd00faefdd4b5d7$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $bcd00faefdd4b5d7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $bcd00faefdd4b5d7$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $bcd00faefdd4b5d7$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $bcd00faefdd4b5d7$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $bcd00faefdd4b5d7$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $bcd00faefdd4b5d7$var$emptyContextObject;
    parentComponent = $bcd00faefdd4b5d7$var$emptyContextObject;
    return parentComponent;
}
function $bcd00faefdd4b5d7$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $bcd00faefdd4b5d7$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $bcd00faefdd4b5d7$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $bcd00faefdd4b5d7$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(element, rootFiber, lane), $bcd00faefdd4b5d7$var$entangleTransitions(element, rootFiber, lane));
}
function $bcd00faefdd4b5d7$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $bcd00faefdd4b5d7$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $bcd00faefdd4b5d7$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $bcd00faefdd4b5d7$var$markRetryLaneImpl(fiber, retryLane);
}
function $bcd00faefdd4b5d7$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $bcd00faefdd4b5d7$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $bcd00faefdd4b5d7$var$_enabled = !0;
function $bcd00faefdd4b5d7$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null;
    var previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    try {
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 2, $bcd00faefdd4b5d7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $bcd00faefdd4b5d7$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null;
    var previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    try {
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 8, $bcd00faefdd4b5d7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $bcd00faefdd4b5d7$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($bcd00faefdd4b5d7$var$_enabled) {
        var blockedOn = $bcd00faefdd4b5d7$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $bcd00faefdd4b5d7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $bcd00faefdd4b5d7$var$return_targetInst, targetContainer), $bcd00faefdd4b5d7$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($bcd00faefdd4b5d7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($bcd00faefdd4b5d7$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $bcd00faefdd4b5d7$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $bcd00faefdd4b5d7$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $bcd00faefdd4b5d7$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $bcd00faefdd4b5d7$var$ensureRootIsScheduled(fiber);
                                0 === ($bcd00faefdd4b5d7$var$executionContext & 6) && ($bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime = $bcd00faefdd4b5d7$var$now() + 500, $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 2), $bcd00faefdd4b5d7$var$flushSyncWork$1(), $bcd00faefdd4b5d7$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $bcd00faefdd4b5d7$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $bcd00faefdd4b5d7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $bcd00faefdd4b5d7$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $bcd00faefdd4b5d7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $bcd00faefdd4b5d7$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $bcd00faefdd4b5d7$var$getEventTarget(nativeEvent);
    return $bcd00faefdd4b5d7$var$findInstanceBlockingTarget(nativeEvent);
}
var $bcd00faefdd4b5d7$var$return_targetInst = null;
function $bcd00faefdd4b5d7$var$findInstanceBlockingTarget(targetNode) {
    $bcd00faefdd4b5d7$var$return_targetInst = null;
    targetNode = $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $bcd00faefdd4b5d7$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $bcd00faefdd4b5d7$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $bcd00faefdd4b5d7$var$return_targetInst = targetNode;
    return null;
}
function $bcd00faefdd4b5d7$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($bcd00faefdd4b5d7$var$getCurrentPriorityLevel()){
                case $bcd00faefdd4b5d7$var$ImmediatePriority:
                    return 2;
                case $bcd00faefdd4b5d7$var$UserBlockingPriority:
                    return 8;
                case $bcd00faefdd4b5d7$var$NormalPriority$1:
                case $bcd00faefdd4b5d7$var$LowPriority:
                    return 32;
                case $bcd00faefdd4b5d7$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $bcd00faefdd4b5d7$var$hasScheduledReplayAttempt = !1, $bcd00faefdd4b5d7$var$queuedFocus = null, $bcd00faefdd4b5d7$var$queuedDrag = null, $bcd00faefdd4b5d7$var$queuedMouse = null, $bcd00faefdd4b5d7$var$queuedPointers = new Map(), $bcd00faefdd4b5d7$var$queuedPointerCaptures = new Map(), $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets = [], $bcd00faefdd4b5d7$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $bcd00faefdd4b5d7$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $bcd00faefdd4b5d7$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $bcd00faefdd4b5d7$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $bcd00faefdd4b5d7$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $bcd00faefdd4b5d7$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bcd00faefdd4b5d7$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $bcd00faefdd4b5d7$var$getInstanceFromNode(blockedOn), null !== blockedOn && $bcd00faefdd4b5d7$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $bcd00faefdd4b5d7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $bcd00faefdd4b5d7$var$queuedFocus = $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $bcd00faefdd4b5d7$var$queuedDrag = $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $bcd00faefdd4b5d7$var$queuedMouse = $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $bcd00faefdd4b5d7$var$queuedPointers.set(pointerId, $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $bcd00faefdd4b5d7$var$queuedPointerCaptures.set(pointerId, $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $bcd00faefdd4b5d7$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $bcd00faefdd4b5d7$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $bcd00faefdd4b5d7$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $bcd00faefdd4b5d7$var$requestUpdateLane(), root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $bcd00faefdd4b5d7$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $bcd00faefdd4b5d7$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $bcd00faefdd4b5d7$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $bcd00faefdd4b5d7$var$currentReplayingEvent = null;
        } else return targetContainers = $bcd00faefdd4b5d7$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $bcd00faefdd4b5d7$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $bcd00faefdd4b5d7$var$replayUnblockedEvents() {
    $bcd00faefdd4b5d7$var$hasScheduledReplayAttempt = !1;
    null !== $bcd00faefdd4b5d7$var$queuedFocus && $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent($bcd00faefdd4b5d7$var$queuedFocus) && ($bcd00faefdd4b5d7$var$queuedFocus = null);
    null !== $bcd00faefdd4b5d7$var$queuedDrag && $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent($bcd00faefdd4b5d7$var$queuedDrag) && ($bcd00faefdd4b5d7$var$queuedDrag = null);
    null !== $bcd00faefdd4b5d7$var$queuedMouse && $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent($bcd00faefdd4b5d7$var$queuedMouse) && ($bcd00faefdd4b5d7$var$queuedMouse = null);
    $bcd00faefdd4b5d7$var$queuedPointers.forEach($bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEventInMap);
    $bcd00faefdd4b5d7$var$queuedPointerCaptures.forEach($bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEventInMap);
}
function $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $bcd00faefdd4b5d7$var$hasScheduledReplayAttempt || ($bcd00faefdd4b5d7$var$hasScheduledReplayAttempt = !0, $go0bk.unstable_scheduleCallback($go0bk.unstable_NormalPriority, $bcd00faefdd4b5d7$var$replayUnblockedEvents)));
}
var $bcd00faefdd4b5d7$var$lastScheduledReplayQueue = null;
function $bcd00faefdd4b5d7$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $bcd00faefdd4b5d7$var$lastScheduledReplayQueue !== formReplayingQueue && ($bcd00faefdd4b5d7$var$lastScheduledReplayQueue = formReplayingQueue, $go0bk.unstable_scheduleCallback($go0bk.unstable_NormalPriority, function() {
        $bcd00faefdd4b5d7$var$lastScheduledReplayQueue === formReplayingQueue && ($bcd00faefdd4b5d7$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $bcd00faefdd4b5d7$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $bcd00faefdd4b5d7$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $bcd00faefdd4b5d7$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $bcd00faefdd4b5d7$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $bcd00faefdd4b5d7$var$queuedFocus && $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked($bcd00faefdd4b5d7$var$queuedFocus, unblocked);
    null !== $bcd00faefdd4b5d7$var$queuedDrag && $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked($bcd00faefdd4b5d7$var$queuedDrag, unblocked);
    null !== $bcd00faefdd4b5d7$var$queuedMouse && $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked($bcd00faefdd4b5d7$var$queuedMouse, unblocked);
    $bcd00faefdd4b5d7$var$queuedPointers.forEach(unblock);
    $bcd00faefdd4b5d7$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.length && (i = $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$bcd00faefdd4b5d7$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$bcd00faefdd4b5d7$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $bcd00faefdd4b5d7$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$bcd00faefdd4b5d7$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $bcd00faefdd4b5d7$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $bcd00faefdd4b5d7$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $bcd00faefdd4b5d7$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$bcd00faefdd4b5d7$var$ReactDOMHydrationRoot.prototype.render = $bcd00faefdd4b5d7$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(409));
    var current = root.current, lane = $bcd00faefdd4b5d7$var$requestUpdateLane();
    $bcd00faefdd4b5d7$var$updateContainerImpl(current, lane, children, root, null, null);
};
$bcd00faefdd4b5d7$var$ReactDOMHydrationRoot.prototype.unmount = $bcd00faefdd4b5d7$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $bcd00faefdd4b5d7$var$flushPassiveEffects();
        $bcd00faefdd4b5d7$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $bcd00faefdd4b5d7$var$flushSyncWork$1();
        container[$bcd00faefdd4b5d7$var$internalContainerInstanceKey] = null;
    }
};
function $bcd00faefdd4b5d7$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$bcd00faefdd4b5d7$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $bcd00faefdd4b5d7$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets[i].priority; i++);
        $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $bcd00faefdd4b5d7$var$attemptExplicitHydrationTarget(target);
    }
};
var $bcd00faefdd4b5d7$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $fIwXP.version;
if ("19.0.0" !== $bcd00faefdd4b5d7$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(527, $bcd00faefdd4b5d7$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$bcd00faefdd4b5d7$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $bcd00faefdd4b5d7$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $bcd00faefdd4b5d7$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $bcd00faefdd4b5d7$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $bcd00faefdd4b5d7$var$ReactSharedInternals,
    findFiberByHostInstance: $bcd00faefdd4b5d7$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bcd00faefdd4b5d7$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bcd00faefdd4b5d7$var$hook$jscomp$inline_2166.isDisabled && $bcd00faefdd4b5d7$var$hook$jscomp$inline_2166.supportsFiber) try {
        $bcd00faefdd4b5d7$var$rendererID = $bcd00faefdd4b5d7$var$hook$jscomp$inline_2166.inject($bcd00faefdd4b5d7$var$internals$jscomp$inline_2165), $bcd00faefdd4b5d7$var$injectedHook = $bcd00faefdd4b5d7$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$bcd00faefdd4b5d7$export$882461b6382ed46c = function(container, options) {
    if (!$bcd00faefdd4b5d7$var$isValidContainer(container)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $bcd00faefdd4b5d7$var$defaultOnUncaughtError, onCaughtError = $bcd00faefdd4b5d7$var$defaultOnCaughtError, onRecoverableError = $bcd00faefdd4b5d7$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $bcd00faefdd4b5d7$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$bcd00faefdd4b5d7$var$internalContainerInstanceKey] = options.current;
    $bcd00faefdd4b5d7$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $bcd00faefdd4b5d7$var$ReactDOMRoot(options);
};
$bcd00faefdd4b5d7$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$bcd00faefdd4b5d7$var$isValidContainer(container)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $bcd00faefdd4b5d7$var$defaultOnUncaughtError, onCaughtError = $bcd00faefdd4b5d7$var$defaultOnCaughtError, onRecoverableError = $bcd00faefdd4b5d7$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $bcd00faefdd4b5d7$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $bcd00faefdd4b5d7$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $bcd00faefdd4b5d7$var$requestUpdateLane();
    identifierPrefix = $bcd00faefdd4b5d7$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $bcd00faefdd4b5d7$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $bcd00faefdd4b5d7$var$markRootUpdated$1(initialChildren, isStrictMode);
    $bcd00faefdd4b5d7$var$ensureRootIsScheduled(initialChildren);
    container[$bcd00faefdd4b5d7$var$internalContainerInstanceKey] = initialChildren.current;
    $bcd00faefdd4b5d7$var$listenToAllSupportedEvents(container);
    return new $bcd00faefdd4b5d7$var$ReactDOMHydrationRoot(initialChildren);
};
$bcd00faefdd4b5d7$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("go0bk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2eTxD"));

});
parcelRegister("2eTxD", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1a17f8fbd958c1eb$export$c4744153514ff05d; }, function (v) { return $1a17f8fbd958c1eb$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1a17f8fbd958c1eb$export$3e506c1ccc9cc1a7; }, function (v) { return $1a17f8fbd958c1eb$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1a17f8fbd958c1eb$export$e26fe2ed2fa76875; }, function (v) { return $1a17f8fbd958c1eb$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1a17f8fbd958c1eb$export$502329bbf4b505b1; }, function (v) { return $1a17f8fbd958c1eb$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1a17f8fbd958c1eb$export$6e3807111c4874c4; }, function (v) { return $1a17f8fbd958c1eb$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1a17f8fbd958c1eb$export$c27134553091fb3a; }, function (v) { return $1a17f8fbd958c1eb$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1a17f8fbd958c1eb$export$33ee1acdc04fd2a2; }, function (v) { return $1a17f8fbd958c1eb$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1a17f8fbd958c1eb$export$b00a404bbd5edef2; }, function (v) { return $1a17f8fbd958c1eb$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1a17f8fbd958c1eb$export$8352ce38b91d0c62; }, function (v) { return $1a17f8fbd958c1eb$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1a17f8fbd958c1eb$export$d66a1c1c77bd778b; }, function (v) { return $1a17f8fbd958c1eb$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1a17f8fbd958c1eb$export$d3dfb8e4810cb555; }, function (v) { return $1a17f8fbd958c1eb$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1a17f8fbd958c1eb$export$839f9183b0465a69; }, function (v) { return $1a17f8fbd958c1eb$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1a17f8fbd958c1eb$export$72fdf0e06517287b; }, function (v) { return $1a17f8fbd958c1eb$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1a17f8fbd958c1eb$export$4b844e58a3e414b4; }, function (v) { return $1a17f8fbd958c1eb$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1a17f8fbd958c1eb$export$816d2913ae6b83b1; }, function (v) { return $1a17f8fbd958c1eb$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1a17f8fbd958c1eb$export$61bcfe829111a1d0; }, function (v) { return $1a17f8fbd958c1eb$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1a17f8fbd958c1eb$export$7ee8c9beb337bc3f; }, function (v) { return $1a17f8fbd958c1eb$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1a17f8fbd958c1eb$export$b5836b71941fa3ed; }, function (v) { return $1a17f8fbd958c1eb$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1a17f8fbd958c1eb$export$cf845f2c119da08a; }, function (v) { return $1a17f8fbd958c1eb$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $1a17f8fbd958c1eb$export$c4744153514ff05d;
var $1a17f8fbd958c1eb$export$3e506c1ccc9cc1a7;
var $1a17f8fbd958c1eb$export$e26fe2ed2fa76875;
var $1a17f8fbd958c1eb$export$502329bbf4b505b1;
var $1a17f8fbd958c1eb$export$6e3807111c4874c4;
var $1a17f8fbd958c1eb$export$c27134553091fb3a;
var $1a17f8fbd958c1eb$export$33ee1acdc04fd2a2;
var $1a17f8fbd958c1eb$export$b00a404bbd5edef2;
var $1a17f8fbd958c1eb$export$8352ce38b91d0c62;
var $1a17f8fbd958c1eb$export$d66a1c1c77bd778b;
var $1a17f8fbd958c1eb$export$d3dfb8e4810cb555;
var $1a17f8fbd958c1eb$export$839f9183b0465a69;
var $1a17f8fbd958c1eb$export$72fdf0e06517287b;
var $1a17f8fbd958c1eb$export$4b844e58a3e414b4;
var $1a17f8fbd958c1eb$export$816d2913ae6b83b1;
var $1a17f8fbd958c1eb$export$61bcfe829111a1d0;
var $1a17f8fbd958c1eb$export$7ee8c9beb337bc3f;
var $1a17f8fbd958c1eb$export$b5836b71941fa3ed;
var $1a17f8fbd958c1eb$export$cf845f2c119da08a;
"use strict";
function $1a17f8fbd958c1eb$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $1a17f8fbd958c1eb$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $1a17f8fbd958c1eb$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $1a17f8fbd958c1eb$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $1a17f8fbd958c1eb$var$compare(left, last)) rightIndex < length && 0 > $1a17f8fbd958c1eb$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $1a17f8fbd958c1eb$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $1a17f8fbd958c1eb$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$1a17f8fbd958c1eb$export$c4744153514ff05d = void 0;
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $YtE9h._)(performance)) && "function" === typeof performance.now) {
    var $1a17f8fbd958c1eb$var$localPerformance = performance;
    $1a17f8fbd958c1eb$export$c4744153514ff05d = function() {
        return $1a17f8fbd958c1eb$var$localPerformance.now();
    };
} else {
    var $1a17f8fbd958c1eb$var$localDate = Date, $1a17f8fbd958c1eb$var$initialTime = $1a17f8fbd958c1eb$var$localDate.now();
    $1a17f8fbd958c1eb$export$c4744153514ff05d = function() {
        return $1a17f8fbd958c1eb$var$localDate.now() - $1a17f8fbd958c1eb$var$initialTime;
    };
}
var $1a17f8fbd958c1eb$var$taskQueue = [], $1a17f8fbd958c1eb$var$timerQueue = [], $1a17f8fbd958c1eb$var$taskIdCounter = 1, $1a17f8fbd958c1eb$var$currentTask = null, $1a17f8fbd958c1eb$var$currentPriorityLevel = 3, $1a17f8fbd958c1eb$var$isPerformingWork = !1, $1a17f8fbd958c1eb$var$isHostCallbackScheduled = !1, $1a17f8fbd958c1eb$var$isHostTimeoutScheduled = !1, $1a17f8fbd958c1eb$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $1a17f8fbd958c1eb$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $1a17f8fbd958c1eb$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $1a17f8fbd958c1eb$var$advanceTimers(currentTime) {
    for(var timer = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue); null !== timer;){
        if (null === timer.callback) $1a17f8fbd958c1eb$var$pop($1a17f8fbd958c1eb$var$timerQueue);
        else if (timer.startTime <= currentTime) $1a17f8fbd958c1eb$var$pop($1a17f8fbd958c1eb$var$timerQueue), timer.sortIndex = timer.expirationTime, $1a17f8fbd958c1eb$var$push($1a17f8fbd958c1eb$var$taskQueue, timer);
        else break;
        timer = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue);
    }
}
function $1a17f8fbd958c1eb$var$handleTimeout(currentTime) {
    $1a17f8fbd958c1eb$var$isHostTimeoutScheduled = !1;
    $1a17f8fbd958c1eb$var$advanceTimers(currentTime);
    if (!$1a17f8fbd958c1eb$var$isHostCallbackScheduled) {
        if (null !== $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue)) $1a17f8fbd958c1eb$var$isHostCallbackScheduled = !0, $1a17f8fbd958c1eb$var$requestHostCallback();
        else {
            var firstTimer = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue);
            null !== firstTimer && $1a17f8fbd958c1eb$var$requestHostTimeout($1a17f8fbd958c1eb$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $1a17f8fbd958c1eb$var$isMessageLoopRunning = !1, $1a17f8fbd958c1eb$var$taskTimeoutID = -1, $1a17f8fbd958c1eb$var$frameInterval = 5, $1a17f8fbd958c1eb$var$startTime = -1;
function $1a17f8fbd958c1eb$var$shouldYieldToHost() {
    return $1a17f8fbd958c1eb$export$c4744153514ff05d() - $1a17f8fbd958c1eb$var$startTime < $1a17f8fbd958c1eb$var$frameInterval ? !1 : !0;
}
function $1a17f8fbd958c1eb$var$performWorkUntilDeadline() {
    if ($1a17f8fbd958c1eb$var$isMessageLoopRunning) {
        var currentTime = $1a17f8fbd958c1eb$export$c4744153514ff05d();
        $1a17f8fbd958c1eb$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $1a17f8fbd958c1eb$var$isHostCallbackScheduled = !1;
                $1a17f8fbd958c1eb$var$isHostTimeoutScheduled && ($1a17f8fbd958c1eb$var$isHostTimeoutScheduled = !1, $1a17f8fbd958c1eb$var$localClearTimeout($1a17f8fbd958c1eb$var$taskTimeoutID), $1a17f8fbd958c1eb$var$taskTimeoutID = -1);
                $1a17f8fbd958c1eb$var$isPerformingWork = !0;
                var previousPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
                try {
                    b: {
                        $1a17f8fbd958c1eb$var$advanceTimers(currentTime);
                        for($1a17f8fbd958c1eb$var$currentTask = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue); null !== $1a17f8fbd958c1eb$var$currentTask && !($1a17f8fbd958c1eb$var$currentTask.expirationTime > currentTime && $1a17f8fbd958c1eb$var$shouldYieldToHost());){
                            var callback = $1a17f8fbd958c1eb$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $1a17f8fbd958c1eb$var$currentTask.callback = null;
                                $1a17f8fbd958c1eb$var$currentPriorityLevel = $1a17f8fbd958c1eb$var$currentTask.priorityLevel;
                                var continuationCallback = callback($1a17f8fbd958c1eb$var$currentTask.expirationTime <= currentTime);
                                currentTime = $1a17f8fbd958c1eb$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $1a17f8fbd958c1eb$var$currentTask.callback = continuationCallback;
                                    $1a17f8fbd958c1eb$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $1a17f8fbd958c1eb$var$currentTask === $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue) && $1a17f8fbd958c1eb$var$pop($1a17f8fbd958c1eb$var$taskQueue);
                                $1a17f8fbd958c1eb$var$advanceTimers(currentTime);
                            } else $1a17f8fbd958c1eb$var$pop($1a17f8fbd958c1eb$var$taskQueue);
                            $1a17f8fbd958c1eb$var$currentTask = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue);
                        }
                        if (null !== $1a17f8fbd958c1eb$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue);
                            null !== firstTimer && $1a17f8fbd958c1eb$var$requestHostTimeout($1a17f8fbd958c1eb$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $1a17f8fbd958c1eb$var$currentTask = null, $1a17f8fbd958c1eb$var$currentPriorityLevel = previousPriorityLevel, $1a17f8fbd958c1eb$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline() : $1a17f8fbd958c1eb$var$isMessageLoopRunning = !1;
        }
    }
}
var $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $1a17f8fbd958c1eb$var$localSetImmediate) $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $1a17f8fbd958c1eb$var$localSetImmediate($1a17f8fbd958c1eb$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1a17f8fbd958c1eb$var$channel = new MessageChannel(), $1a17f8fbd958c1eb$var$port = $1a17f8fbd958c1eb$var$channel.port2;
    $1a17f8fbd958c1eb$var$channel.port1.onmessage = $1a17f8fbd958c1eb$var$performWorkUntilDeadline;
    $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        $1a17f8fbd958c1eb$var$port.postMessage(null);
    };
} else $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $1a17f8fbd958c1eb$var$localSetTimeout($1a17f8fbd958c1eb$var$performWorkUntilDeadline, 0);
};
function $1a17f8fbd958c1eb$var$requestHostCallback() {
    $1a17f8fbd958c1eb$var$isMessageLoopRunning || ($1a17f8fbd958c1eb$var$isMessageLoopRunning = !0, $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline());
}
function $1a17f8fbd958c1eb$var$requestHostTimeout(callback, ms) {
    $1a17f8fbd958c1eb$var$taskTimeoutID = $1a17f8fbd958c1eb$var$localSetTimeout(function() {
        callback($1a17f8fbd958c1eb$export$c4744153514ff05d());
    }, ms);
}
$1a17f8fbd958c1eb$export$3e506c1ccc9cc1a7 = 5;
$1a17f8fbd958c1eb$export$e26fe2ed2fa76875 = 1;
$1a17f8fbd958c1eb$export$502329bbf4b505b1 = 4;
$1a17f8fbd958c1eb$export$6e3807111c4874c4 = 3;
$1a17f8fbd958c1eb$export$c27134553091fb3a = null;
$1a17f8fbd958c1eb$export$33ee1acdc04fd2a2 = 2;
$1a17f8fbd958c1eb$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$1a17f8fbd958c1eb$export$8352ce38b91d0c62 = function() {
    $1a17f8fbd958c1eb$var$isHostCallbackScheduled || $1a17f8fbd958c1eb$var$isPerformingWork || ($1a17f8fbd958c1eb$var$isHostCallbackScheduled = !0, $1a17f8fbd958c1eb$var$requestHostCallback());
};
$1a17f8fbd958c1eb$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1a17f8fbd958c1eb$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$1a17f8fbd958c1eb$export$d3dfb8e4810cb555 = function() {
    return $1a17f8fbd958c1eb$var$currentPriorityLevel;
};
$1a17f8fbd958c1eb$export$839f9183b0465a69 = function() {
    return $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue);
};
$1a17f8fbd958c1eb$export$72fdf0e06517287b = function(eventHandler) {
    switch($1a17f8fbd958c1eb$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
    $1a17f8fbd958c1eb$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $1a17f8fbd958c1eb$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$1a17f8fbd958c1eb$export$4b844e58a3e414b4 = function() {};
$1a17f8fbd958c1eb$export$816d2913ae6b83b1 = function() {};
$1a17f8fbd958c1eb$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
    $1a17f8fbd958c1eb$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $1a17f8fbd958c1eb$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$1a17f8fbd958c1eb$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $1a17f8fbd958c1eb$export$c4744153514ff05d();
    "object" === (typeof options === "undefined" ? "undefined" : (0, $YtE9h._)(options)) && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $1a17f8fbd958c1eb$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $1a17f8fbd958c1eb$var$push($1a17f8fbd958c1eb$var$timerQueue, priorityLevel), null === $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue) && priorityLevel === $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue) && ($1a17f8fbd958c1eb$var$isHostTimeoutScheduled ? ($1a17f8fbd958c1eb$var$localClearTimeout($1a17f8fbd958c1eb$var$taskTimeoutID), $1a17f8fbd958c1eb$var$taskTimeoutID = -1) : $1a17f8fbd958c1eb$var$isHostTimeoutScheduled = !0, $1a17f8fbd958c1eb$var$requestHostTimeout($1a17f8fbd958c1eb$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $1a17f8fbd958c1eb$var$push($1a17f8fbd958c1eb$var$taskQueue, priorityLevel), $1a17f8fbd958c1eb$var$isHostCallbackScheduled || $1a17f8fbd958c1eb$var$isPerformingWork || ($1a17f8fbd958c1eb$var$isHostCallbackScheduled = !0, $1a17f8fbd958c1eb$var$requestHostCallback()));
    return priorityLevel;
};
$1a17f8fbd958c1eb$export$b5836b71941fa3ed = $1a17f8fbd958c1eb$var$shouldYieldToHost;
$1a17f8fbd958c1eb$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
        $1a17f8fbd958c1eb$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $1a17f8fbd958c1eb$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("fIwXP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5p0Oe"));

});

parcelRegister("9F3H4", function(module, exports) {
'use strict';
function $708acee34f03ee3d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($708acee34f03ee3d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$708acee34f03ee3d$var$checkDCE();

module.exports = (parcelRequire("gu98I"));

});
parcelRegister("gu98I", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $c00689a08255ad8b$export$69ce8ef3fe5cead0; }, function (v) { return $c00689a08255ad8b$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $c00689a08255ad8b$export$d39a5bbd09211389; }, function (v) { return $c00689a08255ad8b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c00689a08255ad8b$export$cd75ccfd720a3cd4; }, function (v) { return $c00689a08255ad8b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $c00689a08255ad8b$export$a0816fa17a9e79be; }, function (v) { return $c00689a08255ad8b$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $c00689a08255ad8b$export$7292efcadded39f3; }, function (v) { return $c00689a08255ad8b$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $c00689a08255ad8b$export$da407abadb9b8f86; }, function (v) { return $c00689a08255ad8b$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $c00689a08255ad8b$export$314cfea32580671c; }, function (v) { return $c00689a08255ad8b$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $c00689a08255ad8b$export$513ccb98c53b8039; }, function (v) { return $c00689a08255ad8b$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $c00689a08255ad8b$export$dbca993bc2d264a; }, function (v) { return $c00689a08255ad8b$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $c00689a08255ad8b$export$4797a8006f0655d0; }, function (v) { return $c00689a08255ad8b$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c00689a08255ad8b$export$c78a37762a8d58e1; }, function (v) { return $c00689a08255ad8b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $c00689a08255ad8b$export$606f11b2eb45ecc6; }, function (v) { return $c00689a08255ad8b$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $c00689a08255ad8b$export$f7e8a0bf92324b1e; }, function (v) { return $c00689a08255ad8b$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $c00689a08255ad8b$export$83d89fbfd8236492; }, function (v) { return $c00689a08255ad8b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $c00689a08255ad8b$export$69ce8ef3fe5cead0;
var $c00689a08255ad8b$export$d39a5bbd09211389;
var $c00689a08255ad8b$export$cd75ccfd720a3cd4;
var $c00689a08255ad8b$export$a0816fa17a9e79be;
var $c00689a08255ad8b$export$7292efcadded39f3;
var $c00689a08255ad8b$export$da407abadb9b8f86;
var $c00689a08255ad8b$export$314cfea32580671c;
var $c00689a08255ad8b$export$513ccb98c53b8039;
var $c00689a08255ad8b$export$dbca993bc2d264a;
var $c00689a08255ad8b$export$4797a8006f0655d0;
var $c00689a08255ad8b$export$c78a37762a8d58e1;
var $c00689a08255ad8b$export$606f11b2eb45ecc6;
var $c00689a08255ad8b$export$f7e8a0bf92324b1e;
var $c00689a08255ad8b$export$83d89fbfd8236492;
"use strict";

var $fIwXP = parcelRequire("fIwXP");
function $c00689a08255ad8b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c00689a08255ad8b$var$noop() {}
var $c00689a08255ad8b$var$Internals = {
    d: {
        f: $c00689a08255ad8b$var$noop,
        r: function r() {
            throw Error($c00689a08255ad8b$var$formatProdErrorMessage(522));
        },
        D: $c00689a08255ad8b$var$noop,
        C: $c00689a08255ad8b$var$noop,
        L: $c00689a08255ad8b$var$noop,
        m: $c00689a08255ad8b$var$noop,
        X: $c00689a08255ad8b$var$noop,
        S: $c00689a08255ad8b$var$noop,
        M: $c00689a08255ad8b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $c00689a08255ad8b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $c00689a08255ad8b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c00689a08255ad8b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $c00689a08255ad8b$var$ReactSharedInternals = $fIwXP.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $c00689a08255ad8b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$c00689a08255ad8b$export$69ce8ef3fe5cead0 = $c00689a08255ad8b$var$Internals;
$c00689a08255ad8b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($c00689a08255ad8b$var$formatProdErrorMessage(299));
    return $c00689a08255ad8b$var$createPortal$1(children, container, null, key);
};
$c00689a08255ad8b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $c00689a08255ad8b$var$ReactSharedInternals.T, previousUpdatePriority = $c00689a08255ad8b$var$Internals.p;
    try {
        if ($c00689a08255ad8b$var$ReactSharedInternals.T = null, $c00689a08255ad8b$var$Internals.p = 2, fn) return fn();
    } finally{
        $c00689a08255ad8b$var$ReactSharedInternals.T = previousTransition, $c00689a08255ad8b$var$Internals.p = previousUpdatePriority, $c00689a08255ad8b$var$Internals.d.f();
    }
};
$c00689a08255ad8b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $c00689a08255ad8b$var$Internals.d.C(href, options));
};
$c00689a08255ad8b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $c00689a08255ad8b$var$Internals.d.D(href);
};
$c00689a08255ad8b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c00689a08255ad8b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $c00689a08255ad8b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $c00689a08255ad8b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$c00689a08255ad8b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === (typeof options === "undefined" ? "undefined" : (0, $YtE9h._)(options)) && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $c00689a08255ad8b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $c00689a08255ad8b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $c00689a08255ad8b$var$Internals.d.M(href);
    }
};
$c00689a08255ad8b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === (typeof options === "undefined" ? "undefined" : (0, $YtE9h._)(options)) && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c00689a08255ad8b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $c00689a08255ad8b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$c00689a08255ad8b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $c00689a08255ad8b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $c00689a08255ad8b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $c00689a08255ad8b$var$Internals.d.m(href);
    }
};
$c00689a08255ad8b$export$4797a8006f0655d0 = function(form) {
    $c00689a08255ad8b$var$Internals.d.r(form);
};
$c00689a08255ad8b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$c00689a08255ad8b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $c00689a08255ad8b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$c00689a08255ad8b$export$f7e8a0bf92324b1e = function() {
    return $c00689a08255ad8b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$c00689a08255ad8b$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("7e473", function(module, exports) {

$parcel$export(module.exports, "useParams", function () { return useParams; });
$parcel$export(module.exports, "useRouteError", function () { return useRouteError; });
$parcel$export(module.exports, "RouterProvider", function () { return RouterProvider; });
$parcel$export(module.exports, "Outlet", function () { return Outlet; });
$parcel$export(module.exports, "createBrowserRouter", function () { return createBrowserRouter; });
$parcel$export(module.exports, "Link", function () { return Link; });
/**
 * react-router v7.1.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts

var $7k5I8 = parcelRequire("7k5I8");

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $5dLwP = parcelRequire("5dLwP");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $1dxAe = parcelRequire("1dxAe");

var $kB67t = parcelRequire("kB67t");

var $bQ8GJ = parcelRequire("bQ8GJ");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $lFlDF = parcelRequire("lFlDF");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");

var $f6Ucb = parcelRequire("f6Ucb");

var $aLpOW = parcelRequire("aLpOW");

var $6Htrd = parcelRequire("6Htrd");
var $d1c6608c36d1df9a$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-K6AXKMTT.mjs"
});
var Action = /* @__PURE__ */ function(Action2) {
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
}(Action || {});
var PopStateEventType = "popstate";
function createMemoryHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries;
    entries = initialEntries.map(function(entry, index2) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = "POP" /* Pop */ ;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to) {
        var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, key = arguments.length > 2 ? arguments[2] : void 0;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: ".concat(JSON.stringify(to)));
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL: function(to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = "PUSH" /* Push */ ;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = "REPLACE" /* Replace */ ;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = "POP" /* Pop */ ;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
function createBrowserHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createBrowserLocation(window2, globalHistory) {
        var _window2_location = window2.location, pathname = _window2_location.pathname, search = _window2_location.search, hash = _window2_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function createHashHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createHashLocation(window2, globalHistory) {
        var _parsePath = parsePath(window2.location.hash.substring(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        var base = window2.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window2.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(".concat(JSON.stringify(to), ")"));
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function createLocation(current, to) {
    var state = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, key = arguments.length > 3 ? arguments[3] : void 0;
    var location = (0, $kJeRc._)((0, $eRslx._)({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to), {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
function createPath(param) {
    var _param_pathname = param.pathname, pathname = _param_pathname === void 0 ? "/" : _param_pathname, _param_search = param.search, search = _param_search === void 0 ? "" : _param_search, _param_hash = param.hash, hash = _param_hash === void 0 ? "" : _param_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref2, validateLocation) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var tmp = options.window, window2 = tmp === void 0 ? document.defaultView : tmp, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window2.history;
    var action = "POP" /* Pop */ ;
    var listener = null;
    var index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $kJeRc._)((0, $eRslx._)({}, globalHistory.state), {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        var base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: ".concat(href));
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window2.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
function convertRoutesToDataRoutes(routes, mapRouteProperties2) {
    var parentPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], manifest = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return routes.map(function(route, index) {
        var treePath = (0, $2Xzd1._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "'.concat(id, "\".  Route id's must be globally unique within Data Router usages"));
        if (isIndexRoute(route)) {
            var indexRoute = (0, $kJeRc._)((0, $eRslx._)({}, route, mapRouteProperties2(route)), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = (0, $kJeRc._)((0, $eRslx._)({}, route, mapRouteProperties2(route)), {
                id: id,
                children: void 0
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function matchRoutes(routes, locationArg) {
    var basename = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes) {
    var branches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], parentsMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], parentPath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "'.concat(meta.relativePath, '" nested under path "').concat(parentPath, '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'));
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, 'Index routes must not have child routes. Please remove all child routes from route path "'.concat(path, '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route_path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
function explodeOptionalSegments(path) {
    var _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $bQ8GJ._)(segments), first = _segments[0], rest = _segments.slice(1);
    var isOptional = first.endsWith("?");
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $2Xzd1._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $2Xzd1._)(restExploded));
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    var allowPartial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function generatePath(originalPath) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
        path = path.replace(/\*$/, "/*");
    }
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            var star = "*";
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $kB67t._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":'.concat(key, '" param'));
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $kB67t._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo2, param, index) {
        var paramName = param.paramName, isOptional = param.isOptional;
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path) {
    var caseSensitive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, 'The URL path "'.concat(value, '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding (').concat(error, ")."));
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function resolvePath(to) {
    var fromPathname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '".concat(char, "' character in a manually specified `to.").concat(field, "` field [").concat(JSON.stringify(path), "].  Please separate it out to the `to.").concat(dest, '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.');
}
function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
function getResolveToMatches(matches) {
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
}
function resolveTo(toArg, routePathnames, locationPathname) {
    var isPathRelative = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = (0, $eRslx._)({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
var DataWithResponseInit = function DataWithResponseInit(data2, init) {
    "use strict";
    (0, $bB0zn._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data2;
    this.init = init || null;
};
function data(data2, init) {
    return new DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var redirect = function(url) {
    var init = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, (0, $kJeRc._)((0, $eRslx._)({}, responseInit), {
        headers: headers
    }));
};
var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data2) {
    "use strict";
    var internal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    (0, $bB0zn._)(this, ErrorResponseImpl);
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data2 instanceof Error) {
        this.data = data2.toString();
        this.error = data2;
    } else this.data = data2;
};
function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "GET"
].concat((0, $2Xzd1._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_FETCHER = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    var isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties2 = init.mapRouteProperties || defaultMapRouteProperties;
    var manifest = {};
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    var future = (0, $eRslx._)({}, init.future);
    var unlistenHistory = null;
    var subscribers = /* @__PURE__ */ new Set();
    var savedScrollPositions2 = null;
    var getScrollRestorationKey2 = null;
    var getScrollPosition = null;
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $hD5pT._)({}, route.id, error);
    }
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar1.active && fogOfWar1.matches) initialMatches = fogOfWar1.matches;
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) initialized = true;
    else {
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== void 0;
            });
            initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        } else initialized = initialMatches.every(function(m) {
            return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
        });
    }
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    var pendingAction = "POP" /* Pop */ ;
    var pendingPreventScrollReset = false;
    var pendingNavigationController;
    var pendingViewTransitionEnabled = false;
    var appliedViewTransitions = /* @__PURE__ */ new Map();
    var removePageHideEventListener = null;
    var isUninterruptedRevalidation = false;
    var isRevalidationRequired = false;
    var cancelledFetcherLoads = /* @__PURE__ */ new Set();
    var fetchControllers = /* @__PURE__ */ new Map();
    var incrementingLoadId = 0;
    var pendingNavigationLoadId = -1;
    var fetchReloadIds = /* @__PURE__ */ new Map();
    var fetchRedirectIds = /* @__PURE__ */ new Set();
    var fetchLoadMatches = /* @__PURE__ */ new Map();
    var activeFetchers = /* @__PURE__ */ new Map();
    var fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    var blockerFunctions = /* @__PURE__ */ new Map();
    var unblockBlockerHistoryUpdate = void 0;
    var pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(function(param) {
            var historyAction = param.action, location = param.location, delta = param.delta;
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    function updateState(newState) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        state = (0, $eRslx._)({}, state, newState);
        var unmountedFetchers = [];
        var mountedFetchers = [];
        state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        (0, $2Xzd1._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach(function(key) {
            return deleteFetcher(key);
        });
        mountedFetchers.forEach(function(key) {
            return state.fetchers.delete(key);
        });
    }
    function completeNavigation(location, newState) {
        var flushSync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).flushSync;
        var _location_state, _location_state1;
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        var viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState((0, $kJeRc._)((0, $eRslx._)({}, newState), {
            // matches, errors, fetchers go through as-is
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = (0, $7k5I8._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        nextLocation = (0, $eRslx._)({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : void 0;
                        historyAction = "PUSH" /* Push */ ;
                        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: void 0,
                                        reset: void 0,
                                        location: nextLocation
                                    });
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        var promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = (0, $7k5I8._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $hD5pT._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: "error" /* error */ ,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $kB67t._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        fogOfWar.active = false;
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        pendingNavigationController = null;
                        completeNavigation(location, (0, $kJeRc._)((0, $eRslx._)({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult)), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = (0, $7k5I8._)(function(request, location, submission, matches, isFogOfWar) {
            var opts, navigation, discoverResult, boundaryId, _handleNavigational404, notFoundMatches, error, route, result, actionMatch, results, replace2, location2, boundaryMatch;
            var _arguments = arguments;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        opts = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : {};
                        interruptActiveLoads();
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: "error" /* error */ ,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: "error" /* error */ ,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: "error" /* error */ ,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", state, request, [
                                actionMatch
                            ], matches, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace2 = opts.replace;
                        else {
                            location2 = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace2 = location2 === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isErrorResult(result)) {
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = (0, $7k5I8._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational404, error, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers2, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect2, _processLoaderData, loaderData, errors, updatedFetchers, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState((0, $eRslx._)({
                                navigation: loadingNavigation
                            }, actionData !== void 0 ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, route.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $kB67t._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        pendingNavigationLoadId = ++incrementingLoadId;
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers2 = markFetchRedirectsDone();
                            completeNavigation(location, (0, $eRslx._)({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers2 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== void 0) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect2 = findRedirect(loaderResults);
                        if (!redirect2) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect2 = findRedirect(fetcherResults);
                        if (!redirect2) return [
                            3,
                            7
                        ];
                        fetchRedirectIds.add(redirect2.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        if (initialHydration && state.errors) errors = (0, $eRslx._)({}, state.errors, errors);
                        updatedFetchers = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            (0, $eRslx._)({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) return (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    function fetch2(key, routeId, href, opts) {
        return _fetch2.apply(this, arguments);
    }
    function _fetch2() {
        _fetch2 = (0, $7k5I8._)(function(key, routeId, href, opts) {
            var flushSync, routesToUse, normalizedPath, matches, fogOfWar, _normalizeNavigateOptions, path, submission, error, match, preventScrollReset;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        abortFetcher(key);
                        flushSync = (opts && opts.flushSync) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        normalizedPath = normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        matches = matchRoutes(routesToUse, normalizedPath, basename);
                        fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: normalizedPath
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        _normalizeNavigateOptions = normalizeNavigateOptions(true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (error) {
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        match = getTargetMatch(matches, path);
                        preventScrollReset = (opts && opts.preventScrollReset) === true;
                        if (!(submission && isMutationMethod(submission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        fetchLoadMatches.set(key, {
                            routeId: routeId,
                            path: path
                        });
                        return [
                            4,
                            handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _fetch2.apply(this, arguments);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = (0, $7k5I8._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect2, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", state, fetchRequest, [
                                match
                            ], requestMatches, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if (fetchersQueuedForDeletion.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(void 0));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    updateFetcherState(key, getDoneFetcher(void 0));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $kB67t._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher2 = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect2 = findRedirect(loaderResults);
                        if (redirect2) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect2 = findRedirect(fetcherResults);
                        if (redirect2) {
                            fetchRedirectIds.add(redirect2.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        _processLoaderData = processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = (0, $7k5I8._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", state, fetchRequest, [
                                match
                            ], matches, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (fetchersQueuedForDeletion.has(key)) {
                            updateFetcherState(key, getDoneFetcher(void 0));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        updateFetcherState(key, getDoneFetcher(void 0));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect2, isNavigation) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = (0, $7k5I8._)(function(request, redirect2, isNavigation) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace2, location, redirectLocation, isDocumentReload, url, redirectNavigationType, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            var _arguments = arguments;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace2 = _ref.replace;
                        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect2.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser2) {
                            isDocumentReload = false;
                            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace2) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        pendingNavigationController = null;
                        redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                submission: (0, $kJeRc._)((0, $eRslx._)({}, activeSubmission), {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = (0, $7k5I8._)(function(type, state2, request, matchesToLoad, matches, fetcherKey) {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        matchesToLoad.forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: "error" /* error */ ,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $kB67t._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: "redirect" /* redirect */ ,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $7k5I8._)(function(state2, matches, matchesToLoad, fetchersToLoad, request) {
            var loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(/*#__PURE__*/ function() {
                            var _ref = (0, $7k5I8._)(function(f) {
                                var results, result;
                                return (0, $lFlDF.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy("loader", state2, createClientSideRequest(init.history, f.path, f.controller.signal), [
                                                    f.match
                                                ], f.matches, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            return [
                                                2,
                                                (0, $hD5pT._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $hD5pT._)({}, f.key, {
                                                    type: "error" /* error */ ,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(f) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $hD5pT._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: ".concat(key));
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: ".concat(key));
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: ".concat(blocker.state, " -> ").concat(newBlocker.state));
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(param) {
        var currentLocation = param.currentLocation, nextLocation = param.nextLocation, historyAction = param.historyAction;
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $kB67t._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            var key = getScrollRestorationKey2(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, $7k5I8._)(function(matches, pathname, signal) {
            var _loop, partialMatches, _ret;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, $lFlDF.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            patchRoutesOnNavigationImpl({
                                                path: pathname,
                                                matches: partialMatches,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $2Xzd1._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!patchRoutesOnNavigationImpl) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $lFlDF.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $YtE9h._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = (0, $2Xzd1._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties2 = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || defaultMapRouteProperties;
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    function query(request) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = (0, $7k5I8._)(function(request) {
            var _ref, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            var _arguments = arguments;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $hD5pT._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {}
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $hD5pT._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {}
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        return [
                            2,
                            (0, $eRslx._)({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = (0, $7k5I8._)(function(request) {
            var _ref, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error;
            var _arguments = arguments;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : void 0;
                        if (error !== void 0) throw error;
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) return [
                            2,
                            Object.values(result.loaderData)[0]
                        ];
                        return [
                            2,
                            void 0
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $7k5I8._)(function(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result2, result, e;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result2 = _state.sent();
                        return [
                            2,
                            result2
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            isResponse(result) ? result : (0, $kJeRc._)((0, $eRslx._)({}, result), {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === "error" /* error */ ) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $7k5I8._)(function(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, loaderRequest, boundaryMatch, context2, context;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: "error" /* error */ ,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isRouteRequest) {
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {}
                                }
                            ];
                        }
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context2 = _state.sent();
                        return [
                            2,
                            (0, $kJeRc._)((0, $eRslx._)({}, context2), {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: (0, $eRslx._)({}, result.headers ? (0, $hD5pT._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context = _state.sent();
                        return [
                            2,
                            (0, $kJeRc._)((0, $eRslx._)((0, $kJeRc._)((0, $eRslx._)({}, context), {
                                actionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data)
                            }), result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}), {
                                actionHeaders: result.headers ? (0, $hD5pT._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $7k5I8._)(function(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, context, executedLoaders;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $hD5pT._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {}
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        context = processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            (0, $kJeRc._)((0, $eRslx._)({}, context), {
                                matches: matches
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = (0, $7k5I8._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
            var results, dataResults;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(/*#__PURE__*/ function() {
                                var _ref = (0, $7k5I8._)(function(match) {
                                    var result, response, _;
                                    return (0, $lFlDF.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResult(result)) {
                                                    response = result.result;
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
                                                }
                                                if (isResponse(result.result) && isRouteRequest) throw result;
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(match) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function getStaticContextFromError(routes, context, error) {
    var newContext = (0, $kJeRc._)((0, $eRslx._)({}, context), {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $hD5pT._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error("".concat(method, "() call aborted without an `AbortSignal.reason`: ").concat(request.method, " ").concat(request.url));
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = rawFormMethod.toUpperCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, param) {
                var _param = (0, $kB67t._)(param, 2), name = _param[0], value = _param[1];
                return "".concat(acc).concat(name, "=").concat(value, "\n");
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    var parsedPath = parsePath(path);
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?".concat(searchParams);
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var includeBoundary = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var index = matches.findIndex(function(m) {
        return m.route.id === boundaryId;
    });
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    var boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    var shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if (isNewLoader(state.loaderData, state.matches[index], match)) return true;
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, (0, $kJeRc._)((0, $eRslx._)({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission), {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || fetchersQueuedForDeletion.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = shouldRevalidateLoader(fetcherMatch, (0, $kJeRc._)((0, $eRslx._)({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission), {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    var hasData = loaderData != null && loaderData[route.id] !== void 0;
    var hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    var isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    var _childrenToPatch;
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = ".concat(routeId));
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    var uniqueChildren = children.filter(function(newRoute) {
        return !childrenToPatch.some(function(existingRoute) {
            return isSameRoute(newRoute, existingRoute);
        });
    });
    var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
    ], manifest);
    (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $2Xzd1._)(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
function loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    return _loadLazyRouteModule.apply(this, arguments);
}
function _loadLazyRouteModule() {
    _loadLazyRouteModule = (0, $7k5I8._)(function(route, mapRouteProperties2, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(lazyRouteProperty, '" defined but its lazy function is also returning a value for this property. The lazy route property "').concat(lazyRouteProperty, '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    Object.assign(routeToUpdate, routeUpdates);
                    Object.assign(routeToUpdate, (0, $kJeRc._)((0, $eRslx._)({}, mapRouteProperties2(routeToUpdate)), {
                        lazy: void 0
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteModule.apply(this, arguments);
}
function defaultDataStrategy(_) {
    return _defaultDataStrategy.apply(this, arguments);
}
function _defaultDataStrategy() {
    _defaultDataStrategy = (0, $7k5I8._)(function(param) {
        var matches, matchesToLoad, results;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = param.matches;
                    matchesToLoad = matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(acc, result, i) {
                            return Object.assign(acc, (0, $hD5pT._)({}, matchesToLoad[i].route.id, result));
                        }, {})
                    ];
            }
        });
    });
    return _defaultDataStrategy.apply(this, arguments);
}
function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    return _callDataStrategyImpl.apply(this, arguments);
}
function _callDataStrategyImpl() {
    _callDataStrategyImpl = (0, $7k5I8._)(function(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
        var loadRouteDefinitionsPromises, dsMatches, results, e;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadRouteDefinitionsPromises = matches.map(function(m) {
                        return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0;
                    });
                    dsMatches = matches.map(function(match, i) {
                        var loadRoutePromise = loadRouteDefinitionsPromises[i];
                        var shouldLoad = matchesToLoad.some(function(m) {
                            return m.route.id === match.route.id;
                        });
                        var resolve = /*#__PURE__*/ function() {
                            var _ref = (0, $7k5I8._)(function(handlerOverride) {
                                return (0, $lFlDF.__generator)(this, function(_state) {
                                    if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
                                    return [
                                        2,
                                        shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                                            type: "data" /* data */ ,
                                            result: void 0
                                        })
                                    ];
                                });
                            });
                            return function resolve(handlerOverride) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return (0, $kJeRc._)((0, $eRslx._)({}, match), {
                            shouldLoad: shouldLoad,
                            resolve: resolve
                        });
                    });
                    return [
                        4,
                        dataStrategyImpl({
                            matches: dsMatches,
                            request: request,
                            params: matches[0].params,
                            fetcherKey: fetcherKey,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loadRouteDefinitionsPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _callDataStrategyImpl.apply(this, arguments);
}
function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
    _callLoaderOrAction = (0, $7k5I8._)(function(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error('You cannot call the handler for a route which defines a boolean "'.concat(type, '" [routeId: ').concat(match.route.id, "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $2Xzd1._)(ctx !== void 0 ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = (0, $7k5I8._)(function() {
                            var val, e;
                            return (0, $lFlDF.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            handlerOverride ? handlerOverride(function(ctx) {
                                                return actualHandler(ctx);
                                            }) : actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!loadRoutePromise) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            loadRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $kB67t._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== void 0) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    return [
                        4,
                        loadRoutePromise
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else return [
                        2,
                        {
                            type: "data" /* data */ ,
                            result: void 0
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _callLoaderOrAction.apply(this, arguments);
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
function _convertDataStrategyResultToDataResult() {
    _convertDataStrategyResultToDataResult = (0, $7k5I8._)(function(dataStrategyResult) {
        var _result_init, _result_init1, result, type, data2, contentType, e, _result_init2, _result_init3;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data2 = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data2 = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data2 = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: e
                        }
                    ];
                case 9:
                    if (type === "error" /* error */ ) return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: new ErrorResponseImpl(result.status, result.statusText, data2),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: data2,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === "error" /* error */ ) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: result.data,
                                    statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status
                                }
                            ];
                            result = new ErrorResponseImpl(((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.status) || 500, void 0, result.data);
                        }
                        return [
                            2,
                            {
                                type: "error" /* error */ ,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : void 0
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result.data,
                            statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
                            headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result
                        }
                    ];
            }
        });
    });
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult) {
    var isStaticHandler = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, skipLoaderErrorBubbling = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = (0, $hD5pT._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    revalidatingFetchers.forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = (0, $kJeRc._)((0, $eRslx._)({}, errors), (0, $hD5pT._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) invariant(false, "Unhandled fetcher revalidation redirect");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = Object.entries(newLoaderData).filter(function(param) {
        var _param = (0, $kB67t._)(param, 2), v = _param[1];
        return v !== ResetLoaderDataSymbol;
    }).reduce(function(merged, param) {
        var _param = (0, $kB67t._)(param, 2), k = _param[0], v = _param[1];
        merged[k] = v;
        return merged;
    }, {});
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $2Xzd1._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method, ' request to "').concat(pathname, '" but did not provide a `loader` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "'.concat(routeId, '" does not match URL "').concat(pathname, '"');
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "'.concat(pathname, '"');
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method.toUpperCase(), ' request to "').concat(pathname, '" but did not provide an `action` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (method) errorMessage = 'Invalid request method "'.concat(method.toUpperCase(), '"');
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $kB67t._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath((0, $kJeRc._)((0, $eRslx._)({}, parsedPath), {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function isRedirectDataStrategyResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $YtE9h._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectStatusCode(statusCode) {
    return redirectStatusCodes.has(statusCode);
}
function isRedirectResponse(result) {
    return isResponse(result) && isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toUpperCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toUpperCase());
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data2) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function getDoneFetcher(data2) {
    var fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $kB67t._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {}
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kB67t._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $2Xzd1._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (".concat(error, ")."));
        }
    }
}
function createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = /*#__PURE__*/ function() {
            var _ref = (0, $7k5I8._)(function(val) {
                var e;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(val) {
                return _ref.apply(this, arguments);
            };
        }();
        reject = /*#__PURE__*/ function() {
            var _ref = (0, $7k5I8._)(function(error) {
                var e;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(error) {
                return _ref.apply(this, arguments);
            };
        }();
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
var DataRouterContext = $fIwXP.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = $fIwXP.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var ViewTransitionContext = $fIwXP.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = $fIwXP.createContext(/* @__PURE__ */ new Map());
FetchersContext.displayName = "Fetchers";
var AwaitContext = $fIwXP.createContext(null);
AwaitContext.displayName = "Await";
var NavigationContext = $fIwXP.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = $fIwXP.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = $fIwXP.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = $fIwXP.createContext(null);
RouteErrorContext.displayName = "RouteError";
var ENABLE_DEV_WARNINGS = true;
function useHref(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    invariant(useInRouterContext(), "useHref() may be used only in the context of a <Router> component.");
    var _React2_useContext = $fIwXP.useContext(NavigationContext), basename = _React2_useContext.basename, navigator2 = _React2_useContext.navigator;
    var _useResolvedPath = useResolvedPath(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function useInRouterContext() {
    return $fIwXP.useContext(LocationContext) != null;
}
function useLocation() {
    invariant(useInRouterContext(), "useLocation() may be used only in the context of a <Router> component.");
    return $fIwXP.useContext(LocationContext).location;
}
function useNavigationType() {
    return $fIwXP.useContext(LocationContext).navigationType;
}
function useMatch(pattern) {
    invariant(useInRouterContext(), "useMatch() may be used only in the context of a <Router> component.");
    var pathname = useLocation().pathname;
    return $fIwXP.useMemo(function() {
        return matchPath(pattern, decodePath(pathname));
    }, [
        pathname,
        pattern
    ]);
}
var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function useIsomorphicLayoutEffect(cb) {
    var isStatic = $fIwXP.useContext(NavigationContext).static;
    if (!isStatic) $fIwXP.useLayoutEffect(cb);
}
function useNavigate() {
    var isDataRoute = $fIwXP.useContext(RouteContext).isDataRoute;
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    invariant(useInRouterContext(), "useNavigate() may be used only in the context of a <Router> component.");
    var dataRouterContext = $fIwXP.useContext(DataRouterContext);
    var _React2_useContext = $fIwXP.useContext(NavigationContext), basename = _React2_useContext.basename, navigator2 = _React2_useContext.navigator;
    var matches = $fIwXP.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    var activeRef = $fIwXP.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $fIwXP.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        var path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = $fIwXP.createContext(null);
function useOutletContext() {
    return $fIwXP.useContext(OutletContext);
}
function useOutlet(context) {
    var outlet = $fIwXP.useContext(RouteContext).outlet;
    if (outlet) return /* @__PURE__ */ $fIwXP.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function useParams() {
    var matches = $fIwXP.useContext(RouteContext).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function useResolvedPath(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var matches = $fIwXP.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    return $fIwXP.useMemo(function() {
        return resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    invariant(useInRouterContext(), "useRoutes() may be used only in the context of a <Router> component.");
    var _React2_useContext = $fIwXP.useContext(NavigationContext), navigator2 = _React2_useContext.navigator;
    var _React2_useContext1 = $fIwXP.useContext(RouteContext), parentMatches = _React2_useContext1.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    if (ENABLE_DEV_WARNINGS) {
        var parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), 'You rendered descendant <Routes> (or called `useRoutes()`) at "'.concat(parentPathname, '" (under <Route path="').concat(parentPath, '">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won\'t match anymore and therefore the child routes will never render.\n\nPlease change the parent <Route path="').concat(parentPath, '"> to <Route path="').concat(parentPath === "/" ? "*" : "".concat(parentPath, "/*"), '">.'));
    }
    var locationFromContext = useLocation();
    var location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        var parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
        invariant(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), 'When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "'.concat(parentPathnameBase, '" but pathname "').concat(parsedLocationArg.pathname, '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = matchRoutes(routes, {
        pathname: remainingPathname
    });
    if (ENABLE_DEV_WARNINGS) {
        warning(parentRoute || matches != null, 'No routes matched location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" '));
        warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, 'Matched leaf route at location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
    }
    var renderedMatches = _renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $fIwXP.createElement(LocationContext.Provider, {
        value: {
            location: (0, $eRslx._)({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    var error = useRouteError();
    var message = isRouteErrorResponse(error) ? "".concat(error.status, " ").concat(error.statusText) : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    if (ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, /* @__PURE__ */ $fIwXP.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ $fIwXP.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $fIwXP.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $fIwXP.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, /* @__PURE__ */ $fIwXP.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $fIwXP.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $fIwXP.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /* @__PURE__ */ $fIwXP.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = /*#__PURE__*/ function(_React2_Component) {
    "use strict";
    (0, $5dLwP._)(RenderErrorBoundary, _React2_Component);
    function RenderErrorBoundary(props) {
        (0, $bB0zn._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $3Gvhd._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $6QEWP._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== void 0 ? /* @__PURE__ */ $fIwXP.createElement(RouteContext.Provider, {
                    value: this.props.routeContext
                }, /* @__PURE__ */ $fIwXP.createElement(RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                return {
                    error: props.error !== void 0 ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($fIwXP.Component);
function RenderedRoute(param) {
    var routeContext = param.routeContext, match = param.match, children = param.children;
    var dataRouterContext = $fIwXP.useContext(DataRouterContext);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $fIwXP.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches) {
    var parentMatches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dataRouterState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, future = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    var errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0;
        });
        invariant(errorIndex >= 0, "Could not find a matching route for errors on route IDs: ".concat(Object.keys(errors).join(",")));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors2 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $fIwXP.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $fIwXP.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $fIwXP.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function getDataRouterConsoleError(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext(hookName) {
    var ctx = $fIwXP.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    var state = $fIwXP.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    var route = $fIwXP.useContext(RouteContext);
    invariant(route, getDataRouterConsoleError(hookName));
    return route;
}
function useCurrentRouteId(hookName) {
    var route = useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    invariant(thisRoute.route.id, "".concat(hookName, ' can only be used on routes that contain a unique "id"'));
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function useNavigation() {
    var state = useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function useRevalidator() {
    var dataRouterContext = useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    var state = useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return $fIwXP.useMemo(function() {
        return {
            revalidate: function() {
                return (0, $7k5I8._)(function() {
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    dataRouterContext.router.revalidate()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            state: state.revalidation
        };
    }, [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function useMatches() {
    var _useDataRouterState = useDataRouterState("useMatches" /* UseMatches */ ), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $fIwXP.useMemo(function() {
        return matches.map(function(m) {
            return convertRouteMatchToUiMatch(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
function useLoaderData() {
    var state = useDataRouterState("useLoaderData" /* UseLoaderData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function useRouteLoaderData(routeId) {
    var state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function useActionData() {
    var state = useDataRouterState("useActionData" /* UseActionData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function useRouteError() {
    var _state_errors;
    var error = $fIwXP.useContext(RouteErrorContext);
    var state = useDataRouterState("useRouteError" /* UseRouteError */ );
    var routeId = useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function useAsyncValue() {
    var value = $fIwXP.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function useAsyncError() {
    var value = $fIwXP.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var blockerId = 0;
function useBlocker(shouldBlock) {
    var _useDataRouterContext = useDataRouterContext("useBlocker" /* UseBlocker */ ), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = useDataRouterState("useBlocker" /* UseBlocker */ );
    var _React2_useState = (0, $kB67t._)($fIwXP.useState(""), 2), blockerKey = _React2_useState[0], setBlockerKey = _React2_useState[1];
    var blockerFunction = $fIwXP.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: (0, $kJeRc._)((0, $eRslx._)({}, currentLocation), {
                pathname: stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: (0, $kJeRc._)((0, $eRslx._)({}, nextLocation), {
                pathname: stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $fIwXP.useEffect(function() {
        var key = String(++blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    $fIwXP.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : IDLE_BLOCKER;
}
function useNavigateStable() {
    var router = useDataRouterContext("useNavigate" /* UseNavigateStable */ ).router;
    var id = useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    var activeRef = $fIwXP.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $fIwXP.useCallback(/*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(to) {
            var options;
            var _arguments = arguments;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        warning(activeRef.current, navigateEffectWarning);
                        if (!activeRef.current) return [
                            2
                        ];
                        if (!(typeof to === "number")) return [
                            3,
                            1
                        ];
                        router.navigate(to);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            router.navigate(to, (0, $eRslx._)({
                                fromRouteId: id
                            }, options))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(to) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) {
        alreadyWarned[key] = true;
        warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var alreadyWarned2 = {};
function warnOnce(condition, message) {
    if (!condition && !alreadyWarned2[message]) {
        alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var ENABLE_DEV_WARNINGS2 = true;
function mapRouteProperties(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (ENABLE_DEV_WARNINGS2) {
            if (route.element) warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $fIwXP.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if (ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $fIwXP.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if (ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $fIwXP.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function createMemoryRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createMemoryHistory({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}
var Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $bB0zn._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
function RouterProvider(param) {
    var router = param.router, reactDomFlushSyncImpl = param.flushSync;
    var _React3_useState = (0, $kB67t._)($fIwXP.useState(router.state), 2), state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var _React3_useState1 = (0, $kB67t._)($fIwXP.useState(), 2), pendingState = _React3_useState1[0], setPendingState = _React3_useState1[1];
    var _React3_useState2 = (0, $kB67t._)($fIwXP.useState({
        isTransitioning: false
    }), 2), vtContext = _React3_useState2[0], setVtContext = _React3_useState2[1];
    var _React3_useState3 = (0, $kB67t._)($fIwXP.useState(), 2), renderDfd = _React3_useState3[0], setRenderDfd = _React3_useState3[1];
    var _React3_useState4 = (0, $kB67t._)($fIwXP.useState(), 2), transition = _React3_useState4[0], setTransition = _React3_useState4[1];
    var _React3_useState5 = (0, $kB67t._)($fIwXP.useState(), 2), interruption = _React3_useState5[0], setInterruption = _React3_useState5[1];
    var fetcherData = $fIwXP.useRef(/* @__PURE__ */ new Map());
    var setState = $fIwXP.useCallback(function(newState, param) {
        var deletedFetchers = param.deletedFetchers, flushSync = param.flushSync, viewTransitionOpts = param.viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        var isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(function() {
                return setStateImpl(newState);
            });
            else $fIwXP.startTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(function() {
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            var t = router.window.document.startViewTransition(function() {
                reactDomFlushSyncImpl(function() {
                    return setStateImpl(newState);
                });
            });
            t.finished.finally(function() {
                reactDomFlushSyncImpl(function() {
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(function() {
                return setTransition(t);
            });
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $fIwXP.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $fIwXP.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    $fIwXP.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition2 = router.window.document.startViewTransition(/*#__PURE__*/ (0, $7k5I8._)(function() {
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            $fIwXP.startTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition2.finished.finally(function() {
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $fIwXP.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $fIwXP.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator2 = $fIwXP.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state2, opts) {
                return router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state2, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $fIwXP.useMemo(function() {
        return {
            router: router,
            navigator: navigator2,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, /* @__PURE__ */ $fIwXP.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $fIwXP.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $fIwXP.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $fIwXP.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $fIwXP.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ $fIwXP.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var MemoizedDataRoutes = $fIwXP.memo(DataRoutes);
function DataRoutes(param) {
    var routes = param.routes, future = param.future, state = param.state;
    return useRoutesImpl(routes, void 0, state, future);
}
function MemoryRouter(param) {
    var basename = param.basename, children = param.children, initialEntries = param.initialEntries, initialIndex = param.initialIndex;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React3_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var setState = $fIwXP.useCallback(function(newState) {
        $fIwXP.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        setStateImpl
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fIwXP.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function Navigate(param) {
    var to = param.to, replace2 = param.replace, state = param.state, relative = param.relative;
    invariant(useInRouterContext(), "<Navigate> may be used only in the context of a <Router> component.");
    var _React3_useContext = $fIwXP.useContext(NavigationContext), isStatic = _React3_useContext.static;
    warning(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    var matches = $fIwXP.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var navigate = useNavigate();
    var path = resolveTo(to, getResolveToMatches(matches), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $fIwXP.useEffect(function() {
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function Outlet(props) {
    return useOutlet(props.context);
}
function Route(_props) {
    invariant(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
function Router(param) {
    var tmp = param.basename, basenameProp = tmp === void 0 ? "/" : tmp, _param_children = param.children, children = _param_children === void 0 ? null : _param_children, locationProp = param.location, _param_navigationType = param.navigationType, navigationType = _param_navigationType === void 0 ? "POP" /* Pop */  : _param_navigationType, navigator2 = param.navigator, tmp1 = param.static, staticProp = tmp1 === void 0 ? false : tmp1;
    invariant(!useInRouterContext(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $fIwXP.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        };
    }, [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $fIwXP.useMemo(function() {
        var trailingPathname = stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    warning(locationContext != null, '<Router basename="'.concat(basename, '"> is not able to match the URL "').concat(pathname).concat(search).concat(hash, "\" because it does not start with the basename, so the <Router> won't render anything."));
    if (locationContext == null) return null;
    return /* @__PURE__ */ $fIwXP.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $fIwXP.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
function Routes(param) {
    var children = param.children, location = param.location;
    return useRoutes(createRoutesFromChildren(children), location);
}
function Await(param) {
    var children = param.children, errorElement = param.errorElement, resolve = param.resolve;
    return /* @__PURE__ */ $fIwXP.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $fIwXP.createElement(ResolveAwait, null, children));
}
var AwaitErrorBoundary = /*#__PURE__*/ function(_React3_Component) {
    "use strict";
    (0, $5dLwP._)(AwaitErrorBoundary, _React3_Component);
    function AwaitErrorBoundary(props) {
        (0, $bB0zn._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $3Gvhd._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $6QEWP._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = 0 /* pending */ ;
                if (!(resolve instanceof Promise)) {
                    status = 1 /* success */ ;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    status = 2 /* error */ ;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {});
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    promise = resolve;
                    status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
                } else {
                    status = 0 /* pending */ ;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data2) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data2;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === 2 /* error */  && !errorElement) throw promise._error;
                if (status === 2 /* error */ ) return /* @__PURE__ */ $fIwXP.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === 1 /* success */ ) return /* @__PURE__ */ $fIwXP.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($fIwXP.Component);
function ResolveAwait(param) {
    var children = param.children;
    var data2 = useAsyncValue();
    var toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, toRender);
}
function createRoutesFromChildren(children) {
    var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var routes = [];
    $fIwXP.Children.forEach(children, function(element, index) {
        if (!$fIwXP.isValidElement(element)) return;
        var treePath = (0, $2Xzd1._)(parentPath).concat([
            index
        ]);
        if (element.type === $fIwXP.Fragment) {
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        invariant(element.type === Route, "[".concat(typeof element.type === "string" ? element.type : element.type.name, "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>"));
        invariant(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var createRoutesFromElements = createRoutesFromChildren;
function renderMatches(matches) {
    return _renderMatches(matches);
}
// lib/dom/dom.ts
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event);
}
function createSearchParams() {
    var init = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo2, key) {
        var value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        warning(false, '"'.concat(encType, '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` and will default to "').concat(defaultEncType, '"'));
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if (isFormElement(target)) {
        var attr = target.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? stripBasename(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target);
        if (!isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? "".concat(name, ".") : "";
                formData.append("".concat(prefix, "x"), "0");
                formData.append("".concat(prefix, "y"), "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function loadRouteModule(route, routeModulesCache) {
    return _loadRouteModule.apply(this, arguments);
}
function _loadRouteModule() {
    _loadRouteModule = // lib/dom/ssr/routeModules.ts
    (0, $7k5I8._)(function(route, routeModulesCache) {
        var routeModule, error;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (route.id in routeModulesCache) return [
                        2,
                        routeModulesCache[route.id]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.module)
                    ];
                case 2:
                    routeModule = _state.sent();
                    routeModulesCache[route.id] = routeModule;
                    return [
                        2,
                        routeModule
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error loading route module `".concat(route.module, "`, reloading page..."));
                    console.error(error);
                    if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
                    $d1c6608c36d1df9a$import_meta.hot) throw error;
                    window.location.reload();
                    return [
                        2,
                        new Promise(function() {})
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _loadRouteModule.apply(this, arguments);
}
// lib/dom/ssr/links.ts
function getKeyedLinksForMatches(matches, routeModules, manifest) {
    var descriptors = matches.map(function(match) {
        var _module_links;
        var module = routeModules[match.route.id];
        var route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map(function(href) {
                return {
                    rel: "stylesheet",
                    href: href
                };
            }) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    var preloads = getCurrentPageModulePreloadHrefs(matches, manifest);
    return dedupeLinkDescriptors(descriptors, preloads);
}
function prefetchStyleLinks(route, routeModule) {
    return _prefetchStyleLinks.apply(this, arguments);
}
function _prefetchStyleLinks() {
    _prefetchStyleLinks = (0, $7k5I8._)(function(route, routeModule) {
        var _descriptors, _descriptors1, descriptors, styleLinks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, descriptor, matchingLinks;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css && !routeModule.links || !isPreloadSupported()) return [
                        2
                    ];
                    descriptors = [];
                    if (route.css) (_descriptors = descriptors).push.apply(_descriptors, (0, $2Xzd1._)(route.css.map(function(href) {
                        return {
                            rel: "stylesheet",
                            href: href
                        };
                    })));
                    if (routeModule.links) (_descriptors1 = descriptors).push.apply(_descriptors1, (0, $2Xzd1._)(routeModule.links()));
                    if (descriptors.length === 0) return [
                        2
                    ];
                    styleLinks = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = descriptors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            descriptor = _step.value;
                            if (!isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push((0, $kJeRc._)((0, $eRslx._)({}, descriptor), {
                                rel: "preload",
                                as: "style"
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    matchingLinks = styleLinks.filter(function(link) {
                        return (!link.media || window.matchMedia(link.media).matches) && !document.querySelector('link[rel="stylesheet"][href="'.concat(link.href, '"]'));
                    });
                    return [
                        4,
                        Promise.all(matchingLinks.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _prefetchStyleLinks.apply(this, arguments);
}
function prefetchStyleLink(descriptor) {
    return _prefetchStyleLink.apply(this, arguments);
}
function _prefetchStyleLink() {
    _prefetchStyleLink = (0, $7k5I8._)(function(descriptor) {
        return (0, $lFlDF.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    var removeLink = function removeLink() {
                        if (document.head.contains(link)) document.head.removeChild(link);
                    };
                    var link = document.createElement("link");
                    Object.assign(link, descriptor);
                    link.onload = function() {
                        removeLink();
                        resolve();
                    };
                    link.onerror = function() {
                        removeLink();
                        resolve();
                    };
                    document.head.appendChild(link);
                })
            ];
        });
    });
    return _prefetchStyleLink.apply(this, arguments);
}
function isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
function getKeyedPrefetchLinks(matches, manifest, routeModules) {
    return _getKeyedPrefetchLinks.apply(this, arguments);
}
function _getKeyedPrefetchLinks() {
    _getKeyedPrefetchLinks = (0, $7k5I8._)(function(matches, manifest, routeModules) {
        var links;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(matches.map(/*#__PURE__*/ function() {
                            var _ref = (0, $7k5I8._)(function(match) {
                                var route, mod;
                                return (0, $lFlDF.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            route = manifest.routes[match.route.id];
                                            if (!route) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                loadRouteModule(route, routeModules)
                                            ];
                                        case 1:
                                            mod = _state.sent();
                                            return [
                                                2,
                                                mod.links ? mod.links() : []
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                []
                                            ];
                                    }
                                });
                            });
                            return function(match) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 1:
                    links = _state.sent();
                    return [
                        2,
                        dedupeLinkDescriptors(links.flat(1).filter(isHtmlLinkDescriptor).filter(function(link) {
                            return link.rel === "stylesheet" || link.rel === "preload";
                        }).map(function(link) {
                            return link.rel === "stylesheet" ? (0, $kJeRc._)((0, $eRslx._)({}, link), {
                                rel: "prefetch",
                                as: "style"
                            }) : (0, $kJeRc._)((0, $eRslx._)({}, link), {
                                rel: "prefetch"
                            });
                        }))
                    ];
            }
        });
    });
    return _getKeyedPrefetchLinks.apply(this, arguments);
}
function getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    var isNew = function(match, index) {
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    var matchPathChanged = function(match, index) {
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter(function(match, index) {
        return isNew(match, index) || matchPathChanged(match, index);
    });
    if (mode === "data") return nextMatches.filter(function(match, index) {
        var manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            var routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function getModuleLinkHrefs(matches, manifestPatch) {
    return dedupeHrefs(matches.map(function(match) {
        var route = manifestPatch.routes[match.route.id];
        if (!route) return [];
        var hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function getCurrentPageModulePreloadHrefs(matches, manifest) {
    return dedupeHrefs(matches.map(function(match) {
        var route = manifest.routes[match.route.id];
        if (!route) return [];
        var hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function dedupeHrefs(hrefs) {
    return (0, $2Xzd1._)(new Set(hrefs));
}
function sortKeys(obj) {
    var sorted = {};
    var keys = Object.keys(obj).sort();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            sorted[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sorted;
}
function dedupeLinkDescriptors(descriptors, preloads) {
    var set = /* @__PURE__ */ new Set();
    var preloadsSet = new Set(preloads);
    return descriptors.reduce(function(deduped, descriptor) {
        var alreadyModulePreload = preloads && !isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        var key = JSON.stringify(sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var _isPreloadSupported;
function isPreloadSupported() {
    if (_isPreloadSupported !== void 0) return _isPreloadSupported;
    var el = document.createElement("link");
    _isPreloadSupported = el.relList.supports("preload");
    el = null;
    return _isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function escapeHtml(html) {
    return html.replace(ESCAPE_REGEX, function(match) {
        return ESCAPE_LOOKUP[match];
    });
}
function createHtml(html) {
    return {
        __html: html
    };
}
function createRequestInit(request) {
    return _createRequestInit.apply(this, arguments);
}
function _createRequestInit() {
    _createRequestInit = // lib/dom/ssr/data.ts
    (0, $7k5I8._)(function(request) {
        var init, contentType, _, _1;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    init = {
                        signal: request.signal
                    };
                    if (!(request.method !== "GET")) return [
                        3,
                        8
                    ];
                    init.method = request.method;
                    contentType = request.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        2
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    _ = JSON.stringify;
                    return [
                        4,
                        request.json()
                    ];
                case 1:
                    init.body = _.apply(JSON, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        8
                    ];
                case 2:
                    if (!(contentType && /\btext\/plain\b/.test(contentType))) return [
                        3,
                        4
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    return [
                        4,
                        request.text()
                    ];
                case 3:
                    init.body = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!(contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType))) return [
                        3,
                        6
                    ];
                    _1 = URLSearchParams.bind;
                    return [
                        4,
                        request.text()
                    ];
                case 5:
                    init.body = new (_1.apply(URLSearchParams, [
                        void 0,
                        _state.sent()
                    ]));
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        request.formData()
                    ];
                case 7:
                    init.body = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        init
                    ];
            }
        });
    });
    return _createRequestInit.apply(this, arguments);
}
// lib/dom/ssr/single-fetch.tsx
var SingleFetchRedirectSymbol = Symbol("SingleFetchRedirect");
function StreamTransfer(param) {
    var context = param.context, identifier = param.identifier, reader = param.reader, textDecoder = param.textDecoder, nonce = param.nonce;
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    var streamCache = context.renderMeta.streamCache;
    var promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then(function(result) {
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch(function(e) {
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    var _promise_result = promise.result, done = _promise_result.done, value = _promise_result.value;
    var scriptTag = value ? /* @__PURE__ */ $fIwXP.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.enqueue(".concat(escapeHtml(JSON.stringify(value)), ");")
        }
    }) : null;
    if (done) return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, scriptTag, /* @__PURE__ */ $fIwXP.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.close();"
        }
    }));
    else return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, scriptTag, /* @__PURE__ */ $fIwXP.createElement($fIwXP.Suspense, null, /* @__PURE__ */ $fIwXP.createElement(StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function getSingleFetchDataStrategy(manifest, routeModules, getRouter) {
    return /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(param) {
            var request, matches, fetcherKey;
            return (0, $lFlDF.__generator)(this, function(_state) {
                request = param.request, matches = param.matches, fetcherKey = param.fetcherKey;
                if (request.method !== "GET") return [
                    2,
                    singleFetchActionStrategy(request, matches)
                ];
                if (fetcherKey) return [
                    2,
                    singleFetchLoaderFetcherStrategy(request, matches)
                ];
                return [
                    2,
                    singleFetchLoaderNavigationStrategy(manifest, routeModules, getRouter(), request, matches)
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
}
function singleFetchActionStrategy(request, matches) {
    return _singleFetchActionStrategy.apply(this, arguments);
}
function _singleFetchActionStrategy() {
    _singleFetchActionStrategy = (0, $7k5I8._)(function(request, matches) {
        var actionMatch, actionStatus, result;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    actionMatch = matches.find(function(m) {
                        return m.shouldLoad;
                    });
                    invariant2(actionMatch, "No action match found");
                    actionStatus = void 0;
                    return [
                        4,
                        actionMatch.resolve(/*#__PURE__*/ function() {
                            var _ref = (0, $7k5I8._)(function(handler) {
                                var result2;
                                return (0, $lFlDF.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handler(/*#__PURE__*/ (0, $7k5I8._)(function() {
                                                    var url, init, _ref, data2, status;
                                                    return (0, $lFlDF.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                url = singleFetchUrl(request.url);
                                                                return [
                                                                    4,
                                                                    createRequestInit(request)
                                                                ];
                                                            case 1:
                                                                init = _state.sent();
                                                                return [
                                                                    4,
                                                                    fetchAndDecode(url, init)
                                                                ];
                                                            case 2:
                                                                _ref = _state.sent(), data2 = _ref.data, status = _ref.status;
                                                                actionStatus = status;
                                                                return [
                                                                    2,
                                                                    unwrapSingleFetchResult(data2, actionMatch.route.id)
                                                                ];
                                                        }
                                                    });
                                                }))
                                            ];
                                        case 1:
                                            result2 = _state.sent();
                                            return [
                                                2,
                                                result2
                                            ];
                                    }
                                });
                            });
                            return function(handler) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    result = _state.sent();
                    if (isResponse(result.result) || isRouteErrorResponse(result.result)) return [
                        2,
                        (0, $hD5pT._)({}, actionMatch.route.id, result)
                    ];
                    return [
                        2,
                        (0, $hD5pT._)({}, actionMatch.route.id, {
                            type: result.type,
                            result: data(result.result, actionStatus)
                        })
                    ];
            }
        });
    });
    return _singleFetchActionStrategy.apply(this, arguments);
}
function singleFetchLoaderNavigationStrategy(manifest, routeModules, router, request, matches) {
    return _singleFetchLoaderNavigationStrategy.apply(this, arguments);
}
function _singleFetchLoaderNavigationStrategy() {
    _singleFetchLoaderNavigationStrategy = (0, $7k5I8._)(function(manifest, routeModules, router, request, matches) {
        var routesParams, foundOptOutRoute, routeDfds, routesLoadedPromise, singleFetchDfd, url, init, results, resolvePromise, data2, e;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routesParams = /* @__PURE__ */ new Set();
                    foundOptOutRoute = false;
                    routeDfds = matches.map(function() {
                        return createDeferred2();
                    });
                    routesLoadedPromise = Promise.all(routeDfds.map(function(d) {
                        return d.promise;
                    }));
                    singleFetchDfd = createDeferred2();
                    url = stripIndexParam(singleFetchUrl(request.url));
                    return [
                        4,
                        createRequestInit(request)
                    ];
                case 1:
                    init = _state.sent();
                    results = {};
                    resolvePromise = Promise.all(matches.map(/*#__PURE__*/ function() {
                        var _ref = (0, $7k5I8._)(function(m, i) {
                            return (0, $lFlDF.__generator)(this, function(_state) {
                                return [
                                    2,
                                    m.resolve(/*#__PURE__*/ function() {
                                        var _ref = (0, $7k5I8._)(function(handler) {
                                            var manifestRoute, _routeModules_m_route_id, result, e, result1, e1;
                                            return (0, $lFlDF.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        routeDfds[i].resolve();
                                                        manifestRoute = manifest.routes[m.route.id];
                                                        if (!m.shouldLoad) {
                                                            ;
                                                            if (!router.state.initialized) return [
                                                                2
                                                            ];
                                                            if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) {
                                                                foundOptOutRoute = true;
                                                                return [
                                                                    2
                                                                ];
                                                            }
                                                        }
                                                        if (!(manifestRoute && manifestRoute.hasClientLoader)) return [
                                                            3,
                                                            5
                                                        ];
                                                        if (manifestRoute.hasLoader) foundOptOutRoute = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            fetchSingleLoader(handler, url, init, m.route.id)
                                                        ];
                                                    case 2:
                                                        result = _state.sent();
                                                        results[m.route.id] = {
                                                            type: "data",
                                                            result: result
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        results[m.route.id] = {
                                                            type: "error",
                                                            result: e
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                    case 5:
                                                        if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
                                                        _state.label = 6;
                                                    case 6:
                                                        _state.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(/*#__PURE__*/ (0, $7k5I8._)(function() {
                                                                var data2;
                                                                return (0, $lFlDF.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                singleFetchDfd.promise
                                                                            ];
                                                                        case 1:
                                                                            data2 = _state.sent();
                                                                            return [
                                                                                2,
                                                                                unwrapSingleFetchResults(data2, m.route.id)
                                                                            ];
                                                                    }
                                                                });
                                                            }))
                                                        ];
                                                    case 7:
                                                        result1 = _state.sent();
                                                        results[m.route.id] = {
                                                            type: "data",
                                                            result: result1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 8:
                                                        e1 = _state.sent();
                                                        results[m.route.id] = {
                                                            type: "error",
                                                            result: e1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 9:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(handler) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            });
                        });
                        return function(m, i) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                    return [
                        4,
                        routesLoadedPromise
                    ];
                case 2:
                    _state.sent();
                    if (!((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive)) return [
                        3,
                        3
                    ];
                    singleFetchDfd.resolve({});
                    return [
                        3,
                        6
                    ];
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter(function(m) {
                        return routesParams.has(m.route.id);
                    }).map(function(m) {
                        return m.route.id;
                    }).join(","));
                    return [
                        4,
                        fetchAndDecode(url, init)
                    ];
                case 4:
                    data2 = _state.sent();
                    singleFetchDfd.resolve(data2.data);
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    singleFetchDfd.reject(e);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        4,
                        resolvePromise
                    ];
                case 7:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _singleFetchLoaderNavigationStrategy.apply(this, arguments);
}
function singleFetchLoaderFetcherStrategy(request, matches) {
    return _singleFetchLoaderFetcherStrategy.apply(this, arguments);
}
function _singleFetchLoaderFetcherStrategy() {
    _singleFetchLoaderFetcherStrategy = (0, $7k5I8._)(function(request, matches) {
        var fetcherMatch, result;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetcherMatch = matches.find(function(m) {
                        return m.shouldLoad;
                    });
                    invariant2(fetcherMatch, "No fetcher match found");
                    return [
                        4,
                        fetcherMatch.resolve(/*#__PURE__*/ function() {
                            var _ref = (0, $7k5I8._)(function(handler) {
                                var url, init;
                                return (0, $lFlDF.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            url = stripIndexParam(singleFetchUrl(request.url));
                                            return [
                                                4,
                                                createRequestInit(request)
                                            ];
                                        case 1:
                                            init = _state.sent();
                                            return [
                                                2,
                                                fetchSingleLoader(handler, url, init, fetcherMatch.route.id)
                                            ];
                                    }
                                });
                            });
                            return function(handler) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0, $hD5pT._)({}, fetcherMatch.route.id, result)
                    ];
            }
        });
    });
    return _singleFetchLoaderFetcherStrategy.apply(this, arguments);
}
function fetchSingleLoader(handler, url, init, routeId) {
    return handler(/*#__PURE__*/ (0, $7k5I8._)(function() {
        var singleLoaderUrl, _ref, data2;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    singleLoaderUrl = new URL(url);
                    singleLoaderUrl.searchParams.set("_routes", routeId);
                    return [
                        4,
                        fetchAndDecode(singleLoaderUrl, init)
                    ];
                case 1:
                    _ref = _state.sent(), data2 = _ref.data;
                    return [
                        2,
                        unwrapSingleFetchResults(data2, routeId)
                    ];
            }
        });
    }));
}
function stripIndexParam(url) {
    var indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    var indexValuesToKeep = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var indexValue = _step.value;
            if (indexValue) indexValuesToKeep.push(indexValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = indexValuesToKeep[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var toKeep = _step1.value;
            url.searchParams.append("index", toKeep);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return url;
}
function singleFetchUrl(reqUrl) {
    var url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = "".concat(url.pathname.replace(/\/$/, ""), ".data");
    return url;
}
function fetchAndDecode(url, init) {
    return _fetchAndDecode.apply(this, arguments);
}
function _fetchAndDecode() {
    _fetchAndDecode = (0, $7k5I8._)(function(url, init) {
        var res, decoded, e;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(url, init)
                    ];
                case 1:
                    res = _state.sent();
                    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new ErrorResponseImpl(404, "Not Found", true);
                    invariant2(res.body, "No response body to decode");
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        decodeViaTurboStream(res.body, window)
                    ];
                case 3:
                    decoded = _state.sent();
                    return [
                        2,
                        {
                            status: res.status,
                            data: decoded.value
                        }
                    ];
                case 4:
                    e = _state.sent();
                    throw new Error("Unable to decode turbo-stream response");
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchAndDecode.apply(this, arguments);
}
function decodeViaTurboStream(body, global2) {
    return (0, $f6Ucb.decode)(body, {
        plugins: [
            function(type) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (type === "SanitizedError") {
                    var _rest = (0, $kB67t._)(rest, 3), name = _rest[0], message = _rest[1], stack = _rest[2];
                    var Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    var error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    var _rest1 = (0, $kB67t._)(rest, 3), data2 = _rest1[0], status = _rest1[1], statusText = _rest1[2];
                    return {
                        value: new ErrorResponseImpl(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: (0, $hD5pT._)({}, SingleFetchRedirectSymbol, rest[0])
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function unwrapSingleFetchResults(results, routeId) {
    var redirect2 = results[SingleFetchRedirectSymbol];
    if (redirect2) return unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        var headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        throw redirect(result.redirect, {
            status: result.status,
            headers: headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error('No response found for routeId "'.concat(routeId, '"'));
}
function createDeferred2() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = /*#__PURE__*/ function() {
            var _ref = (0, $7k5I8._)(function(val) {
                var e;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(val) {
                return _ref.apply(this, arguments);
            };
        }();
        reject = /*#__PURE__*/ function() {
            var _ref = (0, $7k5I8._)(function(error) {
                var e;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(error) {
                return _ref.apply(this, arguments);
            };
        }();
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
var RemixErrorBoundary = /*#__PURE__*/ function(_React5_Component) {
    "use strict";
    (0, $5dLwP._)(RemixErrorBoundary, _React5_Component);
    function RemixErrorBoundary(props) {
        (0, $bB0zn._)(this, RemixErrorBoundary);
        var _this;
        _this = (0, $3Gvhd._)(this, RemixErrorBoundary, [
            props
        ]);
        _this.state = {
            error: props.error || null,
            location: props.location
        };
        return _this;
    }
    (0, $6QEWP._)(RemixErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.error) return /* @__PURE__ */ $fIwXP.createElement(RemixRootDefaultErrorBoundary, {
                    error: this.state.error,
                    isOutsideRemixApp: true
                });
                else return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location) return {
                    error: props.error || null,
                    location: props.location
                };
                return {
                    error: props.error || state.error,
                    location: state.location
                };
            }
        }
    ]);
    return RemixErrorBoundary;
}($fIwXP.Component);
function RemixRootDefaultErrorBoundary(param) {
    var error = param.error, isOutsideRemixApp = param.isOutsideRemixApp;
    console.error(error);
    var heyDeveloper = /* @__PURE__ */ $fIwXP.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: '\n        console.log(\n          "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."\n        );\n      '
        }
    });
    if (isRouteErrorResponse(error)) return /* @__PURE__ */ $fIwXP.createElement(BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $fIwXP.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    var errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        var errorString = error == null ? "Unknown Error" : (typeof error === "undefined" ? "undefined" : (0, $YtE9h._)(error)) === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $fIwXP.createElement(BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $fIwXP.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $fIwXP.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function BoundaryShell(param) {
    var title = param.title, renderScripts = param.renderScripts, isOutsideRemixApp = param.isOutsideRemixApp, children = param.children;
    var _routeModules_root;
    var routeModules = useFrameworkContext().routeModules;
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $fIwXP.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $fIwXP.createElement("head", null, /* @__PURE__ */ $fIwXP.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $fIwXP.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $fIwXP.createElement("title", null, title)), /* @__PURE__ */ $fIwXP.createElement("body", null, /* @__PURE__ */ $fIwXP.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $fIwXP.createElement(Scripts, null) : null)));
}
function RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $fIwXP.createElement(BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ $fIwXP.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: '\n              console.log(\n                "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this " +\n                "when your app is loading JS modules and/or running `clientLoader` " +\n                "functions. Check out https://remix.run/route/hydrate-fallback " +\n                "for more information."\n              );\n            '
        }
    }));
}
// lib/dom/ssr/routes.tsx
function groupRoutesByParentId(manifest) {
    var routes = {};
    Object.values(manifest).forEach(function(route) {
        if (route) {
            var parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function getRouteComponents(route, routeModule, isSpaMode) {
    var Component4 = getRouteModuleComponent(routeModule);
    var HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? RemixRootDefaultHydrateFallback : void 0;
    var ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? function() {
        return /* @__PURE__ */ $fIwXP.createElement(RemixRootDefaultErrorBoundary, {
            error: useRouteError()
        });
    } : void 0;
    if (route.id === "root" && routeModule.Layout) return (0, $eRslx._)({}, Component4 ? {
        element: /* @__PURE__ */ $fIwXP.createElement(routeModule.Layout, null, /* @__PURE__ */ $fIwXP.createElement(Component4, null))
    } : {
        Component: Component4
    }, ErrorBoundary ? {
        errorElement: /* @__PURE__ */ $fIwXP.createElement(routeModule.Layout, null, /* @__PURE__ */ $fIwXP.createElement(ErrorBoundary, null))
    } : {
        ErrorBoundary: ErrorBoundary
    }, HydrateFallback ? {
        hydrateFallbackElement: /* @__PURE__ */ $fIwXP.createElement(routeModule.Layout, null, /* @__PURE__ */ $fIwXP.createElement(HydrateFallback, null))
    } : {
        HydrateFallback: HydrateFallback
    });
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function createServerRoutes(manifest, routeModules, future, isSpaMode) {
    var parentId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", routesByParentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : groupRoutesByParentId(manifest), spaModeLazyPromise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Promise.resolve({
        Component: function() {
            return null;
        }
    });
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModules[route.id];
        invariant2(routeModule, "No `routeModule` available to create server routes");
        var dataRoute = (0, $kJeRc._)((0, $eRslx._)({}, getRouteComponents(route, routeModule, isSpaMode)), {
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? function() {
                return spaModeLazyPromise;
            } : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? function() {
                return null;
            } : void 0
        });
        var children = createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function createClientRoutesWithHMRRevalidationOptOut(needsRevalidation, manifest, routeModulesCache, initialState, future, isSpaMode) {
    return createClientRoutes(manifest, routeModulesCache, initialState, isSpaMode, "", groupRoutesByParentId(manifest), needsRevalidation);
}
function preventInvalidServerHandlerCall(type, route, isSpaMode) {
    if (isSpaMode) {
        var fn2 = type === "action" ? "serverAction()" : "serverLoader()";
        var msg2 = "You cannot call ".concat(fn2, ' in SPA Mode (routeId: "').concat(route.id, '")');
        console.error(msg2);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg2), true);
    }
    var fn = type === "action" ? "serverAction()" : "serverLoader()";
    var msg = "You are trying to call ".concat(fn, " on a route that does not have a server ").concat(type, ' (routeId: "').concat(route.id, '")');
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        console.error(msg);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg), true);
    }
}
function noActionDefinedError(type, routeId) {
    var article = type === "clientAction" ? "a" : "an";
    var msg = 'Route "'.concat(routeId, '" does not have ').concat(article, " ").concat(type, ", but you are trying to submit to it. To fix this, please add ").concat(article, " `").concat(type, "` function to the route");
    console.error(msg);
    throw new ErrorResponseImpl(405, "Method Not Allowed", new Error(msg), true);
}
function createClientRoutes(manifest, routeModulesCache, initialState, isSpaMode) {
    var parentId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", routesByParentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : groupRoutesByParentId(manifest), needsRevalidation = arguments.length > 6 ? arguments[6] : void 0;
    return (routesByParentId[parentId] || []).map(function(route) {
        var fetchServerHandler = function fetchServerHandler(singleFetch) {
            invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        };
        var fetchServerLoader = function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        };
        var fetchServerAction = function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        };
        var prefetchStylesAndCallHandler = function prefetchStylesAndCallHandler(handler) {
            return _prefetchStylesAndCallHandler.apply(this, arguments);
        };
        var routeModule = routeModulesCache[route.id];
        function _prefetchStylesAndCallHandler() {
            _prefetchStylesAndCallHandler = (0, $7k5I8._)(function(handler) {
                var cachedModule, linkPrefetchPromise;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cachedModule = routeModulesCache[route.id];
                            linkPrefetchPromise = cachedModule ? prefetchStyleLinks(route, cachedModule) : Promise.resolve();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                2,
                                4
                            ]);
                            return [
                                2,
                                handler()
                            ];
                        case 2:
                            return [
                                4,
                                linkPrefetchPromise
                            ];
                        case 3:
                            _state.sent();
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _prefetchStylesAndCallHandler.apply(this, arguments);
        }
        var dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, (0, $kJeRc._)((0, $eRslx._)({}, dataRoute, getRouteComponents(route, routeModule, isSpaMode)), {
                handle: routeModule.handle,
                shouldRevalidate: getShouldRevalidateFunction(routeModule, route.id, needsRevalidation)
            }));
            var hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            var initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            var hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            var initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            var isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = /*#__PURE__*/ function() {
                var _ref = (0, $7k5I8._)(function(param, singleFetch) {
                    var request, params, result;
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                request = param.request, params = param.params;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    prefetchStylesAndCallHandler(/*#__PURE__*/ (0, $7k5I8._)(function() {
                                        return (0, $lFlDF.__generator)(this, function(_state) {
                                            invariant2(routeModule, "No `routeModule` available for critical-route loader");
                                            if (!routeModule.clientLoader) {
                                                if (isSpaMode) return [
                                                    2,
                                                    null
                                                ];
                                                return [
                                                    2,
                                                    fetchServerLoader(singleFetch)
                                                ];
                                            }
                                            return [
                                                2,
                                                routeModule.clientLoader({
                                                    request: request,
                                                    params: params,
                                                    serverLoader: function() {
                                                        return (0, $7k5I8._)(function() {
                                                            return (0, $lFlDF.__generator)(this, function(_state) {
                                                                preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                                                if (isHydrationRequest) {
                                                                    if (hasInitialData) return [
                                                                        2,
                                                                        initialData
                                                                    ];
                                                                    if (hasInitialError) throw initialError;
                                                                }
                                                                return [
                                                                    2,
                                                                    fetchServerLoader(singleFetch)
                                                                ];
                                                            });
                                                        })();
                                                    }
                                                })
                                            ];
                                        });
                                    }))
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                isHydrationRequest = false;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_, singleFetch) {
                    return _ref.apply(this, arguments);
                };
            }();
            dataRoute.loader.hydrate = shouldHydrateRouteLoader(route, routeModule, isSpaMode);
            dataRoute.action = function(param, singleFetch) {
                var request = param.request, params = param.params;
                return prefetchStylesAndCallHandler(/*#__PURE__*/ (0, $7k5I8._)(function() {
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        invariant2(routeModule, "No `routeModule` available for critical-route action");
                        if (!routeModule.clientAction) {
                            if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                            return [
                                2,
                                fetchServerAction(singleFetch)
                            ];
                        }
                        return [
                            2,
                            routeModule.clientAction({
                                request: request,
                                params: params,
                                serverAction: function() {
                                    return (0, $7k5I8._)(function() {
                                        return (0, $lFlDF.__generator)(this, function(_state) {
                                            preventInvalidServerHandlerCall("action", route, isSpaMode);
                                            return [
                                                2,
                                                fetchServerAction(singleFetch)
                                            ];
                                        });
                                    })();
                                }
                            })
                        ];
                    });
                }));
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = function(param, singleFetch) {
                var request = param.request;
                return prefetchStylesAndCallHandler(function() {
                    if (isSpaMode) return Promise.resolve(null);
                    return fetchServerLoader(singleFetch);
                });
            };
            if (!route.hasClientAction) dataRoute.action = function(param, singleFetch) {
                var request = param.request;
                return prefetchStylesAndCallHandler(function() {
                    if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            };
            dataRoute.lazy = /*#__PURE__*/ (0, $7k5I8._)(function() {
                var mod, lazyRoute, clientLoader, clientAction;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                loadRouteModuleWithBlockingLinks(route, routeModulesCache)
                            ];
                        case 1:
                            mod = _state.sent();
                            lazyRoute = (0, $eRslx._)({}, mod);
                            if (mod.clientLoader) {
                                clientLoader = mod.clientLoader;
                                lazyRoute.loader = function(args, singleFetch) {
                                    return clientLoader((0, $kJeRc._)((0, $eRslx._)({}, args), {
                                        serverLoader: function() {
                                            return (0, $7k5I8._)(function() {
                                                return (0, $lFlDF.__generator)(this, function(_state) {
                                                    preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                                    return [
                                                        2,
                                                        fetchServerLoader(singleFetch)
                                                    ];
                                                });
                                            })();
                                        }
                                    }));
                                };
                            }
                            if (mod.clientAction) {
                                clientAction = mod.clientAction;
                                lazyRoute.action = function(args, singleFetch) {
                                    return clientAction((0, $kJeRc._)((0, $eRslx._)({}, args), {
                                        serverAction: function() {
                                            return (0, $7k5I8._)(function() {
                                                return (0, $lFlDF.__generator)(this, function(_state) {
                                                    preventInvalidServerHandlerCall("action", route, isSpaMode);
                                                    return [
                                                        2,
                                                        fetchServerAction(singleFetch)
                                                    ];
                                                });
                                            })();
                                        }
                                    }));
                                };
                            }
                            return [
                                2,
                                (0, $kJeRc._)((0, $eRslx._)({}, lazyRoute.loader ? {
                                    loader: lazyRoute.loader
                                } : {}, lazyRoute.action ? {
                                    action: lazyRoute.action
                                } : {}), {
                                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                                    shouldRevalidate: getShouldRevalidateFunction(lazyRoute, route.id, needsRevalidation),
                                    handle: lazyRoute.handle,
                                    // No need to wrap these in layout since the root route is never
                                    // loaded via route.lazy()
                                    Component: lazyRoute.Component,
                                    ErrorBoundary: lazyRoute.ErrorBoundary
                                })
                            ];
                    }
                });
            });
        }
        var children = createClientRoutes(manifest, routeModulesCache, initialState, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function getShouldRevalidateFunction(route, routeId, needsRevalidation) {
    if (needsRevalidation) return wrapShouldRevalidateForHdr(routeId, route.shouldRevalidate, needsRevalidation);
    if (route.shouldRevalidate) {
        var fn = route.shouldRevalidate;
        return function(opts) {
            return fn((0, $kJeRc._)((0, $eRslx._)({}, opts), {
                defaultShouldRevalidate: true
            }));
        };
    }
    return route.shouldRevalidate;
}
function wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    var handledRevalidation = false;
    return function(arg) {
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
function loadRouteModuleWithBlockingLinks(route, routeModules) {
    return _loadRouteModuleWithBlockingLinks.apply(this, arguments);
}
function _loadRouteModuleWithBlockingLinks() {
    _loadRouteModuleWithBlockingLinks = (0, $7k5I8._)(function(route, routeModules) {
        var routeModule;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        loadRouteModule(route, routeModules)
                    ];
                case 1:
                    routeModule = _state.sent();
                    return [
                        4,
                        prefetchStyleLinks(route, routeModule)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {
                            Component: getRouteModuleComponent(routeModule),
                            ErrorBoundary: routeModule.ErrorBoundary,
                            clientAction: routeModule.clientAction,
                            clientLoader: routeModule.clientLoader,
                            handle: routeModule.handle,
                            links: routeModule.links,
                            meta: routeModule.meta,
                            shouldRevalidate: routeModule.shouldRevalidate
                        }
                    ];
            }
        });
    });
    return _loadRouteModuleWithBlockingLinks.apply(this, arguments);
}
function getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    var isEmptyObject = (0, $YtE9h._)(routeModule.default) === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function shouldHydrateRouteLoader(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var nextPaths = /* @__PURE__ */ new Set();
var discoveredPathsMaxSize = 1e3;
var discoveredPaths = /* @__PURE__ */ new Set();
var URL_LIMIT = 7680;
function isFogOfWarEnabled(isSpaMode) {
    return !isSpaMode;
}
function getPartialManifest(manifest, router) {
    var routeIds = new Set(router.state.matches.map(function(m) {
        return m.route.id;
    }));
    var segments = router.state.location.pathname.split("/").filter(Boolean);
    var paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push("/".concat(segments.join("/")));
        segments.pop();
    }
    paths.forEach(function(path) {
        var matches = matchRoutes(router.routes, path, router.basename);
        if (matches) matches.forEach(function(m) {
            return routeIds.add(m.route.id);
        });
    });
    var initialRoutes = (0, $2Xzd1._)(routeIds).reduce(function(acc, id) {
        return Object.assign(acc, (0, $hD5pT._)({}, id, manifest.routes[id]));
    }, {});
    return (0, $kJeRc._)((0, $eRslx._)({}, manifest), {
        routes: initialRoutes
    });
}
function getPatchRoutesOnNavigationFunction(manifest, routeModules, isSpaMode, basename) {
    if (!isFogOfWarEnabled(isSpaMode)) return void 0;
    return /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(param) {
            var path, patch;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        path = param.path, patch = param.patch;
                        if (discoveredPaths.has(path)) return [
                            2
                        ];
                        return [
                            4,
                            fetchAndApplyManifestPatches([
                                path
                            ], manifest, routeModules, isSpaMode, basename, patch)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
}
function useFogOFWarDiscovery(router, manifest, routeModules, isSpaMode) {
    $fIwXP.useEffect(function() {
        var registerElement = function registerElement(el) {
            var path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            var url = new URL(path, window.location.origin);
            if (!discoveredPaths.has(url.pathname)) nextPaths.add(url.pathname);
        };
        var fetchPatches = function fetchPatches() {
            return _fetchPatches.apply(this, arguments);
        };
        var isElement = function isElement(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        };
        var _navigator_connection;
        if (!isFogOfWarEnabled(isSpaMode) || ((_navigator_connection = navigator.connection) === null || _navigator_connection === void 0 ? void 0 : _navigator_connection.saveData) === true) return;
        function _fetchPatches() {
            _fetchPatches = (0, $7k5I8._)(function() {
                var lazyPaths, e;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            lazyPaths = Array.from(nextPaths.keys()).filter(function(path) {
                                if (discoveredPaths.has(path)) {
                                    nextPaths.delete(path);
                                    return false;
                                }
                                return true;
                            });
                            if (lazyPaths.length === 0) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, isSpaMode, router.basename, router.patchRoutes)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error("Failed to fetch manifest patches", e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchPatches.apply(this, arguments);
        }
        document.body.querySelectorAll("a[data-discover], form[data-discover]").forEach(function(el) {
            return registerElement(el);
        });
        fetchPatches();
        var debouncedFetchPatches = debounce(fetchPatches, 100);
        var observer = new MutationObserver(function(records) {
            var elements = /* @__PURE__ */ new Set();
            records.forEach(function(r) {
                [
                    r.target
                ].concat((0, $2Xzd1._)(r.addedNodes)).forEach(function(node) {
                    if (!isElement(node)) return;
                    if (node.tagName === "A" && node.getAttribute("data-discover")) elements.add(node);
                    else if (node.tagName === "FORM" && node.getAttribute("data-discover")) elements.add(node);
                    if (node.tagName !== "A") node.querySelectorAll("a[data-discover], form[data-discover]").forEach(function(el) {
                        return elements.add(el);
                    });
                });
            });
            elements.forEach(function(el) {
                return registerElement(el);
            });
            debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
function fetchAndApplyManifestPatches(paths, manifest, routeModules, isSpaMode, basename, patchRoutes) {
    return _fetchAndApplyManifestPatches.apply(this, arguments);
}
function _fetchAndApplyManifestPatches() {
    _fetchAndApplyManifestPatches = (0, $7k5I8._)(function(paths, manifest, routeModules, isSpaMode, basename, patchRoutes) {
        var manifestPath, url, res, _, serverPatches, knownRoutes, patches, parentIds;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    manifestPath = "".concat(basename != null ? basename : "/", "/__manifest").replace(/\/+/g, "/");
                    url = new URL(manifestPath, window.location.origin);
                    paths.sort().forEach(function(path) {
                        return url.searchParams.append("p", path);
                    });
                    url.searchParams.set("version", manifest.version);
                    if (url.toString().length > URL_LIMIT) {
                        nextPaths.clear();
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    res = _state.sent();
                    if (!!res.ok) return [
                        3,
                        2
                    ];
                    throw new Error("".concat(res.status, " ").concat(res.statusText));
                case 2:
                    if (!(res.status >= 400)) return [
                        3,
                        4
                    ];
                    _ = Error.bind;
                    return [
                        4,
                        res.text()
                    ];
                case 3:
                    throw new (_.apply(Error, [
                        void 0,
                        _state.sent()
                    ]));
                case 4:
                    return [
                        4,
                        res.json()
                    ];
                case 5:
                    serverPatches = _state.sent();
                    knownRoutes = new Set(Object.keys(manifest.routes));
                    patches = Object.values(serverPatches).reduce(function(acc, route) {
                        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
                        return acc;
                    }, {});
                    Object.assign(manifest.routes, patches);
                    paths.forEach(function(p) {
                        return addToFifoQueue(p, discoveredPaths);
                    });
                    parentIds = /* @__PURE__ */ new Set();
                    Object.values(patches).forEach(function(patch) {
                        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
                    });
                    parentIds.forEach(function(parentId) {
                        return patchRoutes(parentId || null, createClientRoutes(patches, routeModules, null, isSpaMode, parentId));
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchAndApplyManifestPatches.apply(this, arguments);
}
function addToFifoQueue(path, queue) {
    if (queue.size >= discoveredPathsMaxSize) {
        var first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function debounce(callback, wait) {
    var timeoutId;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            return callback.apply(void 0, (0, $2Xzd1._)(args));
        }, wait);
    };
}
// lib/dom/ssr/components.tsx
function useDataRouterContext2() {
    var context = $fIwXP.useContext(DataRouterContext);
    invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function useDataRouterStateContext() {
    var context = $fIwXP.useContext(DataRouterStateContext);
    invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var FrameworkContext = $fIwXP.createContext(void 0);
FrameworkContext.displayName = "FrameworkContext";
function useFrameworkContext() {
    var context = $fIwXP.useContext(FrameworkContext);
    invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function usePrefetchBehavior(prefetch, theirElementProps) {
    var frameworkContext = $fIwXP.useContext(FrameworkContext);
    var _React9_useState = (0, $kB67t._)($fIwXP.useState(false), 2), maybePrefetch = _React9_useState[0], setMaybePrefetch = _React9_useState[1];
    var _React9_useState1 = (0, $kB67t._)($fIwXP.useState(false), 2), shouldPrefetch = _React9_useState1[0], setShouldPrefetch = _React9_useState1[1];
    var onFocus = theirElementProps.onFocus, onBlur = theirElementProps.onBlur, onMouseEnter = theirElementProps.onMouseEnter, onMouseLeave = theirElementProps.onMouseLeave, onTouchStart = theirElementProps.onTouchStart;
    var ref = $fIwXP.useRef(null);
    $fIwXP.useEffect(function() {
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            var observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return function() {
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $fIwXP.useEffect(function() {
        if (maybePrefetch) {
            var id = setTimeout(function() {
                setShouldPrefetch(true);
            }, 100);
            return function() {
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    var setIntent = function() {
        setMaybePrefetch(true);
    };
    var cancelIntent = function() {
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: composeEventHandlers(onFocus, setIntent),
            onBlur: composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function composeEventHandlers(theirHandler, ourHandler) {
    return function(event) {
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !isHydrated) return [
        matches[0]
    ];
    if (errors) {
        var errorIdx = matches.findIndex(function(m) {
            return errors[m.route.id] !== void 0;
        });
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function Links() {
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules, criticalCss = _useFrameworkContext.criticalCss;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches;
    var matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var keyedLinks = $fIwXP.useMemo(function() {
        return getKeyedLinksForMatches(matches, routeModules, manifest);
    }, [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, criticalCss ? /* @__PURE__ */ $fIwXP.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(function(param) {
        var key = param.key, link = param.link;
        return isPageLinkDescriptor(link) ? /* @__PURE__ */ $fIwXP.createElement(PrefetchPageLinks, (0, $eRslx._)({
            key: key
        }, link)) : /* @__PURE__ */ $fIwXP.createElement("link", (0, $eRslx._)({
            key: key
        }, link));
    }));
}
function PrefetchPageLinks(_param) {
    var page = _param.page, dataLinkProps = (0, $1dxAe._)(_param, [
        "page"
    ]);
    var router = useDataRouterContext2().router;
    var matches = $fIwXP.useMemo(function() {
        return matchRoutes(router.routes, page, router.basename);
    }, [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $fIwXP.createElement(PrefetchPageLinksImpl, (0, $eRslx._)({
        page: page,
        matches: matches
    }, dataLinkProps));
}
function useKeyedPrefetchLinks(matches) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var _React9_useState = (0, $kB67t._)($fIwXP.useState([]), 2), keyedPrefetchLinks = _React9_useState[0], setKeyedPrefetchLinks = _React9_useState[1];
    $fIwXP.useEffect(function() {
        var interrupted = false;
        getKeyedPrefetchLinks(matches, manifest, routeModules).then(function(links) {
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return function() {
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function PrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $1dxAe._)(_param, [
        "page",
        "matches"
    ]);
    var location = useLocation();
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var _useDataRouterStateContext = useDataRouterStateContext(), loaderData = _useDataRouterStateContext.loaderData, matches = _useDataRouterStateContext.matches;
    var newMatchesForData = $fIwXP.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var newMatchesForAssets = $fIwXP.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var dataHrefs = $fIwXP.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var routesParams = /* @__PURE__ */ new Set();
        var foundOptOutRoute = false;
        nextMatches.forEach(function(m) {
            var _routeModules_m_route_id;
            var manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some(function(m2) {
                return m2.route.id === m.route.id;
            }) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        var url = singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter(function(m) {
            return routesParams.has(m.route.id);
        }).map(function(m) {
            return m.route.id;
        }).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    var moduleHrefs = $fIwXP.useMemo(function() {
        return getModuleLinkHrefs(newMatchesForAssets, manifest);
    }, [
        newMatchesForAssets,
        manifest
    ]);
    var keyedPrefetchLinks = useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $fIwXP.createElement("link", (0, $eRslx._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }), moduleHrefs.map(function(href) {
        return /* @__PURE__ */ $fIwXP.createElement("link", (0, $eRslx._)({
            key: href,
            rel: "modulepreload",
            href: href
        }, linkProps));
    }), keyedPrefetchLinks.map(function(param) {
        var key = param.key, link = param.link;
        return(// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $fIwXP.createElement("link", (0, $eRslx._)({
            key: key
        }, link)));
    }));
}
function Meta() {
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, routeModules = _useFrameworkContext.routeModules;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches, loaderData = _useDataRouterStateContext.loaderData;
    var location = useLocation();
    var _matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    var meta = [];
    var leafMeta = null;
    var matches = [];
    for(var i = 0; i < _matches.length; i++){
        var _match = _matches[i];
        var routeId = _match.route.id;
        var data2 = loaderData[routeId];
        var params = _match.params;
        var routeModule = routeModules[routeId];
        var routeMeta = [];
        var match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? (0, $2Xzd1._)(routeModule.meta) : routeModule.meta;
        else if (leafMeta) routeMeta = (0, $2Xzd1._)(leafMeta);
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = (0, $2Xzd1._)(routeMeta);
        leafMeta = meta;
    }
    return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, meta.flat().map(function(metaProps) {
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            var tagName = metaProps.tagName, rest = (0, $1dxAe._)(metaProps, [
                "tagName"
            ]);
            if (!isValidMetaTag(tagName)) {
                console.warn("A meta object uses an invalid tagName: ".concat(tagName, ". Expected either 'link' or 'meta'"));
                return null;
            }
            var Comp = tagName;
            return /* @__PURE__ */ $fIwXP.createElement(Comp, (0, $eRslx._)({
                key: JSON.stringify(rest)
            }, rest));
        }
        if ("title" in metaProps) return /* @__PURE__ */ $fIwXP.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $fIwXP.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            var json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $fIwXP.createElement("script", {
                key: "script:ld+json:".concat(json),
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $fIwXP.createElement("meta", (0, $eRslx._)({
            key: JSON.stringify(metaProps)
        }, metaProps));
    }));
}
function isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var isHydrated = false;
function Scripts(props) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, serverHandoffString = _useFrameworkContext.serverHandoffString, isSpaMode = _useFrameworkContext.isSpaMode, renderMeta = _useFrameworkContext.renderMeta;
    var _useDataRouterContext2 = useDataRouterContext2(), router = _useDataRouterContext2.router, isStatic = _useDataRouterContext2.static, staticContext = _useDataRouterContext2.staticContext;
    var _useDataRouterStateContext = useDataRouterStateContext(), routerMatches = _useDataRouterStateContext.matches;
    var enableFogOfWar = isFogOfWarEnabled(isSpaMode);
    if (renderMeta) renderMeta.didRenderScripts = true;
    var matches = getActiveMatches(routerMatches, null, isSpaMode);
    $fIwXP.useEffect(function() {
        isHydrated = true;
    }, []);
    var initialScripts = $fIwXP.useMemo(function() {
        var _manifest_hmr;
        var streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        var contextScript = staticContext ? "window.__reactRouterContext = ".concat(serverHandoffString, ";").concat(streamScript) : " ";
        var routeModulesScript = !isStatic ? " " : "".concat(((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? "import ".concat(JSON.stringify(manifest.hmr.runtime), ";") : "").concat(!enableFogOfWar ? "import ".concat(JSON.stringify(manifest.url)) : "", ";\n").concat(matches.map(function(match, index) {
            return "import * as route".concat(index, " from ").concat(JSON.stringify(manifest.routes[match.route.id].module), ";");
        }).join("\n"), "\n  ").concat(enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        "window.__reactRouterManifest = ".concat(JSON.stringify(getPartialManifest(manifest, router), null, 2), ";") : "", "\n  window.__reactRouterRouteModules = {").concat(matches.map(function(match, index) {
            return "".concat(JSON.stringify(match.route.id), ":route").concat(index);
        }).join(","), "};\n\nimport(").concat(JSON.stringify(manifest.entry.module), ");");
        return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, /* @__PURE__ */ $fIwXP.createElement("script", (0, $kJeRc._)((0, $eRslx._)({}, props), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: createHtml(contextScript),
            type: void 0
        })), /* @__PURE__ */ $fIwXP.createElement("script", (0, $kJeRc._)((0, $eRslx._)({}, props), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: createHtml(routeModulesScript),
            type: "module",
            async: true
        })));
    }, []);
    var routePreloads = matches.map(function(match) {
        var route = manifest.routes[match.route.id];
        return route ? (route.imports || []).concat([
            route.module
        ]) : [];
    }).flat(1);
    var preloads = isHydrated ? [] : manifest.entry.imports.concat(routePreloads);
    return isHydrated ? null : /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ $fIwXP.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ $fIwXP.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), dedupe(preloads).map(function(path) {
        return /* @__PURE__ */ $fIwXP.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        });
    }), initialScripts);
}
function dedupe(array) {
    return (0, $2Xzd1._)(new Set(array));
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if (isBrowser) window.__reactRouterVersion = "7.1.1";
} catch (e) {}
function createBrowserRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createBrowserHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createHashHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    var state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = (0, $kJeRc._)((0, $eRslx._)({}, state), {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        var error = new ErrorConstructor(val.message);
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {}
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function BrowserRouter(param) {
    var basename = param.basename, children = param.children, window2 = param.window;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = createBrowserHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $fIwXP.useCallback(function(newState) {
        $fIwXP.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        setStateImpl
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fIwXP.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HashRouter(param) {
    var basename = param.basename, children = param.children, window2 = param.window;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = createHashHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $fIwXP.useCallback(function(newState) {
        $fIwXP.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        setStateImpl
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fIwXP.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HistoryRouter(param) {
    var basename = param.basename, children = param.children, history = param.history;
    var _React10_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $fIwXP.useCallback(function(newState) {
        $fIwXP.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        setStateImpl
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fIwXP.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var Link = $fIwXP.forwardRef(function LinkWithRef(_param, forwardedRef) {
    var onClick = _param.onClick, _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, _param_prefetch = _param.prefetch, prefetch = _param_prefetch === void 0 ? "none" : _param_prefetch, relative = _param.relative, reloadDocument = _param.reloadDocument, replace2 = _param.replace, state = _param.state, target = _param.target, to = _param.to, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, rest = (0, $1dxAe._)(_param, [
        "onClick",
        "discover",
        "prefetch",
        "relative",
        "reloadDocument",
        "replace",
        "state",
        "target",
        "to",
        "preventScrollReset",
        "viewTransition"
    ]);
    var basename = $fIwXP.useContext(NavigationContext).basename;
    var isAbsolute = typeof to === "string" && ABSOLUTE_URL_REGEX2.test(to);
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if (isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            warning(false, '<Link to="'.concat(to, '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.'));
        }
    }
    var href = useHref(to, {
        relative: relative
    });
    var _usePrefetchBehavior = (0, $kB67t._)(usePrefetchBehavior(prefetch, rest), 3), shouldPrefetch = _usePrefetchBehavior[0], prefetchRef = _usePrefetchBehavior[1], prefetchHandlers = _usePrefetchBehavior[2];
    var internalOnClick = useLinkClickHandler(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    var link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $fIwXP.createElement("a", (0, $kJeRc._)((0, $eRslx._)({}, rest, prefetchHandlers), {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, link, /* @__PURE__ */ $fIwXP.createElement(PrefetchPageLinks, {
        page: href
    })) : link;
});
Link.displayName = "Link";
var NavLink = $fIwXP.forwardRef(function NavLinkWithRef(_param, ref) {
    var tmp = _param["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _param_caseSensitive = _param.caseSensitive, caseSensitive = _param_caseSensitive === void 0 ? false : _param_caseSensitive, tmp1 = _param.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _param_end = _param.end, end = _param_end === void 0 ? false : _param_end, styleProp = _param.style, to = _param.to, viewTransition = _param.viewTransition, children = _param.children, rest = (0, $1dxAe._)(_param, [
        "aria-current",
        "caseSensitive",
        "className",
        "end",
        "style",
        "to",
        "viewTransition",
        "children"
    ]);
    var path = useResolvedPath(to, {
        relative: rest.relative
    });
    var location = useLocation();
    var routerState = $fIwXP.useContext(DataRouterStateContext);
    var _React10_useContext = $fIwXP.useContext(NavigationContext), navigator2 = _React10_useContext.navigator, basename = _React10_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    var toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : void 0;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $fIwXP.createElement(Link, (0, $kJeRc._)((0, $eRslx._)({}, rest), {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
var Form = $fIwXP.forwardRef(function(_param, forwardedRef) {
    var _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, fetcherKey = _param.fetcherKey, navigate = _param.navigate, reloadDocument = _param.reloadDocument, replace2 = _param.replace, state = _param.state, _param_method = _param.method, method = _param_method === void 0 ? defaultMethod : _param_method, action = _param.action, onSubmit = _param.onSubmit, relative = _param.relative, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, props = (0, $1dxAe._)(_param, [
        "discover",
        "fetcherKey",
        "navigate",
        "reloadDocument",
        "replace",
        "state",
        "method",
        "action",
        "onSubmit",
        "relative",
        "preventScrollReset",
        "viewTransition"
    ]);
    var submit = useSubmit();
    var formAction = useFormAction(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var isAbsolute = typeof action === "string" && ABSOLUTE_URL_REGEX2.test(action);
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $fIwXP.createElement("form", (0, $kJeRc._)((0, $eRslx._)({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props), {
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
});
Form.displayName = "Form";
function ScrollRestoration(_param) {
    var getKey = _param.getKey, storageKey = _param.storageKey, props = (0, $1dxAe._)(_param, [
        "getKey",
        "storageKey"
    ]);
    var remixContext = $fIwXP.useContext(FrameworkContext);
    var basename = $fIwXP.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    var ssrKey = $fIwXP.useMemo(function() {
        if (!remixContext || !getKey) return null;
        var userKey = getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    var restoreScroll = (function(storageKey2, restoreKey) {
        if (!window.history.state || !window.history.state.key) {
            var key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            var positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            var storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $fIwXP.createElement("script", (0, $kJeRc._)((0, $eRslx._)({}, props), {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: "(".concat(restoreScroll, ")(").concat(JSON.stringify(storageKey || SCROLL_RESTORATION_STORAGE_KEY), ", ").concat(JSON.stringify(ssrKey), ")")
        }
    }));
}
ScrollRestoration.displayName = "ScrollRestoration";
function getDataRouterConsoleError2(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext3(hookName) {
    var ctx = $fIwXP.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError2(hookName));
    return ctx;
}
function useDataRouterState2(hookName) {
    var state = $fIwXP.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError2(hookName));
    return state;
}
function useLinkClickHandler(to) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = useNavigate();
    var location = useLocation();
    var path = useResolvedPath(to, {
        relative: relative
    });
    return $fIwXP.useCallback(function(event) {
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            var replace2 = replaceProp !== void 0 ? replaceProp : createPath(location) === createPath(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function useSearchParams(defaultInit) {
    warning(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    var defaultSearchParamsRef = $fIwXP.useRef(createSearchParams(defaultInit));
    var hasSetSearchParamsRef = $fIwXP.useRef(false);
    var location = useLocation();
    var searchParams = $fIwXP.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = useNavigate();
    var setSearchParams = $fIwXP.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var fetcherId = 0;
var getUniqueFetcherId = function() {
    return "__".concat(String(++fetcherId), "__");
};
function useSubmit() {
    var router = useDataRouterContext3("useSubmit" /* UseSubmit */ ).router;
    var basename = $fIwXP.useContext(NavigationContext).basename;
    var currentRouteId = useRouteId();
    return $fIwXP.useCallback(/*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(target) {
            var options, _getFormSubmissionInfo, action, method, encType, formData, body, key;
            var _arguments = arguments;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _getFormSubmissionInfo = getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
                        if (!(options.navigate === false)) return [
                            3,
                            2
                        ];
                        key = options.fetcherKey || getUniqueFetcherId();
                        return [
                            4,
                            router.fetch(key, currentRouteId, options.action || action, {
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                flushSync: options.flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.navigate(options.action || action, {
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                replace: options.replace,
                                state: options.state,
                                fromRouteId: currentRouteId,
                                flushSync: options.flushSync,
                                viewTransition: options.viewTransition
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(target) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var basename = $fIwXP.useContext(NavigationContext).basename;
    var routeContext = $fIwXP.useContext(RouteContext);
    invariant(routeContext, "useFormAction must be used inside a RouteContext");
    var _routeContext_matches_slice = (0, $kB67t._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    var path = (0, $eRslx._)({}, useResolvedPath(action ? action : ".", {
        relative: relative
    }));
    var location = useLocation();
    if (action == null) {
        path.search = location.search;
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function useFetcher() {
    var key = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).key;
    var _route_matches_;
    var router = useDataRouterContext3("useFetcher" /* UseFetcher */ ).router;
    var state = useDataRouterState2("useFetcher" /* UseFetcher */ );
    var fetcherData = $fIwXP.useContext(FetchersContext);
    var route = $fIwXP.useContext(RouteContext);
    var routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    invariant(fetcherData, "useFetcher must be used inside a FetchersContext");
    invariant(route, "useFetcher must be used inside a RouteContext");
    invariant(routeId != null, 'useFetcher can only be used on routes that contain a unique "id"');
    var defaultKey = $fIwXP.useId();
    var _React10_useState = (0, $kB67t._)($fIwXP.useState(key || defaultKey), 2), fetcherKey = _React10_useState[0], setFetcherKey = _React10_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    $fIwXP.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            return router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    var load = $fIwXP.useCallback(/*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(href, opts) {
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(routeId, "No routeId available for fetcher.load()");
                        return [
                            4,
                            router.fetch(fetcherKey, routeId, href, opts)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(href, opts) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = useSubmit();
    var submit = $fIwXP.useCallback(/*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(target, opts) {
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            submitImpl(target, (0, $kJeRc._)((0, $eRslx._)({}, opts), {
                                navigate: false,
                                fetcherKey: fetcherKey
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(target, opts) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $fIwXP.useMemo(function() {
        var FetcherForm2 = $fIwXP.forwardRef(function(props, ref) {
            return /* @__PURE__ */ $fIwXP.createElement(Form, (0, $kJeRc._)((0, $eRslx._)({}, props), {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    var fetcher = state.fetchers.get(fetcherKey) || IDLE_FETCHER;
    var data2 = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $fIwXP.useMemo(function() {
        return (0, $kJeRc._)((0, $eRslx._)({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher), {
            data: data2
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function useFetchers() {
    var state = useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(function(param) {
        var _param = (0, $kB67t._)(param, 2), key = _param[0], fetcher = _param[1];
        return (0, $kJeRc._)((0, $eRslx._)({}, fetcher), {
            key: key
        });
    });
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
function getScrollRestorationKey(location, matches, basename, getKey) {
    var key = null;
    if (getKey) {
        if (basename !== "/") key = getKey((0, $kJeRc._)((0, $eRslx._)({}, location), {
            pathname: stripBasename(location.pathname, basename) || location.pathname
        }), matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function useScrollRestoration() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ ).router;
    var _useDataRouterState2 = useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ ), restoreScrollPosition = _useDataRouterState2.restoreScrollPosition, preventScrollReset = _useDataRouterState2.preventScrollReset;
    var basename = $fIwXP.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    var navigation = useNavigation();
    $fIwXP.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    usePageHide($fIwXP.useCallback(function() {
        if (navigation.state === "idle") {
            var key = getScrollRestorationKey(location, matches, basename, getKey);
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            warning(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (".concat(error, ")."));
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $fIwXP.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $fIwXP.useLayoutEffect(function() {
            var disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration(savedScrollPositions, function() {
                return window.scrollY;
            }, getKey ? function(location2, matches2) {
                return getScrollRestorationKey(location2, matches2, basename, getKey);
            } : void 0);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        $fIwXP.useLayoutEffect(function() {
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function useBeforeUnload(callback, options) {
    var capture = (options || {}).capture;
    $fIwXP.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $fIwXP.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePrompt(param) {
    var when = param.when, message = param.message;
    var blocker = useBlocker(when);
    $fIwXP.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $fIwXP.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function useViewTransitionState(to) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var vtContext = $fIwXP.useContext(ViewTransitionContext);
    invariant(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    var basename = useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ ).basename;
    var path = useResolvedPath(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}
function StaticRouter(param) {
    var basename = param.basename, children = param.children, tmp = param.location, locationProp = tmp === void 0 ? "/" : tmp;
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var action = "POP" /* Pop */ ;
    var location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    var staticNavigator = getStatelessNavigator();
    return /* @__PURE__ */ $fIwXP.createElement(Router, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function StaticRouterProvider(param) {
    var context = param.context, router = param.router, _param_hydrate = param.hydrate, hydrate = _param_hydrate === void 0 ? true : _param_hydrate, nonce = param.nonce;
    invariant(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    var dataRouterContext = {
        router: router,
        navigator: getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    var fetchersContext = /* @__PURE__ */ new Map();
    var hydrateScript = "";
    if (hydrate !== false) {
        var data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors(context.errors)
        };
        var json = htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = "window.__staticRouterHydrationData = JSON.parse(".concat(json, ");");
    }
    var state = dataRouterContext.router.state;
    return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, /* @__PURE__ */ $fIwXP.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $fIwXP.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $fIwXP.createElement(FetchersContext.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $fIwXP.createElement(ViewTransitionContext.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $fIwXP.createElement(Router, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $fIwXP.createElement(DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $fIwXP.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function DataRoutes2(param) {
    var routes = param.routes, future = param.future, state = param.state;
    return useRoutesImpl(routes, void 0, state, future);
}
function serializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (isRouteErrorResponse(val)) serialized[key] = (0, $kJeRc._)((0, $eRslx._)({}, val), {
                __type: "RouteErrorResponse"
            });
            else if (val instanceof Error) serialized[key] = (0, $eRslx._)({
                message: val.message,
                __type: "Error"
            }, val.name !== "Error" ? {
                __subType: val.name
            } : {});
            else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function getStatelessNavigator() {
    return {
        createHref: createHref,
        encodeLocation: encodeLocation,
        push: function(to) {
            throw new Error("You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ")` somewhere in your app."));
        },
        replace: function(to) {
            throw new Error("You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ", { replace: true })` somewhere in your app."));
        },
        go: function(delta) {
            throw new Error("You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(delta, ")` somewhere in your app."));
        },
        back: function() {
            throw new Error("You cannot use navigator.back() on the server because it is a stateless environment.");
        },
        forward: function() {
            throw new Error("You cannot use navigator.forward() on the server because it is a stateless environment.");
        }
    };
}
function createStaticHandler2(routes, opts) {
    return createStaticHandler(routes, (0, $kJeRc._)((0, $eRslx._)({}, opts), {
        mapRouteProperties: mapRouteProperties
    }));
}
function createStaticRouter(routes, context) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var manifest = {};
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, void 0, manifest);
    var matches = context.matches.map(function(match) {
        var route = manifest[match.route.id] || match.route;
        return (0, $kJeRc._)((0, $eRslx._)({}, match), {
            route: route
        });
    });
    var msg = function(method) {
        return "You cannot use router.".concat(method, "() on the server because it is a stateless environment");
    };
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return (0, $eRslx._)({}, opts === null || opts === void 0 ? void 0 : opts.future);
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: IDLE_NAVIGATION,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize: function() {
            throw msg("initialize");
        },
        subscribe: function() {
            throw msg("subscribe");
        },
        enableScrollRestoration: function() {
            throw msg("enableScrollRestoration");
        },
        navigate: function() {
            throw msg("navigate");
        },
        fetch: function() {
            throw msg("fetch");
        },
        revalidate: function() {
            throw msg("revalidate");
        },
        createHref: createHref,
        encodeLocation: encodeLocation,
        getFetcher: function() {
            return IDLE_FETCHER;
        },
        deleteFetcher: function() {
            throw msg("deleteFetcher");
        },
        dispose: function() {
            throw msg("dispose");
        },
        getBlocker: function() {
            return IDLE_BLOCKER;
        },
        deleteBlocker: function() {
            throw msg("deleteBlocker");
        },
        patchRoutes: function() {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes: function() {
            throw msg("_internalSetRoutes");
        }
    };
}
function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
}
function encodeLocation(to) {
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    var encoded = ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function htmlEscape(str) {
    return str.replace(ESCAPE_REGEX2, function(match) {
        return ESCAPE_LOOKUP2[match];
    });
}
function ServerRouter(param) {
    var context = param.context, url = param.url, nonce = param.nonce;
    if (typeof url === "string") url = new URL(url);
    var manifest = context.manifest, routeModules = context.routeModules, criticalCss = context.criticalCss, serverHandoffString = context.serverHandoffString;
    var routes = createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = (0, $eRslx._)({}, context.staticHandlerContext.loaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.staticHandlerContext.matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var routeId = match.route.id;
            var route = routeModules[routeId];
            var manifestRoute = context.manifest.routes[routeId];
            if (route && manifestRoute && shouldHydrateRouteLoader(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var router = createStaticRouter(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $fIwXP.createElement($fIwXP.Fragment, null, /* @__PURE__ */ $fIwXP.createElement(FrameworkContext.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $fIwXP.createElement(RemixErrorBoundary, {
        location: router.state.location
    }, /* @__PURE__ */ $fIwXP.createElement(StaticRouterProvider, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $fIwXP.createElement($fIwXP.Suspense, null, /* @__PURE__ */ $fIwXP.createElement(StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function createRoutesStub(routes) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function RoutesTestStub(param) {
        var initialEntries = param.initialEntries, initialIndex = param.initialIndex, hydrationData = param.hydrationData, future = param.future;
        var routerRef = $fIwXP.useRef();
        var remixContextRef = $fIwXP.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                isSpaMode: false
            };
            var patched = processRoutes(// @ts-expect-error loader/action context types don't match :/
            convertRoutesToDataRoutes(routes, function(r) {
                return r;
            }), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = createMemoryRouter(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $fIwXP.createElement(FrameworkContext.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $fIwXP.createElement(RouterProvider, {
            router: routerRef.current
        }));
    };
}
function processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map(function(route) {
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        var loader = route.loader, action = route.action;
        var newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? function(args) {
                return action((0, $kJeRc._)((0, $eRslx._)({}, args), {
                    context: context
                }));
            } : void 0,
            loader: loader ? function(args) {
                return loader((0, $kJeRc._)((0, $eRslx._)({}, args), {
                    context: context
                }));
            } : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        var entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            module: "build/stub-path-to-module.js"
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || Outlet,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var encoder = new TextEncoder();
var sign = /*#__PURE__*/ function() {
    var _ref = (0, $7k5I8._)(function(value, secret) {
        var _String, data2, key, signature, hash;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data2 = encoder.encode(value);
                    return [
                        4,
                        createKey2(secret, [
                            "sign"
                        ])
                    ];
                case 1:
                    key = _state.sent();
                    return [
                        4,
                        crypto.subtle.sign("HMAC", key, data2)
                    ];
                case 2:
                    signature = _state.sent();
                    hash = btoa((_String = String).fromCharCode.apply(_String, (0, $2Xzd1._)(new Uint8Array(signature)))).replace(/=+$/, "");
                    return [
                        2,
                        value + "." + hash
                    ];
            }
        });
    });
    return function sign(value, secret) {
        return _ref.apply(this, arguments);
    };
}();
var unsign = /*#__PURE__*/ function() {
    var _ref = (0, $7k5I8._)(function(cookie, secret) {
        var index, value, hash, data2, key, signature, valid;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    index = cookie.lastIndexOf(".");
                    value = cookie.slice(0, index);
                    hash = cookie.slice(index + 1);
                    data2 = encoder.encode(value);
                    return [
                        4,
                        createKey2(secret, [
                            "verify"
                        ])
                    ];
                case 1:
                    key = _state.sent();
                    signature = byteStringToUint8Array(atob(hash));
                    return [
                        4,
                        crypto.subtle.verify("HMAC", key, signature, data2)
                    ];
                case 2:
                    valid = _state.sent();
                    return [
                        2,
                        valid ? value : false
                    ];
            }
        });
    });
    return function unsign(cookie, secret) {
        return _ref.apply(this, arguments);
    };
}();
var createKey2 = /*#__PURE__*/ function() {
    var _ref = (0, $7k5I8._)(function(secret, usages) {
        return (0, $lFlDF.__generator)(this, function(_state) {
            return [
                2,
                crypto.subtle.importKey("raw", encoder.encode(secret), {
                    name: "HMAC",
                    hash: "SHA-256"
                }, false, usages)
            ];
        });
    });
    return function createKey2(secret, usages) {
        return _ref.apply(this, arguments);
    };
}();
function byteStringToUint8Array(byteString) {
    var array = new Uint8Array(byteString.length);
    for(var i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var createCookie = function(name) {
    var cookieOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _ref = (0, $eRslx._)({
        path: "/",
        sameSite: "lax"
    }, cookieOptions), _ref_secrets = _ref.secrets, secrets = _ref_secrets === void 0 ? [] : _ref_secrets, options = (0, $1dxAe._)(_ref, [
        "secrets"
    ]);
    warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        parse: function(cookieHeader, parseOptions) {
            return (0, $7k5I8._)(function() {
                var cookies, value, decoded;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!cookieHeader) return [
                                2,
                                null
                            ];
                            cookies = (0, $aLpOW.parse)(cookieHeader, (0, $eRslx._)({}, options, parseOptions));
                            if (!(name in cookies)) return [
                                3,
                                4
                            ];
                            value = cookies[name];
                            if (!(typeof value === "string" && value !== "")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                decodeCookieValue(value, secrets)
                            ];
                        case 1:
                            decoded = _state.sent();
                            return [
                                2,
                                decoded
                            ];
                        case 2:
                            return [
                                2,
                                ""
                            ];
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            return [
                                2,
                                null
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        serialize: function(value, serializeOptions) {
            return (0, $7k5I8._)(function() {
                var _tmp, _tmp1;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = [
                                name
                            ];
                            if (!(value === "")) return [
                                3,
                                1
                            ];
                            _tmp1 = "";
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                encodeCookieValue(value, secrets)
                            ];
                        case 2:
                            _tmp1 = _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                2,
                                (0, $aLpOW.serialize).apply(void 0, _tmp.concat([
                                    _tmp1,
                                    (0, $eRslx._)({}, options, serializeOptions)
                                ]))
                            ];
                    }
                });
            })();
        }
    };
};
var isCookie = function(object) {
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
function encodeCookieValue(value, secrets) {
    return _encodeCookieValue.apply(this, arguments);
}
function _encodeCookieValue() {
    _encodeCookieValue = (0, $7k5I8._)(function(value, secrets) {
        var encoded;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    encoded = encodeData(value);
                    if (!(secrets.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        sign(encoded, secrets[0])
                    ];
                case 1:
                    encoded = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        encoded
                    ];
            }
        });
    });
    return _encodeCookieValue.apply(this, arguments);
}
function decodeCookieValue(value, secrets) {
    return _decodeCookieValue.apply(this, arguments);
}
function _decodeCookieValue() {
    _decodeCookieValue = (0, $7k5I8._)(function(value, secrets) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, secret, unsignedValue, err;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(secrets.length > 0)) return [
                        3,
                        9
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = secrets[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    secret = _step.value;
                    return [
                        4,
                        unsign(value, secret)
                    ];
                case 3:
                    unsignedValue = _state.sent();
                    if (unsignedValue !== false) return [
                        2,
                        decodeData(unsignedValue)
                    ];
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2,
                        null
                    ];
                case 9:
                    return [
                        2,
                        decodeData(value)
                    ];
            }
        });
    });
    return _decodeCookieValue.apply(this, arguments);
}
function encodeData(value) {
    return btoa(myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent(myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function myEscape(value) {
    var str = value.toString();
    var result = "";
    var index = 0;
    var chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + hex(code, 2);
            else result += "%u" + hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function hex(code, length) {
    var result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function myUnescape(value) {
    var str = value.toString();
    var result = "";
    var index = 0;
    var chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function warnOnceAboutExpiresCookie(name, expires) {
    warnOnce(!expires, 'The "'.concat(name, '" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use `commitSession(session, { expires })` if using a session storage object, or `cookie.serialize("value", { expires })` if you\'re using the cookie directly.'));
}
// lib/server-runtime/entry.ts
function createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce(function(memo2, routeId) {
        var route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var ServerMode = /* @__PURE__ */ function(ServerMode2) {
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
}(ServerMode || {});
function isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        var sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce(function(acc, param) {
        var _param = (0, $kB67t._)(param, 2), routeId = _param[0], error = _param[1];
        return Object.assign(acc, (0, $hD5pT._)({}, routeId, sanitizeError(error, serverMode)));
    }, {});
}
function serializeError(error, serverMode) {
    var sanitized = sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (isRouteErrorResponse(val)) serialized[key] = (0, $kJeRc._)((0, $eRslx._)({}, val), {
                __type: "RouteErrorResponse"
            });
            else if (val instanceof Error) {
                var sanitized = sanitizeError(val, serverMode);
                serialized[key] = (0, $eRslx._)({
                    message: sanitized.message,
                    stack: sanitized.stack,
                    __type: "Error"
                }, sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {});
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function matchServerRoutes(routes, pathname, basename) {
    var matches = matchRoutes(routes, pathname, basename);
    if (!matches) return null;
    return matches.map(function(match) {
        return {
            params: match.params,
            pathname: match.pathname,
            route: match.route
        };
    });
}
function callRouteHandler(handler, args) {
    return _callRouteHandler.apply(this, arguments);
}
function _callRouteHandler() {
    _callRouteHandler = // lib/server-runtime/data.ts
    (0, $7k5I8._)(function(handler, args) {
        var result;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        handler({
                            request: stripRoutesParam(stripIndexParam2(args.request)),
                            params: args.params,
                            context: args.context
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (isDataWithResponseInit(result) && result.init && result.init.status && isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _callRouteHandler.apply(this, arguments);
}
function stripIndexParam2(request) {
    var url = new URL(request.url);
    var indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    var indexValuesToKeep = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var indexValue = _step.value;
            if (indexValue) indexValuesToKeep.push(indexValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = indexValuesToKeep[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var toKeep = _step1.value;
            url.searchParams.append("index", toKeep);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function stripRoutesParam(request) {
    var url = new URL(request.url);
    url.searchParams.delete("_routes");
    var init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function groupRoutesByParentId2(manifest) {
    var routes = {};
    Object.values(manifest).forEach(function(route) {
        if (route) {
            var parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function createRoutes(manifest) {
    var parentId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", routesByParentId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : groupRoutesByParentId2(manifest);
    return (routesByParentId[parentId] || []).map(function(route) {
        return (0, $kJeRc._)((0, $eRslx._)({}, route), {
            children: createRoutes(manifest, route.id, routesByParentId)
        });
    });
}
function createStaticHandlerDataRoutes(manifest, future) {
    var parentId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", routesByParentId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : groupRoutesByParentId2(manifest);
    return (routesByParentId[parentId] || []).map(function(route) {
        var commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? /*#__PURE__*/ function() {
                var _ref = (0, $7k5I8._)(function(args) {
                    var preRenderedData, encoded, uint8array, stream, decoded, data2, result, val;
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!args.request.headers.has("X-React-Router-Prerender-Data")) return [
                                    3,
                                    2
                                ];
                                preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                                encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                                invariant3(encoded, "Missing prerendered data for route");
                                uint8array = new TextEncoder().encode(encoded);
                                stream = new ReadableStream({
                                    start: function(controller) {
                                        controller.enqueue(uint8array);
                                        controller.close();
                                    }
                                });
                                return [
                                    4,
                                    decodeViaTurboStream(stream, $parcel$global)
                                ];
                            case 1:
                                decoded = _state.sent();
                                data2 = decoded.value;
                                invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                                result = data2[route.id];
                                invariant3("data" in result, "Unable to process prerendered data");
                                return [
                                    2,
                                    result.data
                                ];
                            case 2:
                                return [
                                    4,
                                    callRouteHandler(route.module.loader, args)
                                ];
                            case 3:
                                val = _state.sent();
                                return [
                                    2,
                                    val
                                ];
                        }
                    });
                });
                return function(args) {
                    return _ref.apply(this, arguments);
                };
            }() : void 0,
            action: route.module.action ? function(args) {
                return callRouteHandler(route.module.action, args);
            } : void 0,
            handle: route.module.handle
        };
        return route.index ? (0, $eRslx._)({
            index: true
        }, commonRoute) : (0, $eRslx._)({
            caseSensitive: route.caseSensitive,
            children: createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId)
        }, commonRoute);
    });
}
// lib/server-runtime/markup.ts
var ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function escapeHtml2(html) {
    return html.replace(ESCAPE_REGEX3, function(match) {
        return ESCAPE_LOOKUP3[match];
    });
}
// lib/server-runtime/serverHandoff.ts
function createServerHandoffString(serverHandoff) {
    return escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var globalDevServerHooksKey = "__reactRouterDevServerHooks";
function setDevServerHooks(devServerHooks) {
    globalThis[globalDevServerHooksKey] = devServerHooks;
}
function getDevServerHooks() {
    return globalThis[globalDevServerHooksKey];
}
function getDocumentHeaders(build, context) {
    var boundaryIdx = context.errors ? context.matches.findIndex(function(m) {
        return context.errors[m.route.id];
    }) : -1;
    var matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    var errorHeaders;
    if (boundaryIdx >= 0) {
        var actionHeaders = context.actionHeaders, actionData = context.actionData, loaderHeaders = context.loaderHeaders, loaderData = context.loaderData;
        context.matches.slice(boundaryIdx).some(function(match) {
            var id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce(function(parentHeaders, match, idx) {
        var id = match.route.id;
        var route = build.routes[id];
        invariant3(route, 'Route with id "'.concat(id, '" not found in build'));
        var routeModule = route.module;
        var loaderHeaders = context.loaderHeaders[id] || new Headers();
        var actionHeaders = context.actionHeaders[id] || new Headers();
        var includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        var includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            var headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) prependCookies(errorHeaders, headers2);
            prependCookies(actionHeaders, headers2);
            prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        var headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) prependCookies(errorHeaders, headers);
        prependCookies(actionHeaders, headers);
        prependCookies(loaderHeaders, headers);
        prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function prependCookies(parentHeaders, childHeaders) {
    var parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        var cookies = (0, $6Htrd.splitCookiesString)(parentSetCookieString);
        cookies.forEach(function(cookie) {
            childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var SINGLE_FETCH_REDIRECT_STATUS = 202;
function getSingleFetchDataStrategy2() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isActionDataRequest = _ref.isActionDataRequest, loadRouteIds = _ref.loadRouteIds;
    return /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(param) {
            var request, matches, matchesToLoad, results;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        request = param.request, matches = param.matches;
                        if (isActionDataRequest && request.method === "GET") return [
                            2,
                            {}
                        ];
                        matchesToLoad = loadRouteIds ? matches.filter(function(m) {
                            return loadRouteIds.includes(m.route.id);
                        }) : matches;
                        return [
                            4,
                            Promise.all(matchesToLoad.map(function(match) {
                                return match.resolve();
                            }))
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            2,
                            results.reduce(function(acc, result, i) {
                                return Object.assign(acc, (0, $hD5pT._)({}, matchesToLoad[i].route.id, result));
                            }, {})
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
}
function singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    return _singleFetchAction.apply(this, arguments);
}
function _singleFetchAction() {
    _singleFetchAction = (0, $7k5I8._)(function(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
        var handlerRequest, result, context, headers, singleFetchResult, error;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    handlerRequest = new Request(handlerUrl, (0, $eRslx._)({
                        method: request.method,
                        body: request.body,
                        headers: request.headers,
                        signal: request.signal
                    }, request.body ? {
                        duplex: "half"
                    } : void 0));
                    return [
                        4,
                        staticHandler.query(handlerRequest, {
                            requestContext: loadContext,
                            skipLoaderErrorBubbling: true,
                            dataStrategy: getSingleFetchDataStrategy2({
                                isActionDataRequest: true
                            })
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (isResponse(result)) return [
                        2,
                        {
                            result: getSingleFetchRedirect(result.status, result.headers, build.basename),
                            headers: result.headers,
                            status: SINGLE_FETCH_REDIRECT_STATUS
                        }
                    ];
                    context = result;
                    headers = getDocumentHeaders(build, context);
                    if (isRedirectStatusCode(context.statusCode) && headers.has("Location")) return [
                        2,
                        {
                            result: getSingleFetchRedirect(context.statusCode, headers, build.basename),
                            headers: headers,
                            status: SINGLE_FETCH_REDIRECT_STATUS
                        }
                    ];
                    if (context.errors) {
                        Object.values(context.errors).forEach(function(err) {
                            if (!isRouteErrorResponse(err) || err.error) handleError(err);
                        });
                        context.errors = sanitizeErrors(context.errors, serverMode);
                    }
                    if (context.errors) singleFetchResult = {
                        error: Object.values(context.errors)[0]
                    };
                    else singleFetchResult = {
                        data: Object.values(context.actionData || {})[0]
                    };
                    return [
                        2,
                        {
                            result: singleFetchResult,
                            headers: headers,
                            status: context.statusCode
                        }
                    ];
                case 2:
                    error = _state.sent();
                    handleError(error);
                    return [
                        2,
                        {
                            result: {
                                error: error
                            },
                            headers: new Headers(),
                            status: 500
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _singleFetchAction.apply(this, arguments);
}
function singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    return _singleFetchLoaders.apply(this, arguments);
}
function _singleFetchLoaders() {
    _singleFetchLoaders = (0, $7k5I8._)(function(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
        var _searchParams_get, handlerRequest, loadRouteIds, result, context, headers, results, loadedMatches, error;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    handlerRequest = new Request(handlerUrl, {
                        headers: request.headers,
                        signal: request.signal
                    });
                    loadRouteIds = ((_searchParams_get = new URL(request.url).searchParams.get("_routes")) === null || _searchParams_get === void 0 ? void 0 : _searchParams_get.split(",")) || void 0;
                    return [
                        4,
                        staticHandler.query(handlerRequest, {
                            requestContext: loadContext,
                            skipLoaderErrorBubbling: true,
                            dataStrategy: getSingleFetchDataStrategy2({
                                loadRouteIds: loadRouteIds
                            })
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (isResponse(result)) return [
                        2,
                        {
                            result: (0, $hD5pT._)({}, SingleFetchRedirectSymbol, getSingleFetchRedirect(result.status, result.headers, build.basename)),
                            headers: result.headers,
                            status: SINGLE_FETCH_REDIRECT_STATUS
                        }
                    ];
                    context = result;
                    headers = getDocumentHeaders(build, context);
                    if (isRedirectStatusCode(context.statusCode) && headers.has("Location")) return [
                        2,
                        {
                            result: (0, $hD5pT._)({}, SingleFetchRedirectSymbol, getSingleFetchRedirect(context.statusCode, headers, build.basename)),
                            headers: headers,
                            status: SINGLE_FETCH_REDIRECT_STATUS
                        }
                    ];
                    if (context.errors) {
                        Object.values(context.errors).forEach(function(err) {
                            if (!isRouteErrorResponse(err) || err.error) handleError(err);
                        });
                        context.errors = sanitizeErrors(context.errors, serverMode);
                    }
                    results = {};
                    loadedMatches = loadRouteIds ? context.matches.filter(function(m) {
                        return m.route.loader && loadRouteIds.includes(m.route.id);
                    }) : context.matches;
                    loadedMatches.forEach(function(m) {
                        var id = m.route.id;
                        if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                            error: context.errors[id]
                        };
                        else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                            data: context.loaderData[id]
                        };
                    });
                    return [
                        2,
                        {
                            result: results,
                            headers: headers,
                            status: context.statusCode
                        }
                    ];
                case 2:
                    error = _state.sent();
                    handleError(error);
                    return [
                        2,
                        {
                            result: {
                                root: {
                                    error: error
                                }
                            },
                            headers: new Headers(),
                            status: 500
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _singleFetchLoaders.apply(this, arguments);
}
function getSingleFetchRedirect(status, headers, basename) {
    var redirect2 = headers.get("Location");
    if (basename) redirect2 = stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    var controller = new AbortController();
    var timeoutId = setTimeout(function() {
        return controller.abort(new Error("Server Timeout"));
    }, typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", function() {
        return clearTimeout(timeoutId);
    });
    return (0, $f6Ucb.encode)(data2, {
        signal: controller.signal,
        plugins: [
            function(value) {
                if (value instanceof Error) {
                    var _ref = serverMode === "production" /* Production */  ? sanitizeError(value, serverMode) : value, name = _ref.name, message = _ref.message, stack = _ref.stack;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof ErrorResponseImpl) {
                    var data3 = value.data, status = value.status, statusText = value.statusText;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && SingleFetchRedirectSymbol in value) return [
                    "SingleFetchRedirect",
                    value[SingleFetchRedirectSymbol]
                ];
            }
        ],
        postPlugins: [
            function(value) {
                if (!value) return;
                if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            function() {
                return [
                    "SingleFetchFallback"
                ];
            }
        ]
    });
}
// lib/server-runtime/server.ts
function derive(build, mode) {
    var routes = createRoutes(build.routes);
    var dataRoutes = createStaticHandlerDataRoutes(build.routes, build.future);
    var serverMode = isServerMode(mode) ? mode : "production" /* Production */ ;
    var staticHandler = createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    var errorHandler = build.entry.module.handleError || function(error, param) {
        var request = param.request;
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        isRouteErrorResponse(error) && error.error ? error.error : error);
    };
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var createRequestHandler = function(build, mode) {
    var _build;
    var routes;
    var serverMode;
    var staticHandler;
    var errorHandler;
    return /*#__PURE__*/ function() {
        var _requestHandler = (0, $7k5I8._)(function(request) {
            var loadContext, _tmp, derived, derived1, url, params, handleError, _build_basename, manifestUrl, res, e, matches, response, handlerUrl, singleFetchMatches, result, headers, _getDevServerHooks_getCriticalCss, _getDevServerHooks, criticalCss, _tmp1;
            var _arguments = arguments;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadContext = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        if (!(typeof build === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            build()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = build;
                        _state.label = 3;
                    case 3:
                        _build = _tmp;
                        if (typeof build === "function") {
                            derived = derive(_build, mode);
                            routes = derived.routes;
                            serverMode = derived.serverMode;
                            staticHandler = derived.staticHandler;
                            errorHandler = derived.errorHandler;
                        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
                            derived1 = derive(_build, mode);
                            routes = derived1.routes;
                            serverMode = derived1.serverMode;
                            staticHandler = derived1.staticHandler;
                            errorHandler = derived1.errorHandler;
                        }
                        url = new URL(request.url);
                        params = {};
                        handleError = function(error) {
                            var _getDevServerHooks_processRequestError, _getDevServerHooks;
                            if (mode === "development" /* Development */ ) (_getDevServerHooks = getDevServerHooks()) === null || _getDevServerHooks === void 0 ? void 0 : (_getDevServerHooks_processRequestError = _getDevServerHooks.processRequestError) === null || _getDevServerHooks_processRequestError === void 0 ? void 0 : _getDevServerHooks_processRequestError.call(_getDevServerHooks, error);
                            errorHandler(error, {
                                context: loadContext,
                                params: params,
                                request: request
                            });
                        };
                        manifestUrl = "".concat((_build_basename = _build.basename) !== null && _build_basename !== void 0 ? _build_basename : "/", "/__manifest").replace(/\/+/g, "/");
                        if (!(url.pathname === manifestUrl)) return [
                            3,
                            7
                        ];
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            handleManifestRequest(_build, routes, url)
                        ];
                    case 5:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                    case 6:
                        e = _state.sent();
                        handleError(e);
                        return [
                            2,
                            new Response("Unknown Server Error", {
                                status: 500
                            })
                        ];
                    case 7:
                        matches = matchServerRoutes(routes, url.pathname, _build.basename);
                        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
                        if (!url.pathname.endsWith(".data")) return [
                            3,
                            11
                        ];
                        handlerUrl = new URL(request.url);
                        handlerUrl.pathname = handlerUrl.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
                        singleFetchMatches = matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
                        return [
                            4,
                            handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError)
                        ];
                    case 8:
                        response = _state.sent();
                        if (!_build.entry.module.handleDataRequest) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            _build.entry.module.handleDataRequest(response, {
                                context: loadContext,
                                params: singleFetchMatches ? singleFetchMatches[0].params : {},
                                request: request
                            })
                        ];
                    case 9:
                        response = _state.sent();
                        if (isRedirectResponse(response)) {
                            result = getSingleFetchRedirect(response.status, response.headers, _build.basename);
                            if (request.method === "GET") result = (0, $hD5pT._)({}, SingleFetchRedirectSymbol, result);
                            headers = new Headers(response.headers);
                            headers.set("Content-Type", "text/x-script");
                            return [
                                2,
                                new Response(encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                                    status: SINGLE_FETCH_REDIRECT_STATUS,
                                    headers: headers
                                })
                            ];
                        }
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            18
                        ];
                    case 11:
                        if (!(matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null)) return [
                            3,
                            13
                        ];
                        return [
                            4,
                            handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError)
                        ];
                    case 12:
                        response = _state.sent();
                        return [
                            3,
                            18
                        ];
                    case 13:
                        if (!(mode === "development" /* Development */ )) return [
                            3,
                            15
                        ];
                        return [
                            4,
                            (_getDevServerHooks = getDevServerHooks()) === null || _getDevServerHooks === void 0 ? void 0 : (_getDevServerHooks_getCriticalCss = _getDevServerHooks.getCriticalCss) === null || _getDevServerHooks_getCriticalCss === void 0 ? void 0 : _getDevServerHooks_getCriticalCss.call(_getDevServerHooks, _build, url.pathname)
                        ];
                    case 14:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            16
                        ];
                    case 15:
                        _tmp1 = void 0;
                        _state.label = 16;
                    case 16:
                        criticalCss = _tmp1;
                        return [
                            4,
                            handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss)
                        ];
                    case 17:
                        response = _state.sent();
                        _state.label = 18;
                    case 18:
                        if (request.method === "HEAD") return [
                            2,
                            new Response(null, {
                                headers: response.headers,
                                status: response.status,
                                statusText: response.statusText
                            })
                        ];
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        function requestHandler(request) {
            return _requestHandler.apply(this, arguments);
        }
        return requestHandler;
    }();
};
function handleManifestRequest(build, routes, url) {
    return _handleManifestRequest.apply(this, arguments);
}
function _handleManifestRequest() {
    _handleManifestRequest = (0, $7k5I8._)(function(build, routes, url) {
        var patches, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, path, matches, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, match, routeId, route;
        return (0, $lFlDF.__generator)(this, function(_state) {
            patches = {};
            if (url.searchParams.has("p")) {
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(_iterator = url.searchParams.getAll("p")[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        path = _step.value;
                        matches = matchServerRoutes(routes, path, build.basename);
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if (matches) try {
                            for(_iterator1 = matches[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                match = _step1.value;
                                routeId = match.route.id;
                                route = build.assets.routes[routeId];
                                if (route) patches[routeId] = route;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    2,
                    Response.json(patches, {
                        headers: {
                            "Cache-Control": "public, max-age=31536000, immutable"
                        }
                    })
                ];
            }
            return [
                2,
                new Response("Invalid Request", {
                    status: 400
                })
            ];
        });
    });
    return _handleManifestRequest.apply(this, arguments);
}
function handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    return _handleSingleFetchRequest.apply(this, arguments);
}
function _handleSingleFetchRequest() {
    _handleSingleFetchRequest = (0, $7k5I8._)(function(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
        var _ref, result, headers, status, _tmp, resultHeaders;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(request.method !== "GET")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError)
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    _ref = _tmp, result = _ref.result, headers = _ref.headers, status = _ref.status;
                    resultHeaders = new Headers(headers);
                    resultHeaders.set("X-Remix-Response", "yes");
                    if (status === 304) return [
                        2,
                        new Response(null, {
                            status: 304,
                            headers: resultHeaders
                        })
                    ];
                    resultHeaders.set("Content-Type", "text/x-script");
                    return [
                        2,
                        new Response(encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
                            status: status || 200,
                            headers: resultHeaders
                        })
                    ];
            }
        });
    });
    return _handleSingleFetchRequest.apply(this, arguments);
}
function handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    return _handleDocumentRequest.apply(this, arguments);
}
function _handleDocumentRequest() {
    _handleDocumentRequest = (0, $7k5I8._)(function(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
        var context, error, headers, state, entryContext, handleDocumentRequestFunction, error1, errorForSecondRender, data2, e, state2, error2;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        staticHandler.query(request, {
                            requestContext: loadContext
                        })
                    ];
                case 1:
                    context = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    handleError(error);
                    return [
                        2,
                        new Response(null, {
                            status: 500
                        })
                    ];
                case 3:
                    if (isResponse(context)) return [
                        2,
                        context
                    ];
                    headers = getDocumentHeaders(build, context);
                    if (context.statusCode === 304) return [
                        2,
                        new Response(null, {
                            status: 304,
                            headers: headers
                        })
                    ];
                    if (context.errors) {
                        Object.values(context.errors).forEach(function(err) {
                            if (!isRouteErrorResponse(err) || err.error) handleError(err);
                        });
                        context.errors = sanitizeErrors(context.errors, serverMode);
                    }
                    state = {
                        loaderData: context.loaderData,
                        actionData: context.actionData,
                        errors: serializeErrors2(context.errors, serverMode)
                    };
                    entryContext = {
                        manifest: build.assets,
                        routeModules: createEntryRouteModules(build.routes),
                        staticHandlerContext: context,
                        criticalCss: criticalCss,
                        serverHandoffString: createServerHandoffString({
                            basename: build.basename,
                            criticalCss: criticalCss,
                            future: build.future,
                            isSpaMode: build.isSpaMode
                        }),
                        serverHandoffStream: encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
                        renderMeta: {},
                        future: build.future,
                        isSpaMode: build.isSpaMode,
                        serializeError: function(err) {
                            return serializeError(err, serverMode);
                        }
                    };
                    handleDocumentRequestFunction = build.entry.module.default;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        15
                    ]);
                    return [
                        4,
                        handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext)
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    error1 = _state.sent();
                    handleError(error1);
                    errorForSecondRender = error1;
                    if (!isResponse(error1)) return [
                        3,
                        10
                    ];
                    _state.label = 7;
                case 7:
                    _state.trys.push([
                        7,
                        9,
                        ,
                        10
                    ]);
                    return [
                        4,
                        unwrapResponse(error1)
                    ];
                case 8:
                    data2 = _state.sent();
                    errorForSecondRender = new ErrorResponseImpl(error1.status, error1.statusText, data2);
                    return [
                        3,
                        10
                    ];
                case 9:
                    e = _state.sent();
                    return [
                        3,
                        10
                    ];
                case 10:
                    context = getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
                    if (context.errors) context.errors = sanitizeErrors(context.errors, serverMode);
                    state2 = {
                        loaderData: context.loaderData,
                        actionData: context.actionData,
                        errors: serializeErrors2(context.errors, serverMode)
                    };
                    entryContext = (0, $kJeRc._)((0, $eRslx._)({}, entryContext), {
                        staticHandlerContext: context,
                        serverHandoffString: createServerHandoffString({
                            basename: build.basename,
                            future: build.future,
                            isSpaMode: build.isSpaMode
                        }),
                        serverHandoffStream: encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                        renderMeta: {}
                    });
                    _state.label = 11;
                case 11:
                    _state.trys.push([
                        11,
                        13,
                        ,
                        14
                    ]);
                    return [
                        4,
                        handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext)
                    ];
                case 12:
                    return [
                        2,
                        _state.sent()
                    ];
                case 13:
                    error2 = _state.sent();
                    handleError(error2);
                    return [
                        2,
                        returnLastResortErrorResponse(error2, serverMode)
                    ];
                case 14:
                    return [
                        3,
                        15
                    ];
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleDocumentRequest.apply(this, arguments);
}
function handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    return _handleResourceRequest.apply(this, arguments);
}
function _handleResourceRequest() {
    _handleResourceRequest = (0, $7k5I8._)(function(serverMode, staticHandler, routeId, request, loadContext, handleError) {
        var response, error;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        staticHandler.queryRoute(request, {
                            routeId: routeId,
                            requestContext: loadContext
                        })
                    ];
                case 1:
                    response = _state.sent();
                    invariant3(isResponse(response), "Expected a Response to be returned from resource route handler");
                    return [
                        2,
                        response
                    ];
                case 2:
                    error = _state.sent();
                    if (isResponse(error)) {
                        error.headers.set("X-Remix-Catch", "yes");
                        return [
                            2,
                            error
                        ];
                    }
                    if (isRouteErrorResponse(error)) {
                        if (error) handleError(error);
                        return [
                            2,
                            errorResponseToJson(error, serverMode)
                        ];
                    }
                    handleError(error);
                    return [
                        2,
                        returnLastResortErrorResponse(error, serverMode)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleResourceRequest.apply(this, arguments);
}
function errorResponseToJson(errorResponse, serverMode) {
    return Response.json(serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function returnLastResortErrorResponse(error, serverMode) {
    var message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += "\n\n".concat(String(error));
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function unwrapResponse(response) {
    var contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function flash(name) {
    return "__flash_".concat(name, "__");
}
var createSession = function() {
    var initialData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has: function(name) {
            return map.has(name) || map.has(flash(name));
        },
        get: function(name) {
            if (map.has(name)) return map.get(name);
            var flashName = flash(name);
            if (map.has(flashName)) {
                var value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set: function(name, value) {
            map.set(name, value);
        },
        flash: function(name, value) {
            map.set(flash(name), value);
        },
        unset: function(name) {
            map.delete(name);
        }
    };
};
var isSession = function(object) {
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function createSessionStorage(param) {
    var cookieArg = param.cookie, createData = param.createData, readData = param.readData, updateData = param.updateData, deleteData = param.deleteData;
    var cookie = isCookie(cookieArg) ? cookieArg : createCookie((cookieArg === null || cookieArg === void 0 ? void 0 : cookieArg.name) || "__session", cookieArg);
    warnOnceAboutSigningSessionCookie(cookie);
    return {
        getSession: function(cookieHeader, options) {
            return (0, $7k5I8._)(function() {
                var id, _tmp, data2, _tmp1;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = cookieHeader;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                cookie.parse(cookieHeader, options)
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            id = _tmp;
                            _tmp1 = id;
                            if (!_tmp1) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                readData(id)
                            ];
                        case 3:
                            _tmp1 = _state.sent();
                            _state.label = 4;
                        case 4:
                            data2 = _tmp1;
                            return [
                                2,
                                createSession(data2 || {}, id || "")
                            ];
                    }
                });
            })();
        },
        commitSession: function(session, options) {
            return (0, $7k5I8._)(function() {
                var id, data2, expires;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = session.id, data2 = session.data;
                            expires = (options === null || options === void 0 ? void 0 : options.maxAge) != null ? new Date(Date.now() + options.maxAge * 1e3) : (options === null || options === void 0 ? void 0 : options.expires) != null ? options.expires : cookie.expires;
                            if (!id) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                updateData(id, data2, expires)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                createData(data2, expires)
                            ];
                        case 3:
                            id = _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                2,
                                cookie.serialize(id, options)
                            ];
                    }
                });
            })();
        },
        destroySession: function(session, options) {
            return (0, $7k5I8._)(function() {
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                deleteData(session.id)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                cookie.serialize("", (0, $kJeRc._)((0, $eRslx._)({}, options), {
                                    maxAge: void 0,
                                    expires: /* @__PURE__ */ new Date(0)
                                }))
                            ];
                    }
                });
            })();
        }
    };
}
function warnOnceAboutSigningSessionCookie(cookie) {
    warnOnce(cookie.isSigned, 'The "'.concat(cookie.name, '" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.'));
}
// lib/server-runtime/sessions/cookieStorage.ts
function createCookieSessionStorage() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cookieArg = _ref.cookie;
    var cookie = isCookie(cookieArg) ? cookieArg : createCookie((cookieArg === null || cookieArg === void 0 ? void 0 : cookieArg.name) || "__session", cookieArg);
    warnOnceAboutSigningSessionCookie(cookie);
    return {
        getSession: function(cookieHeader, options) {
            return (0, $7k5I8._)(function() {
                var _tmp;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = cookieHeader;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                cookie.parse(cookieHeader, options)
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2,
                                createSession.apply(void 0, [
                                    _tmp || {}
                                ])
                            ];
                    }
                });
            })();
        },
        commitSession: function(session, options) {
            return (0, $7k5I8._)(function() {
                var serializedCookie;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                cookie.serialize(session.data, options)
                            ];
                        case 1:
                            serializedCookie = _state.sent();
                            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
                            return [
                                2,
                                serializedCookie
                            ];
                    }
                });
            })();
        },
        destroySession: function(_session, options) {
            return (0, $7k5I8._)(function() {
                return (0, $lFlDF.__generator)(this, function(_state) {
                    return [
                        2,
                        cookie.serialize("", (0, $kJeRc._)((0, $eRslx._)({}, options), {
                            maxAge: void 0,
                            expires: /* @__PURE__ */ new Date(0)
                        }))
                    ];
                });
            })();
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function createMemorySessionStorage() {
    var cookie = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).cookie;
    var map = /* @__PURE__ */ new Map();
    return createSessionStorage({
        cookie: cookie,
        createData: function(data2, expires) {
            return (0, $7k5I8._)(function() {
                var id;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    id = Math.random().toString(36).substring(2, 10);
                    map.set(id, {
                        data: data2,
                        expires: expires
                    });
                    return [
                        2,
                        id
                    ];
                });
            })();
        },
        readData: function(id) {
            return (0, $7k5I8._)(function() {
                var _map_get, data2, expires;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    if (map.has(id)) {
                        _map_get = map.get(id), data2 = _map_get.data, expires = _map_get.expires;
                        if (!expires || expires > /* @__PURE__ */ new Date()) return [
                            2,
                            data2
                        ];
                        if (expires) map.delete(id);
                    }
                    return [
                        2,
                        null
                    ];
                });
            })();
        },
        updateData: function(id, data2, expires) {
            return (0, $7k5I8._)(function() {
                return (0, $lFlDF.__generator)(this, function(_state) {
                    map.set(id, {
                        data: data2,
                        expires: expires
                    });
                    return [
                        2
                    ];
                });
            })();
        },
        deleteData: function(id) {
            return (0, $7k5I8._)(function() {
                return (0, $lFlDF.__generator)(this, function(_state) {
                    map.delete(id);
                    return [
                        2
                    ];
                });
            })();
        }
    });
}
// lib/dom/ssr/errors.ts
function deserializeErrors2(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        var error = new ErrorConstructor(val.message);
                        error.stack = val.stack;
                        serialized[key] = error;
                    } catch (e) {}
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    error1.stack = val.stack;
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}

});
parcelRegister("7k5I8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $554ed4b40b13e16f$export$71511d61b312f219; });
function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("3Gvhd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2aed8e3a8a2d58d2$export$71511d61b312f219; });

var $ZhYhU = parcelRequire("ZhYhU");

var $bFohN = parcelRequire("bFohN");

var $oIOMH = parcelRequire("oIOMH");
function $2aed8e3a8a2d58d2$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $ZhYhU._)(derived);
    return (0, $oIOMH._)(_this, (0, $bFohN._)() ? Reflect.construct(derived, args || [], (0, $ZhYhU._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("ZhYhU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b83a35ce2cd1792$export$71511d61b312f219; });
function $0b83a35ce2cd1792$export$71511d61b312f219(o) {
    $0b83a35ce2cd1792$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0b83a35ce2cd1792$export$71511d61b312f219(o);
}

});

parcelRegister("bFohN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $87e65cc21f1ac8a6$export$71511d61b312f219; });
function $87e65cc21f1ac8a6$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($87e65cc21f1ac8a6$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("oIOMH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $04a501f287790d91$export$71511d61b312f219; });

var $fWfWu = parcelRequire("fWfWu");

var $YtE9h = parcelRequire("YtE9h");
function $04a501f287790d91$export$71511d61b312f219(self, call) {
    if (call && ((0, $YtE9h._)(call) === "object" || typeof call === "function")) return call;
    return (0, $fWfWu._)(self);
}

});
parcelRegister("fWfWu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $02fe9748b9e38ccb$export$71511d61b312f219; });
function $02fe9748b9e38ccb$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$71511d61b312f219; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$71511d61b312f219; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("hD5pT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd5a47cf8ef6d766$export$71511d61b312f219; });
function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("5dLwP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cd308d6b98edc5a$export$71511d61b312f219; });

var $eZsRM = parcelRequire("eZsRM");
function $3cd308d6b98edc5a$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $eZsRM._)(subClass, superClass);
}

});
parcelRegister("eZsRM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae9d277b5847b878$export$71511d61b312f219; });
function $ae9d277b5847b878$export$71511d61b312f219(o, p) {
    $ae9d277b5847b878$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae9d277b5847b878$export$71511d61b312f219(o, p);
}

});


parcelRegister("eRslx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad1c00e896d27009$export$71511d61b312f219; });

var $hD5pT = parcelRequire("hD5pT");
function $ad1c00e896d27009$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $hD5pT._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("kJeRc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f17388ede13a49cc$export$71511d61b312f219; });
function $f17388ede13a49cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f17388ede13a49cc$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f17388ede13a49cc$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("1dxAe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0e310e53d1915a72$export$71511d61b312f219; });

var $34tHH = parcelRequire("34tHH");
function $0e310e53d1915a72$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $34tHH._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("34tHH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $23c8c95eb785a6d9$export$71511d61b312f219; });
function $23c8c95eb785a6d9$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("kB67t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efec029548ccee7f$export$71511d61b312f219; });

var $Q9cvz = parcelRequire("Q9cvz");

var $c4AWK = parcelRequire("c4AWK");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $Q9cvz._)(arr) || (0, $c4AWK._)(arr, i) || (0, $ihB7G._)(arr, i) || (0, $dNApw._)();
}

});
parcelRegister("Q9cvz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09cbfe85151ea6c6$export$71511d61b312f219; });
function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("c4AWK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ca2848f896a6803$export$71511d61b312f219; });
function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("dNApw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a0bc1859061deae1$export$71511d61b312f219; });
function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("bQ8GJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89eb4a55c543f071$export$71511d61b312f219; });

var $Q9cvz = parcelRequire("Q9cvz");

var $Q6yVl = parcelRequire("Q6yVl");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $89eb4a55c543f071$export$71511d61b312f219(arr) {
    return (0, $Q9cvz._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $dNApw._)();
}

});
parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("lFlDF", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $fc5e3658b603cf39$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $fc5e3658b603cf39$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $YtE9h = parcelRequire("YtE9h");
var $fc5e3658b603cf39$var$extendStatics = function extendStatics1(d, b) {
    $fc5e3658b603cf39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc5e3658b603cf39$var$extendStatics(d, b);
};
function $fc5e3658b603cf39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc5e3658b603cf39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc5e3658b603cf39$export$18ce0697a983be9b = function __assign1() {
    $fc5e3658b603cf39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc5e3658b603cf39$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc5e3658b603cf39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc5e3658b603cf39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc5e3658b603cf39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc5e3658b603cf39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc5e3658b603cf39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc5e3658b603cf39$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $YtE9h._)(x)) === "symbol" ? x : "".concat(x);
}
function $fc5e3658b603cf39$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc5e3658b603cf39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc5e3658b603cf39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc5e3658b603cf39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc5e3658b603cf39$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc5e3658b603cf39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc5e3658b603cf39$export$45d3717a4c69092e(o, m, p);
}
function $fc5e3658b603cf39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc5e3658b603cf39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc5e3658b603cf39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc5e3658b603cf39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc5e3658b603cf39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc5e3658b603cf39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc5e3658b603cf39$export$10c90e4f7922046c(v) {
    return this instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? (this.v = v, this) : new $fc5e3658b603cf39$export$10c90e4f7922046c(v);
}
function $fc5e3658b603cf39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc5e3658b603cf39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc5e3658b603cf39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc5e3658b603cf39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc5e3658b603cf39$export$19a8beecd37a4c45 === "function" ? $fc5e3658b603cf39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc5e3658b603cf39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc5e3658b603cf39$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $fc5e3658b603cf39$var$ownKeys = function ownKeys1(o) {
    $fc5e3658b603cf39$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $fc5e3658b603cf39$var$ownKeys(o);
};
function $fc5e3658b603cf39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $fc5e3658b603cf39$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $fc5e3658b603cf39$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $fc5e3658b603cf39$var$__setModuleDefault(result, mod);
    return result;
}
function $fc5e3658b603cf39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc5e3658b603cf39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc5e3658b603cf39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc5e3658b603cf39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $YtE9h._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc5e3658b603cf39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc5e3658b603cf39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc5e3658b603cf39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc5e3658b603cf39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $fc5e3658b603cf39$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $fc5e3658b603cf39$export$2e2bcd8739ae039 = {
    __extends: $fc5e3658b603cf39$export$a8ba968b8961cb8a,
    __assign: $fc5e3658b603cf39$export$18ce0697a983be9b,
    __rest: $fc5e3658b603cf39$export$3c9a16f847548506,
    __decorate: $fc5e3658b603cf39$export$29e00dfd3077644b,
    __param: $fc5e3658b603cf39$export$d5ad3fd78186038f,
    __esDecorate: $fc5e3658b603cf39$export$3a84e1ae4e97e9b0,
    __runInitializers: $fc5e3658b603cf39$export$d831c04e792af3d,
    __propKey: $fc5e3658b603cf39$export$6a2a36740a146cb8,
    __setFunctionName: $fc5e3658b603cf39$export$d1a06452d3489bc7,
    __metadata: $fc5e3658b603cf39$export$f1db080c865becb9,
    __awaiter: $fc5e3658b603cf39$export$1050f835b63b671e,
    __generator: $fc5e3658b603cf39$export$67ebef60e6f28a6,
    __createBinding: $fc5e3658b603cf39$export$45d3717a4c69092e,
    __exportStar: $fc5e3658b603cf39$export$f33643c0debef087,
    __values: $fc5e3658b603cf39$export$19a8beecd37a4c45,
    __read: $fc5e3658b603cf39$export$8d051b38c9118094,
    __spread: $fc5e3658b603cf39$export$afc72e2116322959,
    __spreadArrays: $fc5e3658b603cf39$export$6388937ca91ccae8,
    __spreadArray: $fc5e3658b603cf39$export$1216008129fb82ed,
    __await: $fc5e3658b603cf39$export$10c90e4f7922046c,
    __asyncGenerator: $fc5e3658b603cf39$export$e427f37a30a4de9b,
    __asyncDelegator: $fc5e3658b603cf39$export$bbd80228419bb833,
    __asyncValues: $fc5e3658b603cf39$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc5e3658b603cf39$export$4fb47efe1390b86f,
    __importStar: $fc5e3658b603cf39$export$c21735bcef00d192,
    __importDefault: $fc5e3658b603cf39$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc5e3658b603cf39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc5e3658b603cf39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc5e3658b603cf39$export$81fdc39f203e4e04,
    __addDisposableResource: $fc5e3658b603cf39$export$88ac25d8e944e405,
    __disposeResources: $fc5e3658b603cf39$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $fc5e3658b603cf39$export$889dfb5d17574b0b
};

});

parcelRegister("f6Ucb", function(module, exports) {

var $7k5I8 = parcelRequire("7k5I8");

var $kB67t = parcelRequire("kB67t");

var $YtE9h = parcelRequire("YtE9h");

var $lFlDF = parcelRequire("lFlDF");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encode = module.exports.decode = void 0;

var $j221D = parcelRequire("j221D");

var $6AAJw = parcelRequire("6AAJw");

var $idsEh = parcelRequire("idsEh");
function $b00301d3cc37e75f$var$decode(readable, options) {
    return $b00301d3cc37e75f$var$_decode.apply(this, arguments);
}
function $b00301d3cc37e75f$var$_decode() {
    $b00301d3cc37e75f$var$_decode = (0, $7k5I8._)(function(readable, options) {
        var plugins, done, reader, decoder, decoded, donePromise;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    plugins = (options !== null && options !== void 0 ? options : {}).plugins;
                    done = new $idsEh.Deferred();
                    reader = readable.pipeThrough((0, $idsEh.createLineSplittingTransform)()).getReader();
                    decoder = {
                        values: [],
                        hydrated: [],
                        deferred: {},
                        plugins: plugins
                    };
                    return [
                        4,
                        $b00301d3cc37e75f$var$decodeInitial.call(decoder, reader)
                    ];
                case 1:
                    decoded = _state.sent();
                    donePromise = done.promise;
                    if (decoded.done) done.resolve();
                    else donePromise = $b00301d3cc37e75f$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch(function(reason) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.values(decoder.deferred)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var deferred = _step.value;
                                deferred.reject(reason);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        done.reject(reason);
                    });
                    return [
                        2,
                        {
                            done: donePromise.then(function() {
                                return reader.closed;
                            }),
                            value: decoded.value
                        }
                    ];
            }
        });
    });
    return $b00301d3cc37e75f$var$_decode.apply(this, arguments);
}
module.exports.decode = $b00301d3cc37e75f$var$decode;
function $b00301d3cc37e75f$var$decodeInitial(reader) {
    return $b00301d3cc37e75f$var$_decodeInitial.apply(this, arguments);
}
function $b00301d3cc37e75f$var$_decodeInitial() {
    $b00301d3cc37e75f$var$_decodeInitial = (0, $7k5I8._)(function(reader) {
        var read, line;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    if (!read.value) throw new SyntaxError();
                    try {
                        line = JSON.parse(read.value);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    return [
                        2,
                        {
                            done: read.done,
                            value: $6AAJw.unflatten.call(this, line)
                        }
                    ];
            }
        });
    });
    return $b00301d3cc37e75f$var$_decodeInitial.apply(this, arguments);
}
function $b00301d3cc37e75f$var$decodeDeferred(reader) {
    return $b00301d3cc37e75f$var$_decodeDeferred.apply(this, arguments);
}
function $b00301d3cc37e75f$var$_decodeDeferred() {
    $b00301d3cc37e75f$var$_decodeDeferred = (0, $7k5I8._)(function(reader) {
        var read, line, colonIndex, deferredId, deferred, lineData, jsonLine, value, colonIndex1, deferredId1, deferred1, lineData1, jsonLine1, value1;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!!read.done) return [
                        3,
                        4
                    ];
                    if (!read.value) return [
                        3,
                        2
                    ];
                    line = read.value;
                    switch(line[0]){
                        case $idsEh.TYPE_PROMISE:
                            {
                                colonIndex = line.indexOf(":");
                                deferredId = Number(line.slice(1, colonIndex));
                                deferred = this.deferred[deferredId];
                                if (!deferred) throw new Error("Deferred ID ".concat(deferredId, " not found in stream"));
                                lineData = line.slice(colonIndex + 1);
                                jsonLine = void 0;
                                try {
                                    jsonLine = JSON.parse(lineData);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value = $6AAJw.unflatten.call(this, jsonLine);
                                deferred.resolve(value);
                                break;
                            }
                        case $idsEh.TYPE_ERROR:
                            {
                                colonIndex1 = line.indexOf(":");
                                deferredId1 = Number(line.slice(1, colonIndex1));
                                deferred1 = this.deferred[deferredId1];
                                if (!deferred1) throw new Error("Deferred ID ".concat(deferredId1, " not found in stream"));
                                lineData1 = line.slice(colonIndex1 + 1);
                                jsonLine1 = void 0;
                                try {
                                    jsonLine1 = JSON.parse(lineData1);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value1 = $6AAJw.unflatten.call(this, jsonLine1);
                                deferred1.reject(value1);
                                break;
                            }
                        default:
                            throw new SyntaxError();
                    }
                    return [
                        4,
                        reader.read()
                    ];
                case 3:
                    read = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $b00301d3cc37e75f$var$_decodeDeferred.apply(this, arguments);
}
function $b00301d3cc37e75f$var$encode(input, options) {
    var _ref = options !== null && options !== void 0 ? options : {}, plugins = _ref.plugins, postPlugins = _ref.postPlugins, signal = _ref.signal;
    var encoder = {
        deferred: {},
        index: 0,
        indices: new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    var textEncoder = new TextEncoder();
    var lastSentIndex = 0;
    var readable = new ReadableStream({
        start: function(controller) {
            return (0, $7k5I8._)(function() {
                var id, seenPromises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = $j221D.flatten.call(encoder, input);
                            if (Array.isArray(id)) throw new Error("This should never happen");
                            if (id < 0) controller.enqueue(textEncoder.encode("".concat(id, "\n")));
                            else {
                                controller.enqueue(textEncoder.encode("[".concat(encoder.stringified.join(","), "]\n")));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                            seenPromises = new WeakSet();
                            _state.label = 1;
                        case 1:
                            if (!(Object.keys(encoder.deferred).length > 0)) return [
                                3,
                                3
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                _loop = function() {
                                    var _step_value = (0, $kB67t._)(_step.value, 2), deferredId = _step_value[0], deferred = _step_value[1];
                                    if (seenPromises.has(deferred)) return "continue";
                                    seenPromises.add(encoder.deferred[Number(deferredId)] = $b00301d3cc37e75f$var$raceSignal(deferred, encoder.signal).then(function(resolved) {
                                        var id = $j221D.flatten.call(encoder, resolved);
                                        if (Array.isArray(id)) {
                                            controller.enqueue(textEncoder.encode("".concat($idsEh.TYPE_PROMISE).concat(deferredId, ':[["').concat($idsEh.TYPE_PREVIOUS_RESOLVED, '",').concat(id[0], "]]\n")));
                                            encoder.index++;
                                            lastSentIndex++;
                                        } else if (id < 0) controller.enqueue(textEncoder.encode("".concat($idsEh.TYPE_PROMISE).concat(deferredId, ":").concat(id, "\n")));
                                        else {
                                            var values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                            controller.enqueue(textEncoder.encode("".concat($idsEh.TYPE_PROMISE).concat(deferredId, ":[").concat(values, "]\n")));
                                            lastSentIndex = encoder.stringified.length - 1;
                                        }
                                    }, function(reason) {
                                        if (!reason || (typeof reason === "undefined" ? "undefined" : (0, $YtE9h._)(reason)) !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                        var id = $j221D.flatten.call(encoder, reason);
                                        if (Array.isArray(id)) {
                                            controller.enqueue(textEncoder.encode("".concat($idsEh.TYPE_ERROR).concat(deferredId, ':[["').concat($idsEh.TYPE_PREVIOUS_RESOLVED, '",').concat(id[0], "]]\n")));
                                            encoder.index++;
                                            lastSentIndex++;
                                        } else if (id < 0) controller.enqueue(textEncoder.encode("".concat($idsEh.TYPE_ERROR).concat(deferredId, ":").concat(id, "\n")));
                                        else {
                                            var values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                            controller.enqueue(textEncoder.encode("".concat($idsEh.TYPE_ERROR).concat(deferredId, ":[").concat(values, "]\n")));
                                            lastSentIndex = encoder.stringified.length - 1;
                                        }
                                    }).finally(function() {
                                        delete encoder.deferred[Number(deferredId)];
                                    }));
                                };
                                for(_iterator = Object.entries(encoder.deferred)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                4,
                                Promise.race(Object.values(encoder.deferred))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                1
                            ];
                        case 3:
                            return [
                                4,
                                Promise.all(Object.values(encoder.deferred))
                            ];
                        case 4:
                            _state.sent();
                            controller.close();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    });
    return readable;
}
module.exports.encode = $b00301d3cc37e75f$var$encode;
function $b00301d3cc37e75f$var$raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    var abort = new Promise(function(resolve, reject) {
        signal.addEventListener("abort", function(event) {
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(function() {});
    return Promise.race([
        abort,
        promise
    ]);
}

});
parcelRegister("j221D", function(module, exports) {

var $kB67t = parcelRequire("kB67t");

var $bQ8GJ = parcelRequire("bQ8GJ");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flatten = void 0;

var $idsEh = parcelRequire("idsEh");
function $ddafc66a19dbdd58$var$flatten(input) {
    var indices = this.indices;
    var existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === undefined) return $idsEh.UNDEFINED;
    if (input === null) return $idsEh.NULL;
    if (Number.isNaN(input)) return $idsEh.NAN;
    if (input === Number.POSITIVE_INFINITY) return $idsEh.POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $idsEh.NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $idsEh.NEGATIVE_ZERO;
    var index = this.index++;
    indices.set(input, index);
    $ddafc66a19dbdd58$var$stringify.call(this, input, index);
    return index;
}
module.exports.flatten = $ddafc66a19dbdd58$var$flatten;
function $ddafc66a19dbdd58$var$stringify(input, index) {
    var _this = this;
    var _this1 = this, deferred = _this1.deferred, plugins = _this1.plugins, postPlugins = _this1.postPlugins;
    var str = this.stringified;
    var stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        var _stack_pop = (0, $kB67t._)(stack.pop(), 2), _$input = _stack_pop[0], _$index = _stack_pop[1];
        var partsForObj = function(obj) {
            return Object.keys(obj).map(function(k) {
                return '"_'.concat($ddafc66a19dbdd58$var$flatten.call(_this, k), '":').concat($ddafc66a19dbdd58$var$flatten.call(_this, obj[k]));
            }).join(",");
        };
        var error = null;
        switch(typeof _$input === "undefined" ? "undefined" : (0, $YtE9h._)(_$input)){
            case "boolean":
            case "number":
            case "string":
                str[_$index] = JSON.stringify(_$input);
                break;
            case "bigint":
                str[_$index] = '["'.concat($idsEh.TYPE_BIGINT, '","').concat(_$input, '"]');
                break;
            case "symbol":
                {
                    var keyFor = Symbol.keyFor(_$input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[_$index] = '["'.concat($idsEh.TYPE_SYMBOL, '",').concat(JSON.stringify(keyFor), "]");
                    break;
                }
            case "object":
                {
                    if (!_$input) {
                        str[_$index] = "".concat($idsEh.NULL);
                        break;
                    }
                    var isArray = Array.isArray(_$input);
                    var pluginHandled = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (!isArray && plugins) try {
                        for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var plugin = _step.value;
                            var pluginResult = plugin(_$input);
                            if (Array.isArray(pluginResult)) {
                                pluginHandled = true;
                                var _pluginResult = (0, $bQ8GJ._)(pluginResult), pluginIdentifier = _pluginResult[0], rest = _pluginResult.slice(1);
                                str[_$index] = "[".concat(JSON.stringify(pluginIdentifier));
                                if (rest.length > 0) str[_$index] += ",".concat(rest.map(function(v) {
                                    return $ddafc66a19dbdd58$var$flatten.call(_this, v);
                                }).join(","));
                                str[_$index] += "]";
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!pluginHandled) {
                        var result = isArray ? "[" : "{";
                        if (isArray) {
                            for(var i = 0; i < _$input.length; i++)result += (i ? "," : "") + (i in _$input ? $ddafc66a19dbdd58$var$flatten.call(this, _$input[i]) : $idsEh.HOLE);
                            str[_$index] = "".concat(result, "]");
                        } else if (_$input instanceof Date) str[_$index] = '["'.concat($idsEh.TYPE_DATE, '",').concat(_$input.getTime(), "]");
                        else if (_$input instanceof URL) str[_$index] = '["'.concat($idsEh.TYPE_URL, '",').concat(JSON.stringify(_$input.href), "]");
                        else if (_$input instanceof RegExp) str[_$index] = '["'.concat($idsEh.TYPE_REGEXP, '",').concat(JSON.stringify(_$input.source), ",").concat(JSON.stringify(_$input.flags), "]");
                        else if (_$input instanceof Set) {
                            if (_$input.size > 0) str[_$index] = '["'.concat($idsEh.TYPE_SET, '",').concat((0, $2Xzd1._)(_$input).map(function(val) {
                                return $ddafc66a19dbdd58$var$flatten.call(_this, val);
                            }).join(","), "]");
                            else str[_$index] = '["'.concat($idsEh.TYPE_SET, '"]');
                        } else if (_$input instanceof Map) {
                            if (_$input.size > 0) str[_$index] = '["'.concat($idsEh.TYPE_MAP, '",').concat((0, $2Xzd1._)(_$input).flatMap(function(param) {
                                var _param = (0, $kB67t._)(param, 2), k = _param[0], v = _param[1];
                                return [
                                    $ddafc66a19dbdd58$var$flatten.call(_this, k),
                                    $ddafc66a19dbdd58$var$flatten.call(_this, v)
                                ];
                            }).join(","), "]");
                            else str[_$index] = '["'.concat($idsEh.TYPE_MAP, '"]');
                        } else if (_$input instanceof Promise) {
                            str[_$index] = '["'.concat($idsEh.TYPE_PROMISE, '",').concat(_$index, "]");
                            deferred[_$index] = _$input;
                        } else if (_$input instanceof Error) {
                            str[_$index] = '["'.concat($idsEh.TYPE_ERROR, '",').concat(JSON.stringify(_$input.message));
                            if (_$input.name !== "Error") str[_$index] += ",".concat(JSON.stringify(_$input.name));
                            str[_$index] += "]";
                        } else if (Object.getPrototypeOf(_$input) === null) str[_$index] = '["'.concat($idsEh.TYPE_NULL_OBJECT, '",{').concat(partsForObj(_$input), "}]");
                        else if ($ddafc66a19dbdd58$var$isPlainObject(_$input)) str[_$index] = "{".concat(partsForObj(_$input), "}");
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    var isArray1 = Array.isArray(_$input);
                    var pluginHandled1 = false;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (!isArray1 && plugins) try {
                        for(var _iterator1 = plugins[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var plugin1 = _step1.value;
                            var pluginResult1 = plugin1(_$input);
                            if (Array.isArray(pluginResult1)) {
                                pluginHandled1 = true;
                                var _pluginResult1 = (0, $bQ8GJ._)(pluginResult1), pluginIdentifier1 = _pluginResult1[0], rest1 = _pluginResult1.slice(1);
                                str[_$index] = "[".concat(JSON.stringify(pluginIdentifier1));
                                if (rest1.length > 0) str[_$index] += ",".concat(rest1.map(function(v) {
                                    return $ddafc66a19dbdd58$var$flatten.call(_this, v);
                                }).join(","));
                                str[_$index] += "]";
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (!pluginHandled1) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            var pluginHandled2 = false;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if (postPlugins) try {
                for(var _iterator2 = postPlugins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var plugin2 = _step2.value;
                    var pluginResult2 = plugin2(_$input);
                    if (Array.isArray(pluginResult2)) {
                        pluginHandled2 = true;
                        var _pluginResult2 = (0, $bQ8GJ._)(pluginResult2), pluginIdentifier2 = _pluginResult2[0], rest2 = _pluginResult2.slice(1);
                        str[_$index] = "[".concat(JSON.stringify(pluginIdentifier2));
                        if (rest2.length > 0) str[_$index] += ",".concat(rest2.map(function(v) {
                            return $ddafc66a19dbdd58$var$flatten.call(_this, v);
                        }).join(","));
                        str[_$index] += "]";
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            if (!pluginHandled2) throw error;
        }
    }
}
var $ddafc66a19dbdd58$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $ddafc66a19dbdd58$var$isPlainObject(thing) {
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $ddafc66a19dbdd58$var$objectProtoNames;
}

});
parcelRegister("idsEh", function(module, exports) {

var $bB0zn = parcelRequire("bB0zn");

var $hD5pT = parcelRequire("hD5pT");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createLineSplittingTransform = module.exports.Deferred = module.exports.TYPE_PREVIOUS_RESOLVED = module.exports.TYPE_URL = module.exports.TYPE_SYMBOL = module.exports.TYPE_SET = module.exports.TYPE_REGEXP = module.exports.TYPE_PROMISE = module.exports.TYPE_NULL_OBJECT = module.exports.TYPE_MAP = module.exports.TYPE_ERROR = module.exports.TYPE_DATE = module.exports.TYPE_BIGINT = module.exports.UNDEFINED = module.exports.POSITIVE_INFINITY = module.exports.NULL = module.exports.NEGATIVE_ZERO = module.exports.NEGATIVE_INFINITY = module.exports.NAN = module.exports.HOLE = void 0;
module.exports.HOLE = -1;
module.exports.NAN = -2;
module.exports.NEGATIVE_INFINITY = -3;
module.exports.NEGATIVE_ZERO = -4;
module.exports.NULL = -5;
module.exports.POSITIVE_INFINITY = -6;
module.exports.UNDEFINED = -7;
module.exports.TYPE_BIGINT = "B";
module.exports.TYPE_DATE = "D";
module.exports.TYPE_ERROR = "E";
module.exports.TYPE_MAP = "M";
module.exports.TYPE_NULL_OBJECT = "N";
module.exports.TYPE_PROMISE = "P";
module.exports.TYPE_REGEXP = "R";
module.exports.TYPE_SET = "S";
module.exports.TYPE_SYMBOL = "Y";
module.exports.TYPE_URL = "U";
module.exports.TYPE_PREVIOUS_RESOLVED = "Z";
var $d42fa9ef2923646d$var$Deferred = function Deferred() {
    var _this = this;
    (0, $bB0zn._)(this, Deferred);
    (0, $hD5pT._)(this, "promise", void 0);
    (0, $hD5pT._)(this, "resolve", void 0);
    (0, $hD5pT._)(this, "reject", void 0);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
module.exports.Deferred = $d42fa9ef2923646d$var$Deferred;
function $d42fa9ef2923646d$var$createLineSplittingTransform() {
    var decoder = new TextDecoder();
    var leftover = "";
    return new TransformStream({
        transform: function(chunk, controller) {
            var str = decoder.decode(chunk, {
                stream: true
            });
            var parts = (leftover + str).split("\n");
            // The last part might be a partial line, so keep it for the next chunk.
            leftover = parts.pop() || "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var part = _step.value;
                    controller.enqueue(part);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        flush: function(controller) {
            // If there's any leftover data, enqueue it before closing.
            if (leftover) controller.enqueue(leftover);
        }
    });
}
module.exports.createLineSplittingTransform = $d42fa9ef2923646d$var$createLineSplittingTransform;

});


parcelRegister("6AAJw", function(module, exports) {

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unflatten = void 0;

var $idsEh = parcelRequire("idsEh");
var $4cc2995358f401b2$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : undefined;
function $4cc2995358f401b2$var$unflatten(parsed) {
    var _this = this, hydrated = _this.hydrated, values = _this.values;
    if (typeof parsed === "number") return $4cc2995358f401b2$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    var startIndex = values.length;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            values.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    hydrated.length = values.length;
    return $4cc2995358f401b2$var$hydrate.call(this, startIndex);
}
module.exports.unflatten = $4cc2995358f401b2$var$unflatten;
function $4cc2995358f401b2$var$hydrate(index) {
    var _loop = function() {
        var _stack_pop = (0, $kB67t._)(stack.pop(), 2), _$index = _stack_pop[0], set = _stack_pop[1];
        switch(_$index){
            case $idsEh.UNDEFINED:
                set(undefined);
                return "continue";
            case $idsEh.NULL:
                set(null);
                return "continue";
            case $idsEh.NAN:
                set(NaN);
                return "continue";
            case $idsEh.POSITIVE_INFINITY:
                set(Infinity);
                return "continue";
            case $idsEh.NEGATIVE_INFINITY:
                set(-Infinity);
                return "continue";
            case $idsEh.NEGATIVE_ZERO:
                set(-0);
                return "continue";
        }
        if (hydrated[_$index]) {
            set(hydrated[_$index]);
            return "continue";
        }
        var value = values[_$index];
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object") {
            hydrated[_$index] = value;
            set(value);
            return "continue";
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                var _value = (0, $kB67t._)(value, 3), type = _value[0], b = _value[1], c = _value[2];
                switch(type){
                    case $idsEh.TYPE_DATE:
                        set(hydrated[_$index] = new Date(b));
                        return "continue";
                    case $idsEh.TYPE_URL:
                        set(hydrated[_$index] = new URL(b));
                        return "continue";
                    case $idsEh.TYPE_BIGINT:
                        set(hydrated[_$index] = BigInt(b));
                        return "continue";
                    case $idsEh.TYPE_REGEXP:
                        set(hydrated[_$index] = new RegExp(b, c));
                        return "continue";
                    case $idsEh.TYPE_SYMBOL:
                        set(hydrated[_$index] = Symbol.for(b));
                        return "continue";
                    case $idsEh.TYPE_SET:
                        var newSet = new Set();
                        hydrated[_$index] = newSet;
                        for(var i = 1; i < value.length; i++)stack.push([
                            value[i],
                            function(v) {
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        return "continue";
                    case $idsEh.TYPE_MAP:
                        var _loop = function(i1) {
                            var r = [];
                            stack.push([
                                value[i1 + 1],
                                function(v) {
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i1],
                                function(k) {
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(function() {
                                map.set(r[0], r[1]);
                            });
                        };
                        var map = new Map();
                        hydrated[_$index] = map;
                        for(var i1 = 1; i1 < value.length; i1 += 2)_loop(i1);
                        set(map);
                        return "continue";
                    case $idsEh.TYPE_NULL_OBJECT:
                        var obj = Object.create(null);
                        hydrated[_$index] = obj;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop1 = function() {
                                var key = _step.value;
                                var r = [];
                                stack.push([
                                    b[key],
                                    function(v) {
                                        r[1] = v;
                                    }
                                ]);
                                stack.push([
                                    Number(key.slice(1)),
                                    function(k) {
                                        r[0] = k;
                                    }
                                ]);
                                postRun.push(function() {
                                    obj[r[0]] = r[1];
                                });
                            };
                            for(var _iterator = Object.keys(b).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        set(obj);
                        return "continue";
                    case $idsEh.TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[_$index] = hydrated[b]);
                        else {
                            var d = new $idsEh.Deferred();
                            deferred[b] = d;
                            set(hydrated[_$index] = d.promise);
                        }
                        return "continue";
                    case $idsEh.TYPE_ERROR:
                        var _value1 = (0, $kB67t._)(value, 3), message = _value1[1], errorType = _value1[2];
                        var error = errorType && $4cc2995358f401b2$var$globalObj && $4cc2995358f401b2$var$globalObj[errorType] ? new $4cc2995358f401b2$var$globalObj[errorType](message) : new Error(message);
                        hydrated[_$index] = error;
                        set(error);
                        return "continue";
                    case $idsEh.TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[_$index] = hydrated[b]);
                        return "continue";
                    default:
                        // Run plugins at the end so we have a chance to resolve primitives
                        // without running into a loop
                        if (Array.isArray(plugins)) {
                            var _loop2 = function(i2) {
                                var v = vals[i2];
                                stack.push([
                                    v,
                                    function(v) {
                                        r[i2] = v;
                                    }
                                ]);
                            };
                            var r = [];
                            var vals = value.slice(1);
                            for(var i2 = 0; i2 < vals.length; i2++)_loop2(i2);
                            postRun.push(function() {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var plugin = _step.value;
                                        var result = plugin.apply(void 0, [
                                            value[0]
                                        ].concat((0, $2Xzd1._)(r)));
                                        if (result) {
                                            set(hydrated[_$index] = result.value);
                                            return;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                throw new SyntaxError();
                            });
                            return "continue";
                        }
                        throw new SyntaxError();
                }
            } else {
                var _loop3 = function(i3) {
                    var n = value[i3];
                    if (n !== $idsEh.HOLE) stack.push([
                        n,
                        function(v) {
                            array[i3] = v;
                        }
                    ]);
                };
                var array = [];
                hydrated[_$index] = array;
                for(var i3 = 0; i3 < value.length; i3++)_loop3(i3);
                set(array);
                return "continue";
            }
        } else {
            var object = {};
            hydrated[_$index] = object;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop4 = function() {
                    var key = _step1.value;
                    var r = [];
                    stack.push([
                        value[key],
                        function(v) {
                            r[1] = v;
                        }
                    ]);
                    stack.push([
                        Number(key.slice(1)),
                        function(k) {
                            r[0] = k;
                        }
                    ]);
                    postRun.push(function() {
                        object[r[0]] = r[1];
                    });
                };
                for(var _iterator1 = Object.keys(value).reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop4();
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            set(object);
            return "continue";
        }
    };
    var _this = this, hydrated = _this.hydrated, values = _this.values, deferred = _this.deferred, plugins = _this.plugins;
    var result;
    var stack = [
        [
            index,
            function(v) {
                result = v;
            }
        ]
    ];
    var postRun = [];
    while(stack.length > 0)_loop();
    while(postRun.length > 0)postRun.pop()();
    return result;
}

});


parcelRegister("aLpOW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $7d625297a229b77f$var$parse;
module.exports.serialize = $7d625297a229b77f$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ var $7d625297a229b77f$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ var $7d625297a229b77f$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ var $7d625297a229b77f$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ var $7d625297a229b77f$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
var $7d625297a229b77f$var$__toString = Object.prototype.toString;
var $7d625297a229b77f$var$NullObject = /* @__PURE__ */ function() {
    var C = function C() {};
    C.prototype = Object.create(null);
    return C;
}();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $7d625297a229b77f$var$parse(str, options) {
    var obj = new $7d625297a229b77f$var$NullObject();
    var len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    var dec = (options === null || options === void 0 ? void 0 : options.decode) || $7d625297a229b77f$var$decode;
    var index = 0;
    do {
        var eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        var colonIdx = str.indexOf(";", index);
        var endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        var keyStartIdx = $7d625297a229b77f$var$startIndex(str, index, eqIdx);
        var keyEndIdx = $7d625297a229b77f$var$endIndex(str, eqIdx, keyStartIdx);
        var key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            var valStartIdx = $7d625297a229b77f$var$startIndex(str, eqIdx + 1, endIdx);
            var valEndIdx = $7d625297a229b77f$var$endIndex(str, endIdx, valStartIdx);
            var value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $7d625297a229b77f$var$startIndex(str, index, max) {
    do {
        var code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $7d625297a229b77f$var$endIndex(str, index, min) {
    while(index > min){
        var code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $7d625297a229b77f$var$serialize(name, val, options) {
    var enc = (options === null || options === void 0 ? void 0 : options.encode) || encodeURIComponent;
    if (!$7d625297a229b77f$var$cookieNameRegExp.test(name)) throw new TypeError("argument name is invalid: ".concat(name));
    var value = enc(val);
    if (!$7d625297a229b77f$var$cookieValueRegExp.test(value)) throw new TypeError("argument val is invalid: ".concat(val));
    var str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError("option maxAge is invalid: ".concat(options.maxAge));
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$7d625297a229b77f$var$domainValueRegExp.test(options.domain)) throw new TypeError("option domain is invalid: ".concat(options.domain));
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$7d625297a229b77f$var$pathValueRegExp.test(options.path)) throw new TypeError("option path is invalid: ".concat(options.path));
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$7d625297a229b77f$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError("option expires is invalid: ".concat(options.expires));
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        var priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError("option priority is invalid: ".concat(options.priority));
        }
    }
    if (options.sameSite) {
        var sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid: ".concat(options.sameSite));
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $7d625297a229b77f$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $7d625297a229b77f$var$isDate(val) {
    return $7d625297a229b77f$var$__toString.call(val) === "[object Date]";
}

});

parcelRegister("6Htrd", function(module, exports) {
"use strict";
var $4e0d97f9f95333a8$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $4e0d97f9f95333a8$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $4e0d97f9f95333a8$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($4e0d97f9f95333a8$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $4e0d97f9f95333a8$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $4e0d97f9f95333a8$var$defaultParseOptions, options) : $4e0d97f9f95333a8$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $4e0d97f9f95333a8$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $4e0d97f9f95333a8$var$parse(input, options) {
    options = options ? Object.assign({}, $4e0d97f9f95333a8$var$defaultParseOptions, options) : $4e0d97f9f95333a8$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($4e0d97f9f95333a8$var$isNonEmptyString).map(function(str) {
        return $4e0d97f9f95333a8$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($4e0d97f9f95333a8$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $4e0d97f9f95333a8$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $4e0d97f9f95333a8$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
module.exports = $4e0d97f9f95333a8$var$parse;
module.exports.parse = $4e0d97f9f95333a8$var$parse;
module.exports.parseString = $4e0d97f9f95333a8$var$parseString;
module.exports.splitCookiesString = $4e0d97f9f95333a8$var$splitCookiesString;

});


parcelRegister("jYM0A", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $e8b8dc64a4f17ad2$export$bf730a2d8bf68b42; }, function (v) { return $e8b8dc64a4f17ad2$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8b8dc64a4f17ad2$export$bf730a2d8bf68b42;
"use strict";

var $fIwXP = parcelRequire("fIwXP");
function $e8b8dc64a4f17ad2$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e8b8dc64a4f17ad2$var$objectIs = "function" === typeof Object.is ? Object.is : $e8b8dc64a4f17ad2$var$is, $e8b8dc64a4f17ad2$var$useSyncExternalStore = $fIwXP.useSyncExternalStore, $e8b8dc64a4f17ad2$var$useRef = $fIwXP.useRef, $e8b8dc64a4f17ad2$var$useEffect = $fIwXP.useEffect, $e8b8dc64a4f17ad2$var$useMemo = $fIwXP.useMemo, $e8b8dc64a4f17ad2$var$useDebugValue = $fIwXP.useDebugValue;
$e8b8dc64a4f17ad2$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $e8b8dc64a4f17ad2$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $e8b8dc64a4f17ad2$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($e8b8dc64a4f17ad2$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $e8b8dc64a4f17ad2$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $e8b8dc64a4f17ad2$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $e8b8dc64a4f17ad2$var$useDebugValue(value);
    return value;
};

});

parcelRegister("5icQr", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $kB67t._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $YtE9h._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $bB0zn._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $2Xzd1._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || (typeof base === "undefined" ? "undefined" : (0, $YtE9h._)(base)) !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $2Xzd1._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $6QEWP._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if ((typeof base === "undefined" ? "undefined" : (0, $YtE9h._)(base)) !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $kB67t._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $5dLwP._)(DraftMap, Map1);
        function DraftMap(target, parent) {
            (0, $bB0zn._)(this, DraftMap);
            var _this;
            _this = (0, $3Gvhd._)(this, DraftMap);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: _this,
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $6QEWP._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $hD5pT._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $hD5pT._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $hD5pT._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $hD5pT._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $fPaN7._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $5dLwP._)(DraftSet, Set1);
        function DraftSet(target, parent) {
            (0, $bB0zn._)(this, DraftSet);
            var _this;
            _this = (0, $3Gvhd._)(this, DraftSet);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: _this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $6QEWP._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $fPaN7._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});
parcelRegister("fPaN7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b853fd5b3c362aee$export$71511d61b312f219; });

var $f5KHm = parcelRequire("f5KHm");

var $ZhYhU = parcelRequire("ZhYhU");

var $cHvTP = parcelRequire("cHvTP");

var $eZsRM = parcelRequire("eZsRM");
function $b853fd5b3c362aee$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b853fd5b3c362aee$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $cHvTP._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $f5KHm._)(Class, arguments, (0, $ZhYhU._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $eZsRM._)(Wrapper, Class);
    };
    return $b853fd5b3c362aee$export$71511d61b312f219(Class);
}

});
parcelRegister("f5KHm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $afcb8bf546bf0e4a$export$71511d61b312f219; });

var $bFohN = parcelRequire("bFohN");

var $eZsRM = parcelRequire("eZsRM");
function $afcb8bf546bf0e4a$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $bFohN._)()) $afcb8bf546bf0e4a$export$71511d61b312f219 = Reflect.construct;
    else $afcb8bf546bf0e4a$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $eZsRM._)(instance, Class.prototype);
        return instance;
    };
    return $afcb8bf546bf0e4a$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("cHvTP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $93f23ebd967272a8$export$71511d61b312f219; });
function $93f23ebd967272a8$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});



parcelRegister("c38Wl", function(module, exports) {


module.exports = (parcelRequire("jrcmb"))((parcelRequire("451Sc")).resolve("5Whcg")).then(function() {
    return parcelRequire('dhpq2');
});

});
parcelRegister("jrcmb", function(module, exports) {
"use strict";

var $bnxiY = parcelRequire("bnxiY");
module.exports = $bnxiY(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("bnxiY", function(module, exports) {
"use strict";
var $848bad63e2eca00a$var$cachedBundles = {};
var $848bad63e2eca00a$var$cachedPreloads = {};
var $848bad63e2eca00a$var$cachedPrefetches = {};
function $848bad63e2eca00a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $848bad63e2eca00a$var$cachedPreloads;
        case 'prefetch':
            return $848bad63e2eca00a$var$cachedPrefetches;
        default:
            return $848bad63e2eca00a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $848bad63e2eca00a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $7931135f9316780c$exports = {};


(parcelRequire("451Sc")).register((parcelRequire("i1aqH")).getBundleURL('a3HC9'), JSON.parse("[\"a3HC9\",\"index.478b8ba9.js\",\"bgq02\",\"logo.0dc3ac12.svg\",\"5Whcg\",\"Grocery.14503aea.js\"]"));


var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");
var $fb34d4b6d3b01836$exports = {};
'use strict';
function $fb34d4b6d3b01836$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($fb34d4b6d3b01836$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$fb34d4b6d3b01836$var$checkDCE();

$fb34d4b6d3b01836$exports = (parcelRequire("gd2PY"));



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");
var $beaa0a8e3ecd6c72$exports = {};

$beaa0a8e3ecd6c72$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "logo.0dc3ac12.svg";


var $cc25cc9a913d8a70$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $cc25cc9a913d8a70$export$8878ead86ed0da0b = (0, (/*@__PURE__*/$parcel$interopDefault($beaa0a8e3ecd6c72$exports)));
var $cc25cc9a913d8a70$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.99740&lng=79.00110&restaurantId=";



var $fIwXP = parcelRequire("fIwXP");

var $7e473 = parcelRequire("7e473");

var $kB67t = parcelRequire("kB67t");

var $fIwXP = parcelRequire("fIwXP");
var $3c7428cbea0d9bb7$var$useOnlineStatus = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(true), 2), onlineStatus = _useState[0], setOnlineStatus = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        window.addEventListener("offline", function() {
            setOnlineStatus(false);
        });
        window.addEventListener("online", function() {
            setOnlineStatus(true);
        });
    }, []);
    //boolean value
    return onlineStatus;
};
var $3c7428cbea0d9bb7$export$2e2bcd8739ae039 = $3c7428cbea0d9bb7$var$useOnlineStatus;



var $fIwXP = parcelRequire("fIwXP");
var $409bc5b8063aeee2$var$UserContext = /*#__PURE__*/ (0, $fIwXP.createContext)({
    loggedInUser: "Default User"
});
var $409bc5b8063aeee2$export$2e2bcd8739ae039 = $409bc5b8063aeee2$var$UserContext;



var $hD5pT = parcelRequire("hD5pT");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fIwXP = parcelRequire("fIwXP");
var $6dda7e3f4bfdb607$exports = {};
'use strict';

$6dda7e3f4bfdb607$exports = (parcelRequire("jYM0A"));


var $c7b80bd183211e5d$var$__defProp = Object.defineProperty;
var $c7b80bd183211e5d$var$__defProps = Object.defineProperties;
var $c7b80bd183211e5d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c7b80bd183211e5d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c7b80bd183211e5d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c7b80bd183211e5d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c7b80bd183211e5d$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $c7b80bd183211e5d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $c7b80bd183211e5d$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($c7b80bd183211e5d$var$__hasOwnProp.call(b, prop)) $c7b80bd183211e5d$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($c7b80bd183211e5d$var$__getOwnPropSymbols) try {
        for(var _iterator = $c7b80bd183211e5d$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($c7b80bd183211e5d$var$__propIsEnum.call(b, prop)) $c7b80bd183211e5d$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $c7b80bd183211e5d$var$__spreadProps = function(a, b) {
    return $c7b80bd183211e5d$var$__defProps(a, $c7b80bd183211e5d$var$__getOwnPropDescs(b));
};
var $c7b80bd183211e5d$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($c7b80bd183211e5d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $c7b80bd183211e5d$var$__getOwnPropSymbols) try {
        for(var _iterator = $c7b80bd183211e5d$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $c7b80bd183211e5d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
// src/utils/react-is.ts
var $c7b80bd183211e5d$var$IS_REACT_19 = /* @__PURE__ */ $fIwXP.version.startsWith("19");
var $c7b80bd183211e5d$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($c7b80bd183211e5d$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $c7b80bd183211e5d$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $c7b80bd183211e5d$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $c7b80bd183211e5d$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $c7b80bd183211e5d$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $c7b80bd183211e5d$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $c7b80bd183211e5d$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $c7b80bd183211e5d$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $c7b80bd183211e5d$var$ForwardRef = $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE;
var $c7b80bd183211e5d$var$Memo = $c7b80bd183211e5d$var$REACT_MEMO_TYPE;
function $c7b80bd183211e5d$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE || type === $c7b80bd183211e5d$var$REACT_PROFILER_TYPE || type === $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE || type === $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE || type === $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE || type === $c7b80bd183211e5d$var$REACT_OFFSCREEN_TYPE || (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) === "object" && type !== null && (type.$$typeof === $c7b80bd183211e5d$var$REACT_LAZY_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_MEMO_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_CONSUMER_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $c7b80bd183211e5d$var$typeOf(object) {
    if ((typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $c7b80bd183211e5d$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE:
                    case $c7b80bd183211e5d$var$REACT_PROFILER_TYPE:
                    case $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE:
                    case $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE:
                    case $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE:
                            case $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE:
                            case $c7b80bd183211e5d$var$REACT_LAZY_TYPE:
                            case $c7b80bd183211e5d$var$REACT_MEMO_TYPE:
                                return object;
                            case $c7b80bd183211e5d$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $c7b80bd183211e5d$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $c7b80bd183211e5d$var$isContextConsumer(object) {
    return $c7b80bd183211e5d$var$IS_REACT_19 ? $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_CONSUMER_TYPE : $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE;
}
function $c7b80bd183211e5d$var$isMemo(object) {
    return $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $c7b80bd183211e5d$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $c7b80bd183211e5d$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $c7b80bd183211e5d$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $c7b80bd183211e5d$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $c7b80bd183211e5d$var$verify(mapStateToProps, "mapStateToProps");
    $c7b80bd183211e5d$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $c7b80bd183211e5d$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $c7b80bd183211e5d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $c7b80bd183211e5d$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $c7b80bd183211e5d$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $c7b80bd183211e5d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $c7b80bd183211e5d$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $2Xzd1._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $c7b80bd183211e5d$var$isPlainObject(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $YtE9h._)(obj)) !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $c7b80bd183211e5d$var$verifyPlainObject(value, displayName, methodName) {
    if (!$c7b80bd183211e5d$var$isPlainObject(value)) $c7b80bd183211e5d$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $c7b80bd183211e5d$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $c7b80bd183211e5d$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $c7b80bd183211e5d$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $c7b80bd183211e5d$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $c7b80bd183211e5d$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $c7b80bd183211e5d$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && (typeof mapDispatchToProps === "undefined" ? "undefined" : (0, $YtE9h._)(mapDispatchToProps)) === "object" ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $c7b80bd183211e5d$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $c7b80bd183211e5d$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $c7b80bd183211e5d$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $c7b80bd183211e5d$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $c7b80bd183211e5d$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $c7b80bd183211e5d$var$__spreadValues($c7b80bd183211e5d$var$__spreadValues($c7b80bd183211e5d$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $c7b80bd183211e5d$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $c7b80bd183211e5d$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $c7b80bd183211e5d$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $c7b80bd183211e5d$var$wrapMergePropsFunc(mergeProps) : $c7b80bd183211e5d$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $c7b80bd183211e5d$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $c7b80bd183211e5d$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $c7b80bd183211e5d$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $c7b80bd183211e5d$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $c7b80bd183211e5d$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $c7b80bd183211e5d$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $c7b80bd183211e5d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $c7b80bd183211e5d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $c7b80bd183211e5d$var$canUseDOM = function() {
    return !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
};
var $c7b80bd183211e5d$var$isDOM = /* @__PURE__ */ $c7b80bd183211e5d$var$canUseDOM();
var $c7b80bd183211e5d$var$isRunningInReactNative = function() {
    return typeof navigator !== "undefined" && navigator.product === "ReactNative";
};
var $c7b80bd183211e5d$var$isReactNative = /* @__PURE__ */ $c7b80bd183211e5d$var$isRunningInReactNative();
var $c7b80bd183211e5d$var$getUseIsomorphicLayoutEffect = function() {
    return $c7b80bd183211e5d$var$isDOM || $c7b80bd183211e5d$var$isReactNative ? $fIwXP.useLayoutEffect : $fIwXP.useEffect;
};
var $c7b80bd183211e5d$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $c7b80bd183211e5d$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $c7b80bd183211e5d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $c7b80bd183211e5d$export$d36bdfa510afb180(objA, objB) {
    if ($c7b80bd183211e5d$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $YtE9h._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $YtE9h._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$c7b80bd183211e5d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $c7b80bd183211e5d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c7b80bd183211e5d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c7b80bd183211e5d$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c7b80bd183211e5d$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c7b80bd183211e5d$var$_obj;
var $c7b80bd183211e5d$var$TYPE_STATICS = ($c7b80bd183211e5d$var$_obj = {}, (0, $hD5pT._)($c7b80bd183211e5d$var$_obj, $c7b80bd183211e5d$var$ForwardRef, $c7b80bd183211e5d$var$FORWARD_REF_STATICS), (0, $hD5pT._)($c7b80bd183211e5d$var$_obj, $c7b80bd183211e5d$var$Memo, $c7b80bd183211e5d$var$MEMO_STATICS), $c7b80bd183211e5d$var$_obj);
function $c7b80bd183211e5d$var$getStatics(component) {
    if ($c7b80bd183211e5d$var$isMemo(component)) return $c7b80bd183211e5d$var$MEMO_STATICS;
    return $c7b80bd183211e5d$var$TYPE_STATICS[component["$$typeof"]] || $c7b80bd183211e5d$var$REACT_STATICS;
}
var $c7b80bd183211e5d$var$defineProperty = Object.defineProperty;
var $c7b80bd183211e5d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c7b80bd183211e5d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c7b80bd183211e5d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c7b80bd183211e5d$var$getPrototypeOf = Object.getPrototypeOf;
var $c7b80bd183211e5d$var$objectPrototype = Object.prototype;
function $c7b80bd183211e5d$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($c7b80bd183211e5d$var$objectPrototype) {
            var inheritedComponent = $c7b80bd183211e5d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c7b80bd183211e5d$var$objectPrototype) $c7b80bd183211e5d$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $c7b80bd183211e5d$var$getOwnPropertyNames(sourceComponent);
        if ($c7b80bd183211e5d$var$getOwnPropertySymbols) keys = keys.concat($c7b80bd183211e5d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c7b80bd183211e5d$var$getStatics(targetComponent);
        var sourceStatics = $c7b80bd183211e5d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c7b80bd183211e5d$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c7b80bd183211e5d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $c7b80bd183211e5d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $c7b80bd183211e5d$var$ContextKey = /* @__PURE__ */ Symbol.for("react-redux-context");
var $c7b80bd183211e5d$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $c7b80bd183211e5d$var$getContext() {
    var _a;
    if (!$fIwXP.createContext) return {};
    var contextMap = (_a = $c7b80bd183211e5d$var$gT[$c7b80bd183211e5d$var$ContextKey]) != null ? _a : $c7b80bd183211e5d$var$gT[$c7b80bd183211e5d$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($fIwXP.createContext);
    if (!realContext) {
        realContext = $fIwXP.createContext(null);
        contextMap.set($fIwXP.createContext, realContext);
    }
    return realContext;
}
var $c7b80bd183211e5d$export$cc80c08dc91f1c00 = /* @__PURE__ */ $c7b80bd183211e5d$var$getContext();
// src/components/connect.tsx
var $c7b80bd183211e5d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $c7b80bd183211e5d$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $c7b80bd183211e5d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $2Xzd1._)(effectArgs));
    }, dependencies);
}
function $c7b80bd183211e5d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $c7b80bd183211e5d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $c7b80bd183211e5d$var$strictEqual(a, b) {
    return a === b;
}
var $c7b80bd183211e5d$var$hasWarnedAboutDeprecatedPureOption = false;
function $c7b80bd183211e5d$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $c7b80bd183211e5d$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $c7b80bd183211e5d$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $c7b80bd183211e5d$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $c7b80bd183211e5d$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $c7b80bd183211e5d$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $kB67t._)($fIwXP.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $c7b80bd183211e5d$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $fIwXP.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $fIwXP.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $fIwXP.useMemo(function() {
                return $c7b80bd183211e5d$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $kB67t._)($fIwXP.useMemo(function() {
                if (!shouldHandleStateChanges) return $c7b80bd183211e5d$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $c7b80bd183211e5d$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $fIwXP.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $fIwXP.useRef(void 0);
            var lastWrapperProps = $fIwXP.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $fIwXP.useRef(void 0);
            var renderIsScheduled = $fIwXP.useRef(false);
            var isMounted = $fIwXP.useRef(false);
            var latestSubscriptionCallbackError = $fIwXP.useRef(void 0);
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $fIwXP.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $fIwXP.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $c7b80bd183211e5d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffectWithArgs($c7b80bd183211e5d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $fIwXP.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $fIwXP.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $fIwXP.createElement(WrappedComponent, $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $fIwXP.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $fIwXP.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $fIwXP.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $fIwXP.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $fIwXP.createElement(Connect, $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $c7b80bd183211e5d$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $c7b80bd183211e5d$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $c7b80bd183211e5d$export$64605811ab45167f = $c7b80bd183211e5d$var$connect;
// src/components/Provider.tsx
function $c7b80bd183211e5d$var$Provider(providerProps) {
    var children = providerProps.children, context = providerProps.context, serverState = providerProps.serverState, store = providerProps.store;
    var contextValue = $fIwXP.useMemo(function() {
        var subscription = $c7b80bd183211e5d$var$createSubscription(store);
        var baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    var previousState = $fIwXP.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $fIwXP.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c7b80bd183211e5d$export$2881499e37b75b9a = $c7b80bd183211e5d$var$Provider;
// src/hooks/useReduxContext.ts
function $c7b80bd183211e5d$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $fIwXP.useContext(context);
        return contextValue;
    };
}
var $c7b80bd183211e5d$var$useReduxContext = /* @__PURE__ */ $c7b80bd183211e5d$var$createReduxContextHook();
// src/hooks/useStore.ts
function $c7b80bd183211e5d$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$var$useReduxContext : // @ts-ignore
    $c7b80bd183211e5d$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $c7b80bd183211e5d$export$6ccbb43953eebf8 = /* @__PURE__ */ $c7b80bd183211e5d$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $c7b80bd183211e5d$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useStore2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$export$6ccbb43953eebf8 : $c7b80bd183211e5d$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $c7b80bd183211e5d$export$8ad76b76a4c905f8 = /* @__PURE__ */ $c7b80bd183211e5d$export$bc9b55530897c558();
var $c7b80bd183211e5d$var$refEquality = function(a, b) {
    return a === b;
};
function $c7b80bd183211e5d$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$var$useReduxContext : $c7b80bd183211e5d$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $c7b80bd183211e5d$var$refEquality : _ref_equalityFn;
        var reduxContext = useReduxContext2();
        var store = reduxContext.store, subscription = reduxContext.subscription, getServerState = reduxContext.getServerState;
        var firstRun = $fIwXP.useRef(true);
        var wrappedSelector = $fIwXP.useCallback((0, $hD5pT._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector
        ]);
        var selectedState = (0, $6dda7e3f4bfdb607$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $fIwXP.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $c7b80bd183211e5d$export$2105062e25df4afe = /* @__PURE__ */ $c7b80bd183211e5d$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $c7b80bd183211e5d$export$712ea50be43a7858 = $c7b80bd183211e5d$var$defaultNoopBatch;


var $f310bc4ea983f747$var$Header = function() {
    // let btnName = "Login"; //we are trying with HTML
    //useState variable
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)("Login"), 2), btnNameReact = _useState[0], setBtnNameReact = _useState[1];
    //We have created a global data inside the UserContext and thus for using that
    //we are using a hook below and passing UserContext data.    
    var data = (0, $fIwXP.useContext)((0, $409bc5b8063aeee2$export$2e2bcd8739ae039));
    //Subscribing to the store using a selector
    var cartItems = (0, $c7b80bd183211e5d$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var onlinestatus = (0, $3c7428cbea0d9bb7$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "flex justify-between items-center bg-white shadow-md py-4 px-6 sticky  top-0 z-50",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                    className: "w-32 hover:scale-105 transition-transform duration-300",
                    src: (0, $cc25cc9a913d8a70$export$8878ead86ed0da0b)
                })
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "flex items-center space-x-6 text-lg text-gray-700",
                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                    className: "flex p-4 m-4",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("li", {
                            className: "px-2",
                            children: [
                                "Online Status : ",
                                onlinestatus ? "\uD83D\uDFE2" : "\uD83D\uDE21"
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $7e473.Link), {
                                to: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $7e473.Link), {
                                to: "/About",
                                children: "About Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $7e473.Link), {
                                to: "/contact",
                                children: "Contact Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $7e473.Link), {
                                to: "/Grocery",
                                children: "Grocery"
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)((0, $7e473.Link), {
                                to: "/Cart",
                                children: [
                                    "Cart (",
                                    cartItems.length,
                                    " items)"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "flex items-center space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                    className: "login bg-blue-500 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-600 transition-colors duration-300",
                                    onClick: function() {
                                        btnNameReact === "Login" ? setBtnNameReact("Logout") : setBtnNameReact("Login");
                                    },
                                    children: btnNameReact
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                    className: "px-2 text-gray-600 font-semibold",
                                    children: data.loggedInUser
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $f310bc4ea983f747$export$2e2bcd8739ae039 = $f310bc4ea983f747$var$Header;



var $7k5I8 = parcelRequire("7k5I8");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $cc6u1 = parcelRequire("cc6u1");

var $eRslx = parcelRequire("eRslx");

var $cc6u1 = parcelRequire("cc6u1");

var $d6e6ef2e667bbda8$var$RestaurantCard = function(props) {
    var resData = props.resData; //destructuring the props (props is react) and destructuring is js
    var _ref = resData === null || resData === void 0 ? void 0 : resData.info, name = _ref.name, cuisines = _ref.cuisines, avgRatingString = _ref.avgRatingString, costForTwo = _ref.costForTwo, _ref_slaParshu = _ref.slaParshu, slaParshu = _ref_slaParshu === void 0 ? {} : _ref_slaParshu;
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "res-card p-4 rounded-lg bg-white shadow-lg hover:shadow-xl transition duration-300 ease-in-out",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                className: "rounded-lg w-full h-36 object-cover",
                alt: "res-logo",
                src: (0, $cc25cc9a913d8a70$export$31adfacaf07ffe63) + resData.info.cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h3", {
                className: "font-bold text-lg py-2",
                children: name
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                className: "text-sm text-gray-600",
                children: cuisines.join(", ")
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("h4", {
                className: "text-sm text-green-600 font-semibold",
                children: [
                    avgRatingString,
                    " stars"
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                className: "text-sm text-gray-800",
                children: costForTwo
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("h4", {
                className: "text-sm text-gray-600",
                children: [
                    slaParshu.deliveryTime,
                    " minutes"
                ]
            })
        ]
    });
};
var $d6e6ef2e667bbda8$export$ccb02a230af14023 = function(RestaurantCard) {
    return function(props) {
        return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $cc6u1.jsx)("label", {
                    className: "absolute top-0 left-0 bg-red-600 text-white text-xs font-bold m-2 p-1 rounded-md shadow-md",
                    children: "Promoted"
                }),
                /*#__PURE__*/ (0, $cc6u1.jsx)(RestaurantCard, (0, $eRslx._)({}, props))
            ]
        });
    };
};
var $d6e6ef2e667bbda8$export$2e2bcd8739ae039 = $d6e6ef2e667bbda8$var$RestaurantCard;



var $fIwXP = parcelRequire("fIwXP");

var $cc6u1 = parcelRequire("cc6u1");
var $68ce1d77bc18c07c$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "shimmer-container",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            })
        ]
    });
};
var $68ce1d77bc18c07c$export$2e2bcd8739ae039 = $68ce1d77bc18c07c$var$Shimmer;



var $7e473 = parcelRequire("7e473");


var $373b11f276a41253$var$Body = function() {
    //Local State variable - Super Powerful variable
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), listOfRestaurants = _useState[0], setListOfRestaurants = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), filteredRestaurant = _useState1[0], setFilteredRestaurant = _useState1[1];
    var _useState2 = (0, $kB67t._)((0, $fIwXP.useState)(""), 2), searchText = _useState2[0], setSearchText = _useState2[1];
    var RestaurantCardPromoted = (0, $d6e6ef2e667bbda8$export$ccb02a230af14023)((0, $d6e6ef2e667bbda8$export$2e2bcd8739ae039));
    // console.log("render")
    //use Effect will take two arguments first one is a call back funciton and 
    //second one will be dependency array
    //callback fn will be called once the render cycle is finished
    (0, $fIwXP.useEffect)(function() {
        fetchData();
    }, []);
    //we are directly fetching the data form the swiggy API's 
    //Using edu cors
    var ApiKey = '4e7a00598aebdb3d';
    var EDUCORS_URL = 'https://educorssolver.host/api/getData';
    // Target URL from you want to fetch data m ,ex-github api
    var Target = 'https://foodfire.onrender.com/api/restaurants?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING';
    var fetchData = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function() {
            var data, json, resData;
            //Trying to implement this from chetananda and it worked Baby!..... and I implemented this funciton because everytime the cards[i]
            //value changes in the API.
            // initialize checkJsonData() function to check Swiggy Restaurant data
            function checkJsonData(jsonData) {
                var _jsonData_data;
                // if (!jsonData?.data?.cards) return [];  new thing added watching the deepseek
                for(var i = 0; i < (jsonData === null || jsonData === void 0 ? void 0 : (_jsonData_data = jsonData.data) === null || _jsonData_data === void 0 ? void 0 : _jsonData_data.cards.length); i++){
                    var _json_data_cards_i_card_card_gridElements_infoWithStyle, _json_data_cards_i_card_card_gridElements, _json_data_cards_i_card_card, _json_data_cards_i_card, _json_data_cards_i, _json_data;
                    // initialize checkData for Swiggy Restaurant data
                    var checkData = json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards_i = _json_data.cards[i]) === null || _json_data_cards_i === void 0 ? void 0 : (_json_data_cards_i_card = _json_data_cards_i.card) === null || _json_data_cards_i_card === void 0 ? void 0 : (_json_data_cards_i_card_card = _json_data_cards_i_card.card) === null || _json_data_cards_i_card_card === void 0 ? void 0 : (_json_data_cards_i_card_card_gridElements = _json_data_cards_i_card_card.gridElements) === null || _json_data_cards_i_card_card_gridElements === void 0 ? void 0 : (_json_data_cards_i_card_card_gridElements_infoWithStyle = _json_data_cards_i_card_card_gridElements.infoWithStyle) === null || _json_data_cards_i_card_card_gridElements_infoWithStyle === void 0 ? void 0 : _json_data_cards_i_card_card_gridElements_infoWithStyle.restaurants;
                    // if checkData is not undefined then return it
                    if (checkData !== undefined) return checkData;
                }
                return [];
            }
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat(EDUCORS_URL, "?ApiKey=").concat(ApiKey, "&Target=").concat(encodeURIComponent(Target)))
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        console.log(json);
                        // call the checkJsonData() function which return Swiggy Restaurant data
                        resData = checkJsonData(json);
                        //optional chaining == ?.(symbol)
                        // setListOfRestaurants(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
                        // setFilteredRestaurant(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
                        setListOfRestaurants(resData);
                        setFilteredRestaurant(resData);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    // console.log(listOfRestaurants);
    var onlineStatus = (0, $3c7428cbea0d9bb7$export$2e2bcd8739ae039)();
    if (onlineStatus == false) return /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
        children: "Looks like you are fucking offline, Are you stupid or something, Don't even know how to turn on your Internet!!"
    });
    //Conditional Rendering
    // if(listOfRestaurants.length == 0){
    //     return < Shimmer />;
    // }
    //Another way for the above conditional rendering is ternery operator
    var _useContext = (0, $fIwXP.useContext)((0, $409bc5b8063aeee2$export$2e2bcd8739ae039)), setUserName = _useContext.setUserName, loggedInUser = _useContext.loggedInUser;
    return listOfRestaurants.length == 0 ? /*#__PURE__*/ (0, $cc6u1.jsx)((0, $68ce1d77bc18c07c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "body max-w-7xl mx-auto p-4",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "filter flex flex-wrap justify-between items-center mb-6 bg-gray-50 p-4 rounded-lg shadow-md",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "search flex items-center bg-white border border-gray-300 rounded-full shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                                type: "text",
                                className: "px-4 py-2 w-64 rounded-l-full focus:outline-none",
                                value: searchText,
                                onChange: function(e) {
                                    return setSearchText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                onClick: function() {
                                    //filter the restaurant cards and update the UI
                                    //searchText
                                    // console.log(searchText);
                                    var filteredRestaurant = listOfRestaurants.filter(function(res) {
                                        return res.info.name.toLowerCase().includes(searchText.toLowerCase());
                                    });
                                    setFilteredRestaurant(filteredRestaurant);
                                },
                                className: "bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-r-full transition duration-300",
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                            className: "px-6 py-2 bg-green-600 text-white rounded-lg shadow-md hover:bg-green-700 transition duration-300",
                            onClick: function() {
                                var filteredList = listOfRestaurants.filter(function(res) {
                                    return parseFloat(res.info.avgRating) >= 4.5;
                                });
                                setFilteredRestaurant(filteredList);
                                console.log("Button clicked");
                            },
                            children: "Top Rated Restaurants"
                        })
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "search flex items-center space-x-2",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("label", {
                                className: "font-semibold",
                                children: "Username : "
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                                className: "border border-gray-300 p-2 rounded-md focus:outline-blue-600",
                                value: loggedInUser,
                                onChange: function(e) {
                                    return setUserName(e.target.value);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "res-container grid grid-cols-4 gap-6 p-4",
                children: filteredRestaurant.map(function(restaurant) {
                    return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $7e473.Link), {
                        to: "/restaurants/" + restaurant.info.id,
                        className: "transform hover:scale-105 transition duration-300",
                        children: restaurant.info.veg ? /*#__PURE__*/ (0, $cc6u1.jsx)(RestaurantCardPromoted, {
                            resData: restaurant
                        }) : /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d6e6ef2e667bbda8$export$2e2bcd8739ae039), {
                            resData: restaurant
                        })
                    }, restaurant.info.id);
                })
            })
        ]
    });
};
var $373b11f276a41253$export$2e2bcd8739ae039 = $373b11f276a41253$var$Body;



var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $5dLwP = parcelRequire("5dLwP");

var $cc6u1 = parcelRequire("cc6u1");

var $7k5I8 = parcelRequire("7k5I8");

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $5dLwP = parcelRequire("5dLwP");

var $lFlDF = parcelRequire("lFlDF");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");
var $24207a1288b5d218$var$UserClass = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(UserClass, _React_Component);
    function UserClass(props) {
        (0, $bB0zn._)(this, UserClass);
        var _this;
        _this = (0, $3Gvhd._)(this, UserClass, [
            props
        ]);
        _this.state = {
            userInfo: {
                name: "Dummy",
                location: "Default"
            }
        };
        console.log(_this.props.name + "Child Constructor");
        return _this;
    }
    (0, $6QEWP._)(UserClass, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return (0, $7k5I8._)(function() {
                    var data, json;
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("https://api.github.com/users/ParshuShah")
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    4,
                                    data.json()
                                ];
                            case 2:
                                json = _state.sent();
                                _this.setState({
                                    userInfo: json
                                });
                                console.log(json);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                console.log("Component Did Update");
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_state_userInfo = this.state.userInfo, login = _this_state_userInfo.login, type = _this_state_userInfo.type, avatar_url = _this_state_userInfo.avatar_url;
                return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "user-card",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                            src: avatar_url
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("h2", {
                            children: [
                                "Name: ",
                                login
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("h3", {
                            children: [
                                "Type: ",
                                type
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                            children: "Contact: @ParshuShah"
                        })
                    ]
                });
            }
        }
    ]);
    return UserClass;
}((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).Component);
var $24207a1288b5d218$export$2e2bcd8739ae039 = $24207a1288b5d218$var$UserClass;



var $fIwXP = parcelRequire("fIwXP");

var $601c1599e979598b$var$About = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $5dLwP._)(About, Component);
    function About(props) {
        (0, $bB0zn._)(this, About);
        return (0, $3Gvhd._)(this, About, [
            props
        ]);
    }
    (0, $6QEWP._)(About, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
            // console.log("Parent Component Did Mount");
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                    className: "min-h-screen flex flex-col items-center justify-center bg-gray-100 text-gray-800",
                    children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "bg-white shadow-lg rounded-lg p-8 w-10/12 md:w-8/12 lg:w-6/12",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "mb-4 text-center",
                                children: [
                                    " ",
                                    "loggedInUser : ",
                                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $409bc5b8063aeee2$export$2e2bcd8739ae039).Consumer, {
                                        children: function(param) {
                                            var loggedInUser = param.loggedInUser;
                                            return /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                                className: "text-2xl font-bold text-blue-600",
                                                children: loggedInUser
                                            });
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                className: "text-3xl font-bold mb-2 text-gray-800",
                                children: "About Class Component"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                                className: "text-lg text-gray-600 mb-4",
                                children: "This is Swiggy PROTOTYPE MADE by Parshuram!!!"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                className: "border-t-2 border-gray-200 mt-4 pt-4",
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $24207a1288b5d218$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return About;
}((0, $fIwXP.Component));
var $601c1599e979598b$export$2e2bcd8739ae039 = $601c1599e979598b$var$About;



var $cc6u1 = parcelRequire("cc6u1");
var $717a2f0a6a708d12$var$Contact = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        children: /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
            children: "This is a Contact us Page"
        })
    });
};
var $717a2f0a6a708d12$export$2e2bcd8739ae039 = $717a2f0a6a708d12$var$Contact;



var $cc6u1 = parcelRequire("cc6u1");

var $7e473 = parcelRequire("7e473");
var $eb9ea4566ac52960$var$Error = function() {
    var err = (0, $7e473.useRouteError)();
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "flex flex-col items-center justify-center min-h-screen bg-gray-100",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "text-6xl font-bold text-red-500 mb-4",
                children: "Oops!"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                className: "text-2xl font-semibold text-gray-800 mb-2",
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("h3", {
                className: "text-lg text-gray-600",
                children: [
                    err.status,
                    " : ",
                    err.statusText
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $7e473.Link), {
                to: "/",
                children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                    className: "mt-6 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700",
                    children: "Go Back Home"
                })
            })
        ]
    });
};
var $eb9ea4566ac52960$export$2e2bcd8739ae039 = $eb9ea4566ac52960$var$Error;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");


var $7e473 = parcelRequire("7e473");

var $7k5I8 = parcelRequire("7k5I8");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");

var $6d359334c042511a$var$useRestaurantMenu = function(resId) {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        fetchData();
    }, []);
    //Using edu cors
    var ApiKey = '4e7a00598aebdb3d';
    var EDUCORS_URL = 'https://educorssolver.host/api/getData';
    // Target URL from you want to fetch data m ,ex-github api
    var Target = (0, $cc25cc9a913d8a70$export$b77c1aa4fb57bd1c) + resId;
    var fetchData = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function() {
            var data, json;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat(EDUCORS_URL, "?ApiKey=").concat(ApiKey, "&Target=").concat(encodeURIComponent(Target)))
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        setResInfo(json.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return resInfo;
};
var $6d359334c042511a$export$2e2bcd8739ae039 = $6d359334c042511a$var$useRestaurantMenu;



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");

var $cc6u1 = parcelRequire("cc6u1");



var $7k5I8 = parcelRequire("7k5I8");

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $f5KHm = parcelRequire("f5KHm");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $ZhYhU = parcelRequire("ZhYhU");
function $5f0e95e6df7a47eb$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $ZhYhU._)(object);
        if (object === null) break;
    }
    return object;
}


function $04ca9dac0ceac2e2$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $04ca9dac0ceac2e2$export$71511d61b312f219 = Reflect.get;
    else $04ca9dac0ceac2e2$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $5f0e95e6df7a47eb$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $04ca9dac0ceac2e2$export$71511d61b312f219(target, property, receiver || target);
}



var $ZhYhU = parcelRequire("ZhYhU");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");

var $lFlDF = parcelRequire("lFlDF");
// src/utils/formatProdErrorMessage.ts

var $hD5pT = parcelRequire("hD5pT");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
function $a039f9c7168ef4c9$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $a039f9c7168ef4c9$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $a039f9c7168ef4c9$var$symbol_observable_default = $a039f9c7168ef4c9$var$$$observable;
// src/utils/actionTypes.ts
var $a039f9c7168ef4c9$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $a039f9c7168ef4c9$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($a039f9c7168ef4c9$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($a039f9c7168ef4c9$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($a039f9c7168ef4c9$var$randomString());
    }
};
var $a039f9c7168ef4c9$export$4219e499db7ca678 = $a039f9c7168ef4c9$var$ActionTypes;
// src/utils/isPlainObject.ts
function $a039f9c7168ef4c9$export$53b83ca8eaab0383(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $YtE9h._)(obj)) !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $a039f9c7168ef4c9$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($a039f9c7168ef4c9$var$isDate(val)) return "date";
    if ($a039f9c7168ef4c9$var$isError(val)) return "error";
    var constructorName = $a039f9c7168ef4c9$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $a039f9c7168ef4c9$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $a039f9c7168ef4c9$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $a039f9c7168ef4c9$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $a039f9c7168ef4c9$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $a039f9c7168ef4c9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(1));
        return enhancer($a039f9c7168ef4c9$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$a039f9c7168ef4c9$export$53b83ca8eaab0383(action)) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $hD5pT._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if ((typeof observer === "undefined" ? "undefined" : (0, $YtE9h._)(observer)) !== "object" || observer === null) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $a039f9c7168ef4c9$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $a039f9c7168ef4c9$export$4219e499db7ca678.INIT
    });
    var store = (0, $hD5pT._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $a039f9c7168ef4c9$var$symbol_observable_default, observable);
    return store;
}
function $a039f9c7168ef4c9$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $a039f9c7168ef4c9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $a039f9c7168ef4c9$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $a039f9c7168ef4c9$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $a039f9c7168ef4c9$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$a039f9c7168ef4c9$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($a039f9c7168ef4c9$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $a039f9c7168ef4c9$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $a039f9c7168ef4c9$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(13));
    });
}
function $a039f9c7168ef4c9$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $a039f9c7168ef4c9$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $a039f9c7168ef4c9$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $a039f9c7168ef4c9$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $a039f9c7168ef4c9$var$bindActionCreator(actionCreators, dispatch);
    if ((typeof actionCreators === "undefined" ? "undefined" : (0, $YtE9h._)(actionCreators)) !== "object" || actionCreators === null) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $a039f9c7168ef4c9$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $a039f9c7168ef4c9$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $2Xzd1._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $a039f9c7168ef4c9$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $2Xzd1._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $a039f9c7168ef4c9$export$f672e0b6f7222cd7.apply(void 0, (0, $2Xzd1._)(chain))(store.dispatch);
            return (0, $kJeRc._)((0, $eRslx._)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $a039f9c7168ef4c9$export$b956e38827fca970(action) {
    return $a039f9c7168ef4c9$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $5icQr = parcelRequire("5icQr");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
var $874a87fa87407f05$var$__defProp = Object.defineProperty;
var $874a87fa87407f05$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $874a87fa87407f05$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $874a87fa87407f05$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $874a87fa87407f05$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $874a87fa87407f05$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $874a87fa87407f05$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($874a87fa87407f05$var$__hasOwnProp.call(b, prop)) $874a87fa87407f05$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($874a87fa87407f05$var$__getOwnPropSymbols) try {
        for(var _iterator = $874a87fa87407f05$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($874a87fa87407f05$var$__propIsEnum.call(b, prop)) $874a87fa87407f05$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $874a87fa87407f05$var$__publicField = function(obj, key, value) {
    $874a87fa87407f05$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $874a87fa87407f05$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $874a87fa87407f05$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $2Xzd1._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $874a87fa87407f05$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $874a87fa87407f05$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($874a87fa87407f05$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $874a87fa87407f05$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $874a87fa87407f05$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $YtE9h._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $874a87fa87407f05$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object));
    if ((typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) !== "object") throw new TypeError(errorMessage);
}
function $874a87fa87407f05$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $YtE9h._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $874a87fa87407f05$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $874a87fa87407f05$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $874a87fa87407f05$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $874a87fa87407f05$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $874a87fa87407f05$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $874a87fa87407f05$var$__spreadValues($874a87fa87407f05$var$__spreadValues({}, $874a87fa87407f05$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $874a87fa87407f05$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $874a87fa87407f05$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $874a87fa87407f05$var$$REVISION = 0;
var $874a87fa87407f05$var$CURRENT_TRACKER = null;
var $874a87fa87407f05$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$var$tripleEq;
        (0, $bB0zn._)(this, Cell);
        $874a87fa87407f05$var$__publicField(this, "revision", $874a87fa87407f05$var$$REVISION);
        $874a87fa87407f05$var$__publicField(this, "_value");
        $874a87fa87407f05$var$__publicField(this, "_lastValue");
        $874a87fa87407f05$var$__publicField(this, "_isEqual", $874a87fa87407f05$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $6QEWP._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $874a87fa87407f05$var$CURRENT_TRACKER == null || $874a87fa87407f05$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$874a87fa87407f05$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $874a87fa87407f05$var$tripleEq(a, b) {
    return a === b;
}
var $874a87fa87407f05$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $bB0zn._)(this, TrackingCache);
        $874a87fa87407f05$var$__publicField(this, "_cachedValue");
        $874a87fa87407f05$var$__publicField(this, "_cachedRevision", -1);
        $874a87fa87407f05$var$__publicField(this, "_deps", []);
        $874a87fa87407f05$var$__publicField(this, "hits", 0);
        $874a87fa87407f05$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $6QEWP._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $874a87fa87407f05$var$CURRENT_TRACKER;
                    $874a87fa87407f05$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $874a87fa87407f05$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $874a87fa87407f05$var$CURRENT_TRACKER == null || $874a87fa87407f05$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $2Xzd1._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $874a87fa87407f05$var$getValue(cell) {
    if (!(cell instanceof $874a87fa87407f05$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $874a87fa87407f05$var$setValue(storage, value) {
    if (!(storage instanceof $874a87fa87407f05$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $874a87fa87407f05$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$var$tripleEq;
    return new $874a87fa87407f05$var$Cell(initialValue, isEqual);
}
function $874a87fa87407f05$var$createCache(fn) {
    $874a87fa87407f05$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $874a87fa87407f05$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $874a87fa87407f05$var$neverEq = function(a, b) {
    return false;
};
function $874a87fa87407f05$var$createTag() {
    return $874a87fa87407f05$var$createCell(null, $874a87fa87407f05$var$neverEq);
}
function $874a87fa87407f05$var$dirtyTag(tag, value) {
    $874a87fa87407f05$var$setValue(tag, value);
}
var $874a87fa87407f05$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $874a87fa87407f05$var$createTag();
    $874a87fa87407f05$var$getValue(tag);
};
var $874a87fa87407f05$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $874a87fa87407f05$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $874a87fa87407f05$var$REDUX_PROXY_LABEL = Symbol();
var $874a87fa87407f05$var$nextId = 0;
var $874a87fa87407f05$var$proto = Object.getPrototypeOf({});
var $874a87fa87407f05$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $bB0zn._)(this, ObjectTreeNode);
    this.value = value;
    $874a87fa87407f05$var$__publicField(this, "proxy", new Proxy(this, $874a87fa87407f05$var$objectProxyHandler));
    $874a87fa87407f05$var$__publicField(this, "tag", $874a87fa87407f05$var$createTag());
    $874a87fa87407f05$var$__publicField(this, "tags", {});
    $874a87fa87407f05$var$__publicField(this, "children", {});
    $874a87fa87407f05$var$__publicField(this, "collectionTag", null);
    $874a87fa87407f05$var$__publicField(this, "id", $874a87fa87407f05$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $874a87fa87407f05$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) === "symbol") return childValue;
            if (key in $874a87fa87407f05$var$proto) return childValue;
            if ((typeof childValue === "undefined" ? "undefined" : (0, $YtE9h._)(childValue)) === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $874a87fa87407f05$var$createNode(childValue);
                if (childNode.tag) $874a87fa87407f05$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $874a87fa87407f05$var$createTag();
                    tag.value = childValue;
                }
                $874a87fa87407f05$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $874a87fa87407f05$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $874a87fa87407f05$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $bB0zn._)(this, ArrayTreeNode);
    this.value = value;
    $874a87fa87407f05$var$__publicField(this, "proxy", new Proxy([
        this
    ], $874a87fa87407f05$var$arrayProxyHandler));
    $874a87fa87407f05$var$__publicField(this, "tag", $874a87fa87407f05$var$createTag());
    $874a87fa87407f05$var$__publicField(this, "tags", {});
    $874a87fa87407f05$var$__publicField(this, "children", {});
    $874a87fa87407f05$var$__publicField(this, "collectionTag", null);
    $874a87fa87407f05$var$__publicField(this, "id", $874a87fa87407f05$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $874a87fa87407f05$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        if (key === "length") $874a87fa87407f05$var$consumeCollection(node);
        return $874a87fa87407f05$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.has(node, prop);
    }
};
function $874a87fa87407f05$var$createNode(value) {
    if (Array.isArray(value)) return new $874a87fa87407f05$var$ArrayTreeNode(value);
    return new $874a87fa87407f05$var$ObjectTreeNode(value);
}
function $874a87fa87407f05$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $874a87fa87407f05$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $874a87fa87407f05$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $874a87fa87407f05$var$dirtyCollection(node);
            $874a87fa87407f05$var$dirtyTag(tags[key1], newChildValue);
        }
        if ((typeof newChildValue === "undefined" ? "undefined" : (0, $YtE9h._)(newChildValue)) === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if ((typeof newChildValue1 === "undefined" ? "undefined" : (0, $YtE9h._)(newChildValue1)) === "object" && newChildValue1 !== null) $874a87fa87407f05$var$updateNode(childNode, newChildValue1);
        else {
            $874a87fa87407f05$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $874a87fa87407f05$var$deleteNode(node) {
    if (node.tag) $874a87fa87407f05$var$dirtyTag(node.tag, null);
    $874a87fa87407f05$var$dirtyCollection(node);
    for(var key in node.tags)$874a87fa87407f05$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$874a87fa87407f05$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $874a87fa87407f05$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $874a87fa87407f05$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $874a87fa87407f05$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $874a87fa87407f05$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $874a87fa87407f05$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $874a87fa87407f05$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $874a87fa87407f05$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $874a87fa87407f05$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = (typeof equalityCheckOrOptions === "undefined" ? "undefined" : (0, $YtE9h._)(equalityCheckOrOptions)) === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $874a87fa87407f05$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $874a87fa87407f05$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? $874a87fa87407f05$var$createSingletonCache(comparator) : $874a87fa87407f05$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $874a87fa87407f05$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $874a87fa87407f05$export$c8f9cf88d9fdee55(func) {
    var node = $874a87fa87407f05$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $874a87fa87407f05$var$createCacheKeyComparator($874a87fa87407f05$export$3f025202a230c6dd);
    var cache = $874a87fa87407f05$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $874a87fa87407f05$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $874a87fa87407f05$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $bB0zn._)(this, StrongRef);
        this.value = value;
    }
    (0, $6QEWP._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $874a87fa87407f05$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $874a87fa87407f05$var$StrongRef;
var $874a87fa87407f05$var$UNTERMINATED = 0;
var $874a87fa87407f05$var$TERMINATED = 1;
function $874a87fa87407f05$var$createCacheNode() {
    return {
        s: $874a87fa87407f05$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $874a87fa87407f05$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $874a87fa87407f05$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || (typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg)) === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $874a87fa87407f05$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $874a87fa87407f05$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $874a87fa87407f05$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                var needsWeakRef = (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $874a87fa87407f05$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $874a87fa87407f05$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $874a87fa87407f05$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $874a87fa87407f05$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if ((typeof resultFunc === "undefined" ? "undefined" : (0, $YtE9h._)(resultFunc)) === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $874a87fa87407f05$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $YtE9h._)(resultFunc), "]"));
        var combinedOptions = $874a87fa87407f05$var$__spreadValues($874a87fa87407f05$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $874a87fa87407f05$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $874a87fa87407f05$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $874a87fa87407f05$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $874a87fa87407f05$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $2Xzd1._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $874a87fa87407f05$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $2Xzd1._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $874a87fa87407f05$export$595d22ed68ca2841 = /* @__PURE__ */ $874a87fa87407f05$export$5943f4447f6ef248($874a87fa87407f05$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $874a87fa87407f05$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$export$595d22ed68ca2841;
    $874a87fa87407f05$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $YtE9h._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $874a87fa87407f05$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $2193944b4716daad$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $2193944b4716daad$export$dd164f5517779f15 = $2193944b4716daad$var$createThunkMiddleware();
var $2193944b4716daad$export$16d06542a1949d9e = $2193944b4716daad$var$createThunkMiddleware;



var $ibRPI = parcelRequire("ibRPI");
var $44e97ff44f917989$var$__defProp = Object.defineProperty;
var $44e97ff44f917989$var$__defProps = Object.defineProperties;
var $44e97ff44f917989$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $44e97ff44f917989$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $44e97ff44f917989$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $44e97ff44f917989$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $44e97ff44f917989$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $44e97ff44f917989$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $44e97ff44f917989$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($44e97ff44f917989$var$__hasOwnProp.call(b, prop)) $44e97ff44f917989$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($44e97ff44f917989$var$__getOwnPropSymbols) try {
        for(var _iterator = $44e97ff44f917989$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($44e97ff44f917989$var$__propIsEnum.call(b, prop)) $44e97ff44f917989$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $44e97ff44f917989$var$__spreadProps = function(a, b) {
    return $44e97ff44f917989$var$__defProps(a, $44e97ff44f917989$var$__getOwnPropDescs(b));
};
var $44e97ff44f917989$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($44e97ff44f917989$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $44e97ff44f917989$var$__getOwnPropSymbols) try {
        for(var _iterator = $44e97ff44f917989$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $44e97ff44f917989$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $44e97ff44f917989$var$__publicField = function(obj, key, value) {
    return $44e97ff44f917989$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) !== "symbol" ? key + "" : key, value);
};
var $44e97ff44f917989$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $874a87fa87407f05$export$5943f4447f6ef248).apply(void 0, (0, $2Xzd1._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $2Xzd1._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $5icQr.isDraft)(value) ? (0, $5icQr.current)(value) : value
            ].concat((0, $2Xzd1._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $44e97ff44f917989$export$a5d3c27355e35910 = /* @__PURE__ */ $44e97ff44f917989$export$aab6de9e3dbb1473((0, $874a87fa87407f05$export$8402dc26d96f6902));
var $44e97ff44f917989$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if ((0, $YtE9h._)(arguments[0]) === "object") return 0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7;
    return (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $44e97ff44f917989$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $44e97ff44f917989$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $44e97ff44f917989$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $2Xzd1._)(args));
            if (!prepared) throw new Error($44e97ff44f917989$export$378fa86b259c0280(0));
            return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $a039f9c7168ef4c9$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $44e97ff44f917989$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $44e97ff44f917989$var$hasMatchFunction(action);
}
function $44e97ff44f917989$export$ebd532f9034651f3(action) {
    return (0, $a039f9c7168ef4c9$export$b956e38827fca970)(action) && Object.keys(action).every($44e97ff44f917989$var$isValidKey);
}
function $44e97ff44f917989$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $44e97ff44f917989$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $44e97ff44f917989$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $44e97ff44f917989$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
var $44e97ff44f917989$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $5dLwP._)(_Tuple, Array1);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $bB0zn._)(this, _Tuple);
        var _this;
        _this = (0, $3Gvhd._)(this, _Tuple, (0, $2Xzd1._)(items));
        Object.setPrototypeOf(_this, _Tuple.prototype);
        return _this;
    }
    (0, $6QEWP._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $04ca9dac0ceac2e2$export$71511d61b312f219)((0, $ZhYhU._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $f5KHm._)(_Tuple, (0, $2Xzd1._)(arr[0].concat(this)));
                return (0, $f5KHm._)(_Tuple, (0, $2Xzd1._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $fPaN7._)(Array));
function $44e97ff44f917989$var$freezeDraftable(val) {
    return (0, $5icQr.isDraftable)(val) ? (0, $5icQr.produce)(val, function() {}) : val;
}
function $44e97ff44f917989$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $44e97ff44f917989$export$9021b2733a0028a3(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" || value == null || Object.isFrozen(value);
}
function $44e97ff44f917989$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $44e97ff44f917989$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $44e97ff44f917989$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $44e97ff44f917989$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $44e97ff44f917989$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $44e97ff44f917989$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $44e97ff44f917989$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $YtE9h._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $44e97ff44f917989$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $44e97ff44f917989$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $a039f9c7168ef4c9$export$53b83ca8eaab0383)(val);
}
function $44e97ff44f917989$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $44e97ff44f917989$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $YtE9h._)(nestedValue)) === "object") {
                foundNestedSerializable = $44e97ff44f917989$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $YtE9h._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $44e97ff44f917989$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $44e97ff44f917989$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $YtE9h._)(nestedValue)) !== "object" || nestedValue === null) continue;
            if (!$44e97ff44f917989$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $44e97ff44f917989$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $44e97ff44f917989$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $44e97ff44f917989$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $44e97ff44f917989$export$1908877435b1d5e9();
        if (thunk) {
            if ($44e97ff44f917989$var$isBoolean(thunk)) middlewareArray.push((0, $2193944b4716daad$export$dd164f5517779f15));
            else middlewareArray.push((0, $2193944b4716daad$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $44e97ff44f917989$export$8fb31c0f05df007b = "RTK_autoBatch";
var $44e97ff44f917989$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $hD5pT._)({}, $44e97ff44f917989$export$8fb31c0f05df007b, true)
        };
    };
};
var $44e97ff44f917989$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $44e97ff44f917989$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $2Xzd1._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $44e97ff44f917989$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $44e97ff44f917989$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$44e97ff44f917989$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $44e97ff44f917989$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $44e97ff44f917989$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($44e97ff44f917989$export$676277d7dca0f396((typeof autoBatch === "undefined" ? "undefined" : (0, $YtE9h._)(autoBatch)) === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
function $44e97ff44f917989$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $44e97ff44f917989$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $a039f9c7168ef4c9$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $a039f9c7168ef4c9$export$66e4520cdb265d18)(reducer);
    else throw new Error($44e97ff44f917989$export$378fa86b259c0280(1));
    var finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var finalCompose = (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $44e97ff44f917989$var$composeWithDevTools($44e97ff44f917989$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, (typeof devTools === "undefined" ? "undefined" : (0, $YtE9h._)(devTools)) === "object" && devTools));
    var middlewareEnhancer = (0, $a039f9c7168ef4c9$export$9ff26e0402cc7b7).apply(void 0, (0, $2Xzd1._)(finalMiddleware));
    var getDefaultEnhancers = $44e97ff44f917989$var$buildGetDefaultEnhancers(middlewareEnhancer);
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    var composedEnhancer = finalCompose.apply(void 0, (0, $2Xzd1._)(storeEnhancers));
    return (0, $a039f9c7168ef4c9$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $44e97ff44f917989$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($44e97ff44f917989$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($44e97ff44f917989$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $44e97ff44f917989$var$isStateFunction(x) {
    return typeof x === "function";
}
function $44e97ff44f917989$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $kB67t._)($44e97ff44f917989$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($44e97ff44f917989$var$isStateFunction(initialState)) getInitialState = function() {
        return $44e97ff44f917989$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $44e97ff44f917989$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $2Xzd1._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $5icQr.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5icQr.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result1;
                } else return (0, $5icQr.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $44e97ff44f917989$var$matches = function(matcher, action) {
    if ($44e97ff44f917989$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $44e97ff44f917989$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $44e97ff44f917989$var$matches(matcher, action);
        });
    };
}
function $44e97ff44f917989$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $44e97ff44f917989$var$matches(matcher, action);
        });
    };
}
function $44e97ff44f917989$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $44e97ff44f917989$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $44e97ff44f917989$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$872dec21e9a69476()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $44e97ff44f917989$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $44e97ff44f917989$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $44e97ff44f917989$export$9dd1fb32974da385($44e97ff44f917989$export$a5c5d27e3994c5be.apply(void 0, (0, $2Xzd1._)(asyncThunks)), hasFlag);
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$fcc3388fb56de601()(asyncThunks[0]);
    return $44e97ff44f917989$export$9dd1fb32974da385($44e97ff44f917989$export$a5c5d27e3994c5be.apply(void 0, (0, $2Xzd1._)(asyncThunks)), hasFlag);
}
function $44e97ff44f917989$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$1da80a6ef1307441()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $44e97ff44f917989$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/nanoid.ts
var $44e97ff44f917989$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $44e97ff44f917989$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $44e97ff44f917989$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $44e97ff44f917989$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $44e97ff44f917989$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $bB0zn._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $44e97ff44f917989$var$__publicField(this, "_type");
};
var $44e97ff44f917989$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $bB0zn._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $44e97ff44f917989$var$__publicField(this, "_type");
};
var $44e97ff44f917989$export$c97c53d0b2d5d81e = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $44e97ff44f917989$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $44e97ff44f917989$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $44e97ff44f917989$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $44e97ff44f917989$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $7k5I8._)(function() {
                    var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$44e97ff44f917989$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $44e97ff44f917989$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $44e97ff44f917989$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $44e97ff44f917989$var$RejectWithValue) throw result;
                                            if (result instanceof $44e97ff44f917989$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $44e97ff44f917989$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($44e97ff44f917989$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $44e97ff44f917989$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $44e97ff44f917989$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $44e97ff44f917989$var$isThenable(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $44e97ff44f917989$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $44e97ff44f917989$export$343355ed40c51c46 = (0, $hD5pT._)({}, $44e97ff44f917989$var$asyncThunkSymbol, $44e97ff44f917989$export$6abd22dc03e5063f);
var $44e97ff44f917989$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($44e97ff44f917989$export$23a094319a4b586 || {});
function $44e97ff44f917989$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $44e97ff44f917989$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$44e97ff44f917989$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($44e97ff44f917989$export$378fa86b259c0280(11));
        typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI);
        var reducers = (typeof options.reducers === "function" ? options.reducers($44e97ff44f917989$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($44e97ff44f917989$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($44e97ff44f917989$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $44e97ff44f917989$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($44e97ff44f917989$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $44e97ff44f917989$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $44e97ff44f917989$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $kB67t._)(typeof options.extraReducers === "function" ? $44e97ff44f917989$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $44e97ff44f917989$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $44e97ff44f917989$var$getOrInsertComputed(injectedSelectorCache, injected, function() {
                    return /* @__PURE__ */ new WeakMap();
                });
                return $44e97ff44f917989$var$getOrInsertComputed(selectorCache, selectState, function() {
                    var _a2;
                    var map = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $kB67t._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                            map[name2] = $44e97ff44f917989$var$wrapSelector(selector, selectState, getInitialState, injected);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $44e97ff44f917989$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $44e97ff44f917989$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $2Xzd1._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $44e97ff44f917989$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $44e97ff44f917989$export$affdea4146de9cf5();
function $44e97ff44f917989$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $44e97ff44f917989$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $hD5pT._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $2Xzd1._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $44e97ff44f917989$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$44e97ff44f917989$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $44e97ff44f917989$export$309c7a02b0b0bc62(type, prepareCallback) : $44e97ff44f917989$export$309c7a02b0b0bc62(type));
}
function $44e97ff44f917989$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $44e97ff44f917989$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $44e97ff44f917989$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($44e97ff44f917989$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $44e97ff44f917989$var$noop,
        pending: pending || $44e97ff44f917989$var$noop,
        rejected: rejected || $44e97ff44f917989$var$noop,
        settled: settled || $44e97ff44f917989$var$noop
    });
}
function $44e97ff44f917989$var$noop() {}
// src/entities/entity_state.ts
function $44e97ff44f917989$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $44e97ff44f917989$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($44e97ff44f917989$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $44e97ff44f917989$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $44e97ff44f917989$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $44e97ff44f917989$var$isDraftTyped = (0, $5icQr.isDraft);
function $44e97ff44f917989$var$createSingleArgumentStateOperator(mutator) {
    var operator = $44e97ff44f917989$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $44e97ff44f917989$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $44e97ff44f917989$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($44e97ff44f917989$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5icQr.produce)(state, runMutator);
    };
}
function $44e97ff44f917989$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $44e97ff44f917989$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $44e97ff44f917989$var$getCurrent(value) {
    return (0, $5icQr.isDraft)(value) ? (0, $5icQr.current)(value) : value;
}
function $44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $44e97ff44f917989$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $44e97ff44f917989$var$selectIdValue(entity, selectId);
            if (existingIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $44e97ff44f917989$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $44e97ff44f917989$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $44e97ff44f917989$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $44e97ff44f917989$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $44e97ff44f917989$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $kB67t._)($44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $44e97ff44f917989$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $44e97ff44f917989$var$createStateOperator(addOneMutably),
        addMany: $44e97ff44f917989$var$createStateOperator(addManyMutably),
        setOne: $44e97ff44f917989$var$createStateOperator(setOneMutably),
        setMany: $44e97ff44f917989$var$createStateOperator(setManyMutably),
        setAll: $44e97ff44f917989$var$createStateOperator(setAllMutably),
        updateOne: $44e97ff44f917989$var$createStateOperator(updateOneMutably),
        updateMany: $44e97ff44f917989$var$createStateOperator(updateManyMutably),
        upsertOne: $44e97ff44f917989$var$createStateOperator(upsertOneMutably),
        upsertMany: $44e97ff44f917989$var$createStateOperator(upsertManyMutably),
        removeOne: $44e97ff44f917989$var$createStateOperator(removeOneMutably),
        removeMany: $44e97ff44f917989$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $44e97ff44f917989$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $44e97ff44f917989$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $44e97ff44f917989$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $44e97ff44f917989$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $44e97ff44f917989$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : $44e97ff44f917989$var$getCurrent(state.ids));
        var models = newEntities.filter(function(model) {
            return !existingKeys.has($44e97ff44f917989$var$selectIdValue(model, selectId));
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    delete state.entities[selectId(item)];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $kB67t._)($44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeFunction = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $44e97ff44f917989$var$getCurrent(state.entities);
        var currentIds = $44e97ff44f917989$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $44e97ff44f917989$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $44e97ff44f917989$var$createStateOperator(addOneMutably),
        updateOne: $44e97ff44f917989$var$createStateOperator(updateOneMutably),
        upsertOne: $44e97ff44f917989$var$createStateOperator(upsertOneMutably),
        setOne: $44e97ff44f917989$var$createStateOperator(setOneMutably),
        setMany: $44e97ff44f917989$var$createStateOperator(setManyMutably),
        setAll: $44e97ff44f917989$var$createStateOperator(setAllMutably),
        addMany: $44e97ff44f917989$var$createStateOperator(addManyMutably),
        updateMany: $44e97ff44f917989$var$createStateOperator(updateManyMutably),
        upsertMany: $44e97ff44f917989$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $44e97ff44f917989$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $44e97ff44f917989$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $44e97ff44f917989$var$createSortedStateAdapter(selectId, sortComparer) : $44e97ff44f917989$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $44e97ff44f917989$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $44e97ff44f917989$var$createSelectorsFactory();
    return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $44e97ff44f917989$var$task = "task";
var $44e97ff44f917989$var$listener = "listener";
var $44e97ff44f917989$var$completed = "completed";
var $44e97ff44f917989$var$cancelled = "cancelled";
var $44e97ff44f917989$var$taskCancelled = "task-".concat($44e97ff44f917989$var$cancelled);
var $44e97ff44f917989$var$taskCompleted = "task-".concat($44e97ff44f917989$var$completed);
var $44e97ff44f917989$var$listenerCancelled = "".concat($44e97ff44f917989$var$listener, "-").concat($44e97ff44f917989$var$cancelled);
var $44e97ff44f917989$var$listenerCompleted = "".concat($44e97ff44f917989$var$listener, "-").concat($44e97ff44f917989$var$completed);
var $44e97ff44f917989$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $bB0zn._)(this, TaskAbortError);
    this.code = code;
    $44e97ff44f917989$var$__publicField(this, "name", "TaskAbortError");
    $44e97ff44f917989$var$__publicField(this, "message");
    this.message = "".concat($44e97ff44f917989$var$task, " ").concat($44e97ff44f917989$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $44e97ff44f917989$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError($44e97ff44f917989$export$378fa86b259c0280(32));
};
var $44e97ff44f917989$var$noop2 = function() {};
var $44e97ff44f917989$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $44e97ff44f917989$var$noop2;
    promise.catch(onError);
    return promise;
};
var $44e97ff44f917989$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $44e97ff44f917989$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $44e97ff44f917989$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $44e97ff44f917989$export$cb1bdac908fed7f(reason);
    }
};
function $44e97ff44f917989$var$raceWithSignal(signal, promise) {
    var cleanup = $44e97ff44f917989$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $44e97ff44f917989$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $44e97ff44f917989$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $44e97ff44f917989$var$noop2;
    });
}
var $44e97ff44f917989$var$runTask = /*#__PURE__*/ function() {
    var _ref = (0, $7k5I8._)(function(task2, cleanUp) {
        var value, error;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $44e97ff44f917989$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $44e97ff44f917989$var$createPause = function(signal) {
    return function(promise) {
        return $44e97ff44f917989$var$catchRejection($44e97ff44f917989$var$raceWithSignal(signal, promise).then(function(output) {
            $44e97ff44f917989$var$validateActive(signal);
            return output;
        }));
    };
};
var $44e97ff44f917989$var$createDelay = function(signal) {
    var pause = $44e97ff44f917989$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $44e97ff44f917989$var$assign = Object.assign;
var $44e97ff44f917989$var$INTERNAL_NIL_TOKEN = {};
var $44e97ff44f917989$var$alm = "listenerMiddleware";
var $44e97ff44f917989$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $44e97ff44f917989$var$addAbortSignalListener(parentAbortSignal, function() {
            return $44e97ff44f917989$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $44e97ff44f917989$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $44e97ff44f917989$var$runTask(/*#__PURE__*/ (0, $7k5I8._)(function() {
            var result2;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $44e97ff44f917989$var$validateActive(parentAbortSignal);
                        $44e97ff44f917989$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $44e97ff44f917989$var$createPause(childAbortController.signal),
                                delay: $44e97ff44f917989$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $44e97ff44f917989$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $44e97ff44f917989$var$abortControllerWithReason(childAbortController, $44e97ff44f917989$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($44e97ff44f917989$var$noop2));
        return {
            result: $44e97ff44f917989$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $44e97ff44f917989$var$abortControllerWithReason(childAbortController, $44e97ff44f917989$var$taskCancelled);
            }
        };
    };
};
var $44e97ff44f917989$var$createTakePattern = function(startListening, signal) {
    var take = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $44e97ff44f917989$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $44e97ff44f917989$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $44e97ff44f917989$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $44e97ff44f917989$var$catchRejection(take(predicate, timeout));
    };
};
var $44e97ff44f917989$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $44e97ff44f917989$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($44e97ff44f917989$export$378fa86b259c0280(21));
    $44e97ff44f917989$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $44e97ff44f917989$var$createListenerEntry = /* @__PURE__ */ $44e97ff44f917989$var$assign(function(options) {
    var _getListenerEntryPropsFrom = $44e97ff44f917989$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var entry = {
        id: $44e97ff44f917989$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($44e97ff44f917989$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $44e97ff44f917989$var$createListenerEntry;
    }
});
var $44e97ff44f917989$var$findListenerEntry = function(listenerMap, options) {
    var _getListenerEntryPropsFrom = $44e97ff44f917989$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
    return Array.from(listenerMap.values()).find(function(entry) {
        var matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $44e97ff44f917989$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $44e97ff44f917989$var$abortControllerWithReason(controller, $44e97ff44f917989$var$listenerCancelled);
    });
};
var $44e97ff44f917989$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($44e97ff44f917989$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $44e97ff44f917989$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $44e97ff44f917989$export$f03a6b845d3fb58b = /* @__PURE__ */ $44e97ff44f917989$var$assign(/* @__PURE__ */ $44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/add")), {
    withTypes: function() {
        return $44e97ff44f917989$export$f03a6b845d3fb58b;
    }
});
var $44e97ff44f917989$export$b1b8022855fb2b71 = /* @__PURE__ */ $44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/removeAll"));
var $44e97ff44f917989$export$b03e9483f936dccb = /* @__PURE__ */ $44e97ff44f917989$var$assign(/* @__PURE__ */ $44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/remove")), {
    withTypes: function() {
        return $44e97ff44f917989$export$b03e9483f936dccb;
    }
});
var $44e97ff44f917989$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($44e97ff44f917989$var$alm, "/error")
    ].concat((0, $2Xzd1._)(args)));
};
var $44e97ff44f917989$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $44e97ff44f917989$var$defaultErrorHandler : _middlewareOptions_onError;
    $44e97ff44f917989$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $44e97ff44f917989$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var _a;
        var entry = (_a = $44e97ff44f917989$var$findListenerEntry(listenerMap, options)) != null ? _a : $44e97ff44f917989$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $44e97ff44f917989$var$assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var entry = $44e97ff44f917989$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $44e97ff44f917989$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $44e97ff44f917989$var$assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $44e97ff44f917989$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $44e97ff44f917989$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $44e97ff44f917989$var$createDelay(internalTaskController.signal),
                                pause: $44e97ff44f917989$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $44e97ff44f917989$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $44e97ff44f917989$var$abortControllerWithReason(controller, $44e97ff44f917989$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $44e97ff44f917989$var$abortControllerWithReason(internalTaskController, $44e97ff44f917989$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $44e97ff44f917989$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $44e97ff44f917989$export$cb1bdac908fed7f)) $44e97ff44f917989$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $44e97ff44f917989$var$abortControllerWithReason(internalTaskController, $44e97ff44f917989$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $44e97ff44f917989$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $a039f9c7168ef4c9$export$b956e38827fca970)(action)) return next(action);
                if ($44e97ff44f917989$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($44e97ff44f917989$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($44e97ff44f917989$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $44e97ff44f917989$var$INTERNAL_NIL_TOKEN) throw new Error($44e97ff44f917989$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $44e97ff44f917989$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $44e97ff44f917989$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $44e97ff44f917989$var$createMiddlewareEntry = function(middleware) {
    return {
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $44e97ff44f917989$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $44e97ff44f917989$export$4bb1606a79445586 = function() {
    var instanceId = $44e97ff44f917989$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($44e97ff44f917989$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            $44e97ff44f917989$var$getOrInsertComputed(middlewareMap, middleware2, $44e97ff44f917989$var$createMiddlewareEntry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $44e97ff44f917989$var$getOrInsertComputed(entry.applied, api, entry.middleware);
        });
        return (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7).apply(void 0, (0, $2Xzd1._)(appliedMiddleware));
    };
    var isWithMiddleware = $44e97ff44f917989$export$9dd1fb32974da385(withMiddleware, $44e97ff44f917989$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $2Xzd1._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $44e97ff44f917989$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $44e97ff44f917989$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $44e97ff44f917989$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $44e97ff44f917989$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $44e97ff44f917989$var$isStateProxy = function(value) {
    return !!value && !!value[$44e97ff44f917989$var$ORIGINAL_STATE];
};
var $44e97ff44f917989$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $44e97ff44f917989$var$createStateProxy = function(state, reducerMap) {
    return $44e97ff44f917989$var$getOrInsertComputed($44e97ff44f917989$var$stateProxyMap, state, function() {
        return new Proxy(state, {
            get: function(target, prop, receiver) {
                if (prop === $44e97ff44f917989$var$ORIGINAL_STATE) return target;
                var result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    var reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        var reducerResult = reducer(void 0, {
                            type: $44e97ff44f917989$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($44e97ff44f917989$export$378fa86b259c0280(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        });
    });
};
var $44e97ff44f917989$var$original = function(state) {
    if (!$44e97ff44f917989$var$isStateProxy(state)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(25));
    return state[$44e97ff44f917989$var$ORIGINAL_STATE];
};
var $44e97ff44f917989$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $44e97ff44f917989$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($44e97ff44f917989$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $a039f9c7168ef4c9$export$66e4520cdb265d18)(reducerMap) : $44e97ff44f917989$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $44e97ff44f917989$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $2Xzd1._)(args))) : state, reducerMap)
            ].concat((0, $2Xzd1._)(args)));
        };
    }, {
        original: $44e97ff44f917989$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $44e97ff44f917989$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $2767c9397776ff73$var$cartSlice = (0, $44e97ff44f917989$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: function(state, action) {
            //mutating the state here
            state.items.push(action.payload);
        },
        removeItem: function(state, action) {
            state.item.pop();
        },
        clearCart: function(state, action) {
            state.items.length = 0;
        }
    }
});
var $2767c9397776ff73$var$_cartSlice_actions = $2767c9397776ff73$var$cartSlice.actions;
var $2767c9397776ff73$export$fb9705de59d96855 = $2767c9397776ff73$var$_cartSlice_actions.addItem, $2767c9397776ff73$export$fe2d9b4e03920b4c = $2767c9397776ff73$var$_cartSlice_actions.removeItem, $2767c9397776ff73$export$810121176e3e3671 = $2767c9397776ff73$var$_cartSlice_actions.clearCart;
var $2767c9397776ff73$export$2e2bcd8739ae039 = $2767c9397776ff73$var$cartSlice.reducer;


var $3a63efcc8c0a1cc1$var$ItemList = function(param) {
    var items = param.items;
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var handleAddItem = function(item) {
        //Dispatch an action
        dispatch((0, $2767c9397776ff73$export$fb9705de59d96855)(item));
    };
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "space-y-4",
        children: items.map(function(item) {
            return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-200",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                        src: (0, $cc25cc9a913d8a70$export$31adfacaf07ffe63) + item.card.info.imageId,
                        className: "w-20 h-20 object-cover rounded-md"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex-1 mx-4",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h3", {
                                className: "font-semibold text-gray-800",
                                children: item.card.info.name
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                className: "text-sm text-gray-600 mt-1",
                                children: [
                                    "- \u20B9",
                                    item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                className: "text-xs text-gray-500 mt-1 line-clamp-2",
                                children: item.card.info.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                        className: "bg-blue-500 text-white px-4 py-2 rounded-md shadow hover:bg-blue-600 transition-colors duration-300",
                        // onClick={() => handleAddItem(item)}
                        onClick: function() {
                            return handleAddItem(item);
                        },
                        children: "Add +"
                    })
                ]
            }, item.card.info.id);
        })
    });
};
var $3a63efcc8c0a1cc1$export$2e2bcd8739ae039 = $3a63efcc8c0a1cc1$var$ItemList;


var $d61e5d477b89ad78$var$RestaurantCategory = function(param) {
    var data = param.data, showItems = param.showItems, setShowIndex = param.setShowIndex, dummy = param.dummy;
    var handleClick = function() {
        setShowIndex();
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "w-11/12 mx-auto my-4 rounded-lg shadow-md border border-gray-200",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex justify-between items-center cursor-pointer p-4 bg-white rounded-lg hover:shadow-lg transition-shadow duration-300",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                        className: "font-semibold text-gray-800 text-lg",
                        children: [
                            data.title,
                            " (",
                            data.itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                        children: "\u2B07\uFE0F"
                    })
                ]
            }),
            showItems && /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "bg-gray-50 rounded-b-lg p-4",
                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $3a63efcc8c0a1cc1$export$2e2bcd8739ae039), {
                    items: data.itemCards
                })
            })
        ]
    });
};
var $d61e5d477b89ad78$export$2e2bcd8739ae039 = $d61e5d477b89ad78$var$RestaurantCategory;



var $fIwXP = parcelRequire("fIwXP");
var $d1dc02be9882a390$var$RestuarantMenu = function() {
    var _resInfo_cards__card_card, _resInfo_cards__card, _resInfo_cards_, _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card, _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_, _resInfo_cards__groupedCard_cardGroupMap_REGULAR, _resInfo_cards__groupedCard_cardGroupMap, _resInfo_cards__groupedCard, _resInfo_cards_1, _resInfo_cards__groupedCard_cardGroupMap_REGULAR1, _resInfo_cards__groupedCard_cardGroupMap1, _resInfo_cards__groupedCard1, _resInfo_cards_2;
    // const [resInfo, setResInfo] = useState(null);
    var resId = (0, $7e473.useParams)().resId;
    //useRestaurantMenu is our custom hook and we are going to perform the fetching of the data
    var resInfo = (0, $6d359334c042511a$export$2e2bcd8739ae039)(resId);
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), showIndex = _useState[0], setShowIndex = _useState[1];
    // console.log(resId);
    /*
    useEffect(() => {
        fetchMenu ();
    }, []);

    const fetchMenu = async () => {
        const data = await fetch( MENU_API + resId);
       
        const json = await data.json();

        console.log(json);
        setResInfo(json.data);
    }
*/ if (resInfo === null) return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $68ce1d77bc18c07c$export$2e2bcd8739ae039), {});
    var _ref = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_ = resInfo.cards[2]) === null || _resInfo_cards_ === void 0 ? void 0 : (_resInfo_cards__card = _resInfo_cards_.card) === null || _resInfo_cards__card === void 0 ? void 0 : (_resInfo_cards__card_card = _resInfo_cards__card.card) === null || _resInfo_cards__card_card === void 0 ? void 0 : _resInfo_cards__card_card.info, name = _ref.name, cuisines = _ref.cuisines, costForTwoMessage = _ref.costForTwoMessage;
    var itemCards = (resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_1 = resInfo.cards[4]) === null || _resInfo_cards_1 === void 0 ? void 0 : (_resInfo_cards__groupedCard = _resInfo_cards_1.groupedCard) === null || _resInfo_cards__groupedCard === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap = _resInfo_cards__groupedCard.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR = _resInfo_cards__groupedCard_cardGroupMap.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_ = _resInfo_cards__groupedCard_cardGroupMap_REGULAR.cards[1]) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_ === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card = _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_.card) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card.card).itemCards;
    // console.log(itemCards);
    var categories = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_2 = resInfo.cards[4]) === null || _resInfo_cards_2 === void 0 ? void 0 : (_resInfo_cards__groupedCard1 = _resInfo_cards_2.groupedCard) === null || _resInfo_cards__groupedCard1 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap1 = _resInfo_cards__groupedCard1.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap1 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR1 = _resInfo_cards__groupedCard_cardGroupMap1.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR1 === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR1.cards.filter(function(c) {
        var _c_card_card, _c_card;
        return ((_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card["card"]) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    });
    console.log(categories);
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "max-w-4xl mx-auto p-4",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "font-bold text-4xl text-gray-800 my-4",
                children: name
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                className: "text-lg text-gray-600 mb-8",
                children: [
                    cuisines.join(","),
                    " - ",
                    costForTwoMessage
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "space-y-6",
                children: categories.map(function(category, index) {
                    var _category_card, _category_card1;
                    return(// controlled component
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "bg-white shadow-md rounded-lg p-4 hover:shadow-xl transition-shadow duration-300",
                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d61e5d477b89ad78$export$2e2bcd8739ae039), {
                            data: category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : _category_card.card,
                            showItems: index === showIndex ? true : false,
                            setShowIndex: function() {
                                return setShowIndex(index === showIndex ? null : index);
                            }
                        })
                    }, category === null || category === void 0 ? void 0 : (_category_card1 = category.card) === null || _category_card1 === void 0 ? void 0 : _category_card1.card.title));
                })
            })
        ]
    });
};
var $d1dc02be9882a390$export$2e2bcd8739ae039 = $d1dc02be9882a390$var$RestuarantMenu;



var $7e473 = parcelRequire("7e473");


//This file is the redux store;


var $8c21c4a485ab61ca$var$appStore = (0, $44e97ff44f917989$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $2767c9397776ff73$export$2e2bcd8739ae039)
    }
});
var $8c21c4a485ab61ca$export$2e2bcd8739ae039 = $8c21c4a485ab61ca$var$appStore;



var $cc6u1 = parcelRequire("cc6u1");



var $b47241cf3d81c34b$var$Cart = function() {
    var cartItems = (0, $c7b80bd183211e5d$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    console.log(cartItems);
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var handleClearCart = function() {
        dispatch((0, $2767c9397776ff73$export$810121176e3e3671)());
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "text-center m-4 p-4",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "text-2xl font-bold",
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "w-6/12 m-auto",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                        className: " p-2 m-2 bg-black text-white rounded-lg",
                        onClick: handleClearCart,
                        children: "Clear Cart"
                    }),
                    (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) === 0 && /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        children: " Cart is empty. Add Items to the cart!"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $3a63efcc8c0a1cc1$export$2e2bcd8739ae039), {
                        items: cartItems
                    })
                ]
            })
        ]
    });
};
var $b47241cf3d81c34b$export$2e2bcd8739ae039 = $b47241cf3d81c34b$var$Cart;



var $0daa6d02c6c97a55$var$Grocery = /*#__PURE__*/ (0, $fIwXP.lazy)(function() {
    return (parcelRequire("c38Wl"));
});
var $0daa6d02c6c97a55$var$AppLayout = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(), 2), userName = _useState[0], setUserName = _useState[1];
    //authentication
    (0, $fIwXP.useEffect)(function() {
        //Make an API call and send Username and password
        var data = {
            name: "Parshuram Kumar"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $c7b80bd183211e5d$export$2881499e37b75b9a), {
        store: (0, $8c21c4a485ab61ca$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $409bc5b8063aeee2$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $f310bc4ea983f747$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $7e473.Outlet), {})
                ]
            })
        })
    });
};
var $0daa6d02c6c97a55$var$appRouter = (0, $7e473.createBrowserRouter)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $cc6u1.jsx)($0daa6d02c6c97a55$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $373b11f276a41253$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $601c1599e979598b$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $717a2f0a6a708d12$export$2e2bcd8739ae039), {})
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d1dc02be9882a390$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $fIwXP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        children: "Loading"
                    }),
                    children: /*#__PURE__*/ (0, $cc6u1.jsx)($0daa6d02c6c97a55$var$Grocery, {})
                })
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $b47241cf3d81c34b$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $eb9ea4566ac52960$export$2e2bcd8739ae039), {})
    }
]);
var $0daa6d02c6c97a55$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($fb34d4b6d3b01836$exports))).createRoot(document.getElementById("root"));
$0daa6d02c6c97a55$var$root.render(/*#__PURE__*/ (0, $cc6u1.jsx)((0, $7e473.RouterProvider), {
    router: $0daa6d02c6c97a55$var$appRouter
}));

})();
//# sourceMappingURL=index.478b8ba9.js.map
